
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("2K3wo", function(module, exports) {

var $3ztIq = parcelRequire("3ztIq");


var $iDrrr = parcelRequire("iDrrr");


var $krYZG = parcelRequire("krYZG");


var $1H5A4 = parcelRequire("1H5A4");


var $l3it0 = parcelRequire("l3it0");

const $e5f9c44481f3c7a0$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $e5f9c44481f3c7a0$var$errorCallbackFor = (marks, validate, dispatchAnalyticsEvent, validationOverrides)=>{
    return (entity, error, options)=>{
        return $e5f9c44481f3c7a0$export$468b008419c9a974(entity, error, {
            ...options,
            allowNestedTables: validationOverrides?.allowNestedTables,
            allowTableInPanel: validationOverrides?.allowTableInPanel,
            allowExpandInPanel: validationOverrides?.allowExpandInPanel
        }, marks, validate, dispatchAnalyticsEvent);
    };
};
const $e5f9c44481f3c7a0$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $e5f9c44481f3c7a0$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return (0, $l3it0.wrapWithUnsupported)(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $e5f9c44481f3c7a0$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
   * There's a inconsistency between ProseMirror and ADF.
   * `content` is actually optional in ProseMirror.
   * And, also empty `text` node is not valid.
   */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $e5f9c44481f3c7a0$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $e5f9c44481f3c7a0$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    // Nested tables don't actually exist in ADF. In ADF they are stored as an `extension` node with the nested table content serialized in a property of that extension.
    // Usually when we validate ADF we are validating this `extension` and then later transforming it into nested tables for usage by ProseMirror.
    // Under certain circumstances however, ADF validation is performed on this already transformed extension and since nested tables aren't allowed by ADF this
    // produces an error. For example, nested renderers in Confluence `bodiedExtension`'s. The nested renderer receives the already transformed nested tables that originated from the
    // `extension` node and validates it. This is invalid ADF so an error is thrown.
    // This override allows an exception to be made for nested tables in the validator in this circumstance.
    if (options.allowNestedTables) {
        const meta = error.meta;
        if (options.allowNestedTables && meta?.parentType && [
            'tableCell',
            'tableHeader'
        ].includes(meta?.parentType) && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    // panel_c1 is a ProseMirror-only variant: on save, table-in-panel documents are stored as
    // plain ADF `panel` nodes containing a `table`. The base validator-spec does not permit
    // `table` inside `panel`, so suppress the INVALID_CONTENT error when the experiment is active.
    // Only while platform_editor_table_in_panel_patch_1 is OFF: with the patch on, the adf-utils
    // validator accepts table-in-panel positionally (doc / layout column / synced block only), and
    // this blunt suppression would wrongly allow it in every panel.
    if (options.allowTableInPanel && !(0, $iDrrr.fg)('platform_editor_table_in_panel_patch_1')) {
        const meta = error.meta;
        if (meta?.parentType === 'panel' && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    // panel_c1 is a ProseMirror-only variant: on save, expand-in-panel documents are stored as
    // plain ADF `panel` nodes containing an `expand`. The base validator-spec does not permit
    // `expand` inside `panel` (it's gated behind the experiment), so we suppress the
    // INVALID_CONTENT error when the experiment is active.
    if (options.allowExpandInPanel) {
        const meta = error.meta;
        if (meta?.parentType === 'panel' && error.code === 'INVALID_CONTENT' && entity.type === 'expand') return entity;
    }
    if (options.allowUnsupportedBlock) return (0, $l3it0.wrapWithUnsupported)(entity);
    if (options.allowUnsupportedInline) return (0, $l3it0.wrapWithUnsupported)(entity, 'inline');
    if (dispatchAnalyticsEvent) $e5f9c44481f3c7a0$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $e5f9c44481f3c7a0$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? (0, $l3it0.wrapWithUnsupported)(child) : validate(child, $e5f9c44481f3c7a0$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return (0, $l3it0.wrapWithUnsupported)(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? (0, $l3it0.wrapWithUnsupported)(child) : child;
        });
    }
    return entity;
}
function $e5f9c44481f3c7a0$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $1H5A4.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $krYZG.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $e5f9c44481f3c7a0$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent, validationOverrides)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $3ztIq.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $e5f9c44481f3c7a0$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides));
    return entity;
};
module.exports["validateADFEntity"] = $e5f9c44481f3c7a0$export$884cfad20dece33e;

});

parcelRegister("3ztIq", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $df8cd2f5f7244c7e$export$784d13d8ee351f07 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
source, dest, key)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};


const $4ac5b7432fc33921$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';


const $4cc8c57b3002097f$export$4e62c701997796c1 = (x)=>x != null;


const $778bf7c25181c7e9$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;


const $f5b16bd0ca7e2cfa$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);


const $81ff54957427713c$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);


// This is a kludge, might replace with something like _.isString in future
const $32f9ca2361aeb767$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;


// Helpers
const $86c5bdcf16f1c27d$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];


// This is a lookup map consumed by `createSpec`, not an entry point re-exporting the schema
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $yQ01u = parcelRequire("yQ01u");

const $b360b901131b5408$export$13afbb83a3ae2576 = {
    alignment: $yQ01u.alignment,
    annotation: $yQ01u.annotation,
    backgroundColor: $yQ01u.backgroundColor,
    blockCard: $yQ01u.blockCard,
    blockRootOnly: $yQ01u.blockRootOnly,
    blockTaskItem: $yQ01u.blockTaskItem,
    block_content: $yQ01u.block_content,
    blockquote: $yQ01u.blockquote,
    bodiedExtension: $yQ01u.bodiedExtension,
    bodiedExtension_root_only: $yQ01u.bodiedExtension_root_only,
    bodiedExtension_with_marks: $yQ01u.bodiedExtension_with_marks,
    bodiedSyncBlock: $yQ01u.bodiedSyncBlock,
    border: $yQ01u.border,
    breakout: $yQ01u.breakout,
    bulletList: $yQ01u.bulletList,
    caption: $yQ01u.caption,
    code: $yQ01u.code,
    codeBlock: $yQ01u.codeBlock,
    codeBlock_root_only: $yQ01u.codeBlock_root_only,
    confluenceInlineComment: $yQ01u.confluenceInlineComment,
    dataConsumer: $yQ01u.dataConsumer,
    date: $yQ01u.date,
    decisionItem: $yQ01u.decisionItem,
    decisionList: $yQ01u.decisionList,
    doc: $yQ01u.doc,
    em: $yQ01u.em,
    embedCard: $yQ01u.embedCard,
    emoji: $yQ01u.emoji,
    expand: $yQ01u.expand,
    expand_root_only: $yQ01u.expand_root_only,
    extension: $yQ01u.extension,
    extensionFrame: $yQ01u.extensionFrame,
    extension_root_only: $yQ01u.extension_root_only,
    extension_with_marks: $yQ01u.extension_with_marks,
    fontSize: $yQ01u.fontSize,
    fragment: $yQ01u.fragment,
    hardBreak: $yQ01u.hardBreak,
    heading: $yQ01u.heading,
    heading_with_alignment: $yQ01u.heading_with_alignment,
    heading_with_indentation: $yQ01u.heading_with_indentation,
    heading_with_no_marks: $yQ01u.heading_with_no_marks,
    indentation: $yQ01u.indentation,
    inlineCard: $yQ01u.inlineCard,
    inlineExtension: $yQ01u.inlineExtension,
    inlineExtension_with_marks: $yQ01u.inlineExtension_with_marks,
    inline_content: $yQ01u.inline_content,
    layoutColumn: $yQ01u.layoutColumn,
    layoutSection: $yQ01u.layoutSection,
    layoutSection_full: $yQ01u.layoutSection_full,
    layoutSection_with_single_column: $yQ01u.layoutSection_with_single_column,
    link: $yQ01u.link,
    listItem: $yQ01u.listItem,
    media: $yQ01u.media,
    mediaGroup: $yQ01u.mediaGroup,
    mediaInline: $yQ01u.mediaInline,
    mediaSingle: $yQ01u.mediaSingle,
    mediaSingle_caption: $yQ01u.mediaSingle_caption,
    mediaSingle_full: $yQ01u.mediaSingle_full,
    mention: $yQ01u.mention,
    multiBodiedExtension: $yQ01u.multiBodiedExtension,
    multiBodiedExtension_root_only: $yQ01u.multiBodiedExtension_root_only,
    nestedExpand: $yQ01u.nestedExpand,
    nestedExpand_content: $yQ01u.nestedExpand_content,
    nestedExpand_with_no_marks: $yQ01u.nestedExpand_with_no_marks,
    non_nestable_block_content: $yQ01u.non_nestable_block_content,
    orderedList: $yQ01u.orderedList,
    panel: $yQ01u.panel,
    panel_c1: $yQ01u.panel_c1,
    panel_c1_root_only: $yQ01u.panel_c1_root_only,
    panel_root_only: $yQ01u.panel_root_only,
    paragraph: $yQ01u.paragraph,
    paragraph_with_alignment: $yQ01u.paragraph_with_alignment,
    paragraph_with_font_size: $yQ01u.paragraph_with_font_size,
    paragraph_with_indentation: $yQ01u.paragraph_with_indentation,
    paragraph_with_no_marks: $yQ01u.paragraph_with_no_marks,
    placeholder: $yQ01u.placeholder,
    rule: $yQ01u.rule,
    rule_root_only: $yQ01u.rule_root_only,
    status: $yQ01u.status,
    strike: $yQ01u.strike,
    strong: $yQ01u.strong,
    subsup: $yQ01u.subsup,
    syncBlock: $yQ01u.syncBlock,
    table: $yQ01u.table,
    tableCell: $yQ01u.tableCell,
    tableHeader: $yQ01u.tableHeader,
    tableRow: $yQ01u.tableRow,
    taskItem: $yQ01u.taskItem,
    taskList: $yQ01u.taskList,
    text: $yQ01u.text,
    textColor: $yQ01u.textColor,
    text_code_inline: $yQ01u.text_code_inline,
    text_formatted: $yQ01u.text_formatted,
    text_link_inline: $yQ01u.text_link_inline,
    text_with_no_marks: $yQ01u.text_with_no_marks,
    underline: $yQ01u.underline
};


function $ca93fab8c8ac9c45$export$7d2123bc001cdbf8(validatorSpecs, entity) {
    // Filter out content type + irrelevant nodes
    const potentialAllowedContent = Object.entries(validatorSpecs).filter((item)=>{
        const [node, value] = item;
        if ($ca93fab8c8ac9c45$var$isValidatorSpec(value)) return node === entity.type;
        const [nodeName, spec] = [
            value[0],
            value[1]
        ];
        if (typeof spec === 'string' || typeof spec !== 'object') return false;
        return nodeName === entity.type;
    });
    // Keep types such as `mediaSingle_full` which contain additional spec information
    const contentArray = potentialAllowedContent.map((allowedContent)=>{
        if ($ca93fab8c8ac9c45$var$isValidatorSpec(allowedContent)) return undefined;
        const value = allowedContent[1];
        return !$ca93fab8c8ac9c45$var$isValidatorSpec(value) ? [
            [
                value[0],
                value[1]
            ]
        ] : undefined;
    });
    return contentArray.filter((x)=>!!x);
}
function $ca93fab8c8ac9c45$var$isValidatorSpec(spec) {
    return spec.props !== undefined || spec.required !== undefined || spec.maxItems !== undefined || spec.minItems !== undefined;
}



var $9p0BY = parcelRequire("9p0BY");

const $901aa16493efc66f$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $9p0BY.isSafeUrl)
};


// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $64c6e6185f402e64$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
					 * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
					 * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
					 */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $64c6e6185f402e64$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Checks if a spec is a variant spec.
 * A variant spec is an array where the first element is a string (base spec name)
 * and the second element is a ValidatorSpec object { props: { ... } }
 */ const $64c6e6185f402e64$var$isVariant = (spec)=>typeof spec === 'object' && !!spec && 0 in spec && 1 in spec && typeof spec[0] === 'string' && typeof spec[1] === 'object';
/**
 * Resolve one content-item name against `specs`. Variant specs are stored as tuples (arrays), so a
 * name that refers to one (e.g. `paragraph_with_no_marks`) resolves to that tuple. A plain node
 * name (e.g. `table`) has no tuple in `specs` and is returned unchanged for the matcher to handle
 * by name.
 */ const $64c6e6185f402e64$var$resolveContentItemName = (name)=>{
    const referencedSpec = (0, $b360b901131b5408$export$13afbb83a3ae2576)[name];
    return Array.isArray(referencedSpec) ? referencedSpec : name;
};
/**
 * Expand the content item NAMES inside a variant tuple's override so they resolve the same way a
 * base spec's content does. A variant such as `panel_c1` is `['panel', { props: { content: { items:
 * [['paragraph_with_no_marks', ..., 'table']] } } }]`; those inner names are validator variant
 * names. Unlike a base spec's content (which `createSpec` resolves), the override names are left
 * raw, so the variant branch matches only plainly-named children (e.g. `table`) and rejects
 * variant-named ones (e.g. a normal `paragraph`). Resolve each name one level, leaving plain node
 * names untouched.
 */ const $64c6e6185f402e64$var$resolveVariantOverrideContentItems = (variantTuple)=>{
    const [baseNodeType, variantSpec] = variantTuple;
    const content = variantSpec?.props?.content;
    if (!content || !Array.isArray(content.items)) return variantTuple;
    // Each entry in `content.items` is either a single name or an `$or` group (a list of
    // alternative names). Resolve the names inside each `$or` group; pass single names through.
    const resolvedItems = content.items.map((entry)=>Array.isArray(entry) ? entry.map($64c6e6185f402e64$var$resolveContentItemName) : entry);
    return [
        baseNodeType,
        {
            ...variantSpec,
            props: {
                ...variantSpec.props,
                content: {
                    ...content,
                    items: resolvedItems
                }
            }
        }
    ];
};
// `panel_c1` / `panel_c1_root_only` are distinct ProseMirror-node variants (`preserveVariantNameInPm`)
// in the generated validatorSpec, offered as validator candidates only when the table-in-panel patch
// flag is on — so once it is on, table-in-panel is accepted for all consumers regardless of whether
// their schema registers panel_c1. Names are matched literally because the validatorSpec does not
// mark distinct-node variants; remove when platform_editor_table_in_panel_patch_1 is cleaned up.
const $64c6e6185f402e64$var$isGatedNodeVariant = (name)=>name === 'panel_c1' || name === 'panel_c1_root_only';
function $64c6e6185f402e64$export$a49afc9edc88765c(nodes, marks) {
    const variantOverrides = $64c6e6185f402e64$var$getVariantSpecOverrides();
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys((0, $b360b901131b5408$export$13afbb83a3ae2576)).reduce((newSpecs, k)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let spec = {
            ...(0, $b360b901131b5408$export$13afbb83a3ae2576)[k]
        };
        if ($64c6e6185f402e64$var$isVariant(spec) && Object.values(variantOverrides).includes(k)) // When the spec is a variant it will be in the form of ['base_spec_name', { props: { ... } }]
        // The actual validator spec of the variant will be the second item in the array
        spec = {
            ...spec[1]
        };
        else if ($64c6e6185f402e64$var$isVariant(spec)) {
            // A variant tuple that stays a tuple (e.g. panel_c1) becomes a top-level entry that
            // extractAllowedContent surfaces as an additional candidate when its node is validated as
            // the ROOT entity (e.g. a bare panel pasted/inserted via processRawValue). Only surface the
            // gated node-variants when the feature flag is on; otherwise skip the entry so a bare panel
            // falls through to the base `panel` spec (paragraph preserved, table rejected).
            if ($64c6e6185f402e64$var$isGatedNodeVariant(k) && !(0, $iDrrr.fg)('platform_editor_table_in_panel_patch_1')) return newSpecs;
            // Resolve the tuple's override content names so a top-level match works — otherwise the
            // override names (`paragraph_with_no_marks`, ...) match nothing and valid content is wrapped.
            // (For non-panel variants like mediaSingle_full the names are already plain, so this is a
            // no-op.)
            const resolved = $64c6e6185f402e64$var$resolveVariantOverrideContentItems([
                spec[0],
                spec[1]
            ]);
            spec = {
                ...spec,
                1: resolved[1]
            };
        }
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $32f9ca2361aeb767$export$844ec244b1367d54)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = (0, $b360b901131b5408$export$13afbb83a3ae2576)[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
					 * Flatten
					 *
					 * Input:
					 * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
					 *
					 * Output:
					 * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
					 */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map((item)=>(0, $32f9ca2361aeb767$export$844ec244b1367d54)(item) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray((0, $b360b901131b5408$export$13afbb83a3ae2576)[item]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (0, $b360b901131b5408$export$13afbb83a3ae2576)[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item// Drop gated node-variants (panel_c1 / panel_c1_root_only) from content lists when
                    // the schema doesn't support them, so a panel child only gets the base `panel`
                    // candidate — same node-list-driven rule as the top-level entry above, applied to
                    // the CHILD path (panel inside doc/layoutColumn/etc.).
                    .filter((subItem)=>!$64c6e6185f402e64$var$isGatedNodeVariant(subItem) || (0, $iDrrr.fg)('platform_editor_table_in_panel_patch_1')).map((subItem)=>{
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const resolved = (0, $b360b901131b5408$export$13afbb83a3ae2576)[subItem];
                        if (Array.isArray(resolved)) {
                            // Patch on: resolve the variant tuple's own override content names so a nested
                            // match works; patch off returns the tuple raw.
                            if ((0, $iDrrr.fg)('platform_editor_table_in_panel_patch_1')) return $64c6e6185f402e64$var$resolveVariantOverrideContentItems(resolved);
                            return resolved;
                        }
                        // Now `NoMark` produces `items: []`, should be fixed in generator
                        return (0, $32f9ca2361aeb767$export$844ec244b1367d54)(subItem) ? subItem : [
                            'text',
                            subItem
                        ];
                    })// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                // Patch on: a variant whose override content is a nested `$or` list (string[][],
                                // e.g. panel_c1) is not a flat child-name list, so keep it on the base node and
                                // validate its children recursively rather than dropping it. A flat override still
                                // requires every listed child to be supported.
                                if ((0, $iDrrr.fg)('platform_editor_table_in_panel_patch_1')) {
                                    const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                    const overrideItems = subItem[1]?.props?.content?.items;
                                    const overrideListsChildNodeNames = Array.isArray(overrideItems) && overrideItems.every((item)=>typeof item === 'string');
                                    if (isMainNodeSupported && overrideListsChildNodeNames) return overrideItems.every((item)=>nodes.indexOf(item) > -1);
                                    return isMainNodeSupported;
                                }
                                // Patch off: master's original flat check, verbatim.
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
										 * TODO: Probably try something like immer, but it's 3.3kb gzipped.
										 * Not worth it just for this.
										 */ [
                            subItem[0],
                            $64c6e6185f402e64$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $64c6e6185f402e64$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $64c6e6185f402e64$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $64c6e6185f402e64$export$66c739158ef99a42(spec, value) {
    if (!(0, $4cc8c57b3002097f$export$4e62c701997796c1)(value)) return !!spec.optional;
    if ($64c6e6185f402e64$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $64c6e6185f402e64$var$partitionObject(spec.props, (key, subSpec)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $64c6e6185f402e64$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $4cc8c57b3002097f$export$4e62c701997796c1)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $4ac5b7432fc33921$export$f9ce7b637dfbe238)(value);
        case 'number':
            return (0, $f5b16bd0ca7e2cfa$export$7e4aa119212bc614)(value) && ((0, $4cc8c57b3002097f$export$4e62c701997796c1)(spec.minimum) ? spec.minimum <= value : true) && ((0, $4cc8c57b3002097f$export$4e62c701997796c1)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $778bf7c25181c7e9$export$a287f47fed4544b8)(value) && ((0, $4cc8c57b3002097f$export$4e62c701997796c1)(spec.minimum) ? spec.minimum <= value : true) && ((0, $4cc8c57b3002097f$export$4e62c701997796c1)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $4cc8c57b3002097f$export$4e62c701997796c1)((0, $901aa16493efc66f$export$d1b377ca77ac267d)[rule]) && (0, $901aa16493efc66f$export$d1b377ca77ac267d)[rule](value);
            return (0, $32f9ca2361aeb767$export$844ec244b1367d54)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $4cc8c57b3002097f$export$4e62c701997796c1)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $4cc8c57b3002097f$export$4e62c701997796c1)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $81ff54957427713c$export$53b83ca8eaab0383)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$64c6e6185f402e64$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$64c6e6185f402e64$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $32f9ca2361aeb767$export$844ec244b1367d54)(value) && spec.values.indexOf(value) > -1;
    }
}
const $64c6e6185f402e64$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $64c6e6185f402e64$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $64c6e6185f402e64$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $64c6e6185f402e64$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...child
    }, {
        code: 'INVALID_CONTENT',
        message: message,
        meta: {
            parentType: parentSpec?.props?.type?.values[0]
        }
    }, $64c6e6185f402e64$var$getUnsupportedOptions(parentSpec));
};
const $64c6e6185f402e64$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $64c6e6185f402e64$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $64c6e6185f402e64$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
/**
 * Returns a map of base spec names to a preferred variant spec that should be used
 * in their place during validation. Implemented as a getter function so that entries
 * can be conditionally included behind feature gates.
 *
 * WARNING: The variant spec must be a strict superset of the base spec, i.e. any content valid
 * under the base spec must also be valid under the variant.
 */ const $64c6e6185f402e64$var$getVariantSpecOverrides = ()=>{
    let overrides = {};
    if ((0, $iDrrr.fg)('platform_editor_lovability_resize_gracefully')) overrides = {
        ...overrides,
        panel: 'panel_root_only',
        rule: 'rule_root_only'
    };
    if ((0, $iDrrr.fg)('platform_editor_lovability_resize_exts_gracefully')) overrides = {
        ...overrides,
        extension: 'extension_root_only',
        bodiedExtension: 'bodiedExtension_root_only',
        multiBodiedExtension: 'multiBodiedExtension_root_only'
    };
    return overrides;
};
/**
 * Replaces base validator specs with their designated variant overrides.
 */ const $64c6e6185f402e64$var$applyVariantSpecOverrides = (validatorSpecs)=>{
    Object.entries($64c6e6185f402e64$var$getVariantSpecOverrides()).forEach(([base, variant])=>{
        const baseSpec = validatorSpecs[base];
        const variantOverride = validatorSpecs[variant];
        if (baseSpec?.props && variantOverride?.props && typeof baseSpec.props === 'object' && typeof variantOverride.props === 'object') // Merge variant overrides INTO the base spec
        baseSpec.props = {
            ...baseSpec.props,
            ...variantOverride.props
        };
    });
};
/**
 * Copies the containers that validation writes to, keeping the caller's document read-only.
 *
 * Repairing unsupported content mutates the entity in place: `wrapUnSupportedNodeAttributes` deletes
 * keys from `attrs` and appends an `unsupportedNodeAttribute` mark to `marks`. A plain spread shares
 * both containers with the input, so those writes would escape into the caller's document and the
 * candidate-spec retry would re-validate an already-emptied `attrs`.
 *
 * Only `attrs` and `marks` need copying; nothing writes below that level.
 */ const $64c6e6185f402e64$var$cloneEntityForValidation = (entity)=>{
    const clone = {
        ...entity
    };
    if (entity.attrs) clone.attrs = {
        ...entity.attrs
    };
    if (entity.marks) clone.marks = entity.marks.map((mark)=>({
            ...mark
        }));
    return clone;
};
function $64c6e6185f402e64$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $64c6e6185f402e64$export$a49afc9edc88765c(nodes, marks);
    $64c6e6185f402e64$var$applyVariantSpecOverrides(validatorSpecs);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        if (!allowed) for (const allowed of (0, $ca93fab8c8ac9c45$export$7d2123bc001cdbf8)(validatorSpecs, entity)){
            const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
            if (validationResult.valid) return {
                entity: validationResult.entity,
                valid: validationResult.valid
            };
        }
        // If `allowed` was provided or we haven't passed yet, return the initial result
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        const newEntity = (0, $iDrrr.fg)('platform_adf-utils_validator-no-input-mutation') ? $64c6e6185f402e64$var$cloneEntityForValidation(entity) : {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $64c6e6185f402e64$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $64c6e6185f402e64$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $64c6e6185f402e64$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $64c6e6185f402e64$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $4cc8c57b3002097f$export$4e62c701997796c1)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $4cc8c57b3002097f$export$4e62c701997796c1)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$64c6e6185f402e64$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $4cc8c57b3002097f$export$4e62c701997796c1)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $4cc8c57b3002097f$export$4e62c701997796c1)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $86c5bdcf16f1c27d$export$7b85fd78dd236198)(validatorSpec.props.attrs);
            /**
			 * Attrs can be union type so try each path
			 * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
			 * Gotcha: It will always report the last failure.
			 */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $64c6e6185f402e64$var$partitionObject(attrOption.props, (key, spec)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const valueToValidate = prevEntity.attrs[key];
                    return $64c6e6185f402e64$export$66c739158ef99a42(spec, valueToValidate);
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $64c6e6185f402e64$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $64c6e6185f402e64$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $64c6e6185f402e64$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const message = $64c6e6185f402e64$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        const invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(const invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $64c6e6185f402e64$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        const result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $64c6e6185f402e64$var$partitionObject(prevEntity, (k)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $4cc8c57b3002097f$export$4e62c701997796c1)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $df8cd2f5f7244c7e$export$784d13d8ee351f07)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        const specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $64c6e6185f402e64$var$partitionObject(validatorSpec.props, (k, v)=>{
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : typeof v === 'object' && v !== null && 'optional' in v ? v.optional : false;
            return isOptional || (0, $4cc8c57b3002097f$export$4e62c701997796c1)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $64c6e6185f402e64$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $86c5bdcf16f1c27d$export$7b85fd78dd236198)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $86c5bdcf16f1c27d$export$7b85fd78dd236198)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $64c6e6185f402e64$var$invalidChildContent(child, errorCallback, validatorSpec);
                        // Prefer a candidate branch that validates WITHOUT repair. When a stored node
                        // matches several specs (e.g. a `panel` matches both base `panel` and the
                        // `panel_c1` variant that also allows a nested `table`), the repairing loop
                        // below lets the FIRST branch "succeed" by wrapping otherwise-valid content as
                        // `unsupportedBlock`, never reaching a branch that accepts it cleanly. Probe each
                        // branch with NO callback (every repair helper throws when none is given, so a
                        // non-throwing branch is a genuinely clean match) on a throwaway deep copy (the
                        // repair path mutates attrs before throwing). Return the first clean match;
                        // otherwise fall through to the repairing loop, unchanged.
                        if (errorCallback && allowedSpecsForChild.length > 1 && // Only a `panel` hits the base-panel vs `panel_c1` clean-match ambiguity — scoping
                        // to it keeps the probe (and its per-candidate deep copy) off every other
                        // multi-candidate child (e.g. text with alternative mark specs).
                        child.type === 'panel' && (0, $iDrrr.fg)('platform_editor_table_in_panel_patch_1')) {
                            // Serialize once; each candidate parses its own fresh copy so a probe can't mutate `child`.
                            const serializedChild = JSON.stringify(child);
                            // Probe one candidate spec with NO callback (so every repair helper throws instead of
                            // repairing). Returns `clean: true` only when the candidate validated with no repair
                            // and no unsupported marks.
                            const probeCandidate = (candidateSpec, isLastCandidate)=>{
                                const childProbe = JSON.parse(serializedChild);
                                const { valid: valid, entity: probedEntity, marksValidationOutput: marksValidationOutput } = validateNode(childProbe, undefined, [
                                    candidateSpec
                                ], validatorSpec);
                                if (!valid) return {
                                    clean: false
                                };
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(probedEntity, marksValidationOutput, undefined, isLastCandidate);
                                const hasUnsupportedMark = (entity?.marks ?? []).some((mark)=>mark.type === 'unsupportedMark');
                                return {
                                    clean: marksAreValid && !hasUnsupportedMark,
                                    entity: entity
                                };
                            };
                            for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                                const { clean: clean, entity: entity } = probeCandidate(allowedSpecsForChild[i], i === len - 1);
                                if (clean) return entity;
                            } catch  {
                            // A repair helper threw, so this candidate can't validate cleanly; try the next one.
                            }
                        // No candidate matched cleanly — intentionally fall through to the repairing loop
                        // below, which owns the throw (no callback) vs. repair (callback) decision.
                        }
                        /**
						 * When there's multiple possible branches try all of them.
						 * If all of them fails, throw the first one.
						 * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
						 */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $64c6e6185f402e64$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}
module.exports["validator"] = $64c6e6185f402e64$export$956325f45c5d174a;

});

parcelRegister("yQ01u", function(module, exports) {
const $233241c76f2a61c7$export$8e53000a4ec837 = {
    props: {
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        }
    }
};
const $233241c76f2a61c7$export$8512c9afa7b24c3b = {
    props: {
        attrs: {
            props: {
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                },
                id: {
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        }
    }
};
const $233241c76f2a61c7$export$8c5a050822fd698c = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        }
    }
};
const $233241c76f2a61c7$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
const $233241c76f2a61c7$export$c4c2f833baaebdb8 = {
    props: {
        attrs: [
            {
                props: {
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    layout: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    url: {
                        optional: true,
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    width: {
                        optional: true,
                        type: 'number'
                    }
                }
            },
            {
                props: {
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    }
                }
            }
        ],
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $233241c76f2a61c7$export$67dc04e652a298ca = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        }
    }
};
const $233241c76f2a61c7$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $233241c76f2a61c7$export$16018c61064a18df = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'blockTaskItem'
            ]
        }
    }
};
const $233241c76f2a61c7$export$27903d543b563e39 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        }
    }
};
const $233241c76f2a61c7$export$b7a532f6e202d8ea = [
    'bodiedExtension',
    {
        props: {
            marks: {
                items: [
                    [
                        'breakout',
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$e92c7e4302dd4371 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                resourceId: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'paragraph_with_no_marks',
                    'blockCard',
                    'blockquote',
                    'bulletList',
                    'codeBlock',
                    'decisionList',
                    'embedCard',
                    'expand',
                    'heading',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'heading_with_no_marks',
                    'layoutSection',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'mediaGroup',
                    'mediaSingle',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaSingle_width_type',
                    'orderedList',
                    'panel',
                    'panel_c1',
                    'rule',
                    'table',
                    'taskList'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                'breakout'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bodiedSyncBlock'
            ]
        }
    }
};
const $233241c76f2a61c7$export$1edee58a52776cd9 = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                },
                size: {
                    maximum: 3,
                    minimum: 1,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        }
    }
};
const $233241c76f2a61c7$export$89015c65f1c75e3f = {
    props: {
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    optional: true,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        }
    }
};
const $233241c76f2a61c7$export$a140c94e5ea26bee = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            items: [
                'listItem'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        }
    }
};
const $233241c76f2a61c7$export$8e3c2dfdc4f0453d = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        }
    }
};
const $233241c76f2a61c7$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $233241c76f2a61c7$export$7bb0d5c671655cc4 = {
    props: {
        attrs: {
            optional: true,
            props: {
                hideLineNumbers: {
                    optional: true,
                    type: 'boolean'
                },
                language: {
                    optional: true,
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                uniqueId: {
                    optional: true,
                    type: 'string'
                },
                wrap: {
                    optional: true,
                    type: 'boolean'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        }
    }
};
const $233241c76f2a61c7$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$f3b72f8fc4684ecd = {
    props: {
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        }
    }
};
const $233241c76f2a61c7$export$3024f02c495408d6 = {
    props: {
        attrs: {
            props: {
                sources: {
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1,
                    type: 'array'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        }
    }
};
const $233241c76f2a61c7$export$324d90190a8b822a = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        }
    }
};
const $233241c76f2a61c7$export$6959e16eeff859b4 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        }
    }
};
const $233241c76f2a61c7$export$62d45a65fb43d95e = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'decisionItem'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        }
    }
};
const $233241c76f2a61c7$export$2a111da947c407d2 = {
    props: {
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'panel_root_only',
                    'panel_c1',
                    'panel_c1_root_only',
                    'rule_root_only',
                    'extension_root_only',
                    'bodiedExtension_root_only',
                    'multiBodiedExtension_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only',
                    'syncBlock',
                    'bodiedSyncBlock'
                ]
            ],
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        }
    }
};
const $233241c76f2a61c7$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $233241c76f2a61c7$export$be4283d9a1cb1ff6 = {
    props: {
        attrs: {
            props: {
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                originalHeight: {
                    optional: true,
                    type: 'number'
                },
                originalWidth: {
                    optional: true,
                    type: 'number'
                },
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                width: {
                    maximum: 100,
                    minimum: 0,
                    optional: true,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        }
    }
};
const $233241c76f2a61c7$export$a19185d1233fc4b2 = {
    props: {
        attrs: {
            props: {
                id: {
                    optional: true,
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                shortName: {
                    type: 'string'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        }
    }
};
const $233241c76f2a61c7$export$9f77e0932fb78f72 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                title: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        }
    }
};
const $233241c76f2a61c7$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$1b45514b112dd749 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        }
    }
};
const $233241c76f2a61c7$export$8eba3df128e25335 = [
    'extension',
    {
        props: {
            marks: {
                items: [
                    [
                        'breakout',
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$4fdcae991fd743e7 = {
    props: {
        content: {
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        }
    }
};
const $233241c76f2a61c7$export$85e3c3ca0c6fb93 = {
    props: {
        attrs: {
            props: {
                fontSize: {
                    type: 'enum',
                    values: [
                        'small'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'fontSize'
            ]
        }
    }
};
const $233241c76f2a61c7$export$f00aeb236b6f05af = {
    props: {
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        }
    }
};
const $233241c76f2a61c7$export$371da9dd35aba193 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    optional: true,
                    type: 'enum',
                    values: [
                        '\n'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        }
    }
};
const $233241c76f2a61c7$export$46e4a324ac90507f = {
    props: {
        attrs: {
            props: {
                level: {
                    maximum: 6,
                    minimum: 1,
                    type: 'number'
                },
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        }
    }
};
const $233241c76f2a61c7$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                items: [
                    'alignment'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                items: [
                    'indentation'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$480c699bd4ec0d86 = {
    props: {
        attrs: {
            props: {
                level: {
                    maximum: 6,
                    minimum: 1,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        }
    }
};
const $233241c76f2a61c7$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $233241c76f2a61c7$export$cbf8224b64e0d942 = {
    props: {
        attrs: [
            {
                props: {
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $233241c76f2a61c7$export$16b353b2649bd8d9 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        }
    }
};
const $233241c76f2a61c7$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$ab76e7c03cd6f650 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                valign: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'top',
                        'middle',
                        'bottom'
                    ]
                },
                width: {
                    maximum: 100,
                    minimum: 0,
                    type: 'number'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'panel_c1'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        }
    }
};
const $233241c76f2a61c7$export$b3b6a70a7fa4a5be = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'layoutColumn'
            ],
            maxItems: 3,
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                'breakout'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        }
    }
};
const $233241c76f2a61c7$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'layoutColumn'
                ],
                maxItems: 3,
                minItems: 2,
                type: 'array'
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            attrs: {
                optional: true,
                props: {
                    columnRuleStyle: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'solid'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    }
                }
            },
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'layoutColumn'
                ],
                maxItems: 5,
                minItems: 1,
                type: 'array'
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$9c30223ca0a664fb = {
    props: {
        attrs: {
            props: {
                collection: {
                    optional: true,
                    type: 'string'
                },
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                id: {
                    optional: true,
                    type: 'string'
                },
                occurrenceKey: {
                    optional: true,
                    type: 'string'
                },
                title: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        }
    }
};
const $233241c76f2a61c7$export$76c7e83ecc9cdf05 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_font_size',
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        }
    }
};
const $233241c76f2a61c7$export$987d49ffe1b0900f = {
    props: {
        attrs: [
            {
                props: {
                    alt: {
                        optional: true,
                        type: 'string'
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        optional: true,
                        type: 'number'
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    occurrenceKey: {
                        minLength: 1,
                        optional: true,
                        type: 'string'
                    },
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    width: {
                        optional: true,
                        type: 'number'
                    }
                }
            },
            {
                props: {
                    alt: {
                        optional: true,
                        type: 'string'
                    },
                    height: {
                        optional: true,
                        type: 'number'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    url: {
                        type: 'string'
                    },
                    width: {
                        optional: true,
                        type: 'number'
                    }
                }
            }
        ],
        marks: {
            items: [
                [
                    'dataConsumer',
                    'link',
                    'annotation',
                    'border'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $233241c76f2a61c7$export$2855e964765eac9 = {
    props: {
        content: {
            allowUnsupportedBlock: true,
            items: [
                'media'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        }
    }
};
const $233241c76f2a61c7$export$38bab695e3f720f1 = {
    props: {
        attrs: {
            props: {
                alt: {
                    optional: true,
                    type: 'string'
                },
                collection: {
                    type: 'string'
                },
                data: {
                    optional: true,
                    type: 'object'
                },
                height: {
                    optional: true,
                    type: 'number'
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                type: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ]
                },
                url: {
                    optional: true,
                    type: 'string'
                },
                width: {
                    optional: true,
                    type: 'number'
                }
            }
        },
        marks: {
            items: [
                [
                    'dataConsumer',
                    'link',
                    'annotation',
                    'border'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        }
    }
};
const $233241c76f2a61c7$export$969fe3781ca15058 = {
    props: {
        attrs: [
            {
                props: {
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    width: {
                        maximum: 100,
                        minimum: 0,
                        optional: true,
                        type: 'number'
                    },
                    widthType: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'percentage'
                        ]
                    }
                }
            },
            {
                props: {
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    width: {
                        minimum: 0,
                        type: 'number'
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    }
                }
            }
        ],
        marks: {
            items: [
                'link'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        }
    }
};
const $233241c76f2a61c7$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                maxItems: 2,
                minItems: 1,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'media'
                ],
                maxItems: 1,
                minItems: 1,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'media'
                ],
                maxItems: 1,
                minItems: 1,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$db83999c14438df4 = {
    props: {
        attrs: {
            props: {
                accessLevel: {
                    optional: true,
                    type: 'string'
                },
                id: {
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    optional: true,
                    type: 'string'
                },
                userType: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ]
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        }
    }
};
const $233241c76f2a61c7$export$c3c04d555a8b9013 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            items: [
                'extensionFrame'
            ],
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        }
    }
};
const $233241c76f2a61c7$export$78421d8497ebdea6 = [
    'multiBodiedExtension',
    {
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$63cadbf5f4296627 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                title: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: 'nestedExpand_content',
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        }
    },
    required: [
        'content'
    ]
};
const $233241c76f2a61c7$export$9584f52f3ebd5d7e = {
    allowUnsupportedBlock: true,
    items: [
        [
            'paragraph_with_no_marks',
            'paragraph_with_font_size',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote',
            'extension_with_marks'
        ]
    ],
    minItems: 1,
    type: 'array'
};
const $233241c76f2a61c7$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'paragraph_with_font_size',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $233241c76f2a61c7$export$a5dc81035676e7a = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                order: {
                    minimum: 0,
                    optional: true,
                    type: 'number'
                }
            }
        },
        content: {
            items: [
                'listItem'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        }
    }
};
const $233241c76f2a61c7$export$21f42ab9b6679f44 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                panelColor: {
                    optional: true,
                    type: 'string'
                },
                panelIcon: {
                    optional: true,
                    type: 'string'
                },
                panelIconId: {
                    optional: true,
                    type: 'string'
                },
                panelIconText: {
                    optional: true,
                    type: 'string'
                },
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'decisionList',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        }
    }
};
const $233241c76f2a61c7$export$a08c7bcc7e61d424 = [
    'panel',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'paragraph_with_font_size',
                        'heading_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'blockCard',
                        'mediaGroup',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'taskList',
                        'rule',
                        'decisionList',
                        'extension_with_marks',
                        'table'
                    ]
                ],
                minItems: 1,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$76e58fb94da2bf88 = [
    'panel',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'paragraph_with_font_size',
                        'heading_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'blockCard',
                        'mediaGroup',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'taskList',
                        'rule',
                        'decisionList',
                        'extension_with_marks',
                        'table'
                    ]
                ],
                minItems: 1,
                type: 'array'
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$9388c8efa26ea154 = [
    'panel',
    {
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$9c206ddddb32a9b = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        }
    }
};
const $233241c76f2a61c7$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                items: [
                    [
                        'fontSize',
                        'alignment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$f745a1f9fa5e1ca8 = [
    'paragraph',
    {
        props: {
            marks: {
                items: [
                    'fontSize'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                items: [
                    [
                        'fontSize',
                        'indentation'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$c7187bbd1a7a9244 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        }
    }
};
const $233241c76f2a61c7$export$fbeb3a3956e8a3c7 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
const $233241c76f2a61c7$export$5bc14ade5ae67510 = [
    'rule',
    {
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$471f7ae5c4103ae1 = {
    props: {
        attrs: {
            props: {
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                style: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        }
    }
};
const $233241c76f2a61c7$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $233241c76f2a61c7$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $233241c76f2a61c7$export$b3401ee80eb31041 = {
    props: {
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        }
    }
};
const $233241c76f2a61c7$export$faab0ca9701d7048 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                resourceId: {
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'breakout'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'syncBlock'
            ]
        }
    }
};
const $233241c76f2a61c7$export$9852986a3ec5f6a0 = {
    props: {
        attrs: {
            optional: true,
            props: {
                displayMode: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ]
                },
                isNumberColumnEnabled: {
                    optional: true,
                    type: 'boolean'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                width: {
                    optional: true,
                    type: 'number'
                }
            }
        },
        content: {
            items: [
                'tableRow'
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                'fragment'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        }
    }
};
const $233241c76f2a61c7$export$e1e720e5f4603e6a = {
    props: {
        attrs: {
            optional: true,
            props: {
                background: {
                    optional: true,
                    type: 'string'
                },
                colspan: {
                    optional: true,
                    type: 'number'
                },
                colwidth: {
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true,
                    type: 'array'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                rowspan: {
                    optional: true,
                    type: 'number'
                },
                valign: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'top',
                        'middle',
                        'bottom'
                    ]
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        }
    },
    required: [
        'content'
    ]
};
const $233241c76f2a61c7$export$48884d2a5190dc73 = {
    props: {
        attrs: {
            optional: true,
            props: {
                background: {
                    optional: true,
                    type: 'string'
                },
                colspan: {
                    optional: true,
                    type: 'number'
                },
                colwidth: {
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true,
                    type: 'array'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                rowspan: {
                    optional: true,
                    type: 'number'
                },
                valign: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'top',
                        'middle',
                        'bottom'
                    ]
                }
            }
        },
        content: {
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        }
    },
    required: [
        'content'
    ]
};
const $233241c76f2a61c7$export$ce666bf02318c957 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ],
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        }
    }
};
const $233241c76f2a61c7$export$6d8b0ef52e2e6390 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        }
    }
};
const $233241c76f2a61c7$export$375b6afcc5f4d291 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'taskItem',
                    'taskList',
                    'blockTaskItem'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        }
    }
};
const $233241c76f2a61c7$export$6f093cfa640b7166 = {
    props: {
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        text: {
            minLength: 1,
            type: 'string'
        },
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        }
    }
};
const $233241c76f2a61c7$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                items: [
                    'link'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $233241c76f2a61c7$export$32f78bffcd82ff28 = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        }
    }
};
const $233241c76f2a61c7$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};
module.exports["alignment"] = $233241c76f2a61c7$export$8e53000a4ec837;
module.exports["annotation"] = $233241c76f2a61c7$export$8512c9afa7b24c3b;
module.exports["backgroundColor"] = $233241c76f2a61c7$export$8c5a050822fd698c;
module.exports["block_content"] = $233241c76f2a61c7$export$a31afb40076fa18b;
module.exports["blockCard"] = $233241c76f2a61c7$export$c4c2f833baaebdb8;
module.exports["blockquote"] = $233241c76f2a61c7$export$67dc04e652a298ca;
module.exports["blockRootOnly"] = $233241c76f2a61c7$export$ebb5393736e9ba23;
module.exports["blockTaskItem"] = $233241c76f2a61c7$export$16018c61064a18df;
module.exports["bodiedExtension"] = $233241c76f2a61c7$export$27903d543b563e39;
module.exports["bodiedExtension_root_only"] = $233241c76f2a61c7$export$b7a532f6e202d8ea;
module.exports["bodiedExtension_with_marks"] = $233241c76f2a61c7$export$ee052cc5b2356e83;
module.exports["bodiedSyncBlock"] = $233241c76f2a61c7$export$e92c7e4302dd4371;
module.exports["border"] = $233241c76f2a61c7$export$1edee58a52776cd9;
module.exports["breakout"] = $233241c76f2a61c7$export$89015c65f1c75e3f;
module.exports["bulletList"] = $233241c76f2a61c7$export$a140c94e5ea26bee;
module.exports["caption"] = $233241c76f2a61c7$export$8e3c2dfdc4f0453d;
module.exports["code"] = $233241c76f2a61c7$export$6565f9f03506010b;
module.exports["codeBlock"] = $233241c76f2a61c7$export$7bb0d5c671655cc4;
module.exports["codeBlock_root_only"] = $233241c76f2a61c7$export$38d90d1aac6883a3;
module.exports["confluenceInlineComment"] = $233241c76f2a61c7$export$f3b72f8fc4684ecd;
module.exports["dataConsumer"] = $233241c76f2a61c7$export$3024f02c495408d6;
module.exports["date"] = $233241c76f2a61c7$export$324d90190a8b822a;
module.exports["decisionItem"] = $233241c76f2a61c7$export$6959e16eeff859b4;
module.exports["decisionList"] = $233241c76f2a61c7$export$62d45a65fb43d95e;
module.exports["doc"] = $233241c76f2a61c7$export$2a111da947c407d2;
module.exports["em"] = $233241c76f2a61c7$export$c63c6f932822f543;
module.exports["embedCard"] = $233241c76f2a61c7$export$be4283d9a1cb1ff6;
module.exports["emoji"] = $233241c76f2a61c7$export$a19185d1233fc4b2;
module.exports["expand"] = $233241c76f2a61c7$export$9f77e0932fb78f72;
module.exports["expand_root_only"] = $233241c76f2a61c7$export$b2817c6954dd6d2c;
module.exports["extension"] = $233241c76f2a61c7$export$1b45514b112dd749;
module.exports["extension_root_only"] = $233241c76f2a61c7$export$8eba3df128e25335;
module.exports["extension_with_marks"] = $233241c76f2a61c7$export$15be7c145cec614a;
module.exports["extensionFrame"] = $233241c76f2a61c7$export$4fdcae991fd743e7;
module.exports["fontSize"] = $233241c76f2a61c7$export$85e3c3ca0c6fb93;
module.exports["fragment"] = $233241c76f2a61c7$export$f00aeb236b6f05af;
module.exports["hardBreak"] = $233241c76f2a61c7$export$371da9dd35aba193;
module.exports["heading"] = $233241c76f2a61c7$export$46e4a324ac90507f;
module.exports["heading_with_alignment"] = $233241c76f2a61c7$export$c17edf9af655deaf;
module.exports["heading_with_indentation"] = $233241c76f2a61c7$export$1902f9737466a0dc;
module.exports["heading_with_no_marks"] = $233241c76f2a61c7$export$7b491e75f1be9278;
module.exports["indentation"] = $233241c76f2a61c7$export$480c699bd4ec0d86;
module.exports["inline_content"] = $233241c76f2a61c7$export$e23e6162adaa368d;
module.exports["inlineCard"] = $233241c76f2a61c7$export$cbf8224b64e0d942;
module.exports["inlineExtension"] = $233241c76f2a61c7$export$16b353b2649bd8d9;
module.exports["inlineExtension_with_marks"] = $233241c76f2a61c7$export$e37f10815f36843d;
module.exports["layoutColumn"] = $233241c76f2a61c7$export$ab76e7c03cd6f650;
module.exports["layoutSection"] = $233241c76f2a61c7$export$b3b6a70a7fa4a5be;
module.exports["layoutSection_full"] = $233241c76f2a61c7$export$941b63fbd931e449;
module.exports["layoutSection_with_single_column"] = $233241c76f2a61c7$export$e0e9834198e8601d;
module.exports["link"] = $233241c76f2a61c7$export$9c30223ca0a664fb;
module.exports["listItem"] = $233241c76f2a61c7$export$76c7e83ecc9cdf05;
module.exports["media"] = $233241c76f2a61c7$export$987d49ffe1b0900f;
module.exports["mediaGroup"] = $233241c76f2a61c7$export$2855e964765eac9;
module.exports["mediaInline"] = $233241c76f2a61c7$export$38bab695e3f720f1;
module.exports["mediaSingle"] = $233241c76f2a61c7$export$969fe3781ca15058;
module.exports["mediaSingle_caption"] = $233241c76f2a61c7$export$68b0ead306f9670f;
module.exports["mediaSingle_full"] = $233241c76f2a61c7$export$f7fd577406abd5f8;
module.exports["mention"] = $233241c76f2a61c7$export$db83999c14438df4;
module.exports["multiBodiedExtension"] = $233241c76f2a61c7$export$c3c04d555a8b9013;
module.exports["multiBodiedExtension_root_only"] = $233241c76f2a61c7$export$78421d8497ebdea6;
module.exports["nestedExpand"] = $233241c76f2a61c7$export$63cadbf5f4296627;
module.exports["nestedExpand_content"] = $233241c76f2a61c7$export$9584f52f3ebd5d7e;
module.exports["nestedExpand_with_no_marks"] = $233241c76f2a61c7$export$b756fc994eb0bc4f;
module.exports["non_nestable_block_content"] = $233241c76f2a61c7$export$ed866000601e7fa5;
module.exports["orderedList"] = $233241c76f2a61c7$export$a5dc81035676e7a;
module.exports["panel"] = $233241c76f2a61c7$export$21f42ab9b6679f44;
module.exports["panel_c1"] = $233241c76f2a61c7$export$a08c7bcc7e61d424;
module.exports["panel_c1_root_only"] = $233241c76f2a61c7$export$76e58fb94da2bf88;
module.exports["panel_root_only"] = $233241c76f2a61c7$export$9388c8efa26ea154;
module.exports["paragraph"] = $233241c76f2a61c7$export$9c206ddddb32a9b;
module.exports["paragraph_with_alignment"] = $233241c76f2a61c7$export$9ca11c06877e5c64;
module.exports["paragraph_with_font_size"] = $233241c76f2a61c7$export$f745a1f9fa5e1ca8;
module.exports["paragraph_with_indentation"] = $233241c76f2a61c7$export$a3bd66932996fb7d;
module.exports["paragraph_with_no_marks"] = $233241c76f2a61c7$export$f06f75eb1e56b0c5;
module.exports["placeholder"] = $233241c76f2a61c7$export$c7187bbd1a7a9244;
module.exports["rule"] = $233241c76f2a61c7$export$fbeb3a3956e8a3c7;
module.exports["rule_root_only"] = $233241c76f2a61c7$export$5bc14ade5ae67510;
module.exports["status"] = $233241c76f2a61c7$export$471f7ae5c4103ae1;
module.exports["strike"] = $233241c76f2a61c7$export$4899a95d70ec5056;
module.exports["strong"] = $233241c76f2a61c7$export$59ae2c325a998f89;
module.exports["subsup"] = $233241c76f2a61c7$export$b3401ee80eb31041;
module.exports["syncBlock"] = $233241c76f2a61c7$export$faab0ca9701d7048;
module.exports["table"] = $233241c76f2a61c7$export$9852986a3ec5f6a0;
module.exports["tableCell"] = $233241c76f2a61c7$export$e1e720e5f4603e6a;
module.exports["tableHeader"] = $233241c76f2a61c7$export$48884d2a5190dc73;
module.exports["tableRow"] = $233241c76f2a61c7$export$ce666bf02318c957;
module.exports["taskItem"] = $233241c76f2a61c7$export$6d8b0ef52e2e6390;
module.exports["taskList"] = $233241c76f2a61c7$export$375b6afcc5f4d291;
module.exports["text"] = $233241c76f2a61c7$export$6f093cfa640b7166;
module.exports["text_code_inline"] = $233241c76f2a61c7$export$5008c13f04d544f6;
module.exports["text_formatted"] = $233241c76f2a61c7$export$d24a7becb4e0da7c;
module.exports["text_link_inline"] = $233241c76f2a61c7$export$2a9d18d5b3064e6c;
module.exports["text_with_no_marks"] = $233241c76f2a61c7$export$437a3d96346717e0;
module.exports["textColor"] = $233241c76f2a61c7$export$32f78bffcd82ff28;
module.exports["underline"] = $233241c76f2a61c7$export$425327af25286e5e;

});

parcelRegister("1H5A4", function(module, exports) {

var $krYZG = parcelRequire("krYZG");

const $fb2736ae9a391b13$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $fb2736ae9a391b13$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fb2736ae9a391b13$var$sanitizeMarks = (marks = [])=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $fb2736ae9a391b13$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $fb2736ae9a391b13$var$sanitizeAttributes = (attrs = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$fb2736ae9a391b13$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $fb2736ae9a391b13$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $krYZG.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $fb2736ae9a391b13$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $fb2736ae9a391b13$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $krYZG.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $fb2736ae9a391b13$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $krYZG.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $krYZG.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $krYZG.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $fb2736ae9a391b13$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$fb2736ae9a391b13$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $fb2736ae9a391b13$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $fb2736ae9a391b13$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $fb2736ae9a391b13$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $fb2736ae9a391b13$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $krYZG.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $fb2736ae9a391b13$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $fb2736ae9a391b13$var$trackUnsupportedContentTooltipActionFor((0, $krYZG.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};
module.exports["findAndTrackUnsupportedContentNodes"] = $fb2736ae9a391b13$export$d343369b8f25914;
module.exports["fireUnsupportedEvent"] = $fb2736ae9a391b13$export$e1051b410945e4d4;
module.exports["trackUnsupportedContentTooltipDisplayedFor"] = $fb2736ae9a391b13$export$3a34598135e7219b;

});

parcelRegister("3BY7M", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $4XbfY = parcelRequire("4XbfY");


var $eNbr2 = parcelRequire("eNbr2");

var $jB2jW = parcelRequire("jB2jW");


var $fTrZV = parcelRequire("fTrZV");

var $fghmm = parcelRequire("fghmm");

var $KTiWz = parcelRequire("KTiWz");

var $dUm2W = parcelRequire("dUm2W");




var $lzgC6 = parcelRequire("lzgC6");

const $2cfb903159881be7$export$9ac3d19711324187 = (0, $lzgC6.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});



var $fqVYq = parcelRequire("fqVYq");


var $lOiVq = parcelRequire("lOiVq");


var $8dxef = parcelRequire("8dxef");


var $d5JQX = parcelRequire("d5JQX");


var $hiQdW = parcelRequire("hiQdW");


var $5vSgR = parcelRequire("5vSgR");


var $fS38i = parcelRequire("fS38i");





var $1hQ0e = parcelRequire("1hQ0e");


var $cwk3g = parcelRequire("cwk3g");

var $3iED4 = parcelRequire("3iED4");

var $65DP2 = parcelRequire("65DP2");

var $fHjdT = parcelRequire("fHjdT");

var $b6MPO = parcelRequire("b6MPO");




const $015afeb094e0a6a9$export$3325eba9424d3c32 = (options = {})=>{
    const { stabilityWaitTime: stabilityWaitTime = 200, maxStabilityWaitTime: maxStabilityWaitTime = 10000 } = options;
    const stabilityTimeoutRef = (0, $cozmU.useRef)(null);
    const resizeObserverRef = (0, $cozmU.useRef)(null);
    const lastStableTimeRef = (0, $cozmU.useRef)(0);
    const onStableCallbackRef = (0, $cozmU.useRef)(null);
    const cleanup = (0, $cozmU.useCallback)(()=>{
        if (stabilityTimeoutRef.current) {
            clearTimeout(stabilityTimeoutRef.current);
            stabilityTimeoutRef.current = null;
        }
        if (resizeObserverRef.current) {
            resizeObserverRef.current.disconnect();
            resizeObserverRef.current = null;
        }
        onStableCallbackRef.current = null;
        lastStableTimeRef.current = 0;
    }, []);
    const scheduleStabilityCheck = (0, $cozmU.useCallback)(()=>{
        // Clear any existing stability timeout.
        if (stabilityTimeoutRef.current) {
            clearTimeout(stabilityTimeoutRef.current);
            stabilityTimeoutRef.current = null;
        }
        // Check if we've exceeded the maximum stability wait time.
        const now = Date.now();
        if (lastStableTimeRef.current === 0) lastStableTimeRef.current = now;
        else if (now - lastStableTimeRef.current > maxStabilityWaitTime) {
            // We've waited too long for stability, call the callback now.
            if (onStableCallbackRef.current) {
                onStableCallbackRef.current();
                cleanup();
            }
            return;
        }
        // Set a timeout to call the callback after the stability wait time.
        stabilityTimeoutRef.current = setTimeout(()=>{
            if (onStableCallbackRef.current) {
                onStableCallbackRef.current();
                cleanup();
            }
        }, stabilityWaitTime);
    }, [
        stabilityWaitTime,
        maxStabilityWaitTime,
        cleanup
    ]);
    const waitForStability = (0, $cozmU.useCallback)((container, onStable)=>{
        // Clean up any existing observer
        cleanup();
        // Store the callback
        onStableCallbackRef.current = onStable;
        // Check if ResizeObserver is available
        if (typeof ResizeObserver === 'undefined') {
            // Fallback: just call the callback after the stability wait time
            stabilityTimeoutRef.current = setTimeout(()=>{
                if (onStableCallbackRef.current) {
                    onStableCallbackRef.current();
                    cleanup();
                }
            }, stabilityWaitTime);
            return;
        }
        // Create a ResizeObserver to monitor the container for size changes.
        resizeObserverRef.current = new ResizeObserver(()=>{
            // Container size changed, reset stability timer.
            scheduleStabilityCheck();
        });
        resizeObserverRef.current.observe(container);
        // Start the initial stability check
        scheduleStabilityCheck();
    }, [
        stabilityWaitTime,
        scheduleStabilityCheck,
        cleanup
    ]);
    return {
        waitForStability: waitForStability,
        cleanup: cleanup
    };
};


const $fd7707a93bd981d3$export$81bdbc2b3f1c95ef = (containerRef, adfDoc, scrollToBlock)=>{
    const { waitForStability: waitForStability, cleanup: cleanupStability } = (0, $015afeb094e0a6a9$export$3325eba9424d3c32)({
        stabilityWaitTime: 750,
        maxStabilityWaitTime: 10000
    });
    (0, $cozmU.useEffect)(()=>{
        // Only run in browser environment.
        if (typeof window === 'undefined' || !containerRef?.current) return;
        // Parse hash fragment for block ID (format: #block-{localId}).
        const hash = window.location.hash;
        const defaultPrefixWithHash = `#${(0, $cwk3g.DEFAULT_BLOCK_LINK_HASH_PREFIX)}`;
        const blockId = hash && hash.startsWith(defaultPrefixWithHash) ? hash.slice(defaultPrefixWithHash.length) : null;
        if (!blockId) return;
        let retryCount = 0;
        const maxRetries = 40;
        const retryInterval = 250;
        let intervalId = null;
        let hasScrolled = false;
        let cancelExpandAndScroll = null;
        const scrollToElement = ()=>{
            // Step 1: Search the ADF document for the node with the given blockId.
            // This works even if the node is hidden inside a collapsed expand.
            if (!adfDoc || !containerRef?.current) return false;
            const nodeWithExpandParents = (0, $3iED4.findNodeWithExpandParents)(adfDoc, blockId);
            if (!nodeWithExpandParents) // Node not found in ADF document.
            return false;
            const { expandParentLocalIds: expandParentLocalIds } = nodeWithExpandParents;
            // Step 2: If the node has expand parents, we need to expand them first.
            if (expandParentLocalIds.length > 0) {
                // Find the expand elements in the DOM using their localIds.
                // Note: We need to expand from outermost to innermost.
                let allExpandsFound = true;
                let anyExpandsCollapsed = false;
                for (const expandLocalId of expandParentLocalIds){
                    const expandContainer = containerRef.current.querySelector(`[data-local-id="${expandLocalId}"]`);
                    if (!expandContainer) {
                        // Expand not found in DOM yet (shouldn't happen but handle it).
                        allExpandsFound = false;
                        break;
                    }
                    // Check if this expand is collapsed.
                    if ((0, $b6MPO.isExpandCollapsed)(expandContainer)) {
                        anyExpandsCollapsed = true;
                        // Expand it.
                        (0, $65DP2.expandElement)(expandContainer);
                        // After expanding, we need to retry to handle nested expands.
                        // The DOM needs time to update.
                        return false; // Will retry after interval.
                    }
                }
                if (!allExpandsFound) // Retry later when expands are in DOM.
                return false;
                // All parent expands are now open (or we just expanded one and need to wait).
                if (anyExpandsCollapsed) // Just expanded something, wait for DOM update.
                return false;
            }
            // Step 3: Now the target element should be visible in the DOM, find it and scroll.
            const element = (0, $fHjdT.getLocalIdSelector)(blockId, containerRef.current);
            if (!element) // Element still not in DOM, retry.
            return false;
            // Element found and all parent expands are open! Use the utility to scroll.
            // (This will handle any final edge cases and do the actual scrolling).
            // Capture cleanup function to cancel pending timeouts.
            cancelExpandAndScroll = (0, $3iED4.expandAllParentsThenScroll)(element, 0, (el)=>{
                if (scrollToBlock) scrollToBlock(el);
                else el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
            return true;
        };
        const performScroll = ()=>{
            if (hasScrolled) return;
            // Try to scroll to element.
            if (scrollToElement()) {
                hasScrolled = true;
                cleanup();
            }
        };
        const attemptScroll = ()=>{
            retryCount++;
            // Try to find the element first.
            if (!adfDoc || !containerRef?.current) return false;
            const nodeWithExpandParents = (0, $3iED4.findNodeWithExpandParents)(adfDoc, blockId);
            if (!nodeWithExpandParents) return false;
            const { expandParentLocalIds: expandParentLocalIds } = nodeWithExpandParents;
            // Check if all expands are expanded and element exists.
            let allReady = true;
            if (expandParentLocalIds.length > 0) for (const expandLocalId of expandParentLocalIds){
                const expandContainer = containerRef.current.querySelector(`[data-local-id="${expandLocalId}"]`);
                if (!expandContainer) {
                    allReady = false;
                    break;
                }
                if ((0, $b6MPO.isExpandCollapsed)(expandContainer)) {
                    (0, $65DP2.expandElement)(expandContainer);
                    allReady = false;
                    break;
                }
            }
            const element = (0, $fHjdT.getLocalIdSelector)(blockId, containerRef.current);
            if (!element) allReady = false;
            // If everything is ready, start monitoring for stability.
            if (allReady) {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
                waitForStability(containerRef.current, performScroll);
                return true;
            }
            // Stop retrying if we've exceeded max retries.
            if (retryCount >= maxRetries) {
                cleanup();
                return false;
            }
            return false;
        };
        const cleanup = ()=>{
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
            cleanupStability();
            // Cancel any pending expand and scroll operations.
            if (cancelExpandAndScroll) {
                cancelExpandAndScroll();
                cancelExpandAndScroll = null;
            }
        };
        // Try to scroll immediately.
        if (attemptScroll()) return cleanup;
        if ((0, $1hQ0e.getDocument)()?.readyState === 'complete') // Document is already ready, try a few more times with delays.
        // This handles cases where elements are added after document ready.
        intervalId = setInterval(()=>{
            attemptScroll();
        }, retryInterval);
        else // Document not ready yet, wait for it and then retry.
        intervalId = setInterval(()=>{
            if ((0, $1hQ0e.getDocument)()?.readyState === 'complete') attemptScroll();
            else if (retryCount >= maxRetries) cleanup();
            else retryCount++;
        }, retryInterval);
        // Cleanup function.
        return cleanup;
    // Intentionally not including adfDoc in the dependency array to avoid unnecessary re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        containerRef,
        waitForStability,
        cleanupStability,
        scrollToBlock
    ]);
};



var $ajhUs = parcelRequire("ajhUs");

var $6pnwK = parcelRequire("6pnwK");

var $jj5K7 = parcelRequire("jj5K7");


var $iDrrr = parcelRequire("iDrrr");


var $iTJtk = parcelRequire("iTJtk");


var $eq1BO = parcelRequire("eq1BO");


var $krYZG = parcelRequire("krYZG");


var $3ppaK = parcelRequire("3ppaK");


var $iwjSV = parcelRequire("iwjSV");


var $8MoFC = parcelRequire("8MoFC");

var $j9MAI = parcelRequire("j9MAI");


var $grAaA = parcelRequire("grAaA");


var $cY9xy = parcelRequire("cY9xy");





var $g9ZnD = parcelRequire("g9ZnD");

var $gIMcb = parcelRequire("gIMcb");








var $ieeJu = parcelRequire("ieeJu");

const $1f8729631b28776d$var$getMediaClientConfigForRenderer = (provider)=>{
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    return provider.viewAndUploadMediaClientConfig && (0, $iDrrr.fg)('platform_media_video_captions') && (0, $iDrrr.fg)('platform_editor_video_caption_commit') ? provider.viewAndUploadMediaClientConfig : provider.viewMediaClientConfig;
};
const $1f8729631b28776d$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $cozmU.useState)(()=>(0, $ieeJu.expValEquals)('platform_editor_media_reliability_enhancements', 'isEnabled', true) ? ssr?.config : undefined);
    const providerFactory = (0, $jB2jW.useProviderFactory)();
    const mediaProvider = (0, $jB2jW.useProviderLayout)('mediaProvider');
    /**
   * Whether this renderer has its own media provider and should never inherit
   * the mediaClient from a parent renderer's context.
   *
   * We use providerFactory.hasProvider() rather and checking the mediaProvider
   * state value, because useProviderLayout subscribes via useLayoutEffect —
   * meaning mediaProvider state is always undefined on the first render, even
   * if the ProviderFactory already has a provider registered. This would cause
   * shouldSkipContext to be false on the first render, incorrectly allowing the
   * inner renderer to inherit the outer renderer's MediaClientContext (which
   * carries the wrong media token for this page).
   *
   * hasProvider() is synchronous and correct from render 1, closing that window.
   */ const shouldSkipContext = (0, $ieeJu.expValEquals)('platform_editor_media_reliability_enhancements', 'isEnabled', true) ? Boolean(ssr?.config || providerFactory.hasProvider('mediaProvider') || mediaProvider) : Boolean(ssr?.config || mediaProvider);
    const contextMediaClient = (0, $cozmU.useContext)((0, $gIMcb.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $cozmU.useMemo)(()=>mediaClientConfig ? (0, $g9ZnD.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    // When the experiment is enabled, use useEffect instead of useLayoutEffect because:
    // - For the ssr.config branch: useState is already initialised with ssr.config, so this
    //   effect is a no-op on first render — the "before paint" guarantee is irrelevant.
    // - For the mediaProvider branch: the actual work happens inside a Promise callback which
    //   resolves asynchronously, so it can never run before paint regardless of which hook
    //   schedules it — useLayoutEffect's guarantee is equally irrelevant here.
    // The legacy path keeps useLayoutEffect to preserve existing behaviour when the experiment is off.
    //
    // The two hooks below are mutually exclusive — only one runs per render — so there is no
    // actual chaining of state updates at runtime. The lint rule cannot statically prove this.
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $ieeJu.expValEquals)('platform_editor_media_reliability_enhancements', 'isEnabled', true)) return;
        if (ssr?.config) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        setMediaClientConfig(ssr.config);
        else if (mediaProvider) {
            let cancelled = false;
            // Cancellation flag prevents setMediaClientConfig from being called after
            // unmount or when mediaProvider changes mid-flight (stale promise fix).
            // No .catch() is needed — the media provider is not expected to reject,
            // and a catch handler would be a no-op anyway.
            mediaProvider.then((provider)=>{
                if (!cancelled) setMediaClientConfig($1f8729631b28776d$var$getMediaClientConfigForRenderer(provider));
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, [
        mediaProvider,
        ssr?.config
    ]);
    // Legacy path (experiment off): keep useLayoutEffect to preserve existing behaviour.
    // remove this when clean up platform_editor_media_reliability_enhancements
    (0, $cozmU.useLayoutEffect)(()=>{
        if ((0, $ieeJu.expValEquals)('platform_editor_media_reliability_enhancements', 'isEnabled', true)) return;
        if (ssr?.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig($1f8729631b28776d$var$getMediaClientConfigForRenderer(provider));
        });
    }, [
        mediaProvider,
        ssr?.config
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gIMcb.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient
    }, children);
};



var $kXCPk = parcelRequire("kXCPk");


var $kS1Yv = parcelRequire("kS1Yv");


var $6FNab = parcelRequire("6FNab");


var $hRnS5 = parcelRequire("hRnS5");


var $iWj7r = parcelRequire("iWj7r");


var $lEb7o = parcelRequire("lEb7o");


var $WNsSX = parcelRequire("WNsSX");


var $jqmxP = parcelRequire("jqmxP");


var $gAjKf = parcelRequire("gAjKf");

/* eslint-disable jsdoc/require-jsdoc -- SSR inline script helpers */ 



var $h9Lux = parcelRequire("h9Lux");





var $2bxao = parcelRequire("2bxao");




function $0ccfa23417744341$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
   * Should only inline this script while SSR,
   * not needed on the client side.
   */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    const shouldSkipScript = {
        table: (0, $iDrrr.fg)('platform-ssr-table-resize')
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
        "data-breakout-script-id": id,
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: $0ccfa23417744341$export$92859d13f30c883e(id, shouldSkipScript)
        },
        "data-testid": "breakout-ssr-inline-script"
    });
}
function $0ccfa23417744341$export$92859d13f30c883e(id, shouldSkipScript) {
    const flags = {
        platform_editor_fix_media_in_renderer: (0, $iDrrr.fg)('platform_editor_fix_media_in_renderer'),
        platform_editor_renderer_extension_width_fix: (0, $ieeJu.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)
    };
    return `(function(window){
if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) { return; }
${$0ccfa23417744341$export$47813c4121c8b4b3};
(${$0ccfa23417744341$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${JSON.stringify(shouldSkipScript)}, ${JSON.stringify(flags)});
})(window);
`;
}
const $0ccfa23417744341$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $h9Lux.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $h9Lux.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $h9Lux.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $h9Lux.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $h9Lux.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $h9Lux.breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, $2bxao.FullPagePadding).toString()};
`;
/**
 * WARNING: NO EXTERNAL FUNCTION CALL IN THIS FUNCTION
 * This function will be put to DOM as an inline script.
 * It can not have any external function dependency.
 * All required data must be passed in as serializable parameters.
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0ccfa23417744341$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldSkipBreakoutScript, flags) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(// eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- inline script runs in browser document context
    document.querySelector(`[data-breakout-script-id="${id}"]`), (elem)=>!!elem.parentElement?.classList.contains('ak-renderer-wrapper'));
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            // Remove with feature gate 'platform-ssr-table-resize'
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                const nodeType = node.dataset.nodeType;
                const widthType = node.dataset.widthType;
                const isMediaSingleWithPixelWidth = nodeType === 'mediaSingle' && widthType === 'pixel';
                const isExtension = nodeType === 'extension' || nodeType === 'bodiedExtension';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode) || // skip apply width styling to mediaSingle node with pixel width to avoid image size changing
                isMediaSingleWithPixelWidth && flags['platform_editor_fix_media_in_renderer'] || isExtension && flags['platform_editor_renderer_extension_width_fix']) return;
                // When flag is on we are using CSS to calculate the table width thus don't need logic below to set the width and left.
                if (shouldSkipBreakoutScript.table && node.classList.contains('pm-table-container')) return;
                if (node.classList.contains('fabric-editor-breakout-mark')) return;
                // use breakout script for all other types of nodes
                if (node.classList.contains('pm-table-container') && mode === 'custom') {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const rendererWidth = renderer.offsetWidth;
                    const effectiveWidth = rendererWidth - breakoutConsts.padding;
                    width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                } else // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                width = breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, renderer.offsetWidth);
                if (node.style.width === width) return;
                node.style.width = width;
                // Tables require some special logic, as they are not using common css transform approach,
                // because it breaks with sticky headers. This logic is copied from a table node:
                // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                if (node.classList.contains('pm-table-container') && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !renderer.classList.contains('is-full-width')) {
                    const lineLength = breakoutConsts.calcLineLength(breakoutConsts)();
                    const left = lineLength / 2 - parseInt(width) / 2;
                    if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                    else node.style.left = '';
                }
            });
            else if (/**
       * The mutation observer is only called once per added node.
       * The above condition only deals with direct children of <div class="ak-renderer-document" />
       * When it is initially called on the direct children, not all the sub children have loaded.
       * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
       * Thus adding this conditional to deal with all media elements directly.
       */ // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            item.target.dataset.nodeType === MEDIA_NODE_TYPE) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            applyMediaBreakout(item.target, flags);
        });
    });
    const applyMediaBreakout = (card, flags)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override width
        if (isPixelBasedResizing) return;
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width) card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
   * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
   * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
   * That's why window load is necessary.
   *
   * More info:
   * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
   * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
   * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
   */ const disconnect = ()=>{
        observer.disconnect();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('load', disconnect);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('load', disconnect);
}
const $0ccfa23417744341$export$2a0b3eeee3f2ea40 = (0, $h9Lux.breakoutConsts).calcLineLength((0, $h9Lux.breakoutConsts));



var $cOUnF = parcelRequire("cOUnF");


var $6C5HF = parcelRequire("6C5HF");

function $5ab4acf8b40b46e1$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $6C5HF.mediaViewerPopupClass))) return true;
    if (element.classList.contains((0, $cOUnF.fileCardImageViewSelector))) return true;
    return false;
}



var $lxxPS = parcelRequire("lxxPS");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- emotion jsx pragma; go/DSP-18766






const $843f9ff6f4f11f31$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>/*#__PURE__*/ (0, $lOiVq.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${maxHeight}px`,
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            bottom: 0,
            left: 0,
            right: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, #00000000)"}, ${backgroundColor} )`
        }
    });
const $843f9ff6f4f11f31$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $843f9ff6f4f11f31$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: styles
    }, children);
};
class $843f9ff6f4f11f31$export$79ad592494094f07 extends (0, $cozmU.Component) {
    // TODO: DSP-4123 - Quality ticket as elevation.surface will be issue when sits top of modal.
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, #FFFFFF)", children: children } = this.props;
        return /*#__PURE__*/ (0, $lOiVq.jsx)($843f9ff6f4f11f31$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
    constructor(props){
        super(props);
    }
}



var $8Kasn = parcelRequire("8Kasn");

/* eslint-disable @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- emotion jsx pragma; go/DSP-18766







var $4o0zT = parcelRequire("4o0zT");





var $96p1s = parcelRequire("96p1s");


var $7Y8M5 = parcelRequire("7Y8M5");


var $kMQcj = parcelRequire("kMQcj");


var $3qC7n = parcelRequire("3qC7n");


var $cRhiT = parcelRequire("cRhiT");

var $e4nz6 = parcelRequire("e4nz6");

var $g2MiL = parcelRequire("g2MiL");

var $l3s1y = parcelRequire("l3s1y");

var $6U5OC = parcelRequire("6U5OC");

var $k8PFz = parcelRequire("k8PFz");

var $bYPHE = parcelRequire("bYPHE");

var $HdvOc = parcelRequire("HdvOc");


var $9nUB4 = parcelRequire("9nUB4");

var $ab7A2 = parcelRequire("ab7A2");


var $9ECRl = parcelRequire("9ECRl");

var $kas7q = parcelRequire("kas7q");








var $gPrpc = parcelRequire("gPrpc");


var $fmXA0 = parcelRequire("fmXA0");


var $ft6gK = parcelRequire("ft6gK");


var $csUNO = parcelRequire("csUNO");




const $fa5a721f2d81671e$export$8e2864079bc476bd = (appearance, contentMode)=>{
    if (contentMode === 'compact') return 0, $7Y8M5.akEditorFullPageDenseFontSize;
    return appearance && appearance !== 'comment' ? (0, $7Y8M5.akEditorFullPageDefaultFontSize) : 14;
};



var $l4yrE = parcelRequire("l4yrE");

var $k8ZZN = parcelRequire("k8ZZN");





var $anBbz = parcelRequire("anBbz");


var $95bQO = parcelRequire("95bQO");


var $4oVOc = parcelRequire("4oVOc");

function $2d4e6b1f55281137$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2d4e6b1f55281137$var$wrappedMediaBreakoutPoint = 410;
const $2d4e6b1f55281137$var$TELEPOINTER_ID = 'ai-streaming-telepointer';
const $2d4e6b1f55281137$var$tableShadowWidth = 32;
const $2d4e6b1f55281137$var$LAYOUT_BREAKPOINT_RENDERER = 629;
const $2d4e6b1f55281137$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME = 'remix-block-highlight';
// originally defined from packages/editor/editor-plugin-table/src/ui/common-styles.ts
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: tableRowHeight can be moved into `@atlaskit/editor-common/table`
const $2d4e6b1f55281137$var$tableRowHeight = 44;
const $2d4e6b1f55281137$var$isBackgroundClipBrowserFixNeeded = ()=>{
    const browser = (0, $8dxef.getBrowserInfo)();
    return browser.isGecko || browser.isIE || browser.isMac && browser.isChrome;
};
const $2d4e6b1f55281137$var$baseFontStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    font: (0, $csUNO.editorUGCTokensRefreshed)['editor.font.body']
});
const $2d4e6b1f55281137$var$fontSizeStyles = {
    name: "jdulnm",
    styles: ".fabric-editor-font-size{&[data-font-size='small']{font:var(--ak-renderer-editor-font-small-text);}}li:has(> .fabric-editor-font-size[data-font-size='small'])::marker{font:var(--ak-renderer-editor-font-small-text);}"
};
const $2d4e6b1f55281137$var$originalBaseFontLineHeight = {
    name: "1dw7ik1",
    styles: "line-height:1.5rem"
};
// styles are copied from ./style.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage
const $2d4e6b1f55281137$var$baseStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'var(--ak-renderer-base-font-size)',
    color: "var(--ds-text, #292A2E)",
    '--ak-editor--full-width-layout-width': `${(0, $7Y8M5.akEditorFullWidthLayoutWidth)}px`,
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT}::after`]: {
        // we add a clearfix after ak-renderer-document in order to
        // contain internal floats (such as media images that are "wrap-left")
        // to just the renderer (and not spill outside of it)
        content: '""',
        visibility: 'hidden',
        display: 'block',
        height: 0,
        clear: 'both'
    },
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT}`]: {
        [`> [${0, $4oVOc.COLLAPSED_CONTENT_OWNERS_ATTRIBUTE}][hidden='until-found']`]: {
            display: 'block',
            minBlockSize: 0,
            marginBlock: 0,
            paddingBlock: 0,
            borderBlockWidth: 0
        },
        // p, h3, and action items
        [`.${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            height: '22px',
            transform: `translateY(-2px)`
        },
        h1: {
            [`> .mediaInlineView-content-wrap > .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '36px',
                transform: `translateY(-3px)`
            }
        },
        h2: {
            [`> .mediaInlineView-content-wrap > .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '31px',
                transform: `translateY(-3px)`
            }
        },
        h3: {
            [`> .mediaInlineView-content-wrap > .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '25px',
                transform: `translateY(-2px)`
            }
        },
        h4: {
            [`> .mediaInlineView-content-wrap > .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '23px',
                transform: `translateY(-2px)`
            }
        },
        h5: {
            [`> .mediaInlineView-content-wrap > .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '20px',
                transform: `translateY(-2px)`
            }
        },
        h6: {
            [`> .mediaInlineView-content-wrap > .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $kMQcj.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '18px',
                transform: `translateY(-2px)`
            }
        }
    },
    [`& span.akActionMark`]: {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            color: "var(--ds-link, #1868DB)",
            textDecoration: 'underline'
        },
        '&:active': {
            color: "var(--ds-link-pressed, #1558BC)"
        }
    },
    '& span[data-placeholder]': {
        color: "var(--ds-text-subtlest, #6B6E76)"
    }
});
const $2d4e6b1f55281137$var$headingAnchorStylesDuplicateAnchor = /*#__PURE__*/ (0, $lOiVq.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
            position: 'absolute',
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: 'translate(-8px, 0px)',
                    transitionProperty: 'opacity, transform',
                    transitionDuration: `${"var(--ds-duration-medium, 0.2s)"}, ${"var(--ds-duration-medium, 0.2s)"}`,
                    transitionTimingFunction: `${"var(--ds-easing-out-practical, ease)"}, ${"var(--ds-easing-out-practical, ease)"}`,
                    transitionDelay: '0s, 0s'
                }
            },
            '&:hover': {
                [`.${0, $3qC7n.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    '& h1': {
        [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& h2': {
        [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& h3': {
        [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& h4': {
        [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& h5': {
        [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& h6': {
        [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    }
});
const $2d4e6b1f55281137$var$headingAnchorStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    '& .renderer-heading-wrapper': {
        [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: `translate(-8px, 0px)`,
                    transition: `opacity 0.2s ease 0s, transform 0.2s ease 0s`
                }
            },
            '&:hover': {
                [`.${0, $3qC7n.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    // Line-height for heading anchor based on heading level (via data-level attribute on .renderer-heading-wrapper)
    '& .renderer-heading-wrapper[data-level="1"]': {
        [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="2"]': {
        [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="3"]': {
        [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="4"]': {
        [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="5"]': {
        [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="6"]': {
        [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    }
});
const $2d4e6b1f55281137$var$headingAnchorButtonFocusVisibleStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
        'button:focus-visible': {
            outline: `2px solid ${"var(--ds-border-focused, #4688EC)"}`,
            borderRadius: "var(--ds-radius-small, 3px)"
        }
    }
});
const $2d4e6b1f55281137$var$akEditorBreakpointForSmallDevice = '1266px';
const $2d4e6b1f55281137$var$responsiveBreakoutWidth = /*#__PURE__*/ (0, $lOiVq.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - ${(0, $7Y8M5.akEditorGutterPadding)}px * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $7Y8M5.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$2d4e6b1f55281137$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $7Y8M5.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $2d4e6b1f55281137$var$responsiveBreakoutWidthFullWidth = /*#__PURE__*/ (0, $lOiVq.css)({
    '--ak-editor--breakout-container-without-gutter-width': '100cqw',
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $7Y8M5.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$2d4e6b1f55281137$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $7Y8M5.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $2d4e6b1f55281137$var$responsiveBreakoutWidthWithReducedPadding = /*#__PURE__*/ (0, $lOiVq.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $7Y8M5.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$2d4e6b1f55281137$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $7Y8M5.akEditorCalculatedWideLayoutWidth)}px`
    },
    [`@media (max-width: ${0, $7Y8M5.akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)`
    }
});
const $2d4e6b1f55281137$var$hideHeadingCopyLinkWrapperStylesDuplicateAnchor = /*#__PURE__*/ (0, $lOiVq.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $2d4e6b1f55281137$var$hideHeadingCopyLinkWrapperStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    '& .renderer-heading-wrapper': {
        [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $2d4e6b1f55281137$var$rendererFullPageStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $7Y8M5.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 ${(0, $2bxao.FullPagePadding)}px`
});
const $2d4e6b1f55281137$var$rendererFullPageStylesWithReducedPadding = /*#__PURE__*/ (0, $lOiVq.css)({
    '--ak-renderer--full-page-gutter': `${(0, $2bxao.FullPagePadding)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $7Y8M5.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 var(--ak-renderer--full-page-gutter)`,
    [`@media (max-width: ${0, $7Y8M5.akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-renderer--full-page-gutter': `${(0, $7Y8M5.akEditorGutterPaddingReduced)}px`
    }
});
const $2d4e6b1f55281137$var$oldRendererFullWidthStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $7Y8M5.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $2d4e6b1f55281137$var$rendererFullWidthStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $7Y8M5.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"])': {
        width: '100% !important'
    }
});
const $2d4e6b1f55281137$var$oldRendererMaxWidthStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $7Y8M5.akEditorMaxWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $2d4e6b1f55281137$var$rendererMaxWidthStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $7Y8M5.akEditorMaxWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"])': {
        width: '100% !important'
    }
});
const $2d4e6b1f55281137$var$rendererFullWidthStylesForTableResizing = {
    name: "b6n1sl",
    styles: ".pm-table-container{width:100% !important;}"
};
const $2d4e6b1f55281137$var$rovoTelepointerStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`#${$2d4e6b1f55281137$var$TELEPOINTER_ID}`]: {
        display: 'inline-block',
        position: 'relative',
        width: '1.5px',
        height: '24px',
        backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
        marginLeft: "var(--ds-space-025, 2px)",
        '&::after': {
            content: '""',
            position: 'absolute',
            display: 'block',
            top: 0,
            left: 0,
            width: '31.5px',
            height: '15.5px',
            borderRadius: `0px ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
            background: // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/design-system/ensure-design-token-usage
            'linear-gradient(to right, #1868db 0px, #1868db 1.5px, transparent 1.5px) 0 0 / 100% 100% no-repeat, conic-gradient(from 270deg at 50% 50%, #1868db 0deg, #1868db 115deg, #fca700 115deg, #fca700 180deg, #bf63f3 180deg, #bf63f3 310deg, #82b536 310deg, #82b536 359.96deg, #1868db 360deg)'
        },
        '&::before': {
            content: '"Rovo"',
            position: 'absolute',
            fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            color: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-text, #292A2E)",
            top: 1,
            left: 1,
            borderRadius: `0px ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
            zIndex: 1,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '10px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            padding: '0.5px 2.5px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial'
        }
    }
});
const $2d4e6b1f55281137$var$whitespaceSharedStyles = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};
const $2d4e6b1f55281137$var$blockquoteSharedStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $7Y8M5.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});
const $2d4e6b1f55281137$var$headingsSharedStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h1)`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        },
        '&::before': {}
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h2)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h3)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h4)`,
        marginTop: "var(--ds-space-250, 20px)",
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h5)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h6)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as the refreshed typography tokens use font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    }
});
/**
 * When the copy-link a11y fix is enabled, the heading copy-link button is a sibling of the heading
 * text within `.renderer-heading-wrapper`. To ensure the button sits immediately after the last
 * rendered character (including when the heading wraps), the heading itself needs to participate in
 * inline layout.
 *
 * Since inline elements don't support vertical margins in normal flow, we migrate the UGC heading
 * `marginTop` values (from `headingsSharedStyles`) onto the wrapper.
 */ const $2d4e6b1f55281137$var$headingWrapperInlineFlowStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // Ensure heading and copy-link button participate in inline flow so the button sits after the final wrapped line of text.
    '& .renderer-heading-wrapper > h1, & .renderer-heading-wrapper > h2, & .renderer-heading-wrapper > h3, & .renderer-heading-wrapper > h4, & .renderer-heading-wrapper > h5, & .renderer-heading-wrapper > h6': {
        display: 'inline'
    },
    [`& .renderer-heading-wrapper > .${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
        display: 'inline',
        verticalAlign: 'baseline'
    },
    '& .renderer-heading-wrapper[data-level="1"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em'
    },
    '& .renderer-heading-wrapper[data-level="2"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em'
    },
    '& .renderer-heading-wrapper[data-level="3"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em'
    },
    '& .renderer-heading-wrapper[data-level="4"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.25em'
    },
    '& .renderer-heading-wrapper[data-level="5"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em'
    },
    '& .renderer-heading-wrapper[data-level="6"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em'
    }
});
const $2d4e6b1f55281137$var$headingWithAlignmentStylesDuplicateAnchor = {
    name: "sd2n24",
    styles: ".fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;} > h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}"
};
const $2d4e6b1f55281137$var$headingWithAlignmentStyles = {
    name: "1abdc8p",
    styles: ".fabric-editor-block-mark[data-align=\"center\"] > .renderer-heading-wrapper{justify-content:center;}.fabric-editor-block-mark[data-align=\"end\"] > .renderer-heading-wrapper{justify-content:flex-end;}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> .renderer-heading-wrapper:first-child{margin-top:0;}}"
};
const $2d4e6b1f55281137$var$ruleSharedStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    '& hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #0B120E24)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $7Y8M5.akEditorLineHeight)}em 0`,
        height: '2px',
        borderRadius: "var(--ds-radius-full, 9999px)"
    }
});
// When cleaning up `platform_editor_content_mode_button_mvp` simplify the name/ use the other paragraph style name
const $2d4e6b1f55281137$var$paragraphSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $lOiVq.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $7Y8M5.blockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $2d4e6b1f55281137$var$paragraphStylesUGCScaledMargin = /*#__PURE__*/ (0, $lOiVq.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $7Y8M5.scaledBlockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $2d4e6b1f55281137$var$listsSharedStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    /* =============== INDENTATION SPACING ========= */ 'ul, ol': {
        boxSizing: 'border-box',
        paddingLeft: `var(--ed--list--item-counter--padding, ${(0, $g2MiL.listItemCounterPadding)}px)`
    },
    [`${0, $ab7A2.orderedListSelector}, ${0, $9nUB4.bulletListSelector}`]: {
        /*
    Ensures list item content adheres to the list's margin instead
    of filling the entire block row. This is important to allow
    clicking interactive elements which are floated next to a list.
    	For some history and context on this block, see PRs related to tickets.:
    @see ED-6551 - original issue.
    @see ED-7015 - follow up issue.
    @see ED-7447 - flow-root change.
    	used to have display: 'table' in tag template style but not supported in object styles
    removed display: 'table' as 'flow-root' is supported in latest browsers
    	@see https://css-tricks.com/display-flow-root/
    */ display: 'flow-root'
    },
    /* =============== INDENTATION AESTHETICS ========= */ /**
  	We support nested lists up to six levels deep.
  **/ /* LEGACY LISTS */ 'ul, ul ul ul ul': {
        listStyleType: 'disc'
    },
    'ul ul, ul ul ul ul ul': {
        listStyleType: 'circle'
    },
    'ul ul ul, ul ul ul ul ul ul': {
        listStyleType: 'square'
    },
    'ol, ol ol ol ol': {
        listStyleType: 'decimal'
    },
    'ol ol, ol ol ol ol ol': {
        listStyleType: 'lower-alpha'
    },
    'ol ol ol, ol ol ol ol ol ol': {
        listStyleType: 'lower-roman'
    },
    /* PREDICTABLE LISTS */ 'ol[data-indent-level="1"], ol[data-indent-level="4"]': {
        listStyleType: 'decimal'
    },
    'ol[data-indent-level="2"], ol[data-indent-level="5"]': {
        listStyleType: 'lower-alpha'
    },
    'ol[data-indent-level="3"], ol[data-indent-level="6"]': {
        listStyleType: 'lower-roman'
    },
    'ul[data-indent-level="1"], ul[data-indent-level="4"]': {
        listStyleType: 'disc'
    },
    'ul[data-indent-level="2"], ul[data-indent-level="5"]': {
        listStyleType: 'circle'
    },
    'ul[data-indent-level="3"], ul[data-indent-level="6"]': {
        listStyleType: 'square'
    }
});
/*
	Firefox does not handle empty block element inside li tag.
	If there is not block element inside li tag,
	then firefox sets inherited height to li
	However, if there is any block element and if it's empty
	(or has empty inline element) then
	firefox sets li tag height to zero.
	More details at
	https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
*/ const $2d4e6b1f55281137$var$listsSharedStylesForGekko = {
    name: "jlg15n",
    styles: "ul, ol{li p:empty, li p > span:empty{display:inline-block;}}"
};
/**
 * Hides list markers for "wrapper items" - list items that only contain nested lists with no other content.
 * These wrapper items have no meaningful content themselves, only nested lists below.
 * Applied when platform_editor_flexible_list_schema experiment is enabled.
 */ const $2d4e6b1f55281137$var$listItemHiddenMarkerStyles = {
    name: "j8szsq",
    styles: "li:has(> ul:only-child), li:has(> ol:only-child){list-style-type:none;margin-top:0;margin-bottom:0;}li:has(> ul:only-child) > ul, li:has(> ol:only-child) > ol{margin-top:0;}div[data-task-list-local-id] > div[data-task-list-local-id]{margin-top:0;}div[data-task-local-id] + div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);}"
};
const $2d4e6b1f55281137$var$indentationSharedStyles = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};
const $2d4e6b1f55281137$var$indentationSharedStylesWithMarginFix = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor-indentation-mark': {
        // Prevent marginTop of p:first-child overrode by batch.css
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        'p:first-child': {
            marginTop: (0, $7Y8M5.blockNodesVerticalMargin)
        }
    }
});
const $2d4e6b1f55281137$var$blockMarksSharedStylesDuplicateAnchor = /*#__PURE__*/ (0, $lOiVq.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.fabric-editor-font-size:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, h1, h2, h3, h4, h5, h6, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        }
    }
});
const $2d4e6b1f55281137$var$blockMarksSharedStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.fabric-editor-font-size:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        },
        '.renderer-heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                'h1, h2, h3, h4, h5, h6': {
                    marginTop: 0
                }
            }
        }
    }
});
const $2d4e6b1f55281137$var$codeMarkSharedStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #0515240F)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #0515240F)"})`,
        color: "var(--ds-text, #292A2E)",
        borderStyle: 'none',
        borderRadius: "var(--ds-radius-small, 3px)",
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});
const $2d4e6b1f55281137$var$extensionStyle = {
    name: "188isfx",
    styles: ".ak-renderer-extension :not(.ak-renderer-extension .ak-renderer-document *, .aui-lozenge, .status-lozenge-span *), .ak-renderer-extension .ak-renderer-document .ak-renderer-extension:not(:has(.ak-renderer-document)) :not(.aui-lozenge, .status-lozenge-span *){font-size:var(--ak-renderer-base-font-size);}"
};
const $2d4e6b1f55281137$var$oldExtensionAsInlineStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} [data-as-inline="on"]`]: {
        display: 'inline-block'
    },
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} .${(0, $96p1s.RendererCssClassName).EXTENSION_AS_INLINE}`]: {
        display: 'inline-block',
        // use !important here because the current width has !important applied to it and it's not working when used in React style prop
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'auto !important',
        marginTop: 0
    },
    [`.${(0, $96p1s.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $96p1s.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
        display: 'inline-block',
        overflowX: 'visible',
        containerType: 'normal'
    },
    [`.${(0, $96p1s.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $96p1s.RendererCssClassName).EXTENSION_INNER_WRAPPER}`]: {
        display: 'inline-block'
    }
});
const $2d4e6b1f55281137$var$extensionAsInlineStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} [data-as-inline="on"]`]: {
        display: 'inline-block'
    },
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} .${(0, $96p1s.RendererCssClassName).EXTENSION_AS_INLINE}`]: {
        display: 'inline-block',
        width: 'auto',
        marginTop: 0
    },
    [`.${(0, $96p1s.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $96p1s.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
        display: 'inline-block',
        overflowX: 'visible',
        containerType: 'normal'
    },
    [`.${(0, $96p1s.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $96p1s.RendererCssClassName).EXTENSION_INNER_WRAPPER}`]: {
        display: 'inline-block'
    }
});
// Removes the blockNodesVerticalMargin styling for inline extensions, i.e. borderless excerpt-include
const $2d4e6b1f55281137$var$inlineExtensionRendererMarginFix = {
    name: "vgr91k",
    styles: ".ak-renderer-document .inline-extension-renderer .ak-renderer-extension{margin-top:0;}"
};
const $2d4e6b1f55281137$var$shadowSharedStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $9ECRl.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $9ECRl.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $9ECRl.shadowClassNames).LEFT_SHADOW}::before, .${(0, $9ECRl.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $7Y8M5.akEditorShadowZIndex),
        width: '8px',
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $9ECRl.shadowClassNames).RIGHT_SHADOW}, .${(0, $9ECRl.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $9ECRl.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $9ECRl.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $kas7q.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $kas7q.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});
const $2d4e6b1f55281137$var$dateSharedStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${(0, $e4nz6.DateSharedCssClassName).DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});
const $2d4e6b1f55281137$var$textColorStyles = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};
const $2d4e6b1f55281137$var$backgroundColorStyles = {
    name: "1rjaz80",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:var(--ds-radius-xsmall, 2px);padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
// Don't show text highlight styling when there is a hyperlink.
// Conditionally applied when the highlight-on-links experiment is off.
const $2d4e6b1f55281137$var$highlightLinksUnsetStyles = {
    name: "1d6748d",
    styles: "a .fabric-background-color-mark{background-color:unset;}"
};
const $2d4e6b1f55281137$export$a365082c2a191514 = {
    name: "nf8qu5",
    styles: ".fabric-background-color-mark:has(.background-color-padding-left){padding-left:var(--ds-space-025, 2px);margin-left:var(--ds-space-negative-025, -2px);}.fabric-background-color-mark:has(.background-color-padding-right){padding-right:var(--ds-space-025, 2px);margin-right:var(--ds-space-negative-025, -2px);}"
};
const $2d4e6b1f55281137$var$tasksAndDecisionsStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    '.ProseMirror': {
        [`.taskItemView-content-wrap,
		.${(0, $HdvOc.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: `${(0, $7Y8M5.akEditorTableCellMinWidth)}px`
        },
        [`.${(0, $HdvOc.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        [`.${(0, $HdvOc.TaskDecisionSharedCssClassName).TASK_CONTAINER}`]: {
            'span[contenteditable="false"]': {
                height: `${(0, $7Y8M5.akEditorLineHeight)}em`
            }
        },
        [`.${(0, $HdvOc.TaskDecisionSharedCssClassName).TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $7Y8M5.akEditorLineHeight)
        }
    },
    'div[data-task-local-id]': {
        'span[contenteditable="false"]': {
            height: `${(0, $7Y8M5.akEditorLineHeight)}em`
        },
        'span[contenteditable="false"] + div': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${(0, $7Y8M5.akEditorLineHeight)}em`
        }
    },
    'div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-150, 12px)",
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        // If task item is not first in the list then set margin top to 4px.
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    /* When action list is inside panel */ '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            margin: '0 0 0 0 !important'
        }
    }
});
const $2d4e6b1f55281137$var$headingPanelStyles = {
    name: "e0for6",
    styles: ".ak-editor-panel__content{> .renderer-heading-wrapper:first-child{margin-top:0;}}"
};
const $2d4e6b1f55281137$var$smartCardStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $6U5OC.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: `${(0, $7Y8M5.blockNodesVerticalMargin)} 0 0`,
        maxWidth: `${760}px`
    }
});
const $2d4e6b1f55281137$var$smartCardStylesAvatarFix = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $6U5OC.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $6U5OC.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */ 'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});
const $2d4e6b1f55281137$var$smartCardStylesAvatarMarginFix = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $6U5OC.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $6U5OC.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        'ul, ol': {
            marginRight: 'inherit'
        }
    }
});
const $2d4e6b1f55281137$var$smartCardStylesAvatarListZeroMarginTop = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $6U5OC.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $6U5OC.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        'ul, ol': {
            marginTop: 0
        }
    }
});
// In Renderer in Jira there is no SmartCardSharedCssClassName.INLINE_CARD_CONTAINER, so using data-inline-cart="true"
const $2d4e6b1f55281137$var$headerSmartCardStyles = {
    name: "qwtpmh",
    styles: "[data-inline-card=\"true\"]{[data-inlinecard-button-overlay=\"icon-wrapper-line-height\"] span{line-height:0;}}"
};
// Flex wrapper for centering without transform (platform_editor_flex_based_centering).
// flex: 1 1 0% + minWidth: 0 so the wrapper takes full width when it's a flex item (full-width nodes otherwise render narrow).
// flexShrink: 0 on child so the node keeps size.
const $2d4e6b1f55281137$var$centerWrapperStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $96p1s.RendererCssClassName).FLEX_CENTER_WRAPPER}`]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '100%',
        flex: '1 1 0%',
        minWidth: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > *': {
            flexShrink: 0
        }
    }
});
const $2d4e6b1f55281137$var$baseOtherStylesDuplicateAnchor = /*#__PURE__*/ (0, $lOiVq.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        borderRadius: "var(--ds-radius-small, 3px)",
        color: "var(--ds-text, #292A2E)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-050, 4px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-050, 4px)",
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        color: "var(--ds-text-danger, #AE2E24)"
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: "var(--ds-space-300, 24px)",
        marginLeft: 0
    },
    [`.${0, $l3s1y.richMediaClassName}.rich-media-wrapped + .${0, $l3s1y.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $l3s1y.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $l3s1y.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $l3s1y.richMediaClassName}.image-align-start,
		.${0, $l3s1y.richMediaClassName}.image-center,
		.${0, $l3s1y.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + .renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                marginTop: "var(--ds-space-100, 8px)"
            }
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $96p1s.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $96p1s.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $96p1s.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $7Y8M5.blockNodesVerticalMargin)}`
        },
        [`.${(0, $96p1s.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER} .${(0, $96p1s.RendererCssClassName).EXTENSION}`]: {
            marginBottom: 0
        },
        /* platform_editor_flex_based_centering: embed card center wrapper has margin; zero MediaSingle vertical margin when wrapped so it doesn't double */ [`.${(0, $96p1s.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} .mediaSingleView-content-wrap`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`.${(0, $96p1s.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $96p1s.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $96p1s.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $96p1s.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $96p1s.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $96p1s.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $kas7q.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $2d4e6b1f55281137$var$hideExtensionStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $96p1s.RendererCssClassName).EXTENSION}:has([data-extension-key='hide'])`]: {
        marginTop: 0
    }
});
const $2d4e6b1f55281137$var$extensionCenterAlignLegacyStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $96p1s.RendererCssClassName).EXTENSION_CENTER_ALIGN}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        }
    }
});
const $2d4e6b1f55281137$var$baseOtherStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        borderRadius: "var(--ds-radius-small, 3px)",
        color: "var(--ds-text, #292A2E)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-050, 4px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-050, 4px)",
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        color: "var(--ds-text-danger, #AE2E24)"
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: "var(--ds-space-300, 24px)",
        marginLeft: 0
    },
    [`.${0, $l3s1y.richMediaClassName}.rich-media-wrapped + .${0, $l3s1y.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $l3s1y.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $l3s1y.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $l3s1y.richMediaClassName}.image-align-start,
		.${0, $l3s1y.richMediaClassName}.image-center,
		.${0, $l3s1y.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + .renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                marginTop: "var(--ds-space-100, 8px)"
            }
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $96p1s.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $96p1s.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $96p1s.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $7Y8M5.blockNodesVerticalMargin)}`
        },
        [`.${(0, $96p1s.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER} .${(0, $96p1s.RendererCssClassName).EXTENSION}`]: {
            marginBottom: 0
        },
        /* platform_editor_flex_based_centering: embed card center wrapper has margin; zero MediaSingle vertical margin when wrapped so it doesn't double */ [`.${(0, $96p1s.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} .mediaSingleView-content-wrap`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`.${(0, $96p1s.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $96p1s.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $96p1s.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $96p1s.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $96p1s.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $96p1s.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $kas7q.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $2d4e6b1f55281137$var$alignedHeadingAnchorStyleDuplicateAnchor = /*#__PURE__*/ (0, $lOiVq.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        'h1, h2, h3, h4, h5, h6': {
            position: 'relative'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
            marginTop: 0,
            marginRight: "var(--ds-space-075, 6px)",
            marginBottom: 0,
            marginLeft: 0,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $3qC7n.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
const $2d4e6b1f55281137$var$alignedHeadingAnchorStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        '.renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                position: 'relative'
            }
        }
    },
    // Center alignment for heading wrapper - flex container needs justify-content instead of text-align
    '.fabric-editor-block-mark[data-align="center"] > .renderer-heading-wrapper': {
        justifyContent: 'center'
    },
    // Right/end alignment for heading wrapper - flex container needs justify-content instead of text-align
    '.fabric-editor-block-mark[data-align="end"] > .renderer-heading-wrapper': {
        justifyContent: 'flex-end'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
            marginTop: 0,
            marginRight: "var(--ds-space-075, 6px)",
            marginBottom: 0,
            marginLeft: 0,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $3qC7n.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
const $2d4e6b1f55281137$var$firstWrappedMediaStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // Remove gap between first wrapped mediaSingle and its fellow wrapped mediaSingle
    [`.${0, $l3s1y.richMediaClassName}[class*="image-wrap-"]:has(+ .${0, $l3s1y.richMediaClassName}[class*="image-wrap-"])`]: {
        marginRight: 0,
        marginLeft: 0
    }
});
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: emotion refactor - there's a mediaSingleSharedNewStyle, but not originally used in the renderer.
const $2d4e6b1f55281137$var$mediaSingleSharedStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${0, $l3s1y.richMediaClassName}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${0, $l3s1y.richMediaClassName}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $l3s1y.richMediaClassName}.image-wrap-right + .${0, $l3s1y.richMediaClassName}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $l3s1y.richMediaClassName}.image-wrap-left + .${0, $l3s1y.richMediaClassName}.image-wrap-right, .${0, $l3s1y.richMediaClassName}.image-wrap-right + .${0, $l3s1y.richMediaClassName}.image-wrap-left, .${0, $l3s1y.richMediaClassName}.image-wrap-left + .${0, $l3s1y.richMediaClassName}.image-wrap-left, .${0, $l3s1y.richMediaClassName}.image-wrap-right + .${0, $l3s1y.richMediaClassName}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$2d4e6b1f55281137$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            marginTop: "var(--ds-space-150, 12px)",
            marginRight: 0,
            marginBottom: "var(--ds-space-150, 12px)",
            marginLeft: 0
        }
    }
});
// was shared between editor-core and renderer
const $2d4e6b1f55281137$var$tableSharedStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // originally from packages/editor/editor-common/src/styles/shared/tableCell.ts
    // Hardcoding the background color for the table cells to avoid the use of inline styles
    'td[colorname="white" i], th[colorname="white" i]': {
        backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`
    },
    'td[colorname="light blue" i], th[colorname="light blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtlest, #E9F2FE)"} !important`
    },
    'td[colorname="light teal" i], th[colorname="light teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtlest, #E7F9FF)"} !important`
    },
    'td[colorname="light green" i], th[colorname="light green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtlest, #DCFFF1)"} !important`
    },
    'td[colorname="light yellow" i], th[colorname="light yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtlest, #FEF7C8)"} !important`
    },
    'td[colorname="light red" i], th[colorname="light red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtlest, #FFECEB)"} !important`
    },
    'td[colorname="light purple" i], th[colorname="light purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtlest, #F8EEFE)"} !important`
    },
    'td[colorname="light gray" i], th[colorname="light gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"} !important`
    },
    'td[colorname="blue" i], th[colorname="blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtler, #CFE1FD)"} !important`
    },
    'td[colorname="teal" i], th[colorname="teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtler, #C6EDFB)"} !important`
    },
    'td[colorname="green" i], th[colorname="green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtler, #BAF3DB)"} !important`
    },
    'td[colorname="yellow" i], th[colorname="yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtler, #F5E989)"} !important`
    },
    'td[colorname="red" i], th[colorname="red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtler, #FFD5D2)"} !important`
    },
    'td[colorname="purple" i], th[colorname="purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtler, #EED7FC)"} !important`
    },
    'td[colorname="gray" i], th[colorname="gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtle, #8C8F97)"} !important`
    },
    'td[colorname="dark blue" i], th[colorname="dark blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtle, #669DF1)"} !important`
    },
    'td[colorname="dark teal" i], th[colorname="dark teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtle, #6CC3E0)"} !important`
    },
    'td[colorname="dark green" i], th[colorname="dark green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtle, #4BCE97)"} !important`
    },
    'td[colorname="dark yellow" i], th[colorname="dark yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtle, #FCA700)"} !important`
    },
    'td[colorname="dark red" i], th[colorname="dark red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtle, #F87168)"} !important`
    },
    'td[colorname="dark purple" i], th[colorname="dark purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtle, #C97CF4)"} !important`
    },
    'td[colorname="subtle lime" i], th[colorname="subtle lime" i]': {
        backgroundColor: `${"var(--ds-background-accent-lime-subtlest, #EFFFD6)"} !important`
    },
    'td[colorname="subtle orange" i], th[colorname="subtle orange" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtlest, #FFF5DB)"} !important`
    },
    'td[colorname="subtle magenta" i], th[colorname="subtle magenta" i]': {
        backgroundColor: `${"var(--ds-background-accent-magenta-subtlest, #FFECF8)"} !important`
    },
    'td[colorname="lime" i], th[colorname="lime" i]': {
        backgroundColor: `${"var(--ds-background-accent-lime-subtler, #D3F1A7)"} !important`
    },
    'td[colorname="orange" i], th[colorname="orange" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtler, #FCE4A6)"} !important`
    },
    'td[colorname="magenta" i], th[colorname="magenta" i]': {
        backgroundColor: `${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"} !important`
    },
    'td[colorname="bold gray" i], th[colorname="bold gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)"} !important`
    },
    'td[colorname="bold blue" i], th[colorname="bold blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)"} !important`
    },
    'td[colorname="bold teal" i], th[colorname="bold teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)"} !important`
    },
    'td[colorname="bold green" i], th[colorname="bold green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtler-hovered, #97EDC9)"} !important`
    },
    'td[colorname="bold lime" i], th[colorname="bold lime" i]': {
        backgroundColor: `${"var(--ds-background-accent-lime-subtler-hovered, #BDE97C)"} !important`
    },
    'td[colorname="bold yellow" i], th[colorname="bold yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)"} !important`
    },
    'td[colorname="bold orange" i], th[colorname="bold orange" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtler-hovered, #FBD779)"} !important`
    },
    'td[colorname="bold red" i], th[colorname="bold red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtler-hovered, #FFB8B2)"} !important`
    },
    'td[colorname="bold magenta" i], th[colorname="bold magenta" i]': {
        backgroundColor: `${"var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)"} !important`
    },
    'td[colorname="bold purple" i], th[colorname="bold purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)"} !important`
    },
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        marginTop: 0,
        marginRight: 'auto',
        marginBottom: "var(--ds-space-200, 16px)",
        marginLeft: 'auto',
        boxSizing: 'border-box',
        /**
     * Fix block top alignment inside table cells.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '.decisionItemView-content-wrap:first-of-type > div': {
            marginTop: 0
        }
    },
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true']`]: {
        paddingLeft: `${(0, $7Y8M5.akEditorTableNumberColumnWidth) - 1}px`,
        clear: 'both'
    },
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`]: {
        willChange: 'width, margin-left'
    },
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_RESIZER_CONTAINER} table`]: {
        willChange: 'width'
    },
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table`]: {
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0
    },
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: "var(--ds-space-100, 8px)",
        marginBottom: 0,
        marginLeft: 0
    },
    /* avoid applying styles to nested tables (possible via extensions) */ [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderCollapse: 'collapse',
        border: `${(0, $k8PFz.tableCellBorderWidth)}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        tableLayout: 'fixed',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        width: '100%',
        '&[data-autosize="true"]': {
            tableLayout: 'auto'
        },
        '&[data-initial-width-mode="content"]': {
            tableLayout: 'auto',
            width: 'auto'
        },
        '*': {
            boxSizing: 'border-box'
        },
        hr: {
            boxSizing: 'content-box'
        },
        tbody: {
            borderBottom: 'none'
        },
        'th td': {
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
        },
        '> tbody > tr > td': {
            backgroundColor: "var(--ds-surface, #FFFFFF)"
        },
        th: {
            backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
            textAlign: 'left',
            /* only apply this styling to codeblocks in default background headercells */ /* TODO this needs to be overhauled as it relies on unsafe selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not([style]):not(.danger)': {
                [`.${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}:not(.danger)`]: {
                    backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
                    [`&:not(.${0, $7Y8M5.akEditorSelectedNodeClassName})`]: {
                        boxShadow: `0px 0px 0px 1px ${"var(--ds-border, #0B120E24)"}`
                    },
                    [`.${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: "var(--ds-background-neutral, #0515240F)"
                    },
                    [`.${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                        backgroundColor: "var(--ds-background-neutral, #0515240F)"
                    },
                    /* this is only relevant to the element taken care of by renderer */ '> [data-ds--code--code-block]': {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: `${"var(--ds-background-neutral, #0515240F)"}!important`,
                        // selector lives inside @atlaskit/code
                        '--ds--code--line-number-bg-color': "var(--ds-background-neutral, #0515240F)"
                    }
                }
            }
        }
    }
});
const $2d4e6b1f55281137$var$roundedTableRemixBlockHighlightStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}.${$2d4e6b1f55281137$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME} > table,
	.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}.${$2d4e6b1f55281137$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME} > .${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}.${$2d4e6b1f55281137$var$REMIX_BLOCK_HIGHLIGHT_CLASS_NAME} > .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '&::after': {
            borderColor: "var(--ds-border-selected, #1868DB)"
        }
    }
});
const $2d4e6b1f55281137$var$roundedTableOuterBorderOverlayStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderColor: 'transparent',
        position: 'relative',
        '&::after': {
            content: "''",
            position: 'absolute',
            inset: '-0.5px',
            border: `${(0, $k8PFz.tableCellBorderWidth)}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
            borderRadius: "var(--ds-radius-xlarge, 12px)",
            pointerEvents: 'none',
            zIndex: 1
        },
        '> tbody > tr > th[data-reaches-top], > tbody > tr > td[data-reaches-top]': {
            borderTopColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-bottom], > tbody > tr > td[data-reaches-bottom]': {
            borderBottomColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-left], > tbody > tr > td[data-reaches-left]': {
            borderLeftColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-right], > tbody > tr > td[data-reaches-right]': {
            borderRightColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-top][data-reaches-left], > tbody > tr > td[data-reaches-top][data-reaches-left]': {
            borderTopLeftRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box'
        },
        '> tbody > tr > th[data-reaches-top][data-reaches-right], > tbody > tr > td[data-reaches-top][data-reaches-right]': {
            borderTopRightRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box'
        },
        '> tbody > tr > th[data-reaches-bottom][data-reaches-left], > tbody > tr > td[data-reaches-bottom][data-reaches-left]': {
            borderBottomLeftRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box'
        },
        '> tbody > tr > th[data-reaches-bottom][data-reaches-right], > tbody > tr > td[data-reaches-bottom][data-reaches-right]': {
            borderBottomRightRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box'
        }
    },
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky > .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`]: {
        borderTopLeftRadius: "var(--ds-radius-xlarge, 12px)",
        borderTopRightRadius: "var(--ds-radius-xlarge, 12px)",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
    },
    // Keep the cloned sticky header rounded at the top while preserving a square bottom edge.
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky > .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '&::after': {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        },
        '> tbody > tr': {
            // The sticky table clone sets a row background locally; force it off so
            // the rounded header cells, not a square row box, own the visible fill.
            background: 'transparent !important'
        },
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'border-box'
        },
        '> tbody > tr > th[data-reaches-left], > tbody > tr > td[data-reaches-left]': {
            borderTopLeftRadius: "var(--ds-radius-xlarge, 12px)",
            borderBottomLeftRadius: 0
        },
        '> tbody > tr > th[data-reaches-right], > tbody > tr > td[data-reaches-right]': {
            borderTopRightRadius: "var(--ds-radius-xlarge, 12px)",
            borderBottomRightRadius: 0
        },
        '> tbody > tr > th[data-reaches-left][data-reaches-bottom], > tbody > tr > td[data-reaches-left][data-reaches-bottom]': {
            borderBottomLeftRadius: 0
        },
        '> tbody > tr > th[data-reaches-right][data-reaches-bottom], > tbody > tr > td[data-reaches-right][data-reaches-bottom]': {
            borderBottomRightRadius: 0
        },
        '> tbody > tr > th[data-reaches-left]::after, > tbody > tr > td[data-reaches-left]::after': {
            borderBottomLeftRadius: 0
        },
        '> tbody > tr > th[data-reaches-right]::after, > tbody > tr > td[data-reaches-right]::after': {
            borderBottomRightRadius: 0
        }
    }
});
// Remove when cleaning up platform_editor_table_q4_patch_7.
const $2d4e6b1f55281137$var$roundedTableLegacyClipPathStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th[data-reaches-top][data-reaches-left], > tbody > tr > td[data-reaches-top][data-reaches-left]': {
            clipPath: `inset(0 round ${"var(--ds-radius-xlarge, 12px)"} 0 0 0)`
        },
        '> tbody > tr > th[data-reaches-top][data-reaches-right], > tbody > tr > td[data-reaches-top][data-reaches-right]': {
            clipPath: `inset(0 round 0 ${"var(--ds-radius-xlarge, 12px)"} 0 0)`
        },
        '> tbody > tr > th[data-reaches-bottom][data-reaches-left], > tbody > tr > td[data-reaches-bottom][data-reaches-left]': {
            clipPath: `inset(0 round 0 0 0 ${"var(--ds-radius-xlarge, 12px)"})`
        },
        '> tbody > tr > th[data-reaches-bottom][data-reaches-right], > tbody > tr > td[data-reaches-bottom][data-reaches-right]': {
            clipPath: `inset(0 round 0 0 ${"var(--ds-radius-xlarge, 12px)"} 0)`
        }
    },
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky > .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th[data-reaches-left], > tbody > tr > td[data-reaches-left]': {
            clipPath: `inset(0 round ${"var(--ds-radius-xlarge, 12px)"} 0 0 0)`
        },
        '> tbody > tr > th[data-reaches-right], > tbody > tr > td[data-reaches-right]': {
            clipPath: `inset(0 round 0 ${"var(--ds-radius-xlarge, 12px)"} 0 0)`
        }
    }
});
const $2d4e6b1f55281137$var$tableContentModeScopedStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}:has(> table[data-initial-width-mode="content"]),
	.${(0, $96p1s.RendererCssClassName).DOCUMENT} .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}:has(> .${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table[data-initial-width-mode="content"]),
	.${(0, $96p1s.RendererCssClassName).DOCUMENT} .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}:has(> .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table[data-initial-width-mode="content"])`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'max-content !important',
        maxWidth: 'var(--renderer-table-max-width)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] > colgroup > col`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'unset !important'
    }
});
const $2d4e6b1f55281137$var$tableContentModeNestedTableStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // Nested tables may sit inside expands, extensions, or other blocks within the parent cell.
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] > tbody > tr > :is(th, td) .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $96p1s.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] > tbody > tr > :is(th, td) .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER} > .${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $96p1s.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] > tbody > tr > :is(th, td) .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER} > .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        width: 'max-content !important',
        maxWidth: '100%'
    }
});
const $2d4e6b1f55281137$var$tableRendererHeaderStylesForTableCellOnly = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            minWidth: `${(0, $k8PFz.tableCellMinWidth)}px`,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            verticalAlign: 'top',
            border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
            borderRightWidth: 0,
            borderBottomWidth: 0,
            paddingTop: "var(--ds-space-100, 8px)",
            paddingRight: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            paddingLeft: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            'th p:not(:first-of-type), td p:not(:first-of-type)': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    }
});
const $2d4e6b1f55281137$var$tableRendererNestedPanelStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER} .ak-editor-panel`]: {
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
    }
});
const $2d4e6b1f55281137$var$tableStylesBackGroundClipForGeckoForTableCellOnly = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'padding-box'
        }
    }
});
const $2d4e6b1f55281137$var$firstNodeWithNotMarginTopWithNestedDnD = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
                marginTop: 0
            }
        }
    }
});
const $2d4e6b1f55281137$var$rendererTableStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        zIndex: 0,
        transition: `all 0.1s linear`,
        display: 'flex' /* needed to avoid position: fixed jumpiness in Chrome */ ,
        /** Shadow overrides */ [`&.${(0, $9ECRl.shadowClassNames).RIGHT_SHADOW}::after, &.${(0, $9ECRl.shadowClassNames).LEFT_SHADOW}::before`]: {
            top: `${(0, $k8PFz.tableMarginTop) - 1}px`,
            height: `calc(100% - ${(0, $k8PFz.tableMarginTop)}px)`,
            zIndex: `${(0, $7Y8M5.akEditorStickyHeaderZIndex)}`,
            width: `${$2d4e6b1f55281137$var$tableShadowWidth}px`,
            background: `linear-gradient(
					to left,
					transparent 0,
					${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140%
				),
				linear-gradient(
					to right,
					${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px,
					transparent 1px
				)`
        },
        [`&.${(0, $9ECRl.shadowClassNames).RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(
					to right,
					transparent 0,
					${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140%
				),
				linear-gradient(
					to left,
					${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px,
					transparent 1px
				)`,
            right: `0px`
        },
        [`&
          .${(0, $kas7q.shadowObserverClassNames).SENTINEL_LEFT},
          &
          .${(0, $kas7q.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
            height: `calc(100% - ${(0, $k8PFz.tableMarginTop)}px)`
        }
    }
});
const $2d4e6b1f55281137$var$stickyScrollbarStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        flexDirection: 'column',
        [`> .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`]: {
            width: '100%',
            display: 'block',
            visibility: 'hidden',
            overflowX: 'auto',
            position: 'sticky',
            bottom: `${"var(--ds-space-0, 0px)"}`,
            zIndex: 1
        },
        [`> .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
		> .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            position: 'absolute',
            width: '100%',
            height: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '-1px',
            // need this to avoid sentinel being focused via keyboard
            // this still allows it to be detected by intersection observer
            visibility: 'hidden'
        },
        [`> .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            top: `${$2d4e6b1f55281137$var$tableRowHeight * 3}px`
        },
        [`> .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM}`]: {
            bottom: `${"var(--ds-space-250, 20px)"}` // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
        }
    }
});
const $2d4e6b1f55281137$var$stickyScrollbarOverflowShadowFixStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`&.${(0, $9ECRl.shadowClassNames).RIGHT_SHADOW}::after, &.${(0, $9ECRl.shadowClassNames).LEFT_SHADOW}::before`]: {
            // The sticky scrollbar retains this space in the table container's layout even while hidden.
            bottom: "var(--ds-space-250, 20px)",
            height: 'auto'
        }
    }
});
const $2d4e6b1f55281137$var$rendererTableHeaderEqualHeightStylesForTableCellOnly = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            height: '1px' /* will be ignored */ ,
            marginLeft: 0,
            marginRight: 0
        }
    },
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table > tbody > tr:first-of-type, .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table > tbody > tr:first-of-type`]: {
        height: '100%',
        'td, th': {
            position: 'relative'
        }
    }
});
const $2d4e6b1f55281137$var$rendererTableSortableColumnStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            // allow nested heading links
            [`.${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                padding: 0,
                [`.${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    width: '100%',
                    height: '100%',
                    padding: `${(0, $k8PFz.tableCellPadding)}px`,
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-shape
                    borderWidth: '1.5px',
                    borderStyle: 'solid',
                    borderColor: `transparent`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> *:first-child': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                        marginTop: 0
                    },
                    '@supports selector(:focus-visible)': {
                        '&:focus': {
                            outline: 'unset'
                        },
                        '&:focus-visible': {
                            borderColor: `${"var(--ds-border-focused, #4688EC)"}`
                        }
                    }
                },
                [`> .${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN} > .${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER}`]: {
                    margin: 0,
                    [`.${0, $fmXA0.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 1,
                        transition: `opacity 0.2s ease-in-out`
                    }
                },
                [`> .${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $fmXA0.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 0,
                        '&:focus': {
                            opacity: 1
                        }
                    }
                },
                [`&:hover:not(
							:has(
									.${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}
										.${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN}:hover
								)
						)
						> .${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $fmXA0.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 1
                    }
                }
            }
        }
    }
});
// Sortable header cells render content inside an extra div, so mirror the th alignment there.
const $2d4e6b1f55281137$var$rendererTableSortableColumnValignStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`th[data-valign='middle'].${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN_WRAPPER} > .${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN}`]: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            [`th[data-valign='bottom'].${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN_WRAPPER} > .${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN}`]: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end'
            }
        }
    }
});
const $2d4e6b1f55281137$var$rendererTableColumnStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $96p1s.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"}`,
                borderRight: `${"var(--ds-border-width, 1px)"} solid
								${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
                width: `${(0, $7Y8M5.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${"var(--ds-text-subtlest, #6B6E76)"}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $96p1s.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $2d4e6b1f55281137$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinksDuplicateAnchor = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '>': {
                        'h1, h2, h3, h4, h5, h6': {
                            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                            marginRight: '30px'
                        }
                    }
                }
            }
        }
    }
});
const $2d4e6b1f55281137$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $3qC7n.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '> .renderer-heading-wrapper': {
                        // Reserve space for the sortable-column icon so the heading+anchor wrapper never overlaps it.
                        // Use padding (instead of margin on the heading) so we don't create a gap between the heading
                        // text and the copy-link anchor button
                        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                        paddingRight: '30px'
                    }
                }
            }
        }
    }
});
// @ts-expect-error - throw TS error when use !import in position.
const $2d4e6b1f55281137$var$stickyHeaderStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    'tr[data-header-row].fixed': {
        position: 'fixed !important',
        display: 'flex',
        overflow: 'hidden',
        zIndex: `${(0, $7Y8M5.akEditorStickyHeaderZIndex)}`,
        borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        /* this is to compensate for the table border */ transform: 'translateX(-1px)'
    },
    '.sticky > th': {
        zIndex: `${(0, $7Y8M5.akEditorStickyHeaderZIndex)}`,
        position: 'fixed !important',
        top: 0
    },
    /* Make the number column header sticky */ '.sticky > td': {
        position: 'fixed !important',
        top: 0
    },
    /* add border for position: sticky
  and work around background-clip: padding-box
  bug for FF causing box-shadow bug in Chrome */ '.sticky th, .sticky td': {
        boxShadow: `0px 1px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			0px -0.5px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			inset -1px 0px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			0px -1px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`
    },
    /* this will remove jumpiness caused in Chrome for sticky headers */ '.fixed + tr': {
        minHeight: '0px'
    }
});
const $2d4e6b1f55281137$var$codeBlockAndLayoutStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    /*
   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.
   * See ED-4159.
   */ '& .code-block': {
        maxWidth: '100%',
        display: 'block',
        position: 'relative',
        borderRadius: "var(--ds-radius-small, 3px)",
        /*
     * The overall renderer has word-wrap: break; which causes issues with
     * code block line numbers in Safari / iOS.
     */ wordWrap: 'normal'
    },
    '& .MediaGroup, & .code-block': {
        marginTop: `${(0, $7Y8M5.blockNodesVerticalMargin)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:first-child': {
            marginTop: 0
        }
    },
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT}
		> .${(0, $ft6gK.LightWeightCodeBlockCssClassName).CONTAINER}
		.${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        marginTop: (0, $7Y8M5.blockNodesVerticalMargin)
    },
    '& [data-layout-section]': {
        marginTop: "var(--ds-space-250, 20px)",
        '& > div + div': {
            marginLeft: "var(--ds-space-400, 32px)"
        },
        [`@media screen and (max-width: ${0, $7Y8M5.gridMediumMaxWidth}px)`]: {
            '& > div + div': {
                marginLeft: 0
            }
        },
        '& .MediaGroup, & .code-block': {
            marginTop: (0, $7Y8M5.blockNodesVerticalMargin),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        }
    },
    '& li': {
        '> .code-block': {
            margin: `${(0, $7Y8M5.blockNodesVerticalMargin)} 0 0 0`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:first-child': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:last-of-type.code-block': {
            marginBottom: (0, $7Y8M5.blockNodesVerticalMargin)
        }
    }
});
const $2d4e6b1f55281137$var$layoutSectionForAdvancedLayoutsStyles = {
    name: "4wptv0",
    styles: "& [data-layout-section]{& > div + div{margin-left:0;}}"
};
const $2d4e6b1f55281137$var$gridRenderForCodeBlockStyles = {
    name: "18d2t58",
    styles: "& .code-block{display:grid;grid-template-columns:minmax(0, 1fr);& > span{grid-column:1;}}"
};
// This prevents https://product-fabric.atlassian.net/browse/ED-20924
const $2d4e6b1f55281137$var$codeBlockInListSafariFixStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`&:not([data-node-type='decisionList']) > li,
		&:not(.${(0, $6U5OC.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li`]: {
        '&::before': {
            content: '" "',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $7Y8M5.akEditorLineHeight)
        },
        [`> p:first-child,
			> .code-block:first-child,
			> .ProseMirror-gapcursor:first-child + .code-block`]: {
            marginTop: `-${(0, $7Y8M5.akEditorLineHeight)}em !important`
        }
    }
});
const $2d4e6b1f55281137$var$columnLayoutSharedStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $7Y8M5.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $2d4e6b1f55281137$var$columnLayoutResponsiveSharedStyle = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $2d4e6b1f55281137$var$columnLayoutResponsiveRendererStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container [data-layout-section]': {
        gap: "var(--ds-space-600, 48px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
        [`@container layout-area (max-width: ${$2d4e6b1f55281137$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
            flexDirection: 'column',
            gap: "var(--ds-space-400, 32px)"
        }
    }
});
const $2d4e6b1f55281137$var$rendererAnnotationStylesOld = /*#__PURE__*/ (0, $lOiVq.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
        background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
        cursor: 'pointer',
        paddingTop: "var(--ds-space-050, 4px)",
        paddingRight: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-025, 2px)"
    }
});
const $2d4e6b1f55281137$var$rendererAnnotationStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark]": {
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        cursor: 'pointer',
        paddingTop: "var(--ds-space-050, 4px)",
        paddingRight: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-025, 2px)"
    },
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'][data-has-focus='true'] [data-annotation-mark]": {
        background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    }
});
const $2d4e6b1f55281137$var$rendererAnnotationStylesCommentHeightFix = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node]': {
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingTop: '1px',
        paddingRight: 0,
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: 0,
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
        paddingTop: "var(--ds-space-025, 2px)"
    }
});
const $2d4e6b1f55281137$var$RENDERER_LIST_DENSE_GAP = `max(0px,calc((var(--ak-renderer-base-font-size) - ${(0, $7Y8M5.akEditorFullPageDenseFontSize)}px)* (4/3)))`;
const $2d4e6b1f55281137$var$TASKLIST_CONTAINER_DENSE_MARGIN = `max(calc(10px + (var(--ak-renderer-base-font-size) - ${(0, $7Y8M5.akEditorFullPageDenseFontSize)}px) *( 2 / 3)))`;
const $2d4e6b1f55281137$var$scaledDenseEmojiStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `${(0, $l4yrE.defaultDenseEmojiHeight)}px`,
        minHeight: `${(0, $l4yrE.defaultDenseEmojiHeight)}px`,
        minWidth: `${(0, $l4yrE.defaultDenseEmojiHeight)}px`,
        maxHeight: `${(0, $l4yrE.denseEmojiHeightH1)}px`,
        maxWidth: `${(0, $l4yrE.denseEmojiHeightH1)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    [`h1 :is(.${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $l4yrE.denseEmojiHeightH1)}px`,
        width: `${(0, $l4yrE.denseEmojiHeightH1)}px`
    },
    [`h2 :is(.${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $l4yrE.denseEmojiHeightH2)}px`,
        width: `${(0, $l4yrE.denseEmojiHeightH2)}px`
    },
    [`h3 :is(.${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $l4yrE.denseEmojiHeightH3)}px`,
        width: `${(0, $l4yrE.denseEmojiHeightH3)}px`
    },
    [`h4 :is(.${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $l4yrE.denseEmojiHeightH4)}px`,
        width: `${(0, $l4yrE.denseEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) :is(.${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $l4yrE.defaultDenseEmojiHeight)}px`,
        width: `${(0, $l4yrE.defaultDenseEmojiHeight)}px`
    },
    // sync with platform/packages/linking-platform/smart-card/src/view/InlineCard/IconAndTitleLayout/index.tsx
    [`[data-testid="icon-wrapper"] :is(.${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        minHeight: `${(0, $l4yrE.defaultInlineEmojiHeight)}px`,
        minWidth: `${(0, $l4yrE.defaultInlineEmojiHeight)}px`,
        height: `${(0, $l4yrE.defaultInlineEmojiHeight)}px`,
        width: `${(0, $l4yrE.defaultInlineEmojiHeight)}px`
    }
});
const $2d4e6b1f55281137$var$scaledDenseUnicodeEmojiStylesNew = /*#__PURE__*/ (0, $lOiVq.css)({
    [`[data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $l4yrE.defaultDenseEmojiHeight)}px`
    },
    [`h1 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $l4yrE.denseEmojiHeightH1)}px`
    },
    [`h2 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $l4yrE.denseEmojiHeightH2)}px`
    },
    [`h3 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $l4yrE.denseEmojiHeightH3)}px`
    },
    [`h4 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $l4yrE.denseEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $l4yrE.defaultDenseEmojiHeight)}px`
    }
});
const $2d4e6b1f55281137$var$scaledEmojiStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `${(0, $l4yrE.defaultEmojiHeight)}px`,
        minHeight: `${(0, $l4yrE.defaultEmojiHeight)}px`,
        minWidth: `${(0, $l4yrE.defaultEmojiHeight)}px`,
        maxHeight: `${(0, $l4yrE.scaledEmojiHeightH1)}px`,
        maxWidth: `${(0, $l4yrE.scaledEmojiHeightH1)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    [`h1 :is(.${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $l4yrE.scaledEmojiHeightH1)}px`,
        width: `${(0, $l4yrE.scaledEmojiHeightH1)}px`
    },
    [`h2 :is(.${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $l4yrE.scaledEmojiHeightH2)}px`,
        width: `${(0, $l4yrE.scaledEmojiHeightH2)}px`
    },
    [`h3 :is(.${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $l4yrE.scaledEmojiHeightH3)}px`,
        width: `${(0, $l4yrE.scaledEmojiHeightH3)}px`
    },
    [`h4 :is(.${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $l4yrE.scaledEmojiHeightH4)}px`,
        width: `${(0, $l4yrE.scaledEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) :is(.${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $l4yrE.defaultEmojiHeight)}px`,
        width: `${(0, $l4yrE.defaultEmojiHeight)}px`
    },
    // sync with platform/packages/linking-platform/smart-card/src/view/InlineCard/IconAndTitleLayout/index.tsx
    [`[data-testid="icon-wrapper"] :is(.${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        minHeight: `${(0, $l4yrE.defaultInlineEmojiHeight)}px`,
        minWidth: `${(0, $l4yrE.defaultInlineEmojiHeight)}px`,
        height: `${(0, $l4yrE.defaultInlineEmojiHeight)}px`,
        width: `${(0, $l4yrE.defaultInlineEmojiHeight)}px`
    }
});
const $2d4e6b1f55281137$var$scaledUnicodeEmojiStylesNew = /*#__PURE__*/ (0, $lOiVq.css)({
    [`[data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $l4yrE.defaultEmojiHeight)}px`
    },
    [`h1 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $l4yrE.scaledEmojiHeightH1)}px`
    },
    [`h2 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $l4yrE.scaledEmojiHeightH2)}px`
    },
    [`h3 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $l4yrE.scaledEmojiHeightH3)}px`
    },
    [`h4 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $l4yrE.scaledEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $l4yrE.defaultEmojiHeight)}px`
    }
});
const $2d4e6b1f55281137$var$denseStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // Scale emoji size based on base font size
    // Default: 20px emoji at 16px base font
    // Scaled: 20px * (baseFontSize/16)
    // E.g., dense mode (13px base): 20px * (13/16) = 16.25px
    [`.${(0, $k8ZZN.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `calc(${(0, $l4yrE.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $7Y8M5.akEditorFullPageDefaultFontSize)})`,
        width: `calc(${(0, $l4yrE.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $7Y8M5.akEditorFullPageDefaultFontSize)})`,
        maxHeight: `calc(${(0, $l4yrE.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $7Y8M5.akEditorFullPageDefaultFontSize)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    // Scale panel icon
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT} .ak-editor-panel .ak-editor-panel__icon`]: {
        height: "var(--ds-space-250, 20px)",
        width: "var(--ds-space-250, 20px)"
    },
    // Condense spacing across lists, tasks and decisions
    [`.${(0, $96p1s.RendererCssClassName).DOCUMENT}`]: {
        // Adjacent list items
        'li + li': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $2d4e6b1f55281137$var$RENDERER_LIST_DENSE_GAP
        },
        // Nested lists directly under an li (unordered and ordered)
        'li > ul, li > ol, .ak-ul li > ul, .ak-ul li > ol, .ak-ol li > ul, .ak-ol li > ol': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $2d4e6b1f55281137$var$RENDERER_LIST_DENSE_GAP
        },
        // Task lists
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id]': {
            // Task lists: container top margin
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $2d4e6b1f55281137$var$TASKLIST_CONTAINER_DENSE_MARGIN
        },
        // Task lists: sibling items and nested lists
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id] > * + *': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $2d4e6b1f55281137$var$RENDERER_LIST_DENSE_GAP
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id] [data-task-list-local-id], [data-task-local-id] [data-task-local-id]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $2d4e6b1f55281137$var$RENDERER_LIST_DENSE_GAP
        }
    }
});
const $2d4e6b1f55281137$var$syncBlockRendererStyles = {
    name: "g5u32w",
    styles: "margin:0;max-width:none;padding:0"
};
/**
 * Fake left/right table borders.
 *
 * Adapted from the editor-plugin-table behavior (see editor-common's
 * `tableSharedStyle()` in `editor-common/src/styles/shared/table.ts`). The
 * visible vertical edges of the table are painted by these absolutely-positioned
 * 1px divs that live inside the (non-scrolling) TABLE_CONTAINER, while the real
 * <table> left/right borders are made `transparent`. Because the divs are not
 * inside the horizontally scrolling TABLE_NODE_WRAPPER, they remain visible
 * regardless of scroll position — fixing the missing right border when an
 * overflowing table inside a reference synced block is scrolled all the way to
 * the left.
 *
 * The `height` formula adjusted for table in renderer
 */ const $2d4e6b1f55281137$var$tableFakeBorderStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        // Mirror the editor's tableSharedStyle() rule from
        // `editor-common/src/styles/shared/table.ts` (lines 142-150). The fake
        // borders are absolutely positioned inside pm-table-container;
        // their height is adjusted for renderer to `100% - space.300 - space.250` so the border runs from
        // the top of the table to the bottom of the container
        [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_RIGHT_BORDER},
		.${(0, $bYPHE.TableSharedCssClassName).TABLE_LEFT_BORDER}`]: {
            display: 'block',
            width: '1px',
            height: `calc(100% - ${"var(--ds-space-300, 24px)"} - ${"var(--ds-space-250, 20px)"})`,
            background: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
            position: 'absolute',
            top: "var(--ds-space-300, 24px)"
        },
        [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_RIGHT_BORDER}`]: {
            right: 0
        },
        [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_LEFT_BORDER},
		.${(0, $bYPHE.TableSharedCssClassName).TABLE_LEFT_BORDER}[data-with-numbered-table='true']`]: {
            left: 0
        }
    },
    // Make the real left/right table borders transparent so the fake border
    // divs above are the only painted vertical edges. Top/bottom borders on the
    // <table> element remain visible.
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderLeftColor: 'transparent',
        borderRightColor: 'transparent'
    }
});
const $2d4e6b1f55281137$var$roundedTableFakeBorderOverlayStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $bYPHE.TableSharedCssClassName).TABLE_RIGHT_BORDER},
		.${(0, $bYPHE.TableSharedCssClassName).TABLE_LEFT_BORDER}`]: {
            display: 'none'
        }
    }
});
const $2d4e6b1f55281137$var$syncBlockStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $95bQO.SyncBlockSharedCssClassName).renderer}, .${(0, $95bQO.BodiedSyncBlockSharedCssClassName).renderer}, .${(0, $95bQO.SyncBlockSharedCssClassName).error}, .${(0, $95bQO.SyncBlockSharedCssClassName).loading}`]: {
        borderRadius: "var(--ds-radius-small, 3px)",
        marginTop: "var(--ds-space-075, 6px)",
        paddingBlock: "var(--ds-space-150, 12px)",
        overflow: 'visible'
    },
    [`.${(0, $95bQO.SyncBlockSharedCssClassName).renderer}`]: {
        // First child node in syncBlock in editor is overridden with marginTop: 0, hence apply the same style in renderer for consistency
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-renderer-document > :first-child': {
            marginTop: 0
        }
    },
    [`.${(0, $95bQO.BodiedSyncBlockSharedCssClassName).renderer}`]: {
        // First child node in bodiedSyncBlock in editor is overridden with marginTop: 0, hence apply the same style in renderer for consistency
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '> :first-child': {
            marginTop: 0
        }
    },
    [`.${(0, $95bQO.SyncBlockSharedCssClassName).error}`]: {
        backgroundColor: "var(--ds-background-disabled, #0515240F)"
    },
    [`.${(0, $95bQO.SyncBlockSharedCssClassName).loading}`]: {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    }
});
const $2d4e6b1f55281137$export$8f0929e72efe521f = (props)=>{
    const { onClick: onClick, onMouseDown: onMouseDown, appearance: appearance, contentMode: contentMode, allowNestedHeaderLinks: allowNestedHeaderLinks, allowColumnSorting: allowColumnSorting, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, children: children, innerRef: innerRef, testId: testId, isInsideSyncBlock: isInsideSyncBlock } = props;
    const isAdvancedLayoutsOn = (0, $fqVYq.editorExperiment)('advanced_layouts', true);
    const isPreviewPanelResponsivenessOn = (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    });
    const isStickyScrollbarOn = (0, $gPrpc.isStickyScrollbarEnabled)(appearance);
    const baseFontSize = (0, $fa5a721f2d81671e$export$8e2864079bc476bd)(appearance, contentMode);
    const browser = (0, $8dxef.getBrowserInfo)();
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        role: "none",
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        style: {
            '--ak-renderer-base-font-size': `${baseFontSize}px`,
            '--ak-renderer-editor-font-heading-h1': `${(0, $csUNO.editorUGCTokensRefreshed)['editor.font.heading.h1']}`,
            '--ak-renderer-editor-font-heading-h2': `${(0, $csUNO.editorUGCTokensRefreshed)['editor.font.heading.h2']}`,
            '--ak-renderer-editor-font-heading-h3': `${(0, $csUNO.editorUGCTokensRefreshed)['editor.font.heading.h3']}`,
            '--ak-renderer-editor-font-heading-h4': `${(0, $csUNO.editorUGCTokensRefreshed)['editor.font.heading.h4']}`,
            '--ak-renderer-editor-font-heading-h5': `${(0, $csUNO.editorUGCTokensRefreshed)['editor.font.heading.h5']}`,
            '--ak-renderer-editor-font-heading-h6': `${(0, $csUNO.editorUGCTokensRefreshed)['editor.font.heading.h6']}`,
            '--ak-renderer-editor-font-normal-text': `${(0, $csUNO.editorUGCTokensRefreshed)['editor.font.body']}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- CSS custom properties for UGC font tokens
            ...(0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && {
                '--ak-renderer-editor-font-small-text': (0, $csUNO.editorUGCTokensRefreshed)['editor.font.body.small']
            }
        },
        css: [
            (0, $ieeJu.expValEquals)('confluence_ttvc_inline_extensions', 'isEnabled', true) ? $2d4e6b1f55281137$var$baseFontStyle : $2d4e6b1f55281137$var$originalBaseFontLineHeight,
            $2d4e6b1f55281137$var$baseStyles,
            (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && $2d4e6b1f55281137$var$fontSizeStyles,
            (0, $ieeJu.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $2d4e6b1f55281137$var$headingAnchorStyles : $2d4e6b1f55281137$var$headingAnchorStylesDuplicateAnchor,
            $2d4e6b1f55281137$var$headingAnchorButtonFocusVisibleStyles,
            (0, $ieeJu.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $2d4e6b1f55281137$var$hideHeadingCopyLinkWrapperStyles : $2d4e6b1f55281137$var$hideHeadingCopyLinkWrapperStylesDuplicateAnchor,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $2d4e6b1f55281137$var$rendererFullPageStylesWithReducedPadding,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $2d4e6b1f55281137$var$rendererFullPageStyles,
            appearance === 'full-width' && ((0, $ieeJu.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? $2d4e6b1f55281137$var$rendererFullWidthStyles : $2d4e6b1f55281137$var$oldRendererFullWidthStyles),
            (appearance === 'full-width' || appearance === 'max' && ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) && !(0, $gPrpc.isTableResizingEnabled)(appearance) && $2d4e6b1f55281137$var$rendererFullWidthStylesForTableResizing,
            appearance === 'max' && ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && ((0, $ieeJu.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? $2d4e6b1f55281137$var$rendererMaxWidthStyles : $2d4e6b1f55281137$var$oldRendererMaxWidthStyles),
            $2d4e6b1f55281137$var$rovoTelepointerStyles,
            $2d4e6b1f55281137$var$whitespaceSharedStyles,
            $2d4e6b1f55281137$var$blockquoteSharedStyles,
            $2d4e6b1f55281137$var$headingsSharedStyles,
            (0, $ieeJu.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) && $2d4e6b1f55281137$var$headingWrapperInlineFlowStyles,
            (0, $ieeJu.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $2d4e6b1f55281137$var$headingWithAlignmentStyles : $2d4e6b1f55281137$var$headingWithAlignmentStylesDuplicateAnchor,
            $2d4e6b1f55281137$var$ruleSharedStyles,
            contentMode === 'compact' && $2d4e6b1f55281137$var$extensionStyle,
            contentMode === 'compact' ? $2d4e6b1f55281137$var$paragraphStylesUGCScaledMargin : $2d4e6b1f55281137$var$paragraphSharedStylesWithEditorUGC,
            $2d4e6b1f55281137$var$listsSharedStyles,
            browser.gecko && $2d4e6b1f55281137$var$listsSharedStylesForGekko,
            (0, $ieeJu.expValEquals)('platform_editor_flexible_list_schema', 'isEnabled', true) && $2d4e6b1f55281137$var$listItemHiddenMarkerStyles,
            $2d4e6b1f55281137$var$indentationSharedStyles,
            $2d4e6b1f55281137$var$indentationSharedStylesWithMarginFix,
            (0, $ieeJu.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $2d4e6b1f55281137$var$blockMarksSharedStyles : $2d4e6b1f55281137$var$blockMarksSharedStylesDuplicateAnchor,
            $2d4e6b1f55281137$var$codeMarkSharedStyles,
            $2d4e6b1f55281137$var$shadowSharedStyle,
            $2d4e6b1f55281137$var$dateSharedStyle,
            $2d4e6b1f55281137$var$textColorStyles,
            $2d4e6b1f55281137$var$backgroundColorStyles,
            !(0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $2d4e6b1f55281137$var$highlightLinksUnsetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            $2d4e6b1f55281137$export$a365082c2a191514,
            $2d4e6b1f55281137$var$tasksAndDecisionsStyles,
            (0, $ieeJu.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) && $2d4e6b1f55281137$var$headingPanelStyles,
            $2d4e6b1f55281137$var$smartCardStyles,
            $2d4e6b1f55281137$var$smartCardStylesAvatarFix,
            (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_linking_exp', true) && $2d4e6b1f55281137$var$headerSmartCardStyles,
            $2d4e6b1f55281137$var$smartCardStylesAvatarMarginFix,
            $2d4e6b1f55281137$var$smartCardStylesAvatarListZeroMarginTop,
            (0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes') && ((0, $ieeJu.expValEquals)('confluence_fe_renderer_inline_node_mark_color_fix', 'isEnabled', true) ? $2d4e6b1f55281137$var$rendererAnnotationStyles : $2d4e6b1f55281137$var$rendererAnnotationStylesOld),
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes') && $2d4e6b1f55281137$var$rendererAnnotationStylesCommentHeightFix,
            (0, $ieeJu.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $2d4e6b1f55281137$var$baseOtherStyles : $2d4e6b1f55281137$var$baseOtherStylesDuplicateAnchor,
            !(0, $ieeJu.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true) && $2d4e6b1f55281137$var$extensionCenterAlignLegacyStyles,
            // this should be placed after baseOtherStyles
            (0, $ieeJu.expValEquals)('platform_editor_render_bodied_extension_as_inline', 'isEnabled', true) && ((0, $ieeJu.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? $2d4e6b1f55281137$var$extensionAsInlineStyle : $2d4e6b1f55281137$var$oldExtensionAsInlineStyle),
            $2d4e6b1f55281137$var$inlineExtensionRendererMarginFix,
            allowNestedHeaderLinks && ((0, $ieeJu.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $2d4e6b1f55281137$var$alignedHeadingAnchorStyle : $2d4e6b1f55281137$var$alignedHeadingAnchorStyleDuplicateAnchor),
            $2d4e6b1f55281137$var$mediaSingleSharedStyle,
            // merge firstWrappedMediaStyles with mediaSingleSharedStyle when clean up platform_editor_fix_media_in_renderer
            (0, $iDrrr.fg)('platform_editor_fix_media_in_renderer') && $2d4e6b1f55281137$var$firstWrappedMediaStyles,
            $2d4e6b1f55281137$var$tableSharedStyle,
            (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && $2d4e6b1f55281137$var$roundedTableOuterBorderOverlayStyles,
            (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && !(0, $4o0zT.isExperimentEnabled)('platform_editor_table_q4_patch_7') && $2d4e6b1f55281137$var$roundedTableLegacyClipPathStyles,
            (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && $2d4e6b1f55281137$var$roundedTableRemixBlockHighlightStyles,
            (0, $ieeJu.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true) && $2d4e6b1f55281137$var$tableContentModeScopedStyles,
            (0, $ieeJu.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true) && $2d4e6b1f55281137$var$tableContentModeNestedTableStyles,
            $2d4e6b1f55281137$var$tableRendererHeaderStylesForTableCellOnly,
            (0, $iDrrr.fg)('platform_editor_bordered_panel_nested_in_table') && $2d4e6b1f55281137$var$tableRendererNestedPanelStyles,
            $2d4e6b1f55281137$var$isBackgroundClipBrowserFixNeeded() && $2d4e6b1f55281137$var$tableStylesBackGroundClipForGeckoForTableCellOnly,
            $2d4e6b1f55281137$var$firstNodeWithNotMarginTopWithNestedDnD,
            $2d4e6b1f55281137$var$rendererTableStyles,
            isStickyScrollbarOn && $2d4e6b1f55281137$var$stickyScrollbarStyles,
            isStickyScrollbarOn && (0, $ieeJu.expValEquals)('platform_editor_table_css_overflow_shadow', 'isEnabled', true) && $2d4e6b1f55281137$var$stickyScrollbarOverflowShadowFixStyles,
            $2d4e6b1f55281137$var$rendererTableHeaderEqualHeightStylesForTableCellOnly,
            allowColumnSorting && $2d4e6b1f55281137$var$rendererTableSortableColumnStyles,
            allowColumnSorting && (0, $anBbz.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) && $2d4e6b1f55281137$var$rendererTableSortableColumnValignStyles,
            allowColumnSorting && allowNestedHeaderLinks && ((0, $ieeJu.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $2d4e6b1f55281137$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks : $2d4e6b1f55281137$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinksDuplicateAnchor),
            $2d4e6b1f55281137$var$rendererTableColumnStyles,
            $2d4e6b1f55281137$var$stickyHeaderStyles,
            $2d4e6b1f55281137$var$codeBlockAndLayoutStyles,
            $2d4e6b1f55281137$var$columnLayoutSharedStyle,
            isAdvancedLayoutsOn && $2d4e6b1f55281137$var$columnLayoutResponsiveSharedStyle,
            isAdvancedLayoutsOn && $2d4e6b1f55281137$var$columnLayoutResponsiveRendererStyles,
            isAdvancedLayoutsOn && $2d4e6b1f55281137$var$layoutSectionForAdvancedLayoutsStyles,
            !useBlockRenderForCodeBlock && $2d4e6b1f55281137$var$gridRenderForCodeBlockStyles,
            browser.safari && $2d4e6b1f55281137$var$codeBlockInListSafariFixStyles,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $2d4e6b1f55281137$var$responsiveBreakoutWidth,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $2d4e6b1f55281137$var$responsiveBreakoutWidthWithReducedPadding,
            (appearance === 'full-width' || appearance === 'max' && ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) && $2d4e6b1f55281137$var$responsiveBreakoutWidthFullWidth,
            (0, $ieeJu.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? contentMode === 'compact' ? $2d4e6b1f55281137$var$scaledDenseEmojiStyles : $2d4e6b1f55281137$var$scaledEmojiStyles : contentMode === 'compact' ? $2d4e6b1f55281137$var$denseStyles : undefined,
            contentMode === 'compact' ? $2d4e6b1f55281137$var$scaledDenseUnicodeEmojiStylesNew : $2d4e6b1f55281137$var$scaledUnicodeEmojiStylesNew,
            (0, $fqVYq.editorExperiment)('platform_synced_block', true) && $2d4e6b1f55281137$var$syncBlockStyles,
            $2d4e6b1f55281137$var$centerWrapperStyles,
            (0, $fqVYq.editorExperiment)('platform_synced_block', true) && isInsideSyncBlock ? $2d4e6b1f55281137$var$syncBlockRendererStyles : null,
            isInsideSyncBlock && (0, $fqVYq.editorExperiment)('platform_synced_block', true) && $2d4e6b1f55281137$var$tableFakeBorderStyles,
            isInsideSyncBlock && (0, $fqVYq.editorExperiment)('platform_synced_block', true) && (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? $2d4e6b1f55281137$var$roundedTableFakeBorderOverlayStyles : null,
            (0, $ieeJu.expValEquals)('platform_editor_hide_extension_renderer_support', 'isEnabled', true) && $2d4e6b1f55281137$var$hideExtensionStyles
        ],
        "data-testid": testId
    }, children);
};



const $c561375a29ca9f0a$export$c94cfc0c675062a1 = (document)=>{
    // Check if the document is valid
    if (!document || !document.content || !Array.isArray(document.content)) return document;
    // Check if the node is a meaningful content node meaning it is not an empty paragraph or a paragraph with only whitespace
    const isMeaningfulContentNode = (node)=>{
        // Check if the node is a non-empty paragraph or a non-paragraph node
        if (node.type !== 'paragraph') return true;
        // If the paragraph is empty, return false
        if (!node.content || node.content.length === 0) return false;
        // Check if paragraph has any content other than `hardBreak` or whitespace text nodes
        return node.content.some((child)=>{
            return !(child?.type === 'hardBreak' || child?.type === 'text' && typeof child.text === 'string' && child.text.trim() === '');
        });
    };
    const content = document.content;
    let firstContentIndex = -1;
    let lastContentIndex = -1;
    // Find the first and last paragraphs with content and check if they are meaningful
    for(let i = 0; i < content.length; i++)if (isMeaningfulContentNode(content[i])) {
        if (firstContentIndex === -1) firstContentIndex = i;
        lastContentIndex = i;
    }
    // If no content was found, return an empty document
    if (firstContentIndex === -1) return {
        ...document,
        content: []
    };
    // Slice the content array to include only paragraphs between the first and last content
    const trimmedContent = content.slice(firstContentIndex, lastContentIndex + 1);
    // Return a new document with the trimmed content
    return {
        ...document,
        content: trimmedContent
    };
};


/* eslint-disable jsdoc/require-jsdoc */ 


function $fdd33d4d2ef4731c$export$80ffe7e3c6bf25c3(factory, propsDerivator, props) {
    // cache the last set of props
    const prev = (0, $cozmU.useRef)(props);
    const prevFactory = (0, $cozmU.useRef)(null);
    return (0, $cozmU.useMemo)(()=>{
        // check if the serializer is already created
        let shouldCreate = !prevFactory.current;
        // check each prop to see if value has changed and also check if the number of props has changed
        if (prev.current !== props) {
            const propsEntries = Object.entries(props);
            shouldCreate = propsEntries.length !== Object.keys(prev.current).length || propsEntries.some(([key, prop])=>prev.current[key] !== prop);
        }
        prev.current = props;
        // If first time or any prop value has changed, create a new serializer
        if (shouldCreate) prevFactory.current = factory(propsDerivator(props));
        return prevFactory.current;
    }, // To keep deps consistent, here disable the exhaustive-deps rule to drop factory from the deps array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        propsDerivator,
        props
    ]);
}



var $3uhT3 = parcelRequire("3uhT3");










var $iLcY8 = parcelRequire("iLcY8");

var $jzpoq = parcelRequire("jzpoq");




const $092200709d763fca$export$208d2421b73f3f86 = (renderer)=>{
    const tablesInfo = [];
    const tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach((tableWrapper)=>{
        const table = tableWrapper.querySelector(':scope > table');
        if (table) {
            const isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableWidth: table.scrollWidth,
                hasScrollbar: tableWrapper.clientWidth < table.scrollWidth,
                isNestedTable: isNestedTable
            });
        }
    });
    const maxTableWidth = Math.max(...tablesInfo.map((table)=>table.tableWidth));
    const editorWidth = renderer.scrollWidth;
    return {
        action: (0, $jzpoq.TABLE_ACTION).TABLE_WIDTH_INFO,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
        attributes: {
            editorWidth: editorWidth,
            editorWidthBreakpoint: (0, $6pnwK.getBreakpointKey)(editorWidth),
            tableWidthInfo: tablesInfo,
            maxTableWidthBreakpoint: (0, $6pnwK.getBreakpointKey)(maxTableWidth),
            hasTableWiderThanEditor: maxTableWidth > editorWidth,
            hasTableWithScrollbar: tablesInfo.some((table)=>table.hasScrollbar),
            mode: (0, $iLcY8.MODE).RENDERER
        },
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
    };
};
const $092200709d763fca$export$34e5b28c67455a81 = (renderer)=>{
    const tablesInfo = [];
    const tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach((tableWrapper)=>{
        const table = tableWrapper.querySelector(':scope > table');
        if (table) {
            const isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableHeight: table.scrollHeight,
                isNestedTable: isNestedTable
            });
        }
    });
    const maxTableHeight = Math.max(...tablesInfo.map((table)=>table.tableHeight));
    /** NOTE: Renderer is not scrollable, so this height represents the height of the content */ const rendererClientHeight = renderer.clientHeight;
    const viewportHeight = window.innerHeight;
    if (!viewportHeight) return undefined;
    return {
        action: (0, $jzpoq.TABLE_ACTION).TABLE_RENDERER_HEIGHT_INFO,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
        attributes: {
            viewportHeight: viewportHeight,
            rendererHeight: rendererClientHeight,
            maxTableHeight: maxTableHeight,
            maxTableToViewportHeightRatio: maxTableHeight / viewportHeight,
            tableHeightInfo: tablesInfo
        },
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
    };
};


function $bb65e8b3f77ab0e3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bb65e8b3f77ab0e3$export$47b2879ca9bbf67a = 2000;
const $bb65e8b3f77ab0e3$export$1b622068be977101 = 3000;
// we want to calculate all the table widths (which causes reflows) after the renderer has finished loading to mitigate performance impact
const $bb65e8b3f77ab0e3$var$TABLE_INFO_TIMEOUT = 10000;
const $bb65e8b3f77ab0e3$var$RENDER_EVENT_SAMPLE_RATE = 0.1;
const $bb65e8b3f77ab0e3$var$packageName = "platform-pkg";
const $bb65e8b3f77ab0e3$var$packageVersion = "0.0.0-use.local";
const $bb65e8b3f77ab0e3$var$setAsQueryContainerStyles = {
    name: "3qfej8",
    styles: "container-name:ak-renderer-wrapper;container-type:inline-size"
};
const $bb65e8b3f77ab0e3$var$handleMouseTripleClickInTables = (event)=>{
    const browser = (0, $8dxef.getBrowserInfo)();
    if (browser.ios || browser.android) return;
    const badBrowser = browser.chrome || browser.safari;
    const tripleClick = event.detail >= 3;
    if (!(badBrowser && tripleClick)) return;
    const selection = window.getSelection();
    if (!selection) return;
    const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
    const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
    if (!rangeSelection) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const tableCell = target.closest('td,th');
    const clickedInCell = Boolean(tableCell);
    if (!clickedInCell) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const anchorInCell = tableCell.contains(anchorNode);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const focusInCell = tableCell.contains(focusNode);
    const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
    if (!selectionStartsOrEndsOutsideClickedCell) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const elementToSelect = anchorInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    anchorNode.parentElement?.closest('div,p') : focusInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    focusNode.parentElement?.closest('div,p') : tableCell;
    if (elementToSelect) selection.selectAllChildren(elementToSelect);
};
/**
 * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
 * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
 * renderer out for the editor).
 * @param event Click event anywhere inside renderer
 * @param props
 * @param mouseDownSelection
 * @example
 */ const $bb65e8b3f77ab0e3$var$handleWrapperOnClick = (event, props, mouseDownSelection)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const targetElement = event.target;
    $bb65e8b3f77ab0e3$var$handleMouseTripleClickInTables(event);
    // ED-14862: When a user triple clicks to select a line of content inside a
    // a table cell, but the browser incorrectly moves the selection start or end into
    // a different table cell, we manually set the selection back to within the original
    // table cell the user intended to target
    if (!props.eventHandlers?.onUnhandledClick) return;
    if (!(targetElement instanceof window.Element)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rendererWrapper = event.currentTarget;
    const isInteractiveElementInTree = (0, $6FNab.findInTree)(targetElement, rendererWrapper, (0, $5ab4acf8b40b46e1$export$3dee5e4542c672d9));
    if (isInteractiveElementInTree) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const windowSelection = window.getSelection();
    const selection = windowSelection !== null ? windowSelection.toString() : undefined;
    const hasSelection = selection && selection.length !== 0;
    const hasSelectionMouseDown = mouseDownSelection.current && mouseDownSelection.current.length !== 0;
    const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
    if (allowEditBasedOnSelection) props.eventHandlers.onUnhandledClick(event);
};
const $bb65e8b3f77ab0e3$export$c49fe2316038f3c2 = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const mouseDownSelection = (0, $cozmU.useRef)(undefined);
    const providerFactory = (0, $cozmU.useMemo)(()=>props.dataProviders || new (0, $eNbr2.default)(), [
        props.dataProviders
    ]);
    const { nestedRendererType: nestedRendererType } = (0, $kS1Yv.useRendererContext)();
    const createRendererContext = (0, $cozmU.useMemo)(()=>(featureFlags, isTopLevelRenderer)=>{
            const normalizedFeatureFlags = (0, $3ppaK.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                isTopLevelRenderer: isTopLevelRenderer === undefined,
                nestedRendererType: // Propagate nestedRendererType into the inner RendererContextProvider so that
                // React components inside the renderer (e.g. Colgroup) can read it via
                // useRendererContext(). Without this, the inner provider overwrites the outer
                // AKRendererWrapper context and nestedRendererType becomes undefined.
                nestedRendererType
            };
        }, [
        nestedRendererType
    ]);
    const fireAnalyticsEventOld = (0, $cozmU.useCallback)((event)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        if (createAnalyticsEvent) {
            const channel = (0, $iTJtk.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        props
    ]);
    const fireAnalyticsEventNew = (0, $cozmU.useCallback)((event)=>{
        if (createAnalyticsEvent) {
            const channel = (0, $iTJtk.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsEvent = (0, $fqVYq.editorExperiment)('platform_renderer_fix_analytics_memo_callback', true, {
        exposure: true
    }) ? fireAnalyticsEventNew : fireAnalyticsEventOld;
    const deriveSerializerProps = (0, $cozmU.useCallback)((props)=>{
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = createRendererContext(props.featureFlags, props.isTopLevelRenderer);
        return {
            startPos: props.startPos ?? 0,
            providers: providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            hideExtensionKeysWhilePending: props.hideExtensionKeysWhilePending,
            portal: props.portal,
            objectContext: {
                adDoc: props.shouldRemoveEmptySpaceAroundContent ? (0, $c561375a29ca9f0a$export$c94cfc0c675062a1)(props.document) : props.document,
                schema: props.schema,
                ...props.rendererContext,
                nestedRendererType: nestedRendererType
            },
            appearance: props.appearance,
            contentMode: props.contentMode,
            onSetLinkTarget: props.onSetLinkTarget,
            disableHeadingIDs: props.disableHeadingIDs,
            headingIdPrefix: props.headingIdPrefix,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            mentionNodeDataProvider: props.mentionNodeDataProvider,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            extensionViewportSizes: props.extensionViewportSizes,
            getExtensionHeight: props.getExtensionHeight,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowDownloadCodeBlock: props.allowDownloadCodeBlock,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isPresentational: props.UNSTABLE_isPresentational,
            textHighlighter: props.textHighlighter || props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing,
            disableTableOverflowShadow: props.disableTableOverflowShadow,
            allowFixedColumnWidthOption: props.allowFixedColumnWidthOption,
            shouldDisplayExtensionAsInline: props.shouldDisplayExtensionAsInline
        };
    }, [
        createRendererContext,
        providerFactory,
        fireAnalyticsEvent,
        nestedRendererType
    ]);
    const serializer = (0, $fdd33d4d2ef4731c$export$80ffe7e3c6bf25c3)((serializerProps)=>props.createSerializer?.(serializerProps) ?? new (0, $8MoFC.default)(serializerProps), deriveSerializerProps, props);
    const localRef = (0, $cozmU.useRef)(null);
    const editorRef = props.innerRef || localRef;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $cozmU.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))(), []);
    const renderedMeasurementDistortedDurationMonitor = (0, $cozmU.useMemo)(()=>(0, $5vSgR.getDistortedDurationMonitor)(), []);
    // we are doing this to ensure it runs as
    // early as possible in the React lifecycle
    // to avoid any other side effects
    const measureStarted = (0, $cozmU.useRef)(false);
    const startAnalyticsMeasure = ()=>{
        (0, $hiQdW.startMeasure)(`Renderer Render Time: ${id}`);
    };
    if (!measureStarted.current) {
        startAnalyticsMeasure();
        measureStarted.current = true;
    }
    const anchorLinkAnalytics = (0, $cozmU.useCallback)(()=>{
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const disableHeadingIDs = props.disableHeadingIDs;
        if (!disableHeadingIDs && hash && editorRef && editorRef.current instanceof HTMLElement) {
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- anchor navigation uses document.getElementById for hash targets
            const anchorLinkElement = document.getElementById(hash);
            if (anchorLinkElement && editorRef.current.contains(anchorLinkElement)) fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).VIEWED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $cY9xy.PLATFORM).WEB,
                    mode: (0, $cY9xy.MODE).RENDERER
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            });
        }
    }, [
        props.disableHeadingIDs,
        editorRef,
        fireAnalyticsEvent
    ]);
    const getSchema = (0, $cozmU.useMemo)(()=>{
        return (schema, adfStage)=>{
            if (schema) return schema;
            return (0, $4XbfY.getSchemaBasedOnStage)(adfStage);
        };
    }, []);
    const onMouseDownEditView = ()=>{
        const windowSelection = window.getSelection();
        mouseDownSelection.current = windowSelection !== null ? windowSelection.toString() : undefined;
    };
    const { dataProviders: dataProviders, analyticsEventSeverityTracking: analyticsEventSeverityTracking } = props;
    (0, $cozmU.useEffect)(()=>{
        let rafID;
        let heightWidthAnalyticsSetTimeoutID;
        let heightWidthAnalyticsRicID;
        let heightWidthAnalyticsRafID;
        const handleAnalytics = ()=>{
            if (!(0, $iDrrr.fg)('platform_renderer_sample_high_volume_events') || Math.random() < $bb65e8b3f77ab0e3$var$RENDER_EVENT_SAMPLE_RATE) fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).STARTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, $cY9xy.PLATFORM).WEB,
                    sampleRate: (0, $iDrrr.fg)('platform_renderer_sample_high_volume_events') ? $bb65e8b3f77ab0e3$var$RENDER_EVENT_SAMPLE_RATE : 1
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            });
            rafID = requestAnimationFrame(()=>{
                (0, $hiQdW.stopMeasure)(`Renderer Render Time: ${id}`, (duration)=>{
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $jj5K7.shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, $6pnwK.getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $bb65e8b3f77ab0e3$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $bb65e8b3f77ab0e3$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = analyticsEventSeverityTracking?.enabled === false;
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const distortedDuration = renderedMeasurementDistortedDurationMonitor.distortedDuration;
                    const ttfb = (0, $fS38i.getResponseEndTime)();
                    const nodes = (0, $lxxPS.countNodes)(props.document);
                    // Always signal that the renderer has finished rendering, regardless of analytics
                    // sampling or TTR tracking config. This is a reliable, unsampled lifecycle hook
                    // (e.g. used to release a UFO load hold) and must not be coupled to the sampled
                    // `rendered` analytics event below, which only fires for a fraction of renders.
                    if (props.onRendered) props.onRendered({
                        duration: duration,
                        distortedDuration: distortedDuration,
                        nodes: nodes,
                        ttfb: ttfb
                    });
                    if (!isTTRTrackingExplicitlyDisabled) {
                        const event = {
                            action: (0, $krYZG.ACTION).RENDERED,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).RENDERER,
                            attributes: {
                                platform: (0, $cY9xy.PLATFORM).WEB,
                                duration: duration,
                                distortedDuration: distortedDuration,
                                ttfb: ttfb,
                                nodes: nodes,
                                nestedRendererType: (0, $fqVYq.editorExperiment)('platform_synced_block', true) ? nestedRendererType : undefined,
                                severity: severity,
                                sampleRate: (0, $iDrrr.fg)('platform_renderer_sample_high_volume_events') ? $bb65e8b3f77ab0e3$var$RENDER_EVENT_SAMPLE_RATE : 1
                            },
                            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                        };
                        if (!(0, $iDrrr.fg)('platform_renderer_sample_high_volume_events') || Math.random() < $bb65e8b3f77ab0e3$var$RENDER_EVENT_SAMPLE_RATE) fireAnalyticsEvent(event);
                    }
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderedMeasurementDistortedDurationMonitor.cleanup();
                });
                anchorLinkAnalytics();
            });
            // send statistics about the heights/widths of the tables on the page for alerting
            heightWidthAnalyticsSetTimeoutID = setTimeout(()=>{
                const requestIdleCallbackFn = ()=>{
                    const renderer = props.innerRef?.current?.querySelector('.ak-renderer-document');
                    if (renderer) {
                        const payload = (0, $092200709d763fca$export$208d2421b73f3f86)(renderer);
                        if (payload) fireAnalyticsEvent(payload);
                        if ((0, $iDrrr.fg)('platform_editor_table_height_analytics_event')) {
                            const payloadHeight = (0, $092200709d763fca$export$34e5b28c67455a81)(renderer);
                            if (payloadHeight) fireAnalyticsEvent(payloadHeight);
                        }
                    }
                };
                if (window && typeof window.requestIdleCallback === 'function') heightWidthAnalyticsRicID = window.requestIdleCallback(requestIdleCallbackFn);
                else if (window && typeof window.requestAnimationFrame === 'function') // requestIdleCallback is not supported in safari, fallback to requestAnimationFrame
                heightWidthAnalyticsRafID = window.requestAnimationFrame(requestIdleCallbackFn);
            }, $bb65e8b3f77ab0e3$var$TABLE_INFO_TIMEOUT);
        };
        handleAnalytics();
        return ()=>{
            if (rafID) window.cancelAnimationFrame(rafID);
            if (heightWidthAnalyticsSetTimeoutID) window.clearTimeout(heightWidthAnalyticsSetTimeoutID);
            if (heightWidthAnalyticsRafID) window.cancelAnimationFrame(heightWidthAnalyticsRafID);
            if (heightWidthAnalyticsRicID) window.cancelIdleCallback(heightWidthAnalyticsRicID);
            // if this is the ProviderFactory which was created in constructor
            // it's safe to destroy it on Renderer unmount
            // updated to match existing class component
            if (!dataProviders) providerFactory.destroy();
        };
    // we are going to ignore this because I'm doing this on purpose
    // having a dependency array means we run stopMeasure twice per render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const rendererContext = (0, $cozmU.useMemo)(()=>({
            ...createRendererContext(props.featureFlags, props.isTopLevelRenderer),
            timeZone: props.timeZone
        }), [
        props.featureFlags,
        props.isTopLevelRenderer,
        createRendererContext,
        props.timeZone
    ]);
    const isCollapsibleHeadingsEnabled = props.allowCollapsibleHeadings === true && [
        'full-page',
        'full-width',
        'max'
    ].includes(props.appearance || '') && rendererContext.isTopLevelRenderer && (0, $ieeJu.expValEquals)('platform_renderer_collapsible_headings', 'isEnabled', true);
    (0, $fd7707a93bd981d3$export$81bdbc2b3f1c95ef)(editorRef, props.document, props.scrollToBlock);
    try {
        const schema = getSchema(props.schema, props.adfStage);
        const allowTableInPanel = (0, $d5JQX.isPanelNestingTableSupported)(schema);
        const validationOverrides = allowTableInPanel ? {
            ...props.validationOverrides,
            allowTableInPanel: true
        } : props.validationOverrides;
        const { result: result, stat: stat, pmDoc: pmDoc } = (0, $j9MAI.renderDocument)(props.shouldRemoveEmptySpaceAroundContent ? (0, $c561375a29ca9f0a$export$c94cfc0c675062a1)(props.document) : props.document, serializer, schema, props.adfStage, props.useSpecBasedValidator, id, fireAnalyticsEvent, props.unsupportedContentLevelsTracking, props.appearance, props.includeNodesCountInStats, props.skipValidation, validationOverrides);
        if (props.onComplete) props.onComplete(stat);
        const rendererOutput = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kS1Yv.RendererContextProvider), {
            value: rendererContext
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lEb7o.ActiveHeaderIdProvider), {
            value: (0, $kXCPk.getActiveHeadingId)(props.allowHeadingAnchorLinks)
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $grAaA.default).Provider, {
            // eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            value: {
                fireAnalyticsEvent: (event)=>fireAnalyticsEvent(event)
            }
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $iWj7r.Provider), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $jB2jW.ProviderFactoryProvider), {
            value: providerFactory
        }, /*#__PURE__*/ (0, $lOiVq.jsx)($bb65e8b3f77ab0e3$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: props.contentMode || 'standard',
            allowNestedHeaderLinks: (0, $kXCPk.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            allowColumnSorting: props.allowColumnSorting,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowDownloadCodeBlock: props.allowDownloadCodeBlock,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowPlaceholderText: props.allowPlaceholderText,
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            innerRef: editorRef,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>$bb65e8b3f77ab0e3$var$handleWrapperOnClick(event, props, mouseDownSelection),
            onMouseDown: onMouseDownEditView,
            ssr: props.media?.ssr,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            shouldRemoveEmptySpaceAroundContent: props.shouldRemoveEmptySpaceAroundContent,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, props.enableSsrInlineScripts || props.noOpSSRInlineScript ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $0ccfa23417744341$export$cfc1361be0de4203), {
            noOpSSRInlineScript: Boolean(props.noOpSSRInlineScript)
        }) : null, /*#__PURE__*/ (0, $lOiVq.jsx)($bb65e8b3f77ab0e3$var$RendererActionsInternalUpdater, {
            doc: pmDoc,
            schema: schema,
            onAnalyticsEvent: fireAnalyticsEvent
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $jqmxP.CollapsibleHeadingsProvider), {
            pmDocument: pmDoc,
            rendererRef: editorRef,
            isEnabled: isCollapsibleHeadingsEnabled
        }, result))))))));
        const rendererResult = props.truncated ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $843f9ff6f4f11f31$export$79ad592494094f07), {
            height: props.maxHeight,
            fadeHeight: props.fadeOutHeight
        }, rendererOutput) : rendererOutput;
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, rendererResult);
    } catch (e) {
        if (props.onError) props.onError(e);
        return /*#__PURE__*/ (0, $lOiVq.jsx)($bb65e8b3f77ab0e3$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: props.contentMode || 'standard',
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowDownloadCodeBlock: props.allowDownloadCodeBlock,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowPlaceholderText: props.allowPlaceholderText,
            allowColumnSorting: props.allowColumnSorting,
            allowNestedHeaderLinks: (0, $kXCPk.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>$bb65e8b3f77ab0e3$var$handleWrapperOnClick(event, props, mouseDownSelection),
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $KTiWz.default), null));
    }
};
const $bb65e8b3f77ab0e3$var$RendererFunctionalComponentMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($bb65e8b3f77ab0e3$export$c49fe2316038f3c2);
const $bb65e8b3f77ab0e3$var$RendererFunctionalComponentWithPortalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    // If nodeComponents are provided, we don't remove portal from props and use context instead,
    // because we can't guarantee compatibility with existing Atlaskit Renderer consumers.
    if (props.nodeComponents) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bb65e8b3f77ab0e3$var$RendererFunctionalComponentMemoized, props);
    const { portal: portal, ...propsWithoutPortal } = props;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3uhT3.PortalContext).Provider, {
        value: portal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bb65e8b3f77ab0e3$export$c49fe2316038f3c2, propsWithoutPortal));
});
function $bb65e8b3f77ab0e3$export$88530751e3977073(props) {
    const { startPos: startPos } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $WNsSX.AnnotationsPositionContext));
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $kS1Yv.useRendererContext)();
    const { skipValidation: skipValidation, allowNestedTables: allowNestedTables } = (0, $cozmU.useContext)((0, $8Kasn.ValidationContext)) || {};
    const validationOverrides = (0, $cozmU.useMemo)(()=>({
            allowNestedTables: allowNestedTables
        }), [
        allowNestedTables
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)($bb65e8b3f77ab0e3$var$RendererFunctionalComponentWithPortalContext, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: props.isTopLevelRenderer ?? isTopLevelRenderer,
        skipValidation: skipValidation,
        validationOverrides: validationOverrides
    });
}
const $bb65e8b3f77ab0e3$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $eq1BO.FabricEditorAnalyticsContext), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        data: {
            appearance: (0, $ajhUs.getAnalyticsAppearance)(props.appearance),
            packageName: $bb65e8b3f77ab0e3$var$packageName,
            packageVersion: $bb65e8b3f77ab0e3$var$packageVersion,
            componentName: 'renderer',
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            editorSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))()
        }
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $2cfb903159881be7$export$9ac3d19711324187), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $gAjKf.ErrorBoundary), {
                component: (0, $krYZG.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $fghmm.IntlErrorBoundary), null, /*#__PURE__*/ (0, $lOiVq.jsx)($bb65e8b3f77ab0e3$export$88530751e3977073, {
                ...props,
                createAnalyticsEvent: createAnalyticsEvent
            })));
        }
    })));
const $bb65e8b3f77ab0e3$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, contentMode: contentMode, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer, allowRendererContainerStyles: allowRendererContainerStyles } = props;
    const createTelepointer = ()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- telepointer span for collaborative presence
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $2bxao.TELEPOINTER_ID);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(true);
    const { nestedRendererType: nestedRendererType } = (0, $kS1Yv.useRendererContext)();
    (0, $cozmU.useEffect)(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef?.current) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation, _index)=>{
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $2bxao.TELEPOINTER_ID)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $2bxao.TELEPOINTER_ID)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                    /**
           * When streaming ADF content, we may receive mutations where nodes get
           * replaced, rather than have characterData updated.
           *
           * Telepointer changes will also cause a childList mutation, so we manually ignore it.
           * Telepointer changes are always a singular node-adds or node-removes.
           */ if (mutation.type === 'childList' && !(mutation.addedNodes.length === 1 && mutation.addedNodes[0]?.id === (0, $2bxao.TELEPOINTER_ID) || mutation.removedNodes.length === 1 && mutation.removedNodes[0]?.id === (0, $2bxao.TELEPOINTER_ID))) {
                        const lastChild = renderer.lastChild;
                        if (lastChild) {
                            /**
               * We want to place telepointer inside content (which has data-renderer-start-pos) and
               * inside lines in codeblocks (which have data-ds--code--row).
               */ const contentElements = lastChild.querySelectorAll('[data-renderer-start-pos],[data-ds--code--row]');
                            const lastElement = contentElements[contentElements.length - 1];
                            const oldTelepointer = renderer.querySelector(`#${(0, $2bxao.TELEPOINTER_ID)}`);
                            if (lastElement) {
                                oldTelepointer?.remove();
                                lastElement?.appendChild(createTelepointer());
                            } else {
                                oldTelepointer?.remove();
                                lastChild?.appendChild(createTelepointer());
                            }
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    const renderer = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dUm2W.WidthProvider), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop -- legacy renderer wrapper appearance classes
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: isInsideOfInlineExtension
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $fTrZV.BaseTheme), {
        baseFontSize: (0, $fa5a721f2d81671e$export$8e2864079bc476bd)(appearance, contentMode)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $1f8729631b28776d$export$77218b6ff680865f), {
        ssr: ssr
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $2d4e6b1f55281137$export$8f0929e72efe521f), {
        innerRef: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        appearance: appearance,
        contentMode: contentMode,
        allowNestedHeaderLinks: allowNestedHeaderLinks,
        allowColumnSorting: !!allowColumnSorting,
        useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
        allowAnnotations: props.allowAnnotations,
        allowTableResizing: allowTableResizing,
        allowRendererContainerStyles: allowRendererContainerStyles,
        isInsideSyncBlock: nestedRendererType === 'syncedBlock'
    }, children))));
    // We can only make the wrapper div query container when we have a known width.
    // This is also required for SSR to work correctly. As WidthProvider/WithConsumer will not have the correct width during SSR.
    //
    // allowRendererContainerStyles is not needed for comment container styling as container should always be set for comments
    if (appearance === 'comment' && isTopLevelRenderer && (0, $iDrrr.fg)('platform-ssr-table-resize')) return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $bb65e8b3f77ab0e3$var$setAsQueryContainerStyles
    }, renderer);
    // We are setting this wrapper div as query container conditionally.
    // Only apply container-type = inline-size when having a known width in full-page/full-width/comment mode.
    // Otherwise when appearance is unspecified the renderer size is decided by the content.
    // In this case we can't set the container-type = inline-size as it will collapse width to 0.
    return (appearance === 'full-page' || appearance === 'full-width' || ((0, $anBbz.expValEqualsNoExposure)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && appearance === 'max') && // In case of having excerpt-include on page there are multiple renderers nested.
    // Make sure only the root renderer is set to be query container.
    isTopLevelRenderer && allowRendererContainerStyles && (0, $iDrrr.fg)('platform-ssr-table-resize') ? /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $bb65e8b3f77ab0e3$var$setAsQueryContainerStyles
    }, renderer) : renderer;
});
const $bb65e8b3f77ab0e3$var$RootRendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
function $bb65e8b3f77ab0e3$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const rootRendererContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($bb65e8b3f77ab0e3$var$RootRendererContext);
    const actions = (0, $cozmU.useContext)((0, $hRnS5.RendererContext));
    const rendererRef = (0, $cozmU.useRef)(null);
    // This doc is used by the renderer actions when applying comments to the document.
    // (via hand crafted steps based on non prosemirror based position calculations)
    // It is set to the root renderer's doc as otherwise the resulting document will
    // be incorrect (nested renderers use a fake document which represents a subset
    // of the actual document).
    let _doc;
    if ((0, $fqVYq.editorExperiment)('comment_on_bodied_extensions', true) && rootRendererContextValue) // If rootRendererContextValue is set -- we are inside a nested renderer
    // and should always use the doc from the root renderer
    _doc = rootRendererContextValue.doc;
    else // If rootRendererContextValue is not set -- we are in the root renderer
    // and set the doc to the current doc.
    _doc = doc;
    (0, $cozmU.useLayoutEffect)(()=>{
        if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        _doc,
        onAnalyticsEvent
    ]);
    if ((0, $fqVYq.editorExperiment)('comment_on_bodied_extensions', true)) return(// eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
    /*#__PURE__*/ (0, $lOiVq.jsx)($bb65e8b3f77ab0e3$var$RootRendererContext.Provider, {
        value: {
            doc: _doc
        }
    }, children));
    return children;
}
// Usage notes:
// Used by Confluence for nested renderers
// For the View page renderer - see RendererWithAnalytics
const $bb65e8b3f77ab0e3$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const innerRef = props.innerRef || localRef;
    // @see https://hello.jira.atlassian.cloud/browse/EDITOR-3389
    if (props.appearance === 'max' && !(0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) && !(0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) props.appearance = 'full-width';
    if (!allowAnnotations) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $lOiVq.jsx)($bb65e8b3f77ab0e3$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $WNsSX.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, /*#__PURE__*/ (0, $lOiVq.jsx)($bb65e8b3f77ab0e3$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props,
        featureFlags: props.featureFlags
    })));
};
var // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $bb65e8b3f77ab0e3$export$2e2bcd8739ae039 = $bb65e8b3f77ab0e3$var$RendererWithAnnotationSelection;
module.exports["RendererWithAnalytics"] = $bb65e8b3f77ab0e3$export$af81ffb59b6ef0dd;
module.exports["default"] = $bb65e8b3f77ab0e3$export$2e2bcd8739ae039;

});

parcelRegister("eNbr2", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $dc3c36ac51129759$var$isUndefined(x) {
    return x === undefined;
}
class $dc3c36ac51129759$export$2e2bcd8739ae039 {
    static create(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providers) {
        const providerFactory = new $dc3c36ac51129759$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$dc3c36ac51129759$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
        return provider;
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.providers = new Map();
        this.subscribers = new Map();
    }
}
module.exports["default"] = $dc3c36ac51129759$export$2e2bcd8739ae039;

});

parcelRegister("jB2jW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eNbr2 = parcelRequire("eNbr2");

const $6d306cee8db31413$var$ProviderFactoryContext = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(new (0, $eNbr2.default)());
const $6d306cee8db31413$export$617c134b25cc4265 = $6d306cee8db31413$var$ProviderFactoryContext.Provider;
const $6d306cee8db31413$export$a3af4b6980aa23b5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($6d306cee8db31413$var$ProviderFactoryContext);
} : ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($6d306cee8db31413$var$ProviderFactoryContext);
const $6d306cee8db31413$export$693cdb10cec23617 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (name)=>{
    const $ = (0, $bDgLe.c)(4);
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState();
    const providerFactory = $6d306cee8db31413$export$a3af4b6980aa23b5();
    let t0;
    let t1;
    if ($[0] !== name || $[1] !== providerFactory) {
        t0 = ()=>{
            const providerHandler = (_, provider_0)=>{
                setProvider(provider_0);
            };
            providerFactory.subscribe(name, providerHandler);
            return ()=>{
                providerFactory.unsubscribe(name, providerHandler);
            };
        };
        t1 = [
            name,
            providerFactory
        ];
        $[0] = name;
        $[1] = providerFactory;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t0, t1);
    return provider;
} : (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState();
    const providerFactory = $6d306cee8db31413$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        const providerHandler = (_, provider_0)=>{
            setProvider(provider_0);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
const $6d306cee8db31413$export$6fde1d0d81db98e1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (name)=>{
    const $ = (0, $bDgLe.c)(4);
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState();
    const providerFactory = $6d306cee8db31413$export$a3af4b6980aa23b5();
    let t0;
    let t1;
    if ($[0] !== name || $[1] !== providerFactory) {
        t0 = ()=>{
            const providerHandler = (_, provider_0)=>{
                setProvider(provider_0);
            };
            providerFactory.subscribe(name, providerHandler);
            return ()=>{
                providerFactory.unsubscribe(name, providerHandler);
            };
        };
        t1 = [
            name,
            providerFactory
        ];
        $[0] = name;
        $[1] = providerFactory;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useLayoutEffect(t0, t1);
    return provider;
} : (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState();
    const providerFactory = $6d306cee8db31413$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useLayoutEffect(()=>{
        const providerHandler = (_, provider_0)=>{
            setProvider(provider_0);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
module.exports["ProviderFactoryProvider"] = $6d306cee8db31413$export$617c134b25cc4265;
module.exports["useProviderFactory"] = $6d306cee8db31413$export$a3af4b6980aa23b5;
module.exports["useProvider"] = $6d306cee8db31413$export$693cdb10cec23617;
module.exports["useProviderLayout"] = $6d306cee8db31413$export$6fde1d0d81db98e1;

});

parcelRegister("dUm2W", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $dOBRD = parcelRequire("dOBRD");


var $LQnOI = parcelRequire("LQnOI");


var $1LXnB = parcelRequire("1LXnB");


var $4iudd = parcelRequire("4iudd");

function $77df2560c2ba7d6c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $77df2560c2ba7d6c$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $77df2560c2ba7d6c$var$SCROLLBAR_WIDTH = 30;
function $77df2560c2ba7d6c$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $77df2560c2ba7d6c$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $77df2560c2ba7d6c$export$1eb095b00b926404(width)
    };
}
const $77df2560c2ba7d6c$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($77df2560c2ba7d6c$export$31a4966bffb9ac98());
const $77df2560c2ba7d6c$var$Provider = $77df2560c2ba7d6c$export$27e39f636459b9f.Provider;
const $77df2560c2ba7d6c$export$5d8538aa831b6ebb = $77df2560c2ba7d6c$export$27e39f636459b9f.Consumer;
const $77df2560c2ba7d6c$export$df154c49e93b2ac2 = (0, $dOBRD.default)(()=>{
    return (0, $4iudd.isSSR)() ? 0 : document.body?.offsetWidth ?? 0;
});
const $77df2560c2ba7d6c$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, $cozmU.useContext)($77df2560c2ba7d6c$export$27e39f636459b9f);
    const [width, setWidth] = (0, $cozmU.useState)($77df2560c2ba7d6c$export$df154c49e93b2ac2);
    const widthRef = (0, $cozmU.useRef)(width);
    const isMountedRef = (0, $cozmU.useRef)(true);
    const providerValue = (0, $cozmU.useMemo)(()=>$77df2560c2ba7d6c$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $cozmU.useMemo)(()=>{
        return (0, $LQnOI.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $77df2560c2ba7d6c$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            widthRef.current = nextWidth;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $77df2560c2ba7d6c$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, !skipWidthDetection && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $1LXnB.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $lOiVq.jsx)($77df2560c2ba7d6c$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};
module.exports["getBreakpoint"] = $77df2560c2ba7d6c$export$1eb095b00b926404;
module.exports["createWidthContext"] = $77df2560c2ba7d6c$export$31a4966bffb9ac98;
module.exports["WidthContext"] = $77df2560c2ba7d6c$export$27e39f636459b9f;
module.exports["WidthConsumer"] = $77df2560c2ba7d6c$export$5d8538aa831b6ebb;
module.exports["WidthProvider"] = $77df2560c2ba7d6c$export$7921e18173e8c666;

});

parcelRegister("fghmm", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $6244048130413b2c$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $6244048130413b2c$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
class $6244048130413b2c$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch(error, _errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($6244048130413b2c$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.IntlProvider), {
            locale: "en",
            children: this.props.children
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}
module.exports["IntlErrorBoundary"] = $6244048130413b2c$export$7df0749115d18d19;

});

parcelRegister("KTiWz", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $7Y8M5 = parcelRequire("7Y8M5");


var $kyJuy = parcelRequire("kyJuy");


var $lpNn5 = parcelRequire("lpNn5");


var $krYZG = parcelRequire("krYZG");


var $bHKSU = parcelRequire("bHKSU");


var $1H5A4 = parcelRequire("1H5A4");


var $a89Z1 = parcelRequire("a89Z1");

const $5dd8a46a9705cc7b$var$blockNodeStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    background: "var(--ds-background-disabled, #0515240F)",
    border: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-disabled, #0515240F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $7Y8M5.relativeFontSizeToBase16)(14),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $5dd8a46a9705cc7b$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $a89Z1.getUnsupportedContent)((0, $bHKSU.unsupportedContentMessages).unsupportedBlockContent, (0, $bHKSU.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $bHKSU.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $cozmU.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $cozmU.useCallback)(()=>dispatchAnalyticsEvent && (0, $1H5A4.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $krYZG.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $5dd8a46a9705cc7b$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))), {
        label: "?"
    })))));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $5dd8a46a9705cc7b$var$_default_1 = (0, $kSwu1.injectIntl)($5dd8a46a9705cc7b$var$UnsupportedBlockNode);
var $5dd8a46a9705cc7b$export$2e2bcd8739ae039 = $5dd8a46a9705cc7b$var$_default_1;
module.exports["default"] = $5dd8a46a9705cc7b$export$2e2bcd8739ae039;

});

parcelRegister("bHKSU", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $9335437a6c654760$export$32ec96484dd3ba39 = (0, $kSwu1.defineMessages)({
    unsupportedInlineContent: {
        id: "fabric.editor.unsupportedInlineContent",
        defaultMessage: "Unsupported content"
    },
    unsupportedBlockContent: {
        id: "fabric.editor.unsupportedBlockContent",
        defaultMessage: "This editor does not support displaying this content"
    },
    unsupportedContentTooltip: {
        id: "fabric.editor.unsupportedContentTooltip",
        defaultMessage: "Content is not available in this editor, this will be preserved when you edit and save"
    }
});
module.exports["unsupportedContentMessages"] = $9335437a6c654760$export$32ec96484dd3ba39;

});

parcelRegister("8dxef", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $08398feee5bb89d0$var$IE_EDGE_REGEX = /\sedg\//i;
// eslint-disable-next-line require-unicode-regexp
const $08398feee5bb89d0$var$IE_EDGE2_REGEX = /edg([ea]|ios)/i;
// eslint-disable-next-line require-unicode-regexp
const $08398feee5bb89d0$var$INTERNET_EXPLORER_REGEX = /msie|trident/i;
// eslint-disable-next-line require-unicode-regexp
const $08398feee5bb89d0$var$MAC_REGEX = /Mac/;
// eslint-disable-next-line require-unicode-regexp
const $08398feee5bb89d0$var$WINDOWS_REGEX = /Windows|Win\d+/i;
// eslint-disable-next-line require-unicode-regexp
const $08398feee5bb89d0$var$IE_EDGE_VERSION_REGEX = /\sedg\/(\d+(\.?_?\d+)+)/i;
// eslint-disable-next-line require-unicode-regexp
const $08398feee5bb89d0$var$IE_EDGE2_VERSION_REGEX = /edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i;
// eslint-disable-next-line require-unicode-regexp
const $08398feee5bb89d0$var$IE_VERSION_REGEX = /(?:msie |rv:)(\d+(\.?_?\d+)+)/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $08398feee5bb89d0$var$GECKO_REGEX = /gecko\/\d/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $08398feee5bb89d0$var$FIREFOX_VERSION_REGEX = /Firefox\/(\d+)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $08398feee5bb89d0$var$CHROME_REGEX = /Chrome\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $08398feee5bb89d0$var$CHROME_VERSION_REGEX = /Chrome\/(\d+)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $08398feee5bb89d0$var$ANDROID_REGEX = /Android \d/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $08398feee5bb89d0$var$APPLE_WEBKIT_REGEX = /AppleWebKit/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $08398feee5bb89d0$var$MOBILE_REGEX = /Mobile\/\w+/;
// eslint-disable-next-line require-unicode-regexp
const $08398feee5bb89d0$var$SAFARI_REGEX = /safari|applewebkit/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $08398feee5bb89d0$var$SAFARI_VERSION_REGEX = /Version\/([0-9\._]+).*Safari/;
// eslint-disable-next-line require-unicode-regexp
const $08398feee5bb89d0$var$WEBKIT_REGEX = /(apple)?webkit/i;
const $08398feee5bb89d0$var$getFirstMatch = (regexp, ua)=>{
    const match = ua.match(regexp);
    return match && match.length > 0 && match[1] || '';
};
const $08398feee5bb89d0$var$getSecondMatch = (regexp, ua)=>{
    const match = ua.match(regexp);
    return match && match.length > 0 && match[2] || '';
};
// Helper functions to safely access browser properties
const $08398feee5bb89d0$var$getSafeUserAgent = ()=>{
    if (typeof window === 'undefined') return undefined;
    // Fallback to navigator.userAgent with proper null checking
    return window.navigator?.userAgent;
};
const $08398feee5bb89d0$var$getSafePlatform = ()=>{
    if (typeof window === 'undefined') return undefined;
    return window.navigator?.platform;
};
const $08398feee5bb89d0$var$hasIntersectionObserver = ()=>{
    return typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
};
const $08398feee5bb89d0$var$hasResizeObserver = ()=>{
    return typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
};
const $08398feee5bb89d0$export$6c724a6ffa2dc3e1 = (0, $dOBRD.default)(()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {
        mac: false,
        windows: false,
        ie: false,
        ie_version: 0,
        gecko: false,
        gecko_version: 0,
        chrome: false,
        chrome_version: 0,
        android: false,
        ios: false,
        webkit: false,
        safari: false,
        safari_version: 0,
        supportsIntersectionObserver: false,
        supportsResizeObserver: false
    };
    const userAgent = $08398feee5bb89d0$var$getSafeUserAgent();
    const platform = $08398feee5bb89d0$var$getSafePlatform();
    if (userAgent) {
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        const ieEdge = $08398feee5bb89d0$var$IE_EDGE_REGEX.test(userAgent);
        const ieEdge2 = $08398feee5bb89d0$var$IE_EDGE2_REGEX.test(userAgent);
        const internetExplorer = $08398feee5bb89d0$var$INTERNET_EXPLORER_REGEX.test(userAgent);
        // Ideally we should use userAgent instead of platform, but we have lots of keymap tests failure when we change it
        // So leave it as is for now.
        result.mac = platform && $08398feee5bb89d0$var$MAC_REGEX.test(platform);
        // Previously relied on navigator.userAgentData?.platform and userAgent, now used only userAgent
        result.windows = $08398feee5bb89d0$var$WINDOWS_REGEX.test(userAgent);
        // used userAgent rather than relying on documentMode
        const ie = ieEdge || ieEdge2 || internetExplorer;
        result.ie = ie;
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        result.ie_version = ieEdge ? parseInt($08398feee5bb89d0$var$getFirstMatch($08398feee5bb89d0$var$IE_EDGE_VERSION_REGEX, userAgent), 10) : ieEdge2 ? parseInt($08398feee5bb89d0$var$getSecondMatch($08398feee5bb89d0$var$IE_EDGE2_VERSION_REGEX, userAgent), 10) : parseInt($08398feee5bb89d0$var$getFirstMatch($08398feee5bb89d0$var$IE_VERSION_REGEX, userAgent), 10);
        result.gecko = !ie && $08398feee5bb89d0$var$GECKO_REGEX.test(userAgent);
        result.gecko_version = parseInt((userAgent.match($08398feee5bb89d0$var$FIREFOX_VERSION_REGEX) || [])[1], 10);
        result.chrome = !ie && $08398feee5bb89d0$var$CHROME_REGEX.test(userAgent);
        result.chrome_version = parseInt((userAgent.match($08398feee5bb89d0$var$CHROME_VERSION_REGEX) || [])[1], 10);
        result.android = $08398feee5bb89d0$var$ANDROID_REGEX.test(userAgent);
        result.ios = !ie && $08398feee5bb89d0$var$APPLE_WEBKIT_REGEX.test(userAgent) && $08398feee5bb89d0$var$MOBILE_REGEX.test(userAgent);
        // Previously relied on navigator.vendor, now used userAgent
        result.safari = !result.chrome && !result.ie && !result.gecko && !result.android && !userAgent.includes('CriOS') && !userAgent.includes('FxiOS') && $08398feee5bb89d0$var$SAFARI_REGEX.test(userAgent);
        result.safari_version = parseInt((userAgent.match($08398feee5bb89d0$var$SAFARI_VERSION_REGEX) || [])[1], 10);
        // Previously we relied on documentElement.style.WebkitAppearance, now changed to userAgent
        result.webkit = $08398feee5bb89d0$var$WEBKIT_REGEX.test(userAgent);
        result.supportsIntersectionObserver = $08398feee5bb89d0$var$hasIntersectionObserver();
        result.supportsResizeObserver = $08398feee5bb89d0$var$hasResizeObserver();
    }
    return result;
});
module.exports["getBrowserInfo"] = $08398feee5bb89d0$export$6c724a6ffa2dc3e1;

});

parcelRegister("d5JQX", function(module, exports) {

var $ieeJu = parcelRequire("ieeJu");

const $5f7e89b77e8ef465$export$da873e3c90937d2a = (schema)=>{
    const { table: table, panel_c1: panel_c1 } = schema.nodes;
    if (!table || !panel_c1) return false;
    // Confirm the PM schema actually allows table inside panel_c1
    const panelC1CanContainTable = panel_c1.contentMatch.matchType(table)?.validEnd === true;
    return panelC1CanContainTable && (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true);
};
module.exports["isPanelNestingTableSupported"] = $5f7e89b77e8ef465$export$da873e3c90937d2a;

});

parcelRegister("hiQdW", function(module, exports) {

var $gMweA = parcelRequire("gMweA");

const $a6eff7a9bfeb44f2$var$measureMap = new Map();
function $a6eff7a9bfeb44f2$export$b62aa2130c86b59b(measureName) {
    if (!(0, $gMweA.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $a6eff7a9bfeb44f2$var$measureMap.set(measureName, performance.now());
}
function $a6eff7a9bfeb44f2$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $gMweA.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $a6eff7a9bfeb44f2$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $a6eff7a9bfeb44f2$export$6f766653554dac02(measureName);
    }
}
function $a6eff7a9bfeb44f2$export$6f766653554dac02(measureName) {
    if (!(0, $gMweA.isPerformanceAPIAvailable)()) return;
    $a6eff7a9bfeb44f2$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
function $a6eff7a9bfeb44f2$export$b0a51f9f0047ea32(measureName) {
    if (!(0, $gMweA.isPerformanceAPIAvailable)()) return false;
    return $a6eff7a9bfeb44f2$var$measureMap.get(measureName) !== undefined;
}
module.exports["startMeasure"] = $a6eff7a9bfeb44f2$export$b62aa2130c86b59b;
module.exports["stopMeasure"] = $a6eff7a9bfeb44f2$export$37c25be427bec097;
module.exports["clearMeasure"] = $a6eff7a9bfeb44f2$export$6f766653554dac02;
module.exports["isMeasuring"] = $a6eff7a9bfeb44f2$export$b0a51f9f0047ea32;

});

parcelRegister("gMweA", function(module, exports) {
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => (parcelRequire("0P5jP")).isPerformanceObserverAvailable);

var $0P5jP = parcelRequire("0P5jP");

let $64d704b66c9f5ead$var$hasRequiredPerformanceAPIs;
function $64d704b66c9f5ead$export$b5717a625dd4a3eb() {
    if ($64d704b66c9f5ead$var$hasRequiredPerformanceAPIs === undefined) $64d704b66c9f5ead$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $64d704b66c9f5ead$var$hasRequiredPerformanceAPIs;
}
function $64d704b66c9f5ead$export$4370ec0f52022f66() {
    return (0, $0P5jP.isPerformanceObserverAvailable)() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}
module.exports["isPerformanceAPIAvailable"] = $64d704b66c9f5ead$export$b5717a625dd4a3eb;

});

parcelRegister("0P5jP", function(module, exports) {
function $7ea4cfde2812d56f$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}
module.exports["isPerformanceObserverAvailable"] = $7ea4cfde2812d56f$export$48995af1e77d8643;

});

parcelRegister("5vSgR", function(module, exports) {

var $gMweA = parcelRequire("gMweA");

const $f866b4542ca0f9a1$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
     * Cleans up the document visibility event listener
     */ cleanup () {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $f866b4542ca0f9a1$export$267ed650a5d21ae6(/**
 * Unique name for the measurement
 *
 * Important: if multiple measureRender events are fired at the same time
 * with the same measure name -- the result will not be correct.
 */ measureName, /**
 * Call back fired when the measurement completes.
 *
 * Note: when this function is called when the Document.visibilityState is not
 * visible -- the duration is likely to be misleading/inaccurate. This is due
 * to the measurements use of the `requestAnimationFrame` api which only fires
 * when the Document.visibilityState is visible.
 */ onMeasureComplete) {
    if (!(0, $gMweA.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    const distortedDurationMonitor = $f866b4542ca0f9a1$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}
module.exports["getDistortedDurationMonitor"] = $f866b4542ca0f9a1$export$70f7d127254a90c;
module.exports["measureRender"] = $f866b4542ca0f9a1$export$267ed650a5d21ae6;

});

parcelRegister("fS38i", function(module, exports) {

var $gMweA = parcelRequire("gMweA");

function $779e02c0c8a07560$export$92d097a1155bbe27() {
    if (!(0, $gMweA.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}
module.exports["getResponseEndTime"] = $779e02c0c8a07560$export$92d097a1155bbe27;

});

parcelRegister("cwk3g", function(module, exports) {
const $34a0298c1df3adf4$export$18a71eb9fe4307bc = 'block-';
const $34a0298c1df3adf4$export$d7e471f6502a69e2 = (hash, prefix = $34a0298c1df3adf4$export$18a71eb9fe4307bc)=>{
    if (!hash || !prefix) return false;
    // Match either UUID format (8-4-4-4-12) or short hex ID format (exactly 12 hex chars without dashes).
    // Ignored via go/ees019
    const uuidRegex = new RegExp(`^#?${prefix}[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$`, 'iu');
    // Ignored via go/ees019
    const shortIdRegex = new RegExp(`^#?${prefix}[0-9a-f]{12}$`, 'iu');
    return uuidRegex.test(hash) || shortIdRegex.test(hash);
};
const $34a0298c1df3adf4$export$c95c8d5e0fd74b32 = (hash, prefix = $34a0298c1df3adf4$export$18a71eb9fe4307bc)=>{
    if (!$34a0298c1df3adf4$export$d7e471f6502a69e2(hash, prefix)) return null;
    // Remove leading # if present, then remove the prefix.
    const normalized = hash.startsWith('#') ? hash.slice(1) : hash;
    return normalized.slice(prefix.length);
};
const $34a0298c1df3adf4$export$7d28ccc9eddf2197 = (blockId, prefix = $34a0298c1df3adf4$export$18a71eb9fe4307bc)=>{
    return `${prefix}${blockId}`;
};
module.exports["DEFAULT_BLOCK_LINK_HASH_PREFIX"] = $34a0298c1df3adf4$export$18a71eb9fe4307bc;
module.exports["extractBlockIdFromLinkHash"] = $34a0298c1df3adf4$export$c95c8d5e0fd74b32;
module.exports["createBlockLinkHashValue"] = $34a0298c1df3adf4$export$7d28ccc9eddf2197;

});

parcelRegister("fHjdT", function(module, exports) {
const $81219f89b25a34ba$export$94a68fcf7c5634d2 = (localId, container)=>{
    // Check if the element with data-local-id exists
    let element = container.querySelector(`[data-local-id="${localId}"]`);
    if (element) return element;
    // Special case for decision lists and task lists which already have localId
    element = container.querySelector(`[data-decision-list-local-id="${localId}"]`);
    if (element) return element;
    element = container.querySelector(`[data-task-list-local-id="${localId}"]`);
    if (element) return element;
    // Special case for tables which use data-table-local-id
    element = container.querySelector(`[data-table-local-id="${localId}"]`);
    if (element) // return table wrapper instead of table div, so the height calculation is correct
    return element.parentElement;
    // Special case for extension, smart cards and media which use lowercase localid
    element = container.querySelector(`[localid="${localId}"]`);
    if (element) return element;
    return null;
};
module.exports["getLocalIdSelector"] = $81219f89b25a34ba$export$94a68fcf7c5634d2;

});

parcelRegister("ajhUs", function(module, exports) {

var $kLVNa = parcelRequire("kLVNa");

const $d9df40557d5b8b04$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $kLVNa.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $kLVNa.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $kLVNa.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $kLVNa.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $kLVNa.EDITOR_APPEARANCE_CONTEXT).MOBILE;
        case 'max':
            return (0, $kLVNa.EDITOR_APPEARANCE_CONTEXT).MAX;
    }
};
module.exports["getAnalyticsAppearance"] = $d9df40557d5b8b04$export$be87849653b93e6b;

});

parcelRegister("6pnwK", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsAppearance", () => (parcelRequire("ajhUs")).getAnalyticsAppearance);

var $ajhUs = parcelRequire("ajhUs");


var $aEjzW = parcelRequire("aEjzW");


var $24ZxJ = parcelRequire("24ZxJ");

const $ce832f390774d8e6$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${(0, $ajhUs.getAnalyticsAppearance)(editorAppearance)}` : '_unknown';
const $ce832f390774d8e6$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return (0, $aEjzW.SEVERITY).DEGRADED;
    if (duration > degradedThreshold) return (0, $aEjzW.SEVERITY).BLOCKING;
    return (0, $aEjzW.SEVERITY).NORMAL;
};
const $ce832f390774d8e6$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';
const $ce832f390774d8e6$var$EDITOR_BREAKPOINT_WIDTH = {
    S: 760,
    M: 1600,
    L: Infinity
};
const $ce832f390774d8e6$var$TABLE_BREAKPOINT_KEYS = Object.keys($ce832f390774d8e6$var$EDITOR_BREAKPOINT_WIDTH);
const $ce832f390774d8e6$export$afdcbbd112676ca8 = (width)=>{
    return $ce832f390774d8e6$var$TABLE_BREAKPOINT_KEYS.find((key)=>width <= $ce832f390774d8e6$var$EDITOR_BREAKPOINT_WIDTH[key]) || 'L';
};
module.exports["getAnalyticsEditorAppearance"] = $ce832f390774d8e6$export$31ae53e002edded0;
module.exports["getAnalyticsEventSeverity"] = $ce832f390774d8e6$export$f8edd689e8b20f3a;
module.exports["analyticsEventKey"] = $ce832f390774d8e6$export$288273ee3e3b6132;
module.exports["getBreakpointKey"] = $ce832f390774d8e6$export$afdcbbd112676ca8;

});

parcelRegister("aEjzW", function(module, exports) {
var $a6541de078a3125a$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});
module.exports["SEVERITY"] = $a6541de078a3125a$export$6a6bef12562cd865;

});

parcelRegister("24ZxJ", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $8HW7o = parcelRequire("8HW7o");

function $8e7bbeae3d9bce7c$export$d770b562ead089d8(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    if (selection instanceof (0, $kCECX.NodeSelection)) return selection.node.type.name;
    if (selection instanceof (0, $8HW7o.CellSelection)) return schema.nodes.table.name;
    // Text selection
    const parentNodeInfo = (0, $bjg0G.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}
module.exports["findInsertLocation"] = $8e7bbeae3d9bce7c$export$d770b562ead089d8;

});

parcelRegister("8HW7o", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");

/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json




var $kWLy1 = parcelRequire("kWLy1");

class $b68d59c238011b06$export$ca751a6394ad160e {
    map(mapping) {
        return new $b68d59c238011b06$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $kWLy1.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $kCECX.Selection).fromJSON(doc, data);
        }
        return (0, $kCECX.Selection).near($headCell, 1);
    }
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
}



var $8Z43Z = parcelRequire("8Z43Z");


var $7zMjs = parcelRequire("7zMjs");


var $ksfbF = parcelRequire("ksfbF");







function $dfeda3b236071f91$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $8Z43Z.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $kCECX.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}





class $d835bdf18d02cc62$export$831cc7e2a83afa94 extends (0, $kCECX.Selection) {
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $7zMjs.pointsAtCell)($anchorCell) && (0, $7zMjs.pointsAtCell)($headCell) && (0, $kWLy1.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $d835bdf18d02cc62$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $d835bdf18d02cc62$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $d835bdf18d02cc62$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $kCECX.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $8Z43Z.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $ksfbF.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        attrs = (0, $ksfbF.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            const rowNode = table.child(row).copy((0, $aPdNQ.Fragment).from(rowContent));
            rows.push(rowNode);
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $aPdNQ.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $aPdNQ.Slice).empty : content);
        }
        const sel = (0, $kCECX.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $8Z43Z.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $8Z43Z.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $d835bdf18d02cc62$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $8Z43Z.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        const maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $d835bdf18d02cc62$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell, reverse = false) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $8Z43Z.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return reverse ? new $d835bdf18d02cc62$export$831cc7e2a83afa94($calculatedHeadCell, $calculatedAnchorCell) : new $d835bdf18d02cc62$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $d835bdf18d02cc62$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $d835bdf18d02cc62$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $b68d59c238011b06$export$ca751a6394ad160e)(this.$anchorCell.pos, this.$headCell.pos);
    }
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $dfeda3b236071f91$export$a60a444208fd5099)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        // :: (ResolvedPos, ?ResolvedPos)
        // A table selection is identified by its anchor and head cells. The
        // positions given to this constructor should point _before_ two
        // cells in the same table. They may be the same, to select a single
        // cell.
        this.$anchorCell = void 0;
        this.$headCell = void 0;
        this.visible = void 0;
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
}
(0, $kCECX.Selection).jsonID('cell', $d835bdf18d02cc62$export$831cc7e2a83afa94);
module.exports["CellSelection"] = $d835bdf18d02cc62$export$831cc7e2a83afa94;

});

parcelRegister("kWLy1", function(module, exports) {
function $2611d0b6acba1fe4$export$217a88ad224d1b11(state) {
    const { $head: $head } = state.selection;
    for(let d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}
function $2611d0b6acba1fe4$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}
module.exports["isInTable"] = $2611d0b6acba1fe4$export$217a88ad224d1b11;
module.exports["inSameTable"] = $2611d0b6acba1fe4$export$debd62b44eb7e281;

});

parcelRegister("7zMjs", function(module, exports) {
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $8Z43Z = parcelRequire("8Z43Z");

function $e8bd96f533b9ad32$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $e8bd96f533b9ad32$export$7a283ef453dbae9e($pos) {
    for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
    }
    return null;
}
function $e8bd96f533b9ad32$export$1f482d92c57578ce($pos) {
    for(let d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}
function $e8bd96f533b9ad32$export$172699367bb25225($pos, axis, dir) {
    const start = $pos.start(-1);
    const map = (0, $8Z43Z.TableMap).get($pos.node(-1));
    const moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}
module.exports["pointsAtCell"] = $e8bd96f533b9ad32$export$3c89e45c7dff9619;
module.exports["cellNear"] = $e8bd96f533b9ad32$export$7a283ef453dbae9e;
module.exports["cellAround"] = $e8bd96f533b9ad32$export$1f482d92c57578ce;
module.exports["nextCell"] = $e8bd96f533b9ad32$export$172699367bb25225;

});

parcelRegister("ksfbF", function(module, exports) {
function $4a7200bf6f2bb1b8$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}
function $4a7200bf6f2bb1b8$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
}
function $4a7200bf6f2bb1b8$export$147ee78a1321ac36(attrs, pos, n = 1) {
    $4a7200bf6f2bb1b8$export$6fccdf7cee1b5201(attrs);
    const result = {
        ...attrs,
        colspan: attrs.colspan + n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}
module.exports["removeColSpan"] = $4a7200bf6f2bb1b8$export$b24d9c3cc95412e0;
module.exports["assertColspan"] = $4a7200bf6f2bb1b8$export$6fccdf7cee1b5201;
module.exports["addColSpan"] = $4a7200bf6f2bb1b8$export$147ee78a1321ac36;

});

parcelRegister("jj5K7", function(module, exports) {
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $396ccae53aaf2883$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260
module.exports["shouldForceTracking"] = $396ccae53aaf2883$export$5b59d3e9e22dbdc6;

});

parcelRegister("3ppaK", function(module, exports) {

var $j4yZr = parcelRequire("j4yZr");


var $hQhZW = parcelRequire("hQhZW");


var $dnhfp = parcelRequire("dnhfp");

const $80c9b95146cf8f78$var$EMPTY = {};
function $80c9b95146cf8f78$var$isObjectFlagKey(key, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && objectFlagKeys?.includes(key));
}
function $80c9b95146cf8f78$var$isValidJSONObject(value) {
    try {
        const result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $80c9b95146cf8f78$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $80c9b95146cf8f78$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($80c9b95146cf8f78$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($j4yZr)))(e[0]), e[1], options?.objectFlagKeys) && $80c9b95146cf8f78$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($hQhZW)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($j4yZr)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($80c9b95146cf8f78$var$isObjectFlagKey(key, value, options?.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}
module.exports["normalizeFeatureFlags"] = $80c9b95146cf8f78$export$f1485fc4974593c0;

});

parcelRegister("hQhZW", function(module, exports) {

var $cAUrU = parcelRequire("cAUrU");

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $cfd5410767f20d6a$var$kebabCase = $cAUrU(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
module.exports = $cfd5410767f20d6a$var$kebabCase;

});

parcelRegister("dnhfp", function(module, exports) {
function $c64f0e76e9f9ccee$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}
module.exports["getEnabledFeatureFlagKeys"] = $c64f0e76e9f9ccee$export$6d018dd0f6cbebcb;

});

parcelRegister("8MoFC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aPdNQ = parcelRequire("aPdNQ");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");

parcelRequire("6lXol");
var $5iJHZ = parcelRequire("5iJHZ");
var $6lXol = parcelRequire("6lXol");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");

var $7482641f3477b828$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});





const $9ab683eeecbee02a$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($9ab683eeecbee02a$var$isReactElement(childNode) && childNode.props.children) result = $9ab683eeecbee02a$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $9ab683eeecbee02a$var$isReactElement(child) {
    return !!child.type;
}
const $9ab683eeecbee02a$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $9ab683eeecbee02a$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};



const $30983726871c08f7$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $7482641f3477b828$export$c1bd4813440b4505).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $7482641f3477b828$export$c1bd4813440b4505).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $7482641f3477b828$export$c1bd4813440b4505).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $7482641f3477b828$export$c1bd4813440b4505).START;
    return false;
};



var $82HbV = parcelRequire("82HbV");

function $da4d881dcfe04164$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text ?? ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}





function $f71b4f43d5f12eac$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    const Component = textHighlighter?.component;
    const marks = new Set(marksList.map((m)=>m.type.name));
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-highlighted": true,
            "data-vc": "highlighted-text",
            key: `${segment.text}_${startPos}_${idx}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            match: segment.text,
            groups: segment.groups,
            marks: marks,
            startPos: startPos + idx
        }, segment.text));
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
        key: `text-wrapper_${startPos}`
    }, segments.map(renderSegment));
}



var $bJeQi = parcelRequire("bJeQi");


var $hZmcT = parcelRequire("hZmcT");

// Localized AnnotationSharedCSSByState().common and AnnotationSharedCSSByState().focus
const $76bc3abb0690bbb0$var$markStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
    cursor: 'pointer',
    padding: '1px 0 2px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.card), &:has([data-inline-card])': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.date-lozenger-container)': {
        paddingTop: "var(--ds-space-025, 2px)"
    },
    background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
});
const $76bc3abb0690bbb0$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    const { dispatch: dispatch } = (0, $bJeQi.useAnnotationManagerDispatch)();
    const markRef = (0, $cozmU.useCallback)((node)=>{
        dispatch({
            type: 'setDraftMarkRef',
            data: {
                draftMarkRef: node ?? undefined
            }
        });
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("mark", {
        "data-renderer-mark": true,
        ...(0, $82HbV.dataAttributes)(draftPosition),
        css: $76bc3abb0690bbb0$var$markStyles,
        ref: markRef
    }, children);
};
const $76bc3abb0690bbb0$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $7482641f3477b828$export$c1bd4813440b4505).START) return 0;
    if (annotationPosition === (0, $7482641f3477b828$export$c1bd4813440b4505).END) return fragmentCount - 1;
    if (annotationPosition === (0, $7482641f3477b828$export$c1bd4813440b4505).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $76bc3abb0690bbb0$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
    const annotateIndex = $76bc3abb0690bbb0$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const segments = (0, $da4d881dcfe04164$export$93301b6f1ff0b0c3)(value, textHighlighter);
        if (annotateIndex === index) return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $lOiVq.jsx)($76bc3abb0690bbb0$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $f71b4f43d5f12eac$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], draftPosition.from)));
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: index
        }, (0, $f71b4f43d5f12eac$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], draftPosition.from)));
    });
};
const $76bc3abb0690bbb0$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const { selectionDraftDocumentPosition: nextDraftPosition } = (0, $hZmcT.useAnnotationRangeState)();
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $30983726871c08f7$export$b1baddbd5f289877)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $9ab683eeecbee02a$export$a9795c84b22a1f06)(children);
    if (!textString) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        const segments = (0, $da4d881dcfe04164$export$93301b6f1ff0b0c3)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, (0, $f71b4f43d5f12eac$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $7482641f3477b828$export$c1bd4813440b4505).AROUND_TEXT) {
        const segments = (0, $da4d881dcfe04164$export$93301b6f1ff0b0c3)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $lOiVq.jsx)($76bc3abb0690bbb0$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $f71b4f43d5f12eac$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], startPos));
    }
    const offsets = (0, $9ab683eeecbee02a$export$1059bfc467f4f55d)(nextDraftPosition, textPosition, textString);
    const texts = (0, $9ab683eeecbee02a$export$2878cc467c8be8fe)(textString, offsets);
    if (!texts) {
        const segments = (0, $da4d881dcfe04164$export$93301b6f1ff0b0c3)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, (0, $f71b4f43d5f12eac$export$8a20fd0614851c5f)(segments, textHighlighter, marks || [], startPos));
    }
    const components = $76bc3abb0690bbb0$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, components);
};


const $317b5c4aa79b03b5$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76bc3abb0690bbb0$export$69a4e0ac39aaf9b7), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks
    }, children);
};
var $317b5c4aa79b03b5$export$2e2bcd8739ae039 = $317b5c4aa79b03b5$var$TextWrapper;



var $kXCPk = parcelRequire("kXCPk");


var $hac25 = parcelRequire("hac25");


var $YvadP = parcelRequire("YvadP");

var $dIt4J = parcelRequire("dIt4J");


var $bjg0G = parcelRequire("bjg0G");


var $iDrrr = parcelRequire("iDrrr");


var $6FNab = parcelRequire("6FNab");


var $IYu9M = parcelRequire("IYu9M");
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $dbAJC = parcelRequire("dbAJC");


var $7TS3k = parcelRequire("7TS3k");


var $g8vg9 = parcelRequire("g8vg9");


var $hL2mp = parcelRequire("hL2mp");


var $hZh3g = parcelRequire("hZh3g");


var $kP3O8 = parcelRequire("kP3O8");


var $jFiyG = parcelRequire("jFiyG");


var $BxuzK = parcelRequire("BxuzK");


var $Rqtsm = parcelRequire("Rqtsm");


var $kVRDx = parcelRequire("kVRDx");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");





var $luPs0 = parcelRequire("luPs0");

const $ba5fa06309c0e28c$var$MarkWrapper = (props)=>{
    const dataAlign = props['data-align'] ? (0, $luPs0.alignmentPositionMap)[props['data-align']] : undefined;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        style: {
            textAlign: dataAlign
        },
        ...props
    }, props.children);
};
function $ba5fa06309c0e28c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $lOiVq.jsx)($ba5fa06309c0e28c$var$MarkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}





function $3c09a0336ab0b070$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level
    }, props.children);
}



var $5ja7D = parcelRequire("5ja7D");


var $gakt2 = parcelRequire("gakt2");


var $fAxeQ = parcelRequire("fAxeQ");


var $hbojQ = parcelRequire("hbojQ");





var $aEH72 = parcelRequire("aEH72");


var $cGUVt = parcelRequire("cGUVt");




class $e74793d87feb3375$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference
        }, children);
    }
}


const $dc9b150aaba2acaa$export$c00d967a0f56fdb7 = {
    code: (0, $dbAJC.default),
    em: (0, $7TS3k.default),
    link: (0, $g8vg9.default),
    strike: (0, $hL2mp.default),
    strong: (0, $hZh3g.default),
    subsup: (0, $kP3O8.default),
    textColor: (0, $jFiyG.default),
    backgroundColor: (0, $BxuzK.default),
    underline: (0, $Rqtsm.default),
    annotation: (0, $IYu9M.default),
    border: (0, $aEH72.default),
    fontSize: (0, $cGUVt.default),
    // Stage0
    confluenceInlineComment: (0, $e74793d87feb3375$export$2e2bcd8739ae039),
    breakout: (0, $kVRDx.default),
    alignment: (0, $ba5fa06309c0e28c$export$2e2bcd8739ae039),
    indentation: (0, $3c09a0336ab0b070$export$2e2bcd8739ae039),
    unsupportedMark: (0, $5ja7D.default),
    unsupportedNodeAttribute: (0, $gakt2.default),
    dataConsumer: (0, $fAxeQ.default),
    fragment: (0, $hbojQ.default)
};
const $dc9b150aaba2acaa$export$d4334b129116aad7 = (mark)=>{
    return $dc9b150aaba2acaa$export$c00d967a0f56fdb7[mark.type.name];
};





const $91ccb066a700f5a6$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
const $91ccb066a700f5a6$var$isExpandNode = (node)=>node.type.name === 'expand';
const $91ccb066a700f5a6$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $91ccb066a700f5a6$export$d7bc71cca336a3b = (path)=>path.some((item)=>$91ccb066a700f5a6$var$isLayoutNode(item) && $91ccb066a700f5a6$var$hasBreakOutMark(item));
const $91ccb066a700f5a6$export$3e763fd7277c58c5 = (path)=>path.some((item)=>$91ccb066a700f5a6$var$isExpandNode(item) && $91ccb066a700f5a6$var$hasBreakOutMark(item));
const $91ccb066a700f5a6$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $91ccb066a700f5a6$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};
const $91ccb066a700f5a6$export$244bf4b32387ef62 = (path, schema)=>{
    const { nodes: { table: table } } = schema;
    return path.some((n)=>n.type === table);
};
const $91ccb066a700f5a6$export$a8df1f99c673fa27 = (path, nodeTypeNames)=>{
    for (const node of path){
        if (nodeTypeNames.includes(node.type.name)) return node.type.name;
    }
    return undefined;
};





var $8MoFC = parcelRequire("8MoFC");

const $aabfba9b46b52f73$export$eeb66772b38d7581 = (content)=>{
    const standaloneMarks = [];
    // keep track of the previous node's state
    let prev = {
        selfSpaceOnTheRight: true
    };
    let prevNode = null;
    // Iterates through each node in the content array.
    // Tracks if the previous node had a backgroundColor mark and if it ended with a space.
    // If a backgroundColor mark is followed by a text node that starts with a space,
    // and the previous node ended with a space, the previous backgroundColor mark is considered standalone.
    // At the end, flushes any remaining node that meets the standalone criteria.
    for(let i = 0; i < content.length; i++){
        const node = content[i];
        const nodeMarks = (0, $8MoFC.default).getMarks(node);
        const isBackgroundColor = nodeMarks.some((m)=>m.type.name === 'backgroundColor');
        let selfSpaceOnTheLeft = false;
        let selfSpaceOnTheRight = false;
        if (node.text) {
            selfSpaceOnTheLeft = node.text.startsWith(' ');
            selfSpaceOnTheRight = node.text.endsWith(' ');
        }
        if (isBackgroundColor) {
            prevNode = node;
            prev = {
                selfSpaceOnTheRight: false,
                hasBackgroundColor: true,
                spaceToTheLeft: prev !== null && prev.selfSpaceOnTheRight
            };
        } else {
            // If prev exists, check for standalone logic
            if (prev && prev.hasBackgroundColor && prevNode) // If prev had space on the left and current is a TextNode and has space on the left
            {
                if (prev.spaceToTheLeft && selfSpaceOnTheLeft) {
                    const mark = (0, $8MoFC.default).getMarks(prevNode).find((m)=>m.type.name === 'backgroundColor');
                    if (mark) standaloneMarks.push(mark);
                }
            }
            prevNode = null;
            prev = {
                selfSpaceOnTheRight: selfSpaceOnTheRight,
                hasBackgroundColor: false
            };
        }
    }
    if (prevNode) {
        if (prev && prev.hasBackgroundColor && prev.spaceToTheLeft) {
            const mark = (0, $8MoFC.default).getMarks(prevNode).find((m)=>m.type.name === 'backgroundColor');
            if (mark) standaloneMarks.push(mark);
        }
    }
    return standaloneMarks;
};


function $86871b1acdeb6e07$export$3a88c97d9b0d8d1c({ nodes: nodes, onMark: onMark, parentPos: parentPos, shouldDisplayExtensionAsInline: shouldDisplayExtensionAsInline }) {
    if (!nodes || nodes.length === 0 || nodes[0].isInline) return;
    function isInlineBodiedExtension(node) {
        return Boolean(node?.type.name === 'bodiedExtension' && shouldDisplayExtensionAsInline({
            type: node.type.name,
            extensionKey: node.attrs?.extensionKey,
            extensionType: node.attrs?.extensionType,
            parameters: node.attrs?.parameters,
            content: node.content,
            localId: node.attrs?.localId
        }));
    }
    try {
        let prevPos = parentPos;
        let pos = parentPos;
        let prevTextBlockType;
        for (const [index, node] of nodes.entries()){
            const prevNode = nodes[index - 1];
            // textblock + inlinedBodiedExtension
            if (prevNode?.isTextblock && isInlineBodiedExtension(node)) onMark({
                pos: prevPos
            });
            else if (isInlineBodiedExtension(prevNode) && node.isTextblock && (!prevTextBlockType || node.type === prevTextBlockType)) onMark({
                pos: pos
            });
            if (!isInlineBodiedExtension(node)) prevTextBlockType = node.isTextblock ? node.type : undefined;
            prevPos = pos;
            pos += node.nodeSize;
        }
    } catch  {}
}


function $f4bd82369c31ca5e$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $aPdNQ.MarkType) && prev && prev.type instanceof (0, $aPdNQ.MarkType) && Array.isArray(prev.content) && (0, $dIt4J.isSameMark)(prev, markOrNode)) prev.content = $f4bd82369c31ca5e$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $f4bd82369c31ca5e$export$2e2bcd8739ae039 {
    resetState() {
        this.headingIds = [];
        this.expandHeadingIds = [];
        this.startPos = this.initStartPos;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'date':
                return this.getDateProps(node, parentInfo, path);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node, path);
            case 'mention':
                return this.getMentionProps(node, path);
            case 'extension':
            case 'bodiedExtension':
                return this.getExtensionProps(node, path);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'inlineCard':
                return this.getInlineCardProps(node, path);
            case 'expand':
                return this.getExpandProps(node, path);
            case 'nestedExpand':
                if ((0, $iDrrr.fg)('hot-121622_lazy_load_expand_content')) return this.getExpandProps(node, path);
                return this.getProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            case 'panel_c1':
                if ((0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) return this.getPanelProps(node);
                return this.getProps(node, path);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props = {}, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    target = this.allowSelectAllTrap ? (0, $5iJHZ.DocWithSelectAllTrap) : (0, $5iJHZ.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') this.resetState();
        return this.renderNode(target, props, key, this.getChildNodes(fragment).map((node, index)=>{
            if ((0, $6lXol.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        }));
    }
    serializeTextWrapper(content, { parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        this.standaloneBackgroundColorMarks.push(...(0, $aabfba9b46b52f73$export$eeb66772b38d7581)(content));
        return $f4bd82369c31ca5e$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, _index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $6lXol.isTextNode)(mark)) {
            const serializeContent = (childMark, _index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            const isStandalone = this.standaloneBackgroundColorMarks.some((m)=>mark.eq(m));
            return this.renderMark((0, $dc9b150aaba2acaa$export$d4334b129116aad7)(mark), {
                ...this.getMarkProps(mark, parentMark.path),
                isStandalone: isStandalone
            }, markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $317b5c4aa79b03b5$export$2e2bcd8739ae039), {
                key: textKey,
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks
            }, mark.text);
        }
        const segments = (0, $da4d881dcfe04164$export$93301b6f1ff0b0c3)(mark.text, this.textHighlighter);
        return (0, $f71b4f43d5f12eac$export$8a20fd0614851c5f)(segments, this.textHighlighter, mark.marks, startPos);
    }
    renderNode(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    NodeComponent, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(NodeComponent, {
            key: key,
            ...props
        }, content));
    }
    renderMark(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MarkComponent, props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(MarkComponent, {
            key: key,
            ...props
        }, content));
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        const isInsideOfBlockNode = (0, $91ccb066a700f5a6$export$42ddc573eb5a7b43)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $91ccb066a700f5a6$export$9f1e9347b0411934)(path, node.type.schema);
        const isInsideOfTable = (0, $91ccb066a700f5a6$export$244bf4b32387ef62)(path, node.type.schema);
        const isStickySafeCenteringEnabled = (0, $ieeJu.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
        const isInsideBreakoutExpand = !isStickySafeCenteringEnabled && (0, $ieeJu.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $91ccb066a700f5a6$export$3e763fd7277c58c5)(path);
        const stickyHeaders = isStickySafeCenteringEnabled ? !isInsideOfTable ? this.stickyHeaders : undefined : !isInsideOfTable && !(0, $91ccb066a700f5a6$export$d7bc71cca336a3b)(path) && !isInsideBreakoutExpand ? this.stickyHeaders : undefined;
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: (0, $hac25.getColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
            allowTableAlignment: this.allowTableAlignment,
            allowTableResizing: this.allowTableResizing,
            // eslint-disable-next-line @atlaskit/platform/valid-gate-name
            isPresentational: (0, $iDrrr.fg)('platform_renderer_isPresentational') ? this.isPresentational : false,
            disableTableOverflowShadow: this.disableTableOverflowShadow,
            allowFixedColumnWidthOption: this.allowFixedColumnWidthOption
        };
    }
    getDateProps(node, parentInfo, path = []) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            }
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $91ccb066a700f5a6$export$42ddc573eb5a7b43)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node, path),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>n.type?.name === 'mediaSingle');
        // Only check path for bodiedSyncBlock; syncBlock uses RendererContext
        const nestedUnder = (0, $fqVYq.editorExperiment)('platform_synced_block', true) ? (0, $91ccb066a700f5a6$export$a8df1f99c673fa27)(path, [
            'bodiedSyncBlock'
        ]) : undefined;
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: this.media?.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper,
            enableSyncMediaCard: this.media?.enableSyncMediaCard,
            mediaViewerExtensions: this.media?.mediaViewerExtensions,
            fallbackMediaNameFetcher: this.media?.fallbackMediaNameFetcher,
            nestedUnder: nestedUnder
        };
    }
    getExtensionProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            extensionViewportSizes: this.extensionViewportSizes,
            hideExtensionKeysWhilePending: this.hideExtensionKeysWhilePending,
            nodeHeight: this.getExtensionHeight?.(node),
            shouldDisplayExtensionAsInline: this.shouldDisplayExtensionAsInline
        };
    }
    getEmojiProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            resourceConfig: this.emojiResourceConfig
        };
    }
    getMentionProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            mentionNodeDataProvider: this.mentionNodeDataProvider
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $91ccb066a700f5a6$export$42ddc573eb5a7b43)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode,
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0,
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getInlineCardProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getMediaGroupProps(node) {
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: this.media?.enableDownloadButton,
            ssr: this.media?.ssr
        };
    }
    getMediaInlineProps(node) {
        return {
            ...this.getProps(node),
            ssr: this.media?.ssr,
            fallbackMediaNameFetcher: this.media?.fallbackMediaNameFetcher
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = false;
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getProps(node, path = []) {
        const startPos = this.startPos + path.length;
        return {
            asInline: this.inlinePositions.has(startPos) ? 'on' : undefined,
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            content: node.content ? node.content.toJSON() : undefined,
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowDownloadCodeBlock: this.allowDownloadCodeBlock,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            rendererContentMode: this.contentMode,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': startPos
            },
            startPos: startPos,
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $kXCPk.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            content: node.content ? node.content.toJSON() : undefined,
            headingId: this.getHeadingId(node, this.headingIds),
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, _path = []) {
        let loadBodyContent = false;
        if ((0, $iDrrr.fg)('hot-121622_lazy_load_expand_content')) {
            const annotations = (0, $bjg0G.findChildrenByMark)(node, node.type.schema.marks.annotation, true);
            // Force rendering children if there are inline comments to support comments navigation
            // which relies on the HTML node to be present.
            loadBodyContent = annotations.some((annotation)=>{
                return annotation.node.marks.some((mark)=>mark.attrs.annotationType === 'inlineComment');
            });
        }
        // Only compute searchText when the browser find experiment is enabled,
        // to avoid unnecessary node.textContent string allocations per expand node.
        const searchText = (0, $ieeJu.expValEquals)('platform_editor_close_expand_find', 'isEnabled', true) ? node.textContent : undefined;
        if (!(0, $kXCPk.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return {
            ...this.getProps(node),
            loadBodyContent: loadBodyContent,
            searchText: searchText
        };
        const nestedHeaderIds = (0, $bjg0G.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds,
            loadBodyContent: loadBodyContent,
            searchText: searchText
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nodeContent = node.content.toJSON()// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, node)=>acc.concat((0, $6FNab.getText)(node) || ''), '').trim()// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/\s/g, '-');
        if (!nodeContent) return;
        const uniqueId = this.getUniqueHeadingId(nodeContent, headingIds);
        return this.headingIdPrefix ? `${this.headingIdPrefix}-${uniqueId}` : uniqueId;
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    getChildNodes(fragment) {
        let children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        children = (0, $6lXol.mergeTextNodes)(children);
        if (!!this.shouldDisplayExtensionAsInline && (0, $ieeJu.expValEquals)('platform_editor_render_bodied_extension_as_inline', 'isEnabled', true)) (0, $86871b1acdeb6e07$export$3a88c97d9b0d8d1c)({
            nodes: children,
            onMark: ({ pos: pos })=>{
                this.inlinePositions.add(pos);
            },
            parentPos: this.startPos,
            shouldDisplayExtensionAsInline: this.shouldDisplayExtensionAsInline
        });
        return children;
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $YvadP.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $f4bd82369c31ca5e$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }, node);
        }));
    }
    constructor(init){
        this.providers = void 0;
        this.eventHandlers = void 0;
        this.extensionHandlers = void 0;
        this.portal = void 0;
        this.rendererContext = void 0;
        this.appearance = void 0;
        this.contentMode = void 0;
        this.disableHeadingIDs = void 0;
        this.headingIdPrefix = void 0;
        this.disableActions = void 0;
        this.headingIds = [];
        /**
     * The reason we have this extra array here is because we need to generate the same unique
     * heading id for 2 different nodes: headers and expands (check the implementation of
     * `getUniqueHeadingId` for more info).
     *
     * We will eventually need to refactor the current approach to generate unique ids
     * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
     */ this.expandHeadingIds = [];
        this.allowHeadingAnchorLinks = void 0;
        this.allowColumnSorting = void 0;
        this.allowCopyToClipboard = false;
        this.allowDownloadCodeBlock = false;
        this.allowWrapCodeBlock = false;
        this.allowPlaceholderText = true;
        this.allowCustomPanels = false;
        this.fireAnalyticsEvent = void 0;
        this.shouldOpenMediaViewer = void 0;
        this.allowAltTextOnImages = void 0;
        this.stickyHeaders = void 0;
        this.allowMediaLinking = void 0;
        this.initStartPos = void 0;
        this.startPos = void 0;
        this.surroundTextNodesWithTextWrapper = false;
        this.media = void 0;
        this.mentionNodeDataProvider = void 0;
        this.emojiResourceConfig = void 0;
        this.smartLinks = void 0;
        this.extensionViewportSizes = void 0;
        this.hideExtensionKeysWhilePending = void 0;
        this.getExtensionHeight = void 0;
        this.allowAnnotations = false;
        this.allowSelectAllTrap = void 0;
        this.nodeComponents = void 0;
        this.allowWindowedCodeBlock = void 0;
        this.isInsideOfInlineExtension = void 0;
        this.textHighlighter = void 0;
        this.allowTableAlignment = void 0;
        this.allowTableResizing = void 0;
        this.allowFixedColumnWidthOption = void 0;
        this.isPresentational = void 0;
        this.disableTableOverflowShadow = void 0;
        this.standaloneBackgroundColorMarks = [];
        this.onSetLinkTarget = void 0;
        this.shouldDisplayExtensionAsInline = void 0;
        this.inlinePositions = new Set();
        this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = (node.type.name === 'taskItem' || node.type.name === 'blockTaskItem' && (0, $ieeJu.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true)) && node.attrs.state !== 'DONE' || // If blockTaskItem is in the schema, check if the parent of the current node
            // is an incomplete task item, because blockTaskItems can have nested nodes
            node.type.schema.nodes.blockTaskItem && parentInfo?.parentIsIncompleteTask === true && (0, $ieeJu.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true);
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $6lXol.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>n.type?.name !== 'mediaSingle') && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            return marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return this.renderMark((0, $dc9b150aaba2acaa$export$d4334b129116aad7)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.withMediaMarkProps = (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                ...defaultProps,
                isMediaInline: true
            };
            return defaultProps;
        };
        this.getUnsupportedContentProps = (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        };
        this.getAnnotationMarkProps = (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $IYu9M.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        };
        this.getMarkProps = (mark, marksParentPath, node)=>{
            if ((0, $IYu9M.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node?.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $dbAJC.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            // Add deepLinkTarget for link marks
            const linkSpecificProps = mark.type.name === 'link' ? {
                onSetLinkTarget: this.onSetLinkTarget
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                ...linkSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        };
        if ((0, $fqVYq.editorExperiment)('comment_on_bodied_extensions', true)) {
            this.initStartPos = init.startPos || 1;
            this.startPos = init.startPos || 1;
        } else {
            this.initStartPos = 1;
            this.startPos = 1;
        }
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.contentMode = init.contentMode;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.headingIdPrefix = init.headingIdPrefix;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowDownloadCodeBlock = init.allowDownloadCodeBlock;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.mentionNodeDataProvider = init.mentionNodeDataProvider;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.extensionViewportSizes = init.extensionViewportSizes;
        this.hideExtensionKeysWhilePending = init.hideExtensionKeysWhilePending;
        this.getExtensionHeight = init.getExtensionHeight;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
        this.allowFixedColumnWidthOption = init.allowFixedColumnWidthOption;
        this.isPresentational = init.isPresentational;
        this.disableTableOverflowShadow = init.disableTableOverflowShadow;
        this.onSetLinkTarget = init.onSetLinkTarget;
        this.shouldDisplayExtensionAsInline = init.shouldDisplayExtensionAsInline;
    }
}
module.exports["default"] = $f4bd82369c31ca5e$export$2e2bcd8739ae039;

});

parcelRegister("6lXol", function(module, exports) {
$parcel$export(module.exports, "Doc", () => (parcelRequire("5iJHZ")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("5iJHZ")).DocWithSelectAllTrap);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $4wH3g = parcelRequire("4wH3g");


var $KTiWz = parcelRequire("KTiWz");

var $3F4bj = parcelRequire("3F4bj");


var $gPm8T = parcelRequire("gPm8T");


var $cfEQy = parcelRequire("cfEQy");


var $h41Wr = parcelRequire("h41Wr");


var $62oYX = parcelRequire("62oYX");


var $dMjNA = parcelRequire("dMjNA");


var $5iJHZ = parcelRequire("5iJHZ");


var $6MqGo = parcelRequire("6MqGo");


var $k7Rhl = parcelRequire("k7Rhl");


var $12rmB = parcelRequire("12rmB");


var $l531v = parcelRequire("l531v");


var $1YbJm = parcelRequire("1YbJm");


var $3PnTZ = parcelRequire("3PnTZ");


var $aNi0I = parcelRequire("aNi0I");


var $dRPWO = parcelRequire("dRPWO");


var $cLDox = parcelRequire("cLDox");


var $ZVVLb = parcelRequire("ZVVLb");


var $174uk = parcelRequire("174uk");


var $fARVe = parcelRequire("fARVe");


var $gPrpc = parcelRequire("gPrpc");


var $cAWpJ = parcelRequire("cAWpJ");


var $7OAKt = parcelRequire("7OAKt");


var $57Y2G = parcelRequire("57Y2G");


const $5dce0f35dbd0cfe2$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "lyuNf",
    name: "WindowedCodeBlock",
    loader: ()=>(parcelRequire("adWuF")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "7voiQ",
    name: "CodeBlock",
    loader: ()=>(parcelRequire("9xAS0")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "QxM0Q",
    name: "TaskList",
    loader: ()=>(parcelRequire("22G3u")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "mFjlc",
    name: "TaskItem",
    loader: ()=>(parcelRequire("9A4tY")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Es_G2",
    name: "DecisionList",
    loader: ()=>(parcelRequire("1zncV")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "tXkFq",
    name: "DecisionItem",
    loader: ()=>(parcelRequire("6U7Ru")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "UW2mx",
    name: "Date",
    loader: ()=>(parcelRequire("atGVx")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "YWl55",
    name: "Status",
    loader: ()=>(parcelRequire("36hib")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "vg-Rq",
    name: "Emoji",
    _vcPlaceholderIgnored: true,
    loader: ()=>(parcelRequire("15iJg")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Hm6N8",
    name: "Panel",
    _addVCPlaceholderWrapper: "span",
    loader: ()=>(parcelRequire("b40eF")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Ecfpn",
    name: "EmbedCard",
    loader: ()=>(parcelRequire("4xolx")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "0vDZ-",
    name: "InlineCard",
    loader: ()=>(parcelRequire("jbsCY")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "cNtW6",
    name: "BlockCard",
    loader: ()=>(parcelRequire("aoBOL")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "nouWf",
    name: "Media",
    _vcPlaceholderIgnored: true,
    loader: ()=>(parcelRequire("krgH5")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "l7RKL",
    name: "MediaGroup",
    loader: ()=>(parcelRequire("4biZ8")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "IVdRD",
    name: "MediaInline",
    loader: ()=>(parcelRequire("4Q5c8")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Eb7Gh",
    name: "MediaSingle",
    _delayHydration: true,
    loader: ()=>(parcelRequire("9JAgI")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "w10Xv",
    name: "Mention",
    loader: ()=>(parcelRequire("78smB")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "UPgdC",
    name: "Expand",
    loader: ()=>(parcelRequire("lo4QF")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$var$SyncBlockLoader = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "f1NYX",
    name: "SyncBlockLoader",
    loader: ()=>(parcelRequire("Rc2LS")).then((mod)=>mod.default),
    loading: ()=>null
});

const $5dce0f35dbd0cfe2$var$BodiedSyncBlock = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "uj9UW",
    name: "BodiedSyncBlock",
    loader: ()=>(parcelRequire("gIalr")).then((mod)=>mod.default),
    loading: ()=>null
});
const $5dce0f35dbd0cfe2$export$3931063f6a5f290e = {
    blockquote: (0, $gPm8T.default),
    bulletList: (0, $dMjNA.default),
    blockCard: $5dce0f35dbd0cfe2$export$d18ccd25c0d2c6b0,
    caption: (0, $dRPWO.default),
    date: $5dce0f35dbd0cfe2$export$6341f9a885713487,
    decisionItem: $5dce0f35dbd0cfe2$export$b6f73a2b0b0de599,
    decisionList: $5dce0f35dbd0cfe2$export$b458dfa720128865,
    doc: (0, $5iJHZ.default),
    emoji: $5dce0f35dbd0cfe2$export$56cc48506ff790a,
    extension: (0, $6MqGo.default),
    bodiedExtension: (0, $cfEQy.default),
    multiBodiedExtension: (0, $h41Wr.default),
    extensionFrame: (0, $62oYX.default),
    hardBreak: (0, $k7Rhl.default),
    heading: (0, $12rmB.default),
    inlineCard: $5dce0f35dbd0cfe2$export$aff6291803939b05,
    inlineExtension: (0, $l531v.default),
    layoutSection: (0, $1YbJm.default),
    layoutColumn: (0, $3PnTZ.default),
    listItem: (0, $aNi0I.default),
    media: $5dce0f35dbd0cfe2$export$7fc53215244aec38,
    mediaGroup: $5dce0f35dbd0cfe2$export$d7858be3df00d59,
    mediaInline: $5dce0f35dbd0cfe2$export$462ea7c2a1c4cb1f,
    mediaSingle: $5dce0f35dbd0cfe2$export$888d74bc001c3a5d,
    mention: $5dce0f35dbd0cfe2$export$e891316fea657d90,
    orderedList: (0, $cLDox.default),
    panel: $5dce0f35dbd0cfe2$export$2ddb90ad54e5f587,
    panel_c1: $5dce0f35dbd0cfe2$export$2ddb90ad54e5f587,
    paragraph: (0, $ZVVLb.default),
    placeholder: (0, $174uk.default),
    rule: (0, $fARVe.default),
    status: $5dce0f35dbd0cfe2$export$96e9906d6d93a972,
    taskItem: $5dce0f35dbd0cfe2$export$27c4189b8be1bf93,
    taskList: $5dce0f35dbd0cfe2$export$771a55a10b0a40ae,
    table: (0, $gPrpc.default),
    tableCell: (0, $cAWpJ.TableCell),
    tableHeader: (0, $cAWpJ.TableHeader),
    tableRow: (0, $7OAKt.default),
    unknownBlock: (0, $57Y2G.default),
    unsupportedBlock: (0, $KTiWz.default),
    unsupportedInline: (0, $3F4bj.default),
    expand: $5dce0f35dbd0cfe2$export$49bd1dfb0ad29c40,
    syncBlock: $5dce0f35dbd0cfe2$var$SyncBlockLoader,
    bodiedSyncBlock: $5dce0f35dbd0cfe2$var$BodiedSyncBlock,
    nestedExpand: $5dce0f35dbd0cfe2$export$49bd1dfb0ad29c40,
    embedCard: $5dce0f35dbd0cfe2$export$6789d7ecdc77631b,
    blockTaskItem: $5dce0f35dbd0cfe2$export$27c4189b8be1bf93
};
const $5dce0f35dbd0cfe2$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && flags?.allowSelectAllTrap === true) return 0, $5iJHZ.DocWithSelectAllTrap;
    // Allowing custom components to override those provided in nodeToReact
    const nodes = {
        ...$5dce0f35dbd0cfe2$export$3931063f6a5f290e,
        ...nodeComponents
    };
    if (node.type.name === 'codeBlock') {
        if (flags?.allowWindowedCodeBlock === true) return nodes.windowedCodeBlock ?? $5dce0f35dbd0cfe2$export$a22ee8f907eecb5f;
        return nodes.codeBlock ?? $5dce0f35dbd0cfe2$export$6c415d1fdae3dfdb;
    }
    nodes['multiBodiedExtension'] = (0, $h41Wr.default);
    return nodes[node.type.name];
};
const $5dce0f35dbd0cfe2$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$5dce0f35dbd0cfe2$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $5dce0f35dbd0cfe2$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $5dce0f35dbd0cfe2$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $5dce0f35dbd0cfe2$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $5dce0f35dbd0cfe2$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $5dce0f35dbd0cfe2$var$whitespaceRegex = /^\s*$/;
const $5dce0f35dbd0cfe2$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $5dce0f35dbd0cfe2$var$isEmojiBlock(node.content);
};
const $5dce0f35dbd0cfe2$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($5dce0f35dbd0cfe2$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};
module.exports["InlineCard"] = $5dce0f35dbd0cfe2$export$aff6291803939b05;
module.exports["nodeToReact"] = $5dce0f35dbd0cfe2$export$3931063f6a5f290e;
module.exports["toReact"] = $5dce0f35dbd0cfe2$export$d4334b129116aad7;
module.exports["mergeTextNodes"] = $5dce0f35dbd0cfe2$export$8045509d14b5046f;
module.exports["isTextWrapper"] = $5dce0f35dbd0cfe2$export$d4ebd3557ee7fac1;
module.exports["isTextNode"] = $5dce0f35dbd0cfe2$export$ccbedd67ef6e9417;

});

parcelRegister("3F4bj", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $7Y8M5 = parcelRequire("7Y8M5");


var $kyJuy = parcelRequire("kyJuy");


var $lpNn5 = parcelRequire("lpNn5");


var $krYZG = parcelRequire("krYZG");


var $bHKSU = parcelRequire("bHKSU");


var $1H5A4 = parcelRequire("1H5A4");


var $a89Z1 = parcelRequire("a89Z1");

const $b656cbfc74172cb6$var$inlineNodeStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #0515240F)",
    border: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-disabled, #0515240F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $7Y8M5.relativeFontSizeToBase16)(14),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $b656cbfc74172cb6$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $a89Z1.getUnsupportedContent)((0, $bHKSU.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $bHKSU.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $cozmU.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $cozmU.useCallback)(()=>dispatchAnalyticsEvent && (0, $1H5A4.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $krYZG.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $b656cbfc74172cb6$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))), {
        label: "?"
    }))));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $b656cbfc74172cb6$var$_default_1 = (0, $kSwu1.injectIntl)($b656cbfc74172cb6$var$UnsupportedInlineNode);
var $b656cbfc74172cb6$export$2e2bcd8739ae039 = $b656cbfc74172cb6$var$_default_1;
module.exports["default"] = $b656cbfc74172cb6$export$2e2bcd8739ae039;

});

parcelRegister("aZS5C", function(module, exports) {
$parcel$export(module.exports, "default", () => $e040f8bc05814767$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- emotion jsx pragma; go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $cd8tA = parcelRequire("cd8tA");


var $794I6 = parcelRequire("794I6");


var $apAmb = parcelRequire("apAmb");

function $e040f8bc05814767$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e040f8bc05814767$var$inlineExtensionStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // 0px margin top is important here.
    // When running on server-side emotion will generate style tags before elements.
    // This caused packages/editor/editor-common/src/styles/shared/block-marks.ts to override the margin-top.
    // However as soon as the styles are extracted to <head> it adds back the margin.
    // The timing is tricky as it happens to be when UFO collects the dimension for the placeholder for TTVC calculation.
    // This resulted 1px mismatch on the image. Further cause everything on page to shift by 1px.
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `0px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
const $e040f8bc05814767$var$plainTextMacroStyle = {
    name: "1b7osz4",
    styles: "display:inline;vertical-align:baseline;[data-macro-body]{display:inline;}"
};
function $e040f8bc05814767$export$2e2bcd8739ae039(props) {
    const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>(0, $dOBRD.default)((0, $cd8tA.getNodeRenderer)), []);
    /**
   * null -> provider promise not yet settled (pending)
   * undefined -> provider promise rejected (settled, no provider available)
   * <provider> -> provider promise resolved
   */ const [extensionProvider, setExtensionProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(null);
    const handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((_name, providerPromise)=>{
        providerPromise?.then((provider)=>{
            if (isMounted.current) setExtensionProvider(provider);
        }, ()=>{
            // Consumers can use this to distinguish a rejected provider from a pending one
            if (isMounted.current) setExtensionProvider(undefined);
        });
    }, []);
    const renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((extensionProvider, isExtensionProviderPending)=>{
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        const isPlainTextMacro = Boolean(node?.parameters?.macroParams?.__bodyContent);
        let result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $apAmb.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = /*#__PURE__*/ (0, $lOiVq.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') result = /*#__PURE__*/ (0, $lOiVq.jsx)($e040f8bc05814767$export$f41ccc3bd3324832, {
                    isPlainTextMacro: isPlainTextMacro
                }, /*#__PURE__*/ (0, $lOiVq.jsx)(NodeRenderer, {
                    node: node
                }));
                else result = /*#__PURE__*/ (0, $lOiVq.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch  {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            isExtensionProviderPending: isExtensionProviderPending,
            node: node,
            result: result
        });
    }, [
        actions,
        children,
        content,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext?.adDoc,
        text,
        type
    ]);
    const setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((providers)=>{
        if (extensionProvider === null && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider, Boolean(providers.extensionProvider) && extensionProvider === null);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $794I6.WithProviders), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
const $e040f8bc05814767$export$f41ccc3bd3324832 = ({ children: children, isPlainTextMacro: isPlainTextMacro, ssrPlaceholder: ssrPlaceholder, ssrPlaceholderReplace: ssrPlaceholderReplace })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `inline-extension-renderer ${isPlainTextMacro ? 'plain-text-macro' : ''}`,
        css: [
            $e040f8bc05814767$var$inlineExtensionStyle,
            isPlainTextMacro && $e040f8bc05814767$var$plainTextMacroStyle
        ],
        "data-ssr-placeholder": ssrPlaceholder,
        "data-ssr-placeholder-replace": ssrPlaceholderReplace
    }, children);
};
module.exports["InlineNodeRendererWrapper"] = $e040f8bc05814767$export$f41ccc3bd3324832;

});

parcelRegister("cd8tA", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4wH3g = parcelRequire("4wH3g");


var $iDrrr = parcelRequire("iDrrr");


var $2sp5n = parcelRequire("2sp5n");


var $3nm9z = parcelRequire("3nm9z");


var $HYsb2 = parcelRequire("HYsb2");











var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");





var $ieeJu = parcelRequire("ieeJu");




const $74b728764f4e0c94$var$neutralBorder = "var(--ds-background-neutral, #0515240F)";
const $74b728764f4e0c94$var$unknownMacroContainerStyles = null; // Match LCM header exactly: lcmHeaderStyles from LegacyContentHeader/index.tsx
const $74b728764f4e0c94$var$unknownMacroHeaderStyles = null; // Match LCM content area: white surface, text color inherits
const $74b728764f4e0c94$var$unknownMacroBodyStyles = null;
const $74b728764f4e0c94$var$unknownMacroPreStyles = null;
const $74b728764f4e0c94$var$formatParam = (key, param)=>{
    const value = String(param?.value ?? '').trim();
    return `${key} = ${value}`;
};
const $74b728764f4e0c94$var$EMPTY_MACRO_PARAMS = {};
const $74b728764f4e0c94$export$414b5225f50e455b = (0, $gtMdU.isReactCompilerActivePlatform)() ? function UnknownMacroPlaceholder(t0) {
    const $ = (0, $bDgLe.c)(22);
    const { extensionNode: extensionNode } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const macroTitle = extensionNode.parameters?.macroMetadata?.title || extensionNode.extensionKey;
    const bodyContent = extensionNode.parameters?.macroParams?.__bodyContent?.value;
    let t1;
    if ($[0] !== extensionNode.parameters?.macroParams) {
        const macroParamsOld = extensionNode.parameters?.macroParams ?? {};
        const macroParams = extensionNode.parameters?.macroParams ?? $74b728764f4e0c94$var$EMPTY_MACRO_PARAMS;
        const formatParamInline = $74b728764f4e0c94$var$_temp;
        let t2;
        if ($[2] !== macroParams) {
            t2 = Object.entries(macroParams).filter($74b728764f4e0c94$var$_temp2).map($74b728764f4e0c94$var$_temp3);
            $[2] = macroParams;
            $[3] = t2;
        } else t2 = $[3];
        const memoizedVisibleParams = t2.join(" | ");
        t1 = (0, $ieeJu.expValEquals)("platform_editor_perf_lint_cleanup", "isEnabled", true) ? memoizedVisibleParams : Object.entries(macroParamsOld).filter($74b728764f4e0c94$var$_temp4).map((t3)=>{
            const [key_3, param_1] = t3;
            return formatParamInline(key_3, param_1);
        }).join(" | ");
        $[0] = extensionNode.parameters?.macroParams;
        $[1] = t1;
    } else t1 = $[1];
    const visibleParams = t1;
    let t2;
    if ($[4] !== intl || $[5] !== macroTitle || $[6] !== visibleParams) {
        t2 = visibleParams ? `${intl.formatMessage((0, $3nm9z.messages).unknownMacroHeader, {
            macroTitle: macroTitle
        })} | ${visibleParams}` : intl.formatMessage((0, $3nm9z.messages).unknownMacroHeader, {
            macroTitle: macroTitle
        });
        $[4] = intl;
        $[5] = macroTitle;
        $[6] = visibleParams;
        $[7] = t2;
    } else t2 = $[7];
    const headerText = t2;
    let t3;
    if ($[8] !== intl) {
        t3 = intl.formatMessage((0, $3nm9z.messages).unknownMacroPlaceholderAriaLabel);
        $[8] = intl;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_30huDK5pjl _0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _0KLXruqi9L"
        ]);
        t5 = (0, $hekY6.default)([
            "_0bjKvDuyIt _2sNsIg7NXe _1x1D3gfqb4 _0KLXruDMqu _0Of8r22ADO _1Znuxb5zaO _1wydGW1Y8M _2Zuz6Q5zaO _1mT5xdRAKS _2IhTonA17z"
        ]);
        $[10] = t4;
        $[11] = t5;
    } else {
        t4 = $[10];
        t5 = $[11];
    }
    let t6;
    if ($[12] !== headerText) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t5,
            children: headerText
        });
        $[12] = headerText;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    let t8;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0KLXrulfZc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE"
        ]);
        t8 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2sNsIgmnOE _1ANEUSlpBW _3W2Oc8wPeg _0sxkUM8OLE"
        ]);
        $[14] = t7;
        $[15] = t8;
    } else {
        t7 = $[14];
        t8 = $[15];
    }
    let t9;
    if ($[16] !== bodyContent) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t7,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("pre", {
                className: t8,
                children: bodyContent
            })
        });
        $[16] = bodyContent;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== t3 || $[19] !== t6 || $[20] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsxs)("section", {
            "aria-label": t3,
            className: t4,
            children: [
                t6,
                t9
            ]
        });
        $[18] = t3;
        $[19] = t6;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    return t10;
} : function UnknownMacroPlaceholder({ extensionNode: extensionNode }) {
    const intl = (0, $kSwu1.useIntl)();
    const macroTitle = extensionNode.parameters?.macroMetadata?.title || extensionNode.extensionKey;
    const bodyContent = extensionNode.parameters?.macroParams?.__bodyContent?.value;
    const macroParamsOld = extensionNode.parameters?.macroParams ?? {};
    const macroParams = extensionNode.parameters?.macroParams ?? $74b728764f4e0c94$var$EMPTY_MACRO_PARAMS;
    const formatParamInline = (key, param)=>{
        const value = String(param?.value ?? '').trim();
        return `${key} = ${value}`;
    };
    const memoizedVisibleParams = (0, $cozmU.useMemo)(()=>Object.entries(macroParams).filter(([key_0])=>!key_0.startsWith('_')).map(([key_1, param_0])=>$74b728764f4e0c94$var$formatParam(key_1, param_0)).join(' | '), [
        macroParams
    ]);
    const visibleParams = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedVisibleParams : // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- intentional fallback for experiment off path
    Object.entries(macroParamsOld).filter(([key_2])=>!key_2.startsWith('_')).map(([key_3, param_1])=>formatParamInline(key_3, param_1)).join(' | ');
    const headerText = visibleParams ? `${intl.formatMessage((0, $3nm9z.messages).unknownMacroHeader, {
        macroTitle: macroTitle
    })} | ${visibleParams}` : intl.formatMessage((0, $3nm9z.messages).unknownMacroHeader, {
        macroTitle: macroTitle
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("section", {
        "aria-label": intl.formatMessage((0, $3nm9z.messages).unknownMacroPlaceholderAriaLabel),
        className: (0, $hekY6.default)([
            "_30huDK5pjl _0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _0KLXruqi9L"
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_0bjKvDuyIt _2sNsIg7NXe _1x1D3gfqb4 _0KLXruDMqu _0Of8r22ADO _1Znuxb5zaO _1wydGW1Y8M _2Zuz6Q5zaO _1mT5xdRAKS _2IhTonA17z"
                ]),
                children: headerText
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0KLXrulfZc _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE"
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("pre", {
                    className: (0, $hekY6.default)([
                        "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2sNsIgmnOE _1ANEUSlpBW _3W2Oc8wPeg _0sxkUM8OLE"
                    ]),
                    children: bodyContent
                })
            })
        ]
    });
};
function $74b728764f4e0c94$var$_temp4(t0) {
    const [key_2] = t0;
    return !key_2.startsWith("_");
}
function $74b728764f4e0c94$var$_temp3(t0) {
    const [key_1, param_0] = t0;
    return $74b728764f4e0c94$var$formatParam(key_1, param_0);
}
function $74b728764f4e0c94$var$_temp2(t0) {
    const [key_0] = t0;
    return !key_0.startsWith("_");
}
function $74b728764f4e0c94$var$_temp(key, param) {
    const value = String(param?.value ?? "").trim();
    return `${key} = ${value}`;
}



function $8d7d1df6f664ad48$var$getNodeFromManifest(// eslint-disable-next-line @typescript-eslint/no-explicit-any
manifest, extKey, nodeKey, extensionType, extensionKey) {
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
async function $8d7d1df6f664ad48$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $2sp5n.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    return $8d7d1df6f664ad48$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
}
function $8d7d1df6f664ad48$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $2sp5n.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = extensionProvider?.getPreloadedExtension?.(extensionType, extKey);
    if (manifest) return $8d7d1df6f664ad48$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
    else return extensionProvider.getExtension(extensionType, extKey).then((manifest)=>$8d7d1df6f664ad48$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey));
}
async function $8d7d1df6f664ad48$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $8d7d1df6f664ad48$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        acc[key] = moduleNode[key];
        return acc;
    }, {});
}
function $8d7d1df6f664ad48$var$isUnknownConfluenceMacroWithBody(extensionNode) {
    return extensionNode !== null && extensionNode.type === 'extension' && extensionNode.extensionType === 'com.atlassian.confluence.macro.core' && !!extensionNode.parameters?.macroParams?.__bodyContent?.value;
}
const $8d7d1df6f664ad48$var$ExtensionLoading = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ExtensionLoading(props) {
    const $ = (0, $bDgLe.c)(8);
    const intl = (0, $kSwu1.useIntl)();
    const extensionNode = props.node;
    if (!props.error && !props.timedOut && props.loadingFallback) {
        let t0;
        if ($[0] !== props.loadingFallback) {
            t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
                children: props.loadingFallback
            });
            $[0] = props.loadingFallback;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    if (props.error || props.timedOut) {
        console.error("Error rendering extension", props.error);
        if (props.error && props.showUnknownMacroPlaceholder && extensionNode && $8d7d1df6f664ad48$var$isUnknownConfluenceMacroWithBody(extensionNode) && (0, $iDrrr.fg)("tinymce_display_unknown_macro_body_content")) {
            let t0;
            if ($[2] !== extensionNode) {
                t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $74b728764f4e0c94$export$414b5225f50e455b), {
                    extensionNode: extensionNode
                });
                $[2] = extensionNode;
                $[3] = t0;
            } else t0 = $[3];
            return t0;
        }
        let t0;
        if ($[4] !== intl) {
            t0 = intl.formatMessage((0, $3nm9z.messages).extensionLoadingError);
            $[4] = intl;
            $[5] = t0;
        } else t0 = $[5];
        let t1;
        if ($[6] !== t0) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                children: t0
            });
            $[6] = t0;
            $[7] = t1;
        } else t1 = $[7];
        return t1;
    } else return null;
} : function ExtensionLoading(props) {
    const intl = (0, $kSwu1.useIntl)();
    const extensionNode = props.node;
    if (!props.error && !props.timedOut && props.loadingFallback) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: props.loadingFallback
    });
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        if (props.error && props.showUnknownMacroPlaceholder && extensionNode && $8d7d1df6f664ad48$var$isUnknownConfluenceMacroWithBody(extensionNode) && (0, $iDrrr.fg)('tinymce_display_unknown_macro_body_content')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $74b728764f4e0c94$export$414b5225f50e455b), {
            extensionNode: extensionNode
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            children: intl.formatMessage((0, $3nm9z.messages).extensionLoadingError)
        });
    } else return null;
}; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $8d7d1df6f664ad48$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "w8Pzf",
        name: "getNodeRenderer",
        _maybeSyncLoader: true,
        loader: ()=>{
            const maybePromise = $8d7d1df6f664ad48$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey);
            if (maybePromise instanceof Promise) return maybePromise.then((node)=>(0, $2sp5n.resolveImport)(node.render()));
            else {
                const preloaded = maybePromise?.renderSync?.();
                // Only product implemented preloading will return sync result
                // However the out-of-box won't handle this. Confluence uses a custom implementation
                return preloaded ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $HYsb2.resolveImportSync)(preloaded) : (0, $2sp5n.resolveImport)(maybePromise.render());
            }
        },
        // react-loadable passes all props from <NodeRenderer> to the loading component at runtime,
        // but its TypeScript types only expect LoadingComponentProps. We cast here because
        // ExtensionLoading accepts additional props (node, showUnknownMacroPlaceholder) that
        // react-loadable will pass through but doesn't know about in its type definitions.
        loading: $8d7d1df6f664ad48$var$ExtensionLoading
    });
}
module.exports["getExtensionModuleNode"] = $8d7d1df6f664ad48$export$82dd45c2db936caf;
module.exports["getExtensionModuleNodePrivateProps"] = $8d7d1df6f664ad48$export$426f8efd8690d8aa;
module.exports["getNodeRenderer"] = $8d7d1df6f664ad48$export$67a7d49db68d30a0;

});

parcelRegister("2sp5n", function(module, exports) {

var $judez = parcelRequire("judez");


var $HYsb2 = parcelRequire("HYsb2");

const $98232ed3ef203c6f$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $98232ed3ef203c6f$export$862c0e8acc7585d7 = 'com.atlassian.confluence.macro.core';
const $98232ed3ef203c6f$export$b343a94058bea058 = 'native-embed';
const $98232ed3ef203c6f$export$e400f4d17a615c24 = 'agent-managed-block';
const $98232ed3ef203c6f$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $98232ed3ef203c6f$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
function $98232ed3ef203c6f$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $98232ed3ef203c6f$export$33863d887d6f4bfd(action, manifest);
}
const $98232ed3ef203c6f$export$d69c9b451c47653b = async (importPromise)=>{
    return (0, $HYsb2.resolveImportSync)(await importPromise);
};
function $98232ed3ef203c6f$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = (0, $judez.buildExtensionKeyAndNodeKey)(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}
module.exports["NATIVE_EMBED_EXTENSION_TYPE"] = $98232ed3ef203c6f$export$862c0e8acc7585d7;
module.exports["NATIVE_EMBED_EXTENSION_KEY"] = $98232ed3ef203c6f$export$b343a94058bea058;
module.exports["AGENT_MANAGED_EXTENSION_KEY"] = $98232ed3ef203c6f$export$e400f4d17a615c24;
module.exports["getExtensionKeyAndNodeKey"] = $98232ed3ef203c6f$export$8a49818572e1d105;
module.exports["buildAction"] = $98232ed3ef203c6f$export$bb33bcdd9a10a608;
module.exports["resolveImport"] = $98232ed3ef203c6f$export$d69c9b451c47653b;

});

parcelRegister("3nm9z", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


const $8d3714cf4af833be$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    edit: {
        id: "fabric.editor.edit",
        defaultMessage: "Edit"
    },
    deleteElementTitle: {
        id: "fabric.editor.extension.deleteElementTitle",
        defaultMessage: "Delete element"
    },
    unnamedSource: {
        id: "fabric.editor.extension.sourceNoTitledName",
        defaultMessage: "this element"
    },
    confirmDeleteLinkedModalOKButton: {
        id: "fabric.editor.extension.confirmDeleteLinkedModalOKButton",
        defaultMessage: "Delete"
    },
    confirmDeleteLinkedModalMessage: {
        id: "fabric.editor.extension.confirmDeleteLinkedModalMessage",
        defaultMessage: "Deleting {nodeName} will break anything connected to it."
    },
    confirmModalCheckboxLabel: {
        id: "fabric.editor.floatingToolbar.confirmModalCheckboxLabel",
        defaultMessage: "Also delete connected elements"
    },
    saveIndicator: {
        id: "fabric.editor.extensions.config-panel.save-indicator",
        defaultMessage: "All changes are always autosaved"
    },
    panelLoadingError: {
        id: "fabric.editor.extensions.config-panel.loading-error.non-final",
        defaultMessage: "We ran into a bit of trouble. Refresh to try again."
    },
    extensionLoadingError: {
        id: "fabric.editor.extension.loading-error",
        defaultMessage: "Error loading the extension!"
    },
    unknownMacroPlaceholderAriaLabel: {
        id: "fabric.editor.extension.unknownMacroPlaceholderAriaLabel",
        defaultMessage: "Unknown macro placeholder"
    },
    unknownMacroHeader: {
        id: "fabric.editor.extension.unknownMacroHeader",
        defaultMessage: "Unknown macro: ''{macroTitle}''"
    }
});
module.exports["messages"] = $8d3714cf4af833be$export$defe85febe8b728c;

});

parcelRegister("794I6", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ 
var $cozmU = parcelRequire("cozmU");

class $cd2ed91e917bffdf$export$d498ee8be33e096f extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProviderIfMounted);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
    constructor(props){
        super(props);
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProviderIfMounted = (name, provider)=>{
            if (!this.mounted) return;
            this.handleProvider(name, provider);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const _providers = {};
        this.props.providers.forEach((name)=>{
            const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
            _providers[name] = providerPromise;
        });
        this.state = {
            providers: _providers
        };
    }
}
$cd2ed91e917bffdf$export$d498ee8be33e096f.displayName = 'WithProviders';
module.exports["WithProviders"] = $cd2ed91e917bffdf$export$d498ee8be33e096f;

});

parcelRegister("apAmb", function(module, exports) {
function $c8abaa51bdb9cc4f$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}
module.exports["getExtensionRenderer"] = $c8abaa51bdb9cc4f$export$9214452ef07eda7;

});

parcelRegister("9ECRl", function(module, exports) {
$parcel$export(module.exports, "default", () => $894e48615c3e9ddb$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $ieeJu = parcelRequire("ieeJu");


var $beDE4 = parcelRequire("beDE4");


var $kas7q = parcelRequire("kas7q");

const $ea65e0480f023c4d$var$requestIdleCallback = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.requestIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $ea65e0480f023c4d$var$cancelIdleCallback = (id)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.cancelIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $ea65e0480f023c4d$export$51a5b28e4fb2dba2 {
    dispose() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $ea65e0480f023c4d$var$cancelIdleCallback(this.requestCallbackId);
        }
        if ((0, $ieeJu.expValEquals)('platform_editor_renderer_shadow_observer_cleanup', 'isEnabled', true)) {
            this.sentinels.left?.remove();
            this.sentinels.right?.remove();
            this.sentinels = {};
        }
    }
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.intersectionObserver = void 0;
        this.scrollContainer = void 0;
        this.onUpdateShadows = void 0;
        this.sentinels = {};
        this.requestCallbackId = void 0;
        this.shadowStates = {
            [(0, $beDE4.ShadowKeys).SHOW_LEFT_SHADOW]: false,
            [(0, $beDE4.ShadowKeys).SHOW_RIGHT_SHADOW]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add((0, $kas7q.shadowObserverClassNames).SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add((0, $kas7q.shadowObserverClassNames).SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $ea65e0480f023c4d$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains((0, $kas7q.shadowObserverClassNames).SENTINEL_LEFT)) this.shadowStates[(0, $beDE4.ShadowKeys).SHOW_LEFT_SHADOW] = !entry.isIntersecting;
                if (entry.target.classList.contains((0, $kas7q.shadowObserverClassNames).SENTINEL_RIGHT)) this.shadowStates[(0, $beDE4.ShadowKeys).SHOW_RIGHT_SHADOW] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
}





const $894e48615c3e9ddb$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $894e48615c3e9ddb$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $ea65e0480f023c4d$export$51a5b28e4fb2dba2)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            const classNames = [
                !this.props?.disableTableOverflowShadow && showRightShadow && $894e48615c3e9ddb$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                !this.props?.disableTableOverflowShadow && showLeftShadow && $894e48615c3e9ddb$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $kas7q.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            /**
       * The widths have already been calculated to determine
       * showRightShadow and showLeftShadow. If either is true,
       * then the content is scrollable and we need to set the
       * tabIndex to 0 to allow the user to scroll the content
       * for a11y purposes.
       */ const hasOverflowScroll = showRightShadow || showLeftShadow;
            return /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                handleRef: this.handleContainer,
                tabIndex: hasOverflowScroll ? 0 : undefined,
                shadowClassNames: classNames,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.overflowContainer = void 0;
            this.container = void 0;
            this.shadowObserver = void 0;
            this.overflowContainerWidth = 0;
            this.scrollable = void 0;
            this.diff = void 0;
            this.state = {
                showLeftShadow: false,
                showRightShadow: false
            };
            this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            };
            this.updateShadows = ()=>{
                if (options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            };
            this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            };
            this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            };
            this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    const scrollableElement = this.scrollable[i];
                    if ($894e48615c3e9ddb$var$isElementNode(scrollableElement)) width += scrollableElement.scrollWidth;
                }
                return width;
            };
            this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}
// Helper function to check if the passed node is of Element class
function $894e48615c3e9ddb$var$isElementNode(node) {
    return node.nodeType === 1;
}
module.exports["shadowClassNames"] = $894e48615c3e9ddb$export$4735dd2b0fa88aa5;

});

parcelRegister("h9Lux", function(module, exports) {

var $7Y8M5 = parcelRequire("7Y8M5");


var $fTrZV = parcelRequire("fTrZV");


var $dUm2W = parcelRequire("dUm2W");


var $3IK8A = parcelRequire("3IK8A");





const $e1f53262cfe34cb6$export$ead1fecec2ecf57c = {
    padding: (0, $7Y8M5.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $7Y8M5.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $7Y8M5.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $7Y8M5.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $7Y8M5.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $fTrZV.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $dUm2W.getBreakpoint,
    /**
   * This function can return percentage value or px value depending upon the inputs
   */ calcBreakoutWidth: (breakoutConsts)=>(layout, containerWidth, padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            switch(layout){
                case 'full-width':
                    return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                case 'wide':
                    if (effectiveFullWidth <= 0) return '100%';
                    const wideWidth = breakoutConsts.calcWideWidth(breakoutConsts)(containerWidth, undefined, undefined, padding);
                    if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                    return wideWidth;
                default:
                    return '100%';
            }
        },
    calcBreakoutWithCustomWidth: (breakoutConsts)=>(mode, width, editorContainerWidth)=>{
            if (width !== null && width > 0) {
                const effectiveFullWidth = editorContainerWidth - breakoutConsts.padding;
                // if below 0 then expect we're rendering in SSR
                return `${Math.min(width, effectiveFullWidth)}px`;
            }
            return breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, editorContainerWidth);
        },
    calcLineLength: (breakoutConsts)=>()=>breakoutConsts.defaultLayoutWidth,
    calcWideWidth: (breakoutConsts)=>(containerWidth = breakoutConsts.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            const layoutMaxWidth = breakoutConsts.mapBreakpointToLayoutMaxWidth(breakoutConsts.getBreakpoint(containerWidth));
            const wideWidth = Math.min(Math.ceil(layoutMaxWidth * breakoutConsts.wideScaleRatio), effectiveFullWidth);
            return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
        }
};
const $e1f53262cfe34cb6$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $e1f53262cfe34cb6$export$ead1fecec2ecf57c.calcBreakoutWidth($e1f53262cfe34cb6$export$ead1fecec2ecf57c)(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $7Y8M5.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $7Y8M5.akEditorWideLayoutWidth;
        default:
            return $e1f53262cfe34cb6$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($e1f53262cfe34cb6$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $e1f53262cfe34cb6$export$86325001fe8f3adc = $e1f53262cfe34cb6$export$ead1fecec2ecf57c.calcWideWidth($e1f53262cfe34cb6$export$ead1fecec2ecf57c);
const $e1f53262cfe34cb6$export$5f4502874a28dfce = $e1f53262cfe34cb6$export$ead1fecec2ecf57c.calcBreakoutWidth($e1f53262cfe34cb6$export$ead1fecec2ecf57c);
const $e1f53262cfe34cb6$export$ccc0a02edddeed39 = $e1f53262cfe34cb6$export$ead1fecec2ecf57c.calcBreakoutWithCustomWidth($e1f53262cfe34cb6$export$ead1fecec2ecf57c);
function $e1f53262cfe34cb6$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $e1f53262cfe34cb6$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $3IK8A.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $7Y8M5.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $7Y8M5.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $e1f53262cfe34cb6$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $3IK8A.parsePx)($e1f53262cfe34cb6$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}
module.exports["breakoutConsts"] = $e1f53262cfe34cb6$export$ead1fecec2ecf57c;
module.exports["absoluteBreakoutWidth"] = $e1f53262cfe34cb6$export$b34ea040d1533a3;
module.exports["calcWideWidth"] = $e1f53262cfe34cb6$export$86325001fe8f3adc;
module.exports["calcBreakoutWidth"] = $e1f53262cfe34cb6$export$5f4502874a28dfce;
module.exports["calculateBreakoutStyles"] = $e1f53262cfe34cb6$export$c377853ecdd53e5b;

});

parcelRegister("3IK8A", function(module, exports) {
/**
 * Util for converting a css pixel size value to a number (of pixels).
 *
 * ie.
 * ```ts
 * const pixels = parsePx('10px')
 * //    ^$ const pixels: number
 * ```
 * * ```ts
 * const pixels = parsePx('10')
 * //    ^$ const pixels: number | undefined
 * ```
 */ // At time of writting prettier would strip the extend here.
// prettier-ignore
function $50546514ddfeb49e$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}
module.exports["parsePx"] = $50546514ddfeb49e$export$b0eef8cd00b29d5c;

});

parcelRegister("96p1s", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $4c49af8eb8684b1f$var$clPrefix = 'ak-renderer-';
const $4c49af8eb8684b1f$export$91f3bbbf974496e2 = {
    FLEX_CENTER_WRAPPER: `${$4c49af8eb8684b1f$var$clPrefix}flex-center-wrapper`,
    DOCUMENT: `${$4c49af8eb8684b1f$var$clPrefix}document`,
    EXTENSION: `${$4c49af8eb8684b1f$var$clPrefix}extension`,
    EXTENSION_AS_INLINE: `${$4c49af8eb8684b1f$var$clPrefix}extension-as-inline`,
    EXTENSION_CENTER_ALIGN: `${$4c49af8eb8684b1f$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$4c49af8eb8684b1f$var$clPrefix}extension-overflow-container`,
    EXTENSION_INNER_WRAPPER: `${$4c49af8eb8684b1f$var$clPrefix}extension-inner-wrapper`,
    /** Wrapper for center-aligned extensions/MBE; margin here so it participates in collapse */ STICKY_SAFE_CENTER_WRAPPER: `${$4c49af8eb8684b1f$var$clPrefix}sticky-safe-center-wrapper`,
    /** Wrapper for center-aligned embed card (wide/full-width); margin here so it participates in collapse */ EMBED_CARD_CENTER_WRAPPER: `${$4c49af8eb8684b1f$var$clPrefix}embed-card-center-wrapper`,
    /** Wrapper for center-aligned block card datasource (wide/full-width); margin here so it participates in collapse */ BLOCK_CARD_DATASOURCE_CENTER_WRAPPER: `${$4c49af8eb8684b1f$var$clPrefix}block-card-datasource-center-wrapper`,
    /** Outer flex wrapper for sticky-safe breakout (has vertical margin); zero margin when first in doc */ STICKY_SAFE_BREAKOUT_WRAPPER: `${$4c49af8eb8684b1f$var$clPrefix}sticky-safe-breakout-wrapper`,
    /** Flex item in sticky-safe breakout; zero first/last child margin so flex container height matches legacy */ STICKY_SAFE_BREAKOUT_INNER: `${$4c49af8eb8684b1f$var$clPrefix}sticky-safe-breakout-inner`,
    NUMBER_COLUMN: `${$4c49af8eb8684b1f$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$4c49af8eb8684b1f$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$4c49af8eb8684b1f$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$4c49af8eb8684b1f$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_NO_ORDER: `${$4c49af8eb8684b1f$var$clPrefix}tableHeader-sorting-icon__no-order`
};
module.exports["RendererCssClassName"] = $4c49af8eb8684b1f$export$91f3bbbf974496e2;

});

parcelRegister("gAjKf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $iTJtk = parcelRequire("iTJtk");


var $jv11C = parcelRequire("jv11C");


var $cY9xy = parcelRequire("cY9xy");

// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $fd954f4d95020af2$var$FAILED_TO_EXECUTE_REGEX = /Failed to execute.*on 'Node'.*/;
class $fd954f4d95020af2$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $iTJtk.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        const additionalInfo = this.props.additionalInfo ?? '';
        this.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $cY9xy.PLATFORM).WEB,
                errorMessage: `${additionalInfo}${error?.message}`,
                componentStack: errorInfo?.componentStack || undefined,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $jv11C.logException)(error, {
            location: 'renderer'
        });
        const matchesPattern = $fd954f4d95020af2$var$FAILED_TO_EXECUTE_REGEX.test(error.message);
        if (matchesPattern) {
            this.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).CAUGHT_DOM_ERROR,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, $cY9xy.PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error?.message}`
                }
            });
            this.setState((prevState)=>({
                    domError: true,
                    domErrorCount: prevState.domErrorCount + 1
                }));
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if (this.state.domError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: this.state.domErrorCount
        }, this.props.children);
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            errorCaptured: false,
            domError: false,
            domErrorCount: 0
        };
    }
}
module.exports["ErrorBoundary"] = $fd954f4d95020af2$export$e926676385687eaf;

});

parcelRegister("jv11C", function(module, exports) {

var $eieXD = parcelRequire("eieXD");


var $iDrrr = parcelRequire("iDrrr");

const $749e3763fe83201f$var$FEDRAMP_MODERATE = 'fedramp-moderate';
// Ignored via go/ees005
/* eslint-disable require-unicode-regexp */ const $749e3763fe83201f$var$FEDRAMP_HOSTNAME_REGEX = /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/;
function $749e3763fe83201f$export$64d6499adf9b2e51() {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $749e3763fe83201f$var$FEDRAMP_MODERATE;
    const matches = global.location?.hostname?.match($749e3763fe83201f$var$FEDRAMP_HOSTNAME_REGEX);
    return matches ? matches.length > 0 : false;
}


const $6172b9f2f8a8421a$export$b5bdb04ea16a02e3 = [
    'data-test-id',
    'data-testid'
];
const $6172b9f2f8a8421a$var$WHITELISTED_ATTRIBNUTES = [
    'type',
    'name',
    ...$6172b9f2f8a8421a$export$b5bdb04ea16a02e3
];
const $6172b9f2f8a8421a$var$REG_MATCH_NOTALLOWED_ATTRIBUTES = new RegExp(`\\[(?!${$6172b9f2f8a8421a$var$WHITELISTED_ATTRIBNUTES.join('|')}).*?\\]`, 'gmu');
// attributes may contain UGC that we need to strip out
// only allow type and name attributes
const $6172b9f2f8a8421a$var$sanitiseUiBreadcrumbMessage = (message)=>message.replace($6172b9f2f8a8421a$var$REG_MATCH_NOTALLOWED_ATTRIBUTES, '');
const $6172b9f2f8a8421a$export$6f14342128c6eaa4 = (breadcrumb)=>{
    const { category: category } = breadcrumb || {};
    // allow "ui*"" category breadcrumbs, that include clicks and inputs on DOM elements
    // they may contain UGC that needs to be stripped out
    if (category?.startsWith('ui')) {
        // sentry can include the element attributes in the data
        // which may contain UGC that we need to strip out
        const sanitisedBreadCrumb = breadcrumb;
        const { message: message } = sanitisedBreadCrumb;
        if (message !== null && message !== undefined) sanitisedBreadCrumb.message = $6172b9f2f8a8421a$var$sanitiseUiBreadcrumbMessage(message);
        return breadcrumb;
    }
    return breadcrumb;
};


// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $68f23b2209560d49$var$NETWORK_ERROR_REGEX = /^network error/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $68f23b2209560d49$var$NETWORK_FAILURE_REGEX = /^network failure/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $68f23b2209560d49$var$RESIZE_OBSERVER_LOOP_REGEX = /ResizeObserver loop completed with undelivered notifications/;
const $68f23b2209560d49$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $68f23b2209560d49$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $68f23b2209560d49$var$packageVersion = "0.0.0-use.local";
const $68f23b2209560d49$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $68f23b2209560d49$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await Promise.resolve((parcelRequire("eieXD")));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("dLbBR"));
        const breadcrumbsIntegration = (0, $iDrrr.fg)('platform_editor_sentry_breadcrumbs') ? new (0, $eieXD.Integrations).Breadcrumbs({
            // only enable breadcrumbs for dom (UI clicks and inputs)
            // include 'data-test-id', 'data-testid' in the breadcrumbs if they are found
            dom: {
                serializeAttribute: (0, $6172b9f2f8a8421a$export$b5bdb04ea16a02e3)
            },
            fetch: false,
            xhr: false,
            console: false,
            history: false,
            sentry: false
        }) : undefined;
        const sentryOptions = {
            dsn: (0, $749e3763fe83201f$export$64d6499adf9b2e51)() ? undefined : $68f23b2209560d49$var$SENTRY_DSN,
            release: `${$68f23b2209560d49$var$packageName}@${$68f23b2209560d49$var$packageVersion}`,
            environment: "production" ?? 'unknown',
            beforeBreadcrumb: (0, $iDrrr.fg)('platform_editor_sentry_breadcrumbs') ? (0, $6172b9f2f8a8421a$export$6f14342128c6eaa4) : undefined,
            ignoreErrors: [
                // Network issues
                $68f23b2209560d49$var$NETWORK_ERROR_REGEX,
                $68f23b2209560d49$var$NETWORK_FAILURE_REGEX,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                $68f23b2209560d49$var$RESIZE_OBSERVER_LOOP_REGEX
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    ...breadcrumbsIntegration ? [
                        breadcrumbsIntegration
                    ] : [],
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $68f23b2209560d49$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        hub.bindClient(client);
        hub.withScope((scope)=>{
            scope.setTags({
                // Jira environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-bundler': window.BUNDLER_VERSION,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-variant': window.BUILD_VARIANT,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'confluence-frontend-version': window.__buildInfo?.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};
module.exports["logException"] = $68f23b2209560d49$export$f86b2a1a2ce291b3;

});

parcelRegister("dLbBR", function(module, exports) {

let $a048ab94ad69f829$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a048ab94ad69f829$var$load("eHgxr"),
    $a048ab94ad69f829$var$load("kYwSN")
]).then(()=>parcelRequire('4s4MX'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("cY9xy", function(module, exports) {
var $8a63d5c8eadf93dc$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $8a63d5c8eadf93dc$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $8a63d5c8eadf93dc$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($8a63d5c8eadf93dc$var$RESOLVE_METHOD || {});
module.exports["PLATFORM"] = $8a63d5c8eadf93dc$export$88c4881e092abcaf;
module.exports["MODE"] = $8a63d5c8eadf93dc$export$e48589d9e4824227;

});

parcelRegister("GTXrQ", function(module, exports) {
var $0da33a4060cb9c1a$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $0da33a4060cb9c1a$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInfo";
    return ACTION;
}({});
var $0da33a4060cb9c1a$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    return ACTION_SUBJECT;
}({});
var $0da33a4060cb9c1a$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_DOWNLOAD"] = "codeBlockDownload";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    return ACTION_SUBJECT_ID;
}({});
module.exports["EVENT_TYPE"] = $0da33a4060cb9c1a$export$76a2e4c433c23bb9;
module.exports["ACTION"] = $0da33a4060cb9c1a$export$9523889e0a5da4ba;
module.exports["ACTION_SUBJECT"] = $0da33a4060cb9c1a$export$7525482b5931e326;
module.exports["ACTION_SUBJECT_ID"] = $0da33a4060cb9c1a$export$9957974f8b4d8f74;

});

parcelRegister("WNsSX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $epbW8 = parcelRequire("epbW8");





var $6RYDu = parcelRequire("6RYDu");


var $5J8wl = parcelRequire("5J8wl");


var $hRnS5 = parcelRequire("hRnS5");

const $50c524287b55d226$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $cozmU.useContext)((0, $6RYDu.ProvidersContext));
    const actionContext = (0, $cozmU.useContext)((0, $hRnS5.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const viewComponentProps = (0, $5J8wl.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $cozmU.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (0, $cozmU.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};















var $ieeJu = parcelRequire("ieeJu");





var $82HbV = parcelRequire("82HbV");


var $iTJtk = parcelRequire("iTJtk");


var $krYZG = parcelRequire("krYZG");





var $hZmcT = parcelRequire("hZmcT");

const $bc99974b53534da1$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteHoverToDraft: promoteHoverToDraft, clearHoverDraft: clearHoverDraft } = (0, $hZmcT.useAnnotationRangeDispatch)();
    const { hoverDraftDocumentPosition: hoverDraftDocumentPosition } = (0, $hZmcT.useAnnotationRangeState)();
    const actions = (0, $cozmU.useContext)((0, $hRnS5.RendererContext));
    const onCreateCallback = (0, $cozmU.useCallback)((annotationId)=>{
        // Always use documentPosition directly when gate is on — hoverDraftDocumentPosition
        // in this closure may be stale (captured before state update) (COMMENTS-6594).
        const positionToAnnotate = (0, $ieeJu.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true) ? documentPosition : hoverDraftDocumentPosition || documentPosition;
        if (!isAnnotationAllowed || !positionToAnnotate || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        }).fire((0, $iTJtk.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        hoverDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $cozmU.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $cozmU.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $krYZG.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            }).fire((0, $iTJtk.FabricChannel).editor);
            return false;
        }
        // Clear any stale draft position before promoting the new one.
        // Without this, if a previous draft was not explicitly closed, hoverDraftDocumentPosition
        // retains the old position and the comment anchors to the wrong text (COMMENTS-6594).
        if ((0, $ieeJu.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true)) clearHoverDraft();
        promoteHoverToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $krYZG.ACTION).OPENED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $iTJtk.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $82HbV.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        // Always use documentPosition directly when gate is on — hoverDraftDocumentPosition
        // in this closure may be stale (captured before state update) (COMMENTS-6594).
        const positionToAnnotate = (0, $ieeJu.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true) ? documentPosition : hoverDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $krYZG.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            }).fire((0, $iTJtk.FabricChannel).editor);
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        hoverDraftDocumentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        promoteHoverToDraft,
        clearHoverDraft
    ]);
    const removeDraftModeCallback = (0, $cozmU.useCallback)(()=>{
        clearHoverDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearHoverDraft
    ]);
    const onCloseCallback = (0, $cozmU.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $krYZG.ACTION).CLOSED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $iTJtk.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        range: range,
        isWithinRange: isWithinRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});









var $4PCaV = parcelRequire("4PCaV");

const $7bc387eb010b18d0$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $cozmU.useContext)((0, $hRnS5.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $hZmcT.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $hZmcT.useAnnotationRangeState)();
    const { isWithinRange: isWithinRange } = (0, $4PCaV.useAnnotationHoverContext)();
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bc99974b53534da1$export$2109cd350bcf6eda), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$7bc387eb010b18d0$export$6d8376a902cb8aa7.displayName = 'HoverRangeValidator';











/** Exists in its own module to allow mocking in unit tests */ const $9b1180b39fe7107d$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};



var $bJeQi = parcelRequire("bJeQi");




const $726dda1dd8c41585$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $cozmU.useRef)();
    const { clearSelectionRange: clearSelectionRange, setSelectionRange: setSelectionRange } = (0, $hZmcT.useAnnotationRangeDispatch)();
    const { range: range, type: type, selectionDraftRange: selectionDraftRange } = (0, $hZmcT.useAnnotationRangeState)();
    const { annotationManager: annotationManager } = (0, $bJeQi.useAnnotationManagerDispatch)();
    const lastRangeRef = (0, $cozmU.useRef)(null);
    const isAnnotationManagerEnabled = !!annotationManager;
    const onSelectionChange = (0, $cozmU.useCallback)((_event)=>{
        if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
        /*
			 * The 100ms debounce batches rapid `selectionchange` events during user drag/extend
			 * operations into a single React update. When the nudge button triggers a programmatic
			 * `addRange`, it fires exactly ONE `selectionchange` — no batching needed. Skipping the
			 * debounce ensures annotation position is computed synchronously so the first click
			 * applies the yellow highlight immediately. `data-nudge-selection-active` is set
			 * exclusively by the Confluence comment nudge feature and is double-gated:
			 * (1) `expValEquals('confluence_comment_nudgebar_improvement', ...)` — explicit experiment
			 * gate; (2) `data-nudge-selection-active` — ensures 0ms only fires during an actual nudge
			 * click, not on every selectionchange for experiment-ON users. Zero behavioral change for
			 * other products or experiment-OFF users.
			 */ const nudgeDelay = typeof document !== 'undefined' && document.body?.getAttribute('data-nudge-selection-active') === 'true' && (0, $ieeJu.expValEquals)('confluence_comment_nudgebar_improvement', 'isEnabled', true) ? 0 : 100;
        selectionTimeoutRef.current = setTimeout(()=>{
            const sel = document.getSelection();
            if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) {
                lastRangeRef.current = null; // Clear last range if selection is invalid
                if (isAnnotationManagerEnabled) clearSelectionRange();
                return;
            }
            let _range = sel.getRangeAt(0);
            // Skip if the selection hasn't changed
            if (lastRangeRef.current && _range.compareBoundaryPoints(Range.START_TO_START, lastRangeRef.current) === 0 && _range.compareBoundaryPoints(Range.END_TO_END, lastRangeRef.current) === 0) return;
            if (rendererDOM && (0, $9b1180b39fe7107d$export$90ee8f2d9317f430)(rendererDOM, _range)) {
                const { startContainer: startContainer, endContainer: endContainer } = _range;
                const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                if (isTripleClick) {
                    let p = startContainer;
                    while(p && p.nodeName !== 'P' && p !== rendererDOM)p = p.parentNode;
                    if (p && p.nodeName === 'P' && p instanceof Element) {
                        const range = document.createRange();
                        range.selectNodeContents(p);
                        sel.removeAllRanges();
                        sel.addRange(range);
                        _range = sel.getRangeAt(0);
                    }
                }
                setSelectionRange(_range.cloneRange());
                lastRangeRef.current = _range;
            }
        }, nudgeDelay);
    }, [
        rendererDOM,
        setSelectionRange,
        clearSelectionRange,
        isAnnotationManagerEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('selectionchange', onSelectionChange);
            clearSelectionRange();
        };
    }, [
        rendererDOM,
        onSelectionChange,
        clearSelectionRange
    ]);
    return [
        type,
        range,
        selectionDraftRange,
        clearSelectionRange
    ];
};









var $iDrrr = parcelRequire("iDrrr");


var $iwjSV = parcelRequire("iwjSV");














var $lX0Us = parcelRequire("lX0Us");










const $3aff470266cf7833$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteSelectionToDraft: promoteSelectionToDraft, clearSelectionDraft: clearSelectionDraft } = (0, $hZmcT.useAnnotationRangeDispatch)();
    const { selectionDraftDocumentPosition: selectionDraftDocumentPosition } = (0, $hZmcT.useAnnotationRangeState)();
    const actions = (0, $cozmU.useContext)((0, $hRnS5.RendererContext));
    const { isDrafting: isDrafting, draftId: draftId } = (0, $bJeQi.useAnnotationManagerState)();
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $bJeQi.useAnnotationManagerDispatch)();
    const inlineNodeTypes = (0, $cozmU.useMemo)(()=>{
        if (!actions.isRangeAnnotatable(range)) return undefined;
        return (0, $lX0Us.getRendererRangeInlineNodeNames)({
            pos: documentPosition,
            actions: actions
        });
    }, [
        documentPosition,
        actions,
        range
    ]);
    const onCreateCallback = (0, $cozmU.useCallback)((annotationId)=>{
        // Use documentPosition directly when gate is on — selectionDraftDocumentPosition may be stale
        // (from a previous selection) causing the comment to anchor to the wrong text (COMMENTS-6594).
        const positionToAnnotate = (0, $ieeJu.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true) ? documentPosition : selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) return false;
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        }).fire((0, $iTJtk.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        selectionDraftDocumentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    const createIndexCallback = (0, $cozmU.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $cozmU.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $krYZG.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes,
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            }).fire((0, $iTJtk.FabricChannel).editor);
            return false;
        }
        // Clear any stale draft position before promoting the new one (COMMENTS-6594).
        if ((0, $ieeJu.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true)) clearSelectionDraft();
        promoteSelectionToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $krYZG.ACTION).OPENED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $iTJtk.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $82HbV.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        // Use documentPosition directly when either:
        // - platform_editor_comments_api_manager is on (existing behaviour), OR
        // - COMMENTS-6594 experiment is on (fix: avoids stale closure value)
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        const positionToAnnotate = (0, $iDrrr.fg)('platform_editor_comments_api_manager') || (0, $ieeJu.expValEquals)('confluence_inline_comments_fix_stale_selection', 'isEnabled', true) ? documentPosition : selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $krYZG.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            }).fire((0, $iTJtk.FabricChannel).editor);
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        inlineNodeTypes,
        promoteSelectionToDraft,
        clearSelectionDraft,
        selectionDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $cozmU.useCallback)(()=>{
        clearSelectionDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearSelectionDraft
    ]);
    const onCloseCallback = (0, $cozmU.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $krYZG.ACTION).CLOSED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $iTJtk.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (annotationManager) {
            const allowAnnotation = ()=>{
                if (isDrafting) return false;
                return isAnnotationAllowed;
            };
            annotationManager.hook('allowAnnotation', allowAnnotation);
            return ()=>{
                annotationManager.unhook('allowAnnotation', allowAnnotation);
            };
        }
    }, [
        annotationManager,
        isAnnotationAllowed,
        isDrafting
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (annotationManager) {
            const startDraft = ()=>{
                // if there is a draft in progress, we ignore it and start a new draft
                // this is because clearing the draft will remove the mark node from the DOM, which will cause the selection range to be invalid
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const id = (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))();
                const result = applyDraftModeCallback({
                    annotationId: id,
                    keepNativeSelection: false
                });
                if (!result) return {
                    success: false,
                    reason: 'invalid-range'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: true,
                        draftId: id,
                        draftActionResult: result
                    }
                });
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return {
                    success: true,
                    // We cannot get a ref to the target element here
                    // because the draft is not yet applied to the DOM
                    targetElement: undefined,
                    inlineNodeTypes: result.inlineNodeTypes ?? [],
                    actionResult: {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    }
                };
            };
            annotationManager.hook('startDraft', startDraft);
            return ()=>{
                annotationManager.unhook('startDraft', startDraft);
            };
        }
    }, [
        annotationManager,
        isDrafting,
        applyDraftModeCallback,
        actions,
        range,
        dispatch
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (annotationManager) {
            const clearDraft = ()=>{
                if (!isDrafting) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                onCloseCallback();
                return {
                    success: true
                };
            };
            annotationManager.hook('clearDraft', clearDraft);
            return ()=>{
                annotationManager.unhook('clearDraft', clearDraft);
            };
        }
    }, [
        annotationManager,
        onCloseCallback,
        isDrafting,
        dispatch
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (annotationManager) {
            const applyDraft = (id)=>{
                if (!isDrafting || !draftId) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                const result = onCreateCallback(id);
                if (!result) return {
                    success: false,
                    reason: 'range-no-longer-exists'
                };
                onCloseCallback();
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true,
                        markState: (0, $epbW8.AnnotationMarkStates).ACTIVE
                    }
                });
                return {
                    success: true,
                    targetElement: undefined,
                    actionResult: id !== draftId ? {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    } : undefined
                };
            };
            annotationManager.hook('applyDraft', applyDraft);
            return ()=>{
                annotationManager.unhook('applyDraft', applyDraft);
            };
        }
    }, [
        annotationManager,
        onCreateCallback,
        onCloseCallback,
        isDrafting,
        draftId,
        dispatch
    ]);
    // Please remove this NOP function when the flag platform_editor_comments_api_manager is removed.
    const nop = (0, $cozmU.useMemo)(()=>()=>false, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        range: range,
        draftRange: draftRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: annotationManager ? nop : onCloseCallback,
        onCreate: annotationManager ? nop : onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: annotationManager ? nop : applyDraftModeCallback,
        removeDraftMode: annotationManager ? nop : removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});





const $7dbdf305794065cc$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $cozmU.useContext)((0, $hRnS5.RendererContext));
    const [type, range, draftRange, clearRange] = (0, $726dda1dd8c41585$export$47201332e612f5a4)({
        rendererRef: rendererRef
    });
    const selectionRange = type === 'selection' ? range : null;
    // !!! the draft range will become invalid after the mark DOM is inserted
    if (!selectionRange && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3aff470266cf7833$export$ca7741472ed8ba00), {
        range: selectionRange,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$7dbdf305794065cc$export$74435b85e23b84d9.displayName = 'SelectionRangeValidator';


const $0cc1ff11e56fcba2$export$787af8a111ff3c03 = (props)=>{
    const providers = (0, $cozmU.useContext)((0, $6RYDu.ProvidersContext));
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children, !!hoverComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7bc387eb010b18d0$export$6d8376a902cb8aa7), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        component: hoverComponent
    }), !!selectionComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7dbdf305794065cc$export$74435b85e23b84d9), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectionComponent: selectionComponent
    }));
};









var $fJCU9 = parcelRequire("fJCU9");










const $05f8c20537d265c8$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    const actions = (0, $cozmU.useContext)((0, $hRnS5.RendererContext));
    const providers = (0, $cozmU.useContext)((0, $6RYDu.ProvidersContext));
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $bJeQi.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $cozmU.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) {
            if (!isNestedRender) // inlineCommentGetState handles empty lists gracefully. It has a side-effect of clearing state, which is why this call is needed
            inlineCommentGetState([], isNestedRender);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: 0
            });
            return;
        }
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            if (isAnnotationManagerEnabled) dispatch({
                type: 'loadAnnotation',
                data: Object.keys(payload).map((id)=>({
                        id: id,
                        markState: payload[id].state ?? undefined
                    }))
            });
            else updateSubscriberInlineComment.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
            });
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender,
        onLoadComplete,
        dispatch,
        isAnnotationManagerEnabled
    ]);
};






var $9DHhW = parcelRequire("9DHhW");










const $197771b936a77ce0$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    (0, $05f8c20537d265c8$export$39f7c1a861a0d41c)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    });
    return null;
});
const $197771b936a77ce0$export$8c8c3e12db6c0591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    startPos: 1
});
const $197771b936a77ce0$export$7121915072388536 = (props)=>{
    const { children: children, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    const providers = (0, $cozmU.useContext)((0, $6RYDu.ProvidersContext));
    const updateSubscriber = providers && providers.inlineComment && providers.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $5J8wl.useAnnotationStateByTypeEvent)({
        type: (0, $epbW8.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6RYDu.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hZmcT.AnnotationRangeProvider), {
        allowCommentsOnMedia: providers?.inlineComment?.allowCommentsOnMedia ?? false,
        isNestedRender: isNestedRender
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PCaV.AnnotationHoverContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0cc1ff11e56fcba2$export$787af8a111ff3c03), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef,
        isNestedRender: isNestedRender
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($197771b936a77ce0$var$LoadAnnotations, {
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $50c524287b55d226$export$41cd4a02859c2806), {
        isNestedRender: isNestedRender,
        createAnalyticsEvent: createAnalyticsEvent
    }), children))));
};
const $197771b936a77ce0$export$cef0157dd42cbb3f = (props)=>{
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    if (!isNestedRender && annotationProvider?.annotationManager) // We need to ensure there is a single instance of the annotation manager for the whole document
    // and that it is the same instance for all annotations.
    // This is because the annotation manager is responsible for managing the state of ALL annotations.
    // This includes annotations inside extensions.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6RYDu.ProvidersContext).Provider, {
        value: annotationProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bJeQi.AnnotationManagerProvider), {
        annotationManager: annotationProvider.annotationManager,
        updateSubscriber: annotationProvider?.inlineComment?.updateSubscriber ?? undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($197771b936a77ce0$export$7121915072388536, {
        rendererRef: rendererRef,
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    }, children)));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6RYDu.ProvidersContext).Provider, {
        value: annotationProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($197771b936a77ce0$export$7121915072388536, {
        rendererRef: rendererRef,
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    }, children));
};
module.exports["AnnotationsPositionContext"] = $197771b936a77ce0$export$8c8c3e12db6c0591;
module.exports["AnnotationsWrapper"] = $197771b936a77ce0$export$cef0157dd42cbb3f;

});

parcelRegister("hRnS5", function(module, exports) {
/* eslint-disable jsdoc/require-jsdoc */ 
var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $9DHhW = parcelRequire("9DHhW");


var $fmu9K = parcelRequire("fmu9K");


var $krYZG = parcelRequire("krYZG");


var $epbW8 = parcelRequire("epbW8");


var $fRYCB = parcelRequire("fRYCB");


var $2lPWP = parcelRequire("2lPWP");


var $kCECX = parcelRequire("kCECX");





var $eOaGc = parcelRequire("eOaGc");




/* eslint-disable jsdoc/require-jsdoc -- internal step helpers */ 





// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $5ff2fb6925df381e$var$MEDIA_OR_MEDIA_SINGLE_REGEX = /media|mediaSingle/;
function $5ff2fb6925df381e$export$aabc9b13a308cc43(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $5ff2fb6925df381e$var$getNodeType = (element)=>element.dataset.nodeType;
function $5ff2fb6925df381e$var$isPositionPointer(element) {
    return $5ff2fb6925df381e$export$aabc9b13a308cc43(element) > -1;
}
function $5ff2fb6925df381e$export$25245567f53f158f(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $5ff2fb6925df381e$export$9d1d5d87ae7da22f(parentElement)) return null;
    if ($5ff2fb6925df381e$var$isPositionPointer(parentElement)) return parentElement;
    return $5ff2fb6925df381e$export$25245567f53f158f(parentElement);
}
function $5ff2fb6925df381e$var$findMediaParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $5ff2fb6925df381e$export$9d1d5d87ae7da22f(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $5ff2fb6925df381e$var$findMediaParent(parentElement);
}
function $5ff2fb6925df381e$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($5ff2fb6925df381e$export$9d1d5d87ae7da22f(parentElement) || !parentElement) return null;
    if ($5ff2fb6925df381e$var$isPositionPointer(parentElement)) return element;
    return $5ff2fb6925df381e$var$findParentBeforePointer(parentElement);
}
function $5ff2fb6925df381e$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $5ff2fb6925df381e$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $5ff2fb6925df381e$var$isHighlightTextNode(node) {
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return !!node?.dataset?.highlighted;
}
function $5ff2fb6925df381e$var$isNodeInlineMark(node) {
    return $5ff2fb6925df381e$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $5ff2fb6925df381e$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $5ff2fb6925df381e$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    const isInlineMark = $5ff2fb6925df381e$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
   * This checks if the element has any descendents with the data-inline-card
   * attribute set to 'true'. If it does, we should not consider it as an
   * inline text mark.
   **/ if ($5ff2fb6925df381e$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $5ff2fb6925df381e$var$hasInlineNodeDescendant(node) {
    if ($5ff2fb6925df381e$var$isElementNode(node)) {
        if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($5ff2fb6925df381e$var$hasInlineNodeDescendant);
    }
    return false;
}
function $5ff2fb6925df381e$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if (prev.nodeType === Node.COMMENT_NODE) {
            // Comment nodes should not result in the position being
            // incremented, so we skip them.
            prev = prev.previousSibling;
            continue;
        }
        if (prev && ($5ff2fb6925df381e$var$isTextNode(prev) || $5ff2fb6925df381e$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($5ff2fb6925df381e$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($5ff2fb6925df381e$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $5ff2fb6925df381e$export$9d1d5d87ae7da22f(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $5ff2fb6925df381e$export$5db587db55468da7(node, offset, findEnd = false) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) {
        const startPosAncestor = node.parentElement?.closest('[data-renderer-start-pos');
        const potentialParent = (0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor?.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10) + 1;
            else return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10);
        }
    }
    /**
   * If anchor node is an element (e.g. after a triple click) the anchorOffset
   * is the number of child nodes preceding the anchor.
   * https://developer.mozilla.org/en-US/docs/Web/API/Selection/anchorOffset
   *
   * For end pos we calculate the number of characters by stepping through
   * each of the node's children.
   */ if (node instanceof HTMLElement && $5ff2fb6925df381e$var$isPositionPointer(node)) {
        if (findEnd) {
            let count = $5ff2fb6925df381e$export$aabc9b13a308cc43(node);
            const children = node.childNodes;
            for(let i = 0; i < offset; i++)count += children[i]?.textContent?.length || 1;
            return count;
        }
        return $5ff2fb6925df381e$export$aabc9b13a308cc43(node) + offset;
    }
    const parent = $5ff2fb6925df381e$export$25245567f53f158f(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $5ff2fb6925df381e$export$aabc9b13a308cc43(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $5ff2fb6925df381e$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($5ff2fb6925df381e$var$isNodeInlineTextMark(preParentPointer) || $5ff2fb6925df381e$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($5ff2fb6925df381e$var$isElementInlineMark(preParentPointer) || $5ff2fb6925df381e$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $5ff2fb6925df381e$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                const nodePos = $5ff2fb6925df381e$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $5ff2fb6925df381e$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $5ff2fb6925df381e$export$243cdddc5b21d8c1(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const possibleMediaOrMediaSingleElement = $5ff2fb6925df381e$export$25245567f53f158f(startContainer);
    // Video hover targets return media single, not media, thus, the extra check in condition.
    const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && $5ff2fb6925df381e$var$MEDIA_OR_MEDIA_SINGLE_REGEX.test($5ff2fb6925df381e$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
    if (isMediaOrMediaSingle) {
        let pos;
        const mediaSingleElement = $5ff2fb6925df381e$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $5ff2fb6925df381e$var$findMediaParent(possibleMediaOrMediaSingleElement);
        if (mediaSingleElement) pos = $5ff2fb6925df381e$export$aabc9b13a308cc43(mediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    const from = $5ff2fb6925df381e$export$5db587db55468da7(startContainer, startOffset);
    const findEnd = true;
    const to = $5ff2fb6925df381e$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $5ff2fb6925df381e$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $eOaGc.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}



var $lX0Us = parcelRequire("lX0Us");

function $0de512fe27bdb37e$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const { media: media } = schema.nodes;
        // Mirrors Confluence backend and doesn't construct textContent if it doesn't allow annotations
        // Don't skip media node so that block node can be defined its startIndex in within [nodeStart, nodeEnd]
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) // Note: `return true` as a parent disallowing annotations does not mean a child disallows annotations.
        // Eg: panel (invalid) > p (valid)
        return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // if it's a node block, set position to pos to indicate to the backend
            // that it's an annotation on a block node
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $0de512fe27bdb37e$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $0de512fe27bdb37e$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $0de512fe27bdb37e$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}






var $2ROjz = parcelRequire("2ROjz");

var $3rWk6 = parcelRequire("3rWk6");


const $1dab780c240aae42$export$3726c4866ce829b5 = ({ doc: doc, schema: schema })=>{
    if (!doc || !schema) return null;
    const selection = document.getSelection();
    if (!selection || selection.type !== 'Range' || selection.rangeCount !== 1) return null;
    const range = selection.getRangeAt(0);
    if (range.collapsed) return null;
    const startNode = (0, $5ff2fb6925df381e$export$25245567f53f158f)(range.startContainer);
    const endNode = (0, $5ff2fb6925df381e$export$25245567f53f158f)(range.endContainer);
    if (!startNode || !endNode) return null;
    const startPos = (0, $5ff2fb6925df381e$export$aabc9b13a308cc43)(startNode);
    const endPos = (0, $5ff2fb6925df381e$export$aabc9b13a308cc43)(endNode);
    if (startPos === null || endPos === null) return null;
    const pos = (0, $5ff2fb6925df381e$export$243cdddc5b21d8c1)(range);
    if (!pos) return null;
    const from = Math.min(pos.from, pos.to);
    const to = Math.max(pos.from, pos.to);
    if (from === to) return null;
    let pmSelection;
    try {
        pmSelection = (0, $kCECX.TextSelection).create(doc, from, to);
    } catch  {
        return null;
    }
    const startIndex = from - startPos;
    const endIndex = to - endPos;
    if (startIndex < 0 || endIndex < 0) return null;
    const selectionFragment = (0, $2ROjz.getFragmentsFromSelection)(pmSelection);
    const localIds = (0, $3rWk6.getLocalIdsFromSelection)(pmSelection);
    return {
        localIds: localIds,
        selectionFragment: selectionFragment,
        selectionMarkdown: null,
        startIndex: startIndex,
        endIndex: endIndex
    };
};


class $dd6cb94b419ad111$export$2e2bcd8739ae039 {
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
    }
    /**
   * Validate whether we can create an annotation between two positions
   */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) return false;
        const currentSelection = (0, $kCECX.TextSelection).create(this.doc, from, to);
        if ((0, $fRYCB.isEmptyTextSelectionRenderer)(currentSelection, this.schema)) return false;
        const result = (0, $fRYCB.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
        return result;
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && node.type.name === 'media') nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $eOaGc.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $eOaGc.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $krYZG.ACTION).DELETED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: step instanceof (0, $eOaGc.RemoveMarkStep) ? (0, $lX0Us.getRendererRangeInlineNodeNames)({
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        pos: {
                            from: from,
                            to: to
                        },
                        actions: this
                    }) : undefined
                }
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, _annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $5ff2fb6925df381e$export$243cdddc5b21d8c1)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) {
            if (this.isRendererWithinRange(range)) return false;
        }
        const pos = (0, $5ff2fb6925df381e$export$243cdddc5b21d8c1)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isRangeAnnotatable(range) {
        try {
            if (!range) return false;
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if (startContainer.parentElement?.closest('.ak-renderer-extension') || endContainer.parentElement?.closest('.ak-renderer-extension')) return false;
            return this.isValidAnnotationRange(range);
        } catch  {
            // isValidAnnotationRange can fail when called inside nested renderers.
            // while isRendererWithinRange guards against this to some degree -- the classnames
            // are controlled by product -- and we don't have platform guarantees on them.
            //
            // Currently there is a mix of logic across the platform and confluence on determining
            // positions that are annotatable. This is a defensive check to ensure we don't throw an error
            // in cases where the range is not valid.
            return false;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * This is replaced by `isRangeAnnotatable`.
   *
   * @deprecated
   **/ isRendererWithinRange(range) {
        const { startContainer: startContainer, endContainer: endContainer } = range;
        if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
        return false;
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    /**
   * Note: False indicates that the selection not able to be calculated.
   */ getPositionFromRange(range) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $5ff2fb6925df381e$export$243cdddc5b21d8c1)(range);
    }
    getSelectionContext() {
        return (0, $1dab780c240aae42$export$3726c4866ce829b5)({
            doc: this.doc,
            schema: this.schema
        });
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $5ff2fb6925df381e$export$243cdddc5b21d8c1)(range);
        if (!pos || !this.doc) return [];
        return (0, $fRYCB.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        let targetNodeType;
        // As part of fix for RAP, `from` points to the position right before media node
        // hence, -1 is not needed
        const beforeNodePos = from;
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        if (possibleNode?.type.name === 'media') {
            targetNodeType = 'media';
            step = new (0, $eOaGc.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                id: annotationId,
                type: annotationType
            }));
        } else {
            const resolvedNode = this.doc.resolve(from).node();
            // annotation is technically on text, but the context is caption
            targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
            step = (0, $5ff2fb6925df381e$export$74899f7e5acb5cd3)(from, to, {
                annotationId: annotationId,
                annotationType: annotationType,
                schema: this.schema
            });
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) return false;
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $0de512fe27bdb37e$export$fb7dab895a0d310e)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            inlineNodeTypes: (0, $lX0Us.getRendererRangeInlineNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            ancestorNodeTypes: (0, $lX0Us.getRendererRangeAncestorNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos,
            targetNodeType: targetNodeType
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $0de512fe27bdb37e$export$fb7dab895a0d310e)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Do not forget to remove `undefined` when the `editor_inline_comments_on_inline_nodes` is removed.
    getInlineNodeTypes(annotationId) {
        if (!this.doc || !this.schema) return [];
        return (0, $fRYCB.getAnnotationInlineNodeTypes)({
            doc: this.doc,
            schema: this.schema
        }, annotationId);
    }
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        this.initFromContext = false;
        this.transformer = void 0;
        this.doc = void 0;
        this.schema = void 0;
        // Any kind of refence is allowed
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.ref = void 0;
        this.onAnalyticsEvent = void 0;
        this.initFromContext = initFromContext;
        this.transformer = new (0, $2lPWP.JSONTransformer)();
    }
}


const $15613669d2fb03b5$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(new (0, $dd6cb94b419ad111$export$2e2bcd8739ae039)());
function $15613669d2fb03b5$export$66feffbad722f9d4({ children: children, context: context }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const actions = (0, $cozmU.useMemo)(()=>new (0, $dd6cb94b419ad111$export$2e2bcd8739ae039)(true), []);
    // Remove this eventually when root cause is assessed
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) > 1 && (0, $iDrrr.fg)('confluence_frontend_fix_view_page_slo')) // Send event when we get more than 1 child
    try {
        throw new Error('Too many children');
    } catch (e) {
        const { stack: stack } = e;
        createAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: 'rendered',
            actionSubject: 'multipleChildren',
            actionSubjectId: 'rendererActionsContext',
            attributes: {
                numChildren: (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children),
                stackTrace: stack
            }
        }).fire((0, $fmu9K.FabricChannel).editor);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($15613669d2fb03b5$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions
    }, (0, $iDrrr.fg)('confluence_frontend_fix_view_page_slo') ? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.only(children) : children);
}
const $15613669d2fb03b5$export$d5fcf151601331bc = $15613669d2fb03b5$export$1e9ea4edb6d1bfe6.Consumer;
module.exports["RendererContext"] = $15613669d2fb03b5$export$1e9ea4edb6d1bfe6;
module.exports["RendererActionsContext"] = $15613669d2fb03b5$export$66feffbad722f9d4;
module.exports["RendererActionsContextConsumer"] = $15613669d2fb03b5$export$d5fcf151601331bc;

});

parcelRegister("fRYCB", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $epbW8 = parcelRequire("epbW8");


var $iDrrr = parcelRequire("iDrrr");

const $af642983a79d8d5a$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $af642983a79d8d5a$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    const annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $af642983a79d8d5a$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $af642983a79d8d5a$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $af642983a79d8d5a$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($af642983a79d8d5a$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $af642983a79d8d5a$export$35054451202ed5d9({ doc: doc, pos: pos }) {
    if (!(0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, (node)=>{
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        const sortedNames = [
            ...nodeNames
        ].sort();
        return sortedNames;
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $af642983a79d8d5a$export$2a160f09551a3adc({ doc: doc, pos: pos }) {
    if (!(0, $iDrrr.fg)('cc_comments_log_draft_annotation_ancestor_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        // For a range, we can get ancestors at both from and to positions
        // or just use the from position if you want ancestors at the start
        const resolvedFromPos = doc.resolve(pos.from);
        const resolvedToPos = doc.resolve(pos.to);
        // Collect ancestors at the 'from' position
        for(let depth = resolvedFromPos.depth; depth > 0; depth--){
            const ancestorNode = resolvedFromPos.node(depth);
            nodeNames.add(ancestorNode.type.name);
        }
        // Use nodesBetween to collect parent types without additional resolve() calls
        // This isn't as precise as calling resolve() on each parent, but it's a lot faster
        // and should hopefully provide a good approximation of the ancestor nodes
        const seenParents = new Set();
        doc.nodesBetween(pos.from, pos.to, (_node, _nodePos, parent)=>{
            // Collect parent chain using the parent parameter
            const currentParent = parent;
            if (!!currentParent && !seenParents.has(currentParent)) {
                seenParents.add(currentParent);
                nodeNames.add(currentParent.type.name);
            // Note: We can't easily get the parent's parent from this context
            // without additional resolve calls, so this approach has limitations
            }
            return true;
        });
        // Optionally collect ancestors at the 'to' position if different
        // This ensures we capture all ancestor contexts across the range
        if (pos.from !== pos.to) for(let depth = resolvedToPos.depth; depth > 0; depth--){
            const ancestorNode = resolvedToPos.node(depth);
            nodeNames.add(ancestorNode.type.name);
        }
        return [
            ...nodeNames
        ];
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $af642983a79d8d5a$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
    });
    const inlineNodeNames = new Set();
    state.doc.descendants((node, _pos)=>{
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return [
        ...inlineNodeNames
    ].sort();
}
function $af642983a79d8d5a$export$bb1945a828f2864b(pos) {
    const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
    return annotationMarks;
}
function $af642983a79d8d5a$export$2efbc6d84ea0fbec(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for not a text or nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type !== text || !node.textContent) hasContent = true;
        return !hasContent;
    });
    return !hasContent;
}
function $af642983a79d8d5a$export$a35880e7ecdcf47b(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for inline elements - consider nonempty
        if (node.type !== text && node.type.isInline) hasContent = true;
        // for nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type === text && !!node.textContent) hasContent = true;
        // for other non-text nodes - continue descending
        return !hasContent;
    });
    return !hasContent;
}
module.exports["canApplyAnnotationOnRange"] = $af642983a79d8d5a$export$77ddf8216f9eb904;
module.exports["getAnnotationIdsFromRange"] = $af642983a79d8d5a$export$badbcc229c848aec;
module.exports["hasAnnotationMark"] = $af642983a79d8d5a$export$5fe1412b20386053;
module.exports["containsAnyAnnotations"] = $af642983a79d8d5a$export$1976770b876b2728;
module.exports["getRangeInlineNodeNames"] = $af642983a79d8d5a$export$35054451202ed5d9;
module.exports["getRangeAncestorNodeNames"] = $af642983a79d8d5a$export$2a160f09551a3adc;
module.exports["getAnnotationInlineNodeTypes"] = $af642983a79d8d5a$export$8261bc1f662f3f6e;
module.exports["getAnnotationMarksForPos"] = $af642983a79d8d5a$export$bb1945a828f2864b;
module.exports["isEmptyTextSelection"] = $af642983a79d8d5a$export$2efbc6d84ea0fbec;
module.exports["isEmptyTextSelectionRenderer"] = $af642983a79d8d5a$export$a35880e7ecdcf47b;

});

parcelRegister("2ROjz", function(module, exports) {

var $2AUaD = parcelRequire("2AUaD");


var $9fhVI = parcelRequire("9fhVI");

const $23baee69aa3636b2$export$dae3dcae007fe30 = (selection)=>{
    if (!selection || selection.empty) return null;
    const slice = (0, $9fhVI.getSliceFromSelection)(selection);
    const content = slice.content;
    const fragment = [];
    content.forEach((node)=>{
        fragment.push((0, $2AUaD.toJSON)(node));
    });
    return fragment;
};
module.exports["getFragmentsFromSelection"] = $23baee69aa3636b2$export$dae3dcae007fe30;

});

parcelRegister("9fhVI", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");



const $7c04778510a09ff2$var$listDepth = 3;
const $7c04778510a09ff2$export$8701765a689d47ab = ($from, $to)=>{
    // Block level lists
    const listParents = [
        'bulletList',
        'orderedList'
    ];
    if ($from.depth >= $7c04778510a09ff2$var$listDepth && $to.depth >= $7c04778510a09ff2$var$listDepth && $from.depth === $to.depth) {
        // Get grandparents (from)
        const grandparentFrom = $from.node($from.depth - 1);
        const greatGrandparentFrom = $from.node($from.depth - 2);
        // Get grandparents (to)
        const grandparentTo = $to.node($from.depth - 1);
        const greatGrandparentTo = $to.node($from.depth - 2);
        if (greatGrandparentTo.eq(greatGrandparentFrom) && listParents.includes(greatGrandparentFrom.type.name) && // Selection covers entire list
        greatGrandparentFrom.firstChild?.eq(grandparentFrom) && greatGrandparentFrom.lastChild?.eq(grandparentTo)) return true;
    }
    return false;
};
const $7c04778510a09ff2$export$4fd509032ef7561b = (selection)=>{
    const { from: from, to: to } = selection;
    if (from === to) return (0, $aPdNQ.Fragment).empty;
    let frag = (0, $aPdNQ.Fragment).empty;
    const sortedRanges = [
        ...selection.ranges.slice()
    ].sort((a, b)=>a.$from.pos - b.$from.pos);
    for (const range of sortedRanges){
        const { $from: $from, $to: $to } = range;
        const to = $to.pos;
        const depth = // If we're in a text selection, and share the parent node across the anchor->head
        // make the depth the parent node
        selection instanceof (0, $kCECX.TextSelection) && $from.parent.eq($to.parent) ? Math.max(0, $from.sharedDepth(to) - 1) : $from.sharedDepth(to);
        let finalDepth = depth;
        // For block-level lists (non-nested) specifically use the selection
        if ($7c04778510a09ff2$export$8701765a689d47ab($from, $to)) finalDepth = $from.depth - $7c04778510a09ff2$var$listDepth;
        const start = $from.start(finalDepth);
        const node = $from.node(finalDepth);
        const content = node.content.cut($from.pos - start, $to.pos - start);
        frag = frag.append(content);
    }
    return frag;
};
module.exports["getSliceFromSelection"] = $7c04778510a09ff2$export$4fd509032ef7561b;

});

parcelRegister("3rWk6", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $8HW7o = parcelRequire("8HW7o");


var $iDrrr = parcelRequire("iDrrr");


var $9fhVI = parcelRequire("9fhVI");

const $8ba12c76f7ae9309$export$9ce8378d786d4035 = (selection)=>{
    if (!selection) return null;
    if (selection instanceof (0, $kCECX.NodeSelection)) {
        if ((0, $iDrrr.fg)('platform_editor_ai_selection_local_ids')) {
            const ids = [];
            const rootLocalId = selection.node.attrs?.localId;
            if (rootLocalId) ids.push(rootLocalId);
            selection.node.descendants((node)=>{
                if (node.isInline) return false;
                const localId = node.attrs?.localId;
                if (localId) ids.push(localId);
            });
            return ids;
        }
        return [
            selection.node.attrs.localId
        ];
    } else if (selection instanceof (0, $8HW7o.CellSelection)) {
        if ((0, $iDrrr.fg)('platform_editor_ai_selection_local_ids')) {
            const ids = [];
            const ancestorIds = new Set();
            // Collect localIds from each selected cell and its descendants
            selection.forEachCell((cellNode, cellPos)=>{
                const cellLocalId = cellNode.attrs?.localId;
                if (cellLocalId) ids.push(cellLocalId);
                cellNode.descendants((node)=>{
                    if (node.isInline) return false;
                    const localId = node.attrs?.localId;
                    if (localId) ids.push(localId);
                });
                // Collect ancestor localIds (row, table) separately
                const $cell = selection.$anchorCell.doc.resolve(cellPos + 1);
                for(let depth = $cell.depth - 1; depth >= 1; depth--){
                    const ancestor = $cell.node(depth);
                    const localId = ancestor.attrs?.localId;
                    if (localId) ancestorIds.add(localId);
                }
            });
            const uniqueIds = new Set(ids);
            const uniqueAncestors = [
                ...ancestorIds
            ].filter((id)=>!uniqueIds.has(id));
            return [
                ...uniqueIds,
                ...uniqueAncestors
            ];
        }
    } else if (selection.empty) return [
        selection.$from.parent.attrs.localId
    ];
    const slice = (0, $9fhVI.getSliceFromSelection)(selection);
    const content = slice.content;
    const ids = [];
    content.forEach((node)=>{
        const localId = node.attrs?.localId;
        if (localId) ids.push(localId);
    });
    return ids;
};
module.exports["getLocalIdsFromSelection"] = $8ba12c76f7ae9309$export$9ce8378d786d4035;

});

parcelRegister("hZmcT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $c020fdec3cea04a6$var$initialState = {
    type: null,
    selectionRange: null,
    hoverRange: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
};
function $c020fdec3cea04a6$var$reducer(state, action) {
    switch(action.type){
        case 'clearSelection':
            if (state.selectionRange !== null) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type
            };
            return state;
        case 'clearHover':
            if (state.hoverRange !== null) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type
            };
            return state;
        case 'setSelection':
            if (state.selectionRange !== action.range) return {
                ...state,
                selectionRange: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.hoverRange !== action.range) return {
                ...state,
                hoverRange: action.range,
                type: 'hover'
            };
            return state;
        case 'promoteSelectionToDraft':
            // we should only promote the range to a draft if the current range type is a selection
            // we should also store the promotion type, so that a clear will not accidently clear the draft of a
            // different type
            if (state.selectionDraftRange !== state.selectionRange) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type,
                selectionDraftRange: state.selectionRange,
                selectionDraftDocumentPosition: action.position
            };
            return state;
        case 'promoteHoverToDraft':
            if (state.hoverDraftRange !== state.hoverRange) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type,
                hoverDraftRange: state.hoverRange,
                hoverDraftDocumentPosition: action.position
            };
            return state;
        case 'clearSelectionDraft':
            if (state.selectionDraftRange !== null) return {
                ...state,
                selectionDraftRange: null,
                selectionDraftDocumentPosition: null
            };
            return state;
        case 'clearHoverDraft':
            if (state.hoverDraftRange !== null) return {
                ...state,
                hoverDraftRange: null,
                hoverDraftDocumentPosition: null
            };
            return state;
    }
}
const $c020fdec3cea04a6$export$145b9bb655c3d220 = /*#__PURE__*/ (0, $cozmU.createContext)({
    range: null,
    type: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
});
const $c020fdec3cea04a6$export$efb0d1c8cbaac647 = /*#__PURE__*/ (0, $cozmU.createContext)({
    clearSelectionRange: ()=>{},
    clearHoverRange: ()=>{},
    setSelectionRange: ()=>{},
    promoteSelectionToDraft: ()=>{},
    promoteHoverToDraft: ()=>{},
    clearSelectionDraft: ()=>{},
    clearHoverDraft: ()=>{}
});
const $c020fdec3cea04a6$export$7cf774ce920e4bbd = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
    const [{ selectionRange: selectionRange, hoverRange: hoverRange, type: type, selectionDraftRange: selectionDraftRange, selectionDraftDocumentPosition: selectionDraftDocumentPosition, hoverDraftRange: hoverDraftRange, hoverDraftDocumentPosition: hoverDraftDocumentPosition }, dispatch] = (0, $cozmU.useReducer)($c020fdec3cea04a6$var$reducer, $c020fdec3cea04a6$var$initialState);
    const clearSelectionRange = (0, $cozmU.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearHoverRange = (0, $cozmU.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setSelectionRange = (0, $cozmU.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const setHoverTarget = (0, $cozmU.useCallback)((target)=>{
        // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
        const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
        if (!mediaNode) return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- range for media hover highlight
        const range = document.createRange();
        range.setStartBefore(mediaNode);
        range.setEndAfter(mediaNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    const promoteSelectionToDraft = (0, $cozmU.useCallback)((position)=>{
        dispatch({
            type: 'promoteSelectionToDraft',
            position: position
        });
    }, []);
    const clearSelectionDraft = (0, $cozmU.useCallback)(()=>{
        dispatch({
            type: 'clearSelectionDraft'
        });
    }, []);
    const promoteHoverToDraft = (0, $cozmU.useCallback)((position)=>{
        dispatch({
            type: 'promoteHoverToDraft',
            position: position
        });
    }, []);
    const clearHoverDraft = (0, $cozmU.useCallback)(()=>{
        dispatch({
            type: 'clearHoverDraft'
        });
    }, []);
    const stateData = (0, $cozmU.useMemo)(()=>{
        return {
            // We techinically have two ranges, however we only want to expose one of them at a time, because only one draft
            // can be active at a time. The type of range is used to determine which range is active.
            range: type === 'selection' ? selectionRange : hoverRange,
            type: type,
            selectionDraftRange: selectionDraftRange,
            hoverDraftRange: hoverDraftRange,
            selectionDraftDocumentPosition: selectionDraftDocumentPosition,
            hoverDraftDocumentPosition: hoverDraftDocumentPosition
        };
    }, [
        selectionRange,
        hoverRange,
        type,
        selectionDraftRange,
        selectionDraftDocumentPosition,
        hoverDraftRange,
        hoverDraftDocumentPosition
    ]);
    const dispatchData = (0, $cozmU.useMemo)(()=>({
            clearSelectionRange: clearSelectionRange,
            clearHoverRange: clearHoverRange,
            setSelectionRange: setSelectionRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined,
            promoteSelectionToDraft: promoteSelectionToDraft,
            promoteHoverToDraft: promoteHoverToDraft,
            clearSelectionDraft: clearSelectionDraft,
            clearHoverDraft: clearHoverDraft
        }), [
        allowCommentsOnMedia,
        clearSelectionRange,
        clearHoverRange,
        setSelectionRange,
        setHoverTarget,
        promoteSelectionToDraft,
        promoteHoverToDraft,
        clearSelectionDraft,
        clearHoverDraft
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c020fdec3cea04a6$export$145b9bb655c3d220.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c020fdec3cea04a6$export$efb0d1c8cbaac647.Provider, {
        value: dispatchData
    }, children));
};
const $c020fdec3cea04a6$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia, isNestedRender: isNestedRender })=>{
    /*
   * If this is a nested render, we do not provide the context
   * because it has already been provided higher up the component tree
   * and we need the original context to create annotations on extensions.
   */ return isNestedRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c020fdec3cea04a6$export$7cf774ce920e4bbd, {
        allowCommentsOnMedia: allowCommentsOnMedia
    }, children);
};
const $c020fdec3cea04a6$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $cozmU.useContext)($c020fdec3cea04a6$export$145b9bb655c3d220);
};
const $c020fdec3cea04a6$export$708fc397e2b6f08d = ()=>{
    return (0, $cozmU.useContext)($c020fdec3cea04a6$export$efb0d1c8cbaac647);
};
module.exports["AnnotationRangeProvider"] = $c020fdec3cea04a6$export$30384a6aedd19fee;
module.exports["useAnnotationRangeState"] = $c020fdec3cea04a6$export$e07ee6d6cc95d9a0;
module.exports["useAnnotationRangeDispatch"] = $c020fdec3cea04a6$export$708fc397e2b6f08d;

});

parcelRegister("4PCaV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $32e85bb02ff595b4$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    isWithinRange: false
});
const $32e85bb02ff595b4$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    cancelTimeout: ()=>{},
    initiateTimeout: ()=>{},
    setIsWithinRange: ()=>{}
});
const $32e85bb02ff595b4$export$b3db0feb20552fc3 = ({ children: children })=>{
    const [isWithinRange, setIsWithinRange] = (0, $cozmU.useState)(false);
    const timeoutHandler = (0, $cozmU.useRef)();
    const cancelTimeout = (0, $cozmU.useCallback)(()=>{
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    const initiateTimeout = (0, $cozmU.useCallback)(()=>{
        if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    const stateData = (0, $cozmU.useMemo)(()=>({
            isWithinRange: isWithinRange
        }), [
        isWithinRange
    ]);
    const dispatchData = (0, $cozmU.useMemo)(()=>({
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        }), [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($32e85bb02ff595b4$var$AnnotationHoverStateContext.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($32e85bb02ff595b4$var$AnnotationHoverDispatchContext.Provider, {
        value: dispatchData
    }, children));
};
const $32e85bb02ff595b4$export$a02bfcbbbf920306 = ()=>{
    return (0, $cozmU.useContext)($32e85bb02ff595b4$var$AnnotationHoverStateContext);
};
const $32e85bb02ff595b4$export$c288883964405c82 = ()=>{
    return (0, $cozmU.useContext)($32e85bb02ff595b4$var$AnnotationHoverDispatchContext);
};
module.exports["AnnotationHoverContext"] = $32e85bb02ff595b4$export$b3db0feb20552fc3;
module.exports["useAnnotationHoverContext"] = $32e85bb02ff595b4$export$a02bfcbbbf920306;
module.exports["useAnnotationHoverDispatch"] = $32e85bb02ff595b4$export$c288883964405c82;

});

parcelRegister("8Kasn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $2dc2ecd22aaff4c9$export$d452675449e81987 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $2dc2ecd22aaff4c9$export$5b655fe45447a548 = $2dc2ecd22aaff4c9$export$d452675449e81987.Provider;
module.exports["ValidationContext"] = $2dc2ecd22aaff4c9$export$d452675449e81987;
module.exports["ValidationContextProvider"] = $2dc2ecd22aaff4c9$export$5b655fe45447a548;

});

parcelRegister("grAaA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $e3b11a5077b37edf$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $e3b11a5077b37edf$export$2e2bcd8739ae039 = $e3b11a5077b37edf$var$AnalyticsContext;
module.exports["default"] = $e3b11a5077b37edf$export$2e2bcd8739ae039;

});

parcelRegister("jyFxy", function(module, exports) {
const $b84ded3998fade41$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });
module.exports["copyTextToClipboard"] = $b84ded3998fade41$export$f980440e1ab4537d;

});

parcelRegister("88npU", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");




const $17d10290e4e4f92a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    placeholder: {
        id: "fabric.editor.captionPlaceholder",
        defaultMessage: "Add a caption"
    }
});


function $eb9627afff116203$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $eb9627afff116203$var$captionWrapperStyle = {
    name: "4iruax",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #505258)"
};
const $eb9627afff116203$var$placeholderStyle = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    position: 'absolute',
    top: 'space.0',
    width: '100%'
});
class $eb9627afff116203$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $eb9627afff116203$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
            xcss: $eb9627afff116203$var$placeholderStyle
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6Pqow.Text), null, formatMessage((0, $17d10290e4e4f92a$export$defe85febe8b728c).placeholder))) : null, children);
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $eb9627afff116203$var$_default_1 = (0, $kSwu1.injectIntl)($eb9627afff116203$export$f7feb87190a94c76);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$eb9627afff116203$export$2e2bcd8739ae039 = $eb9627afff116203$var$_default_1;
module.exports["default"] = $eb9627afff116203$export$2e2bcd8739ae039;

});

parcelRegister("g2MiL", function(module, exports) {
const $ba6a02d6a78f0d3f$export$bafd6beec0797f87 = 24;
var $ba6a02d6a78f0d3f$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($ba6a02d6a78f0d3f$var$CSS_VAR_NAMES || {});
const $ba6a02d6a78f0d3f$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 2) {
        // When there are 2 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $ba6a02d6a78f0d3f$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $ba6a02d6a78f0d3f$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $ba6a02d6a78f0d3f$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $ba6a02d6a78f0d3f$var$stringifyStyle(style);
    return style;
}
module.exports["listItemCounterPadding"] = $ba6a02d6a78f0d3f$export$bafd6beec0797f87;
module.exports["getOrderedListInlineStyles"] = $ba6a02d6a78f0d3f$export$6d31fdb1d74cee3e;

});

parcelRegister("eTXkv", function(module, exports) {
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.

var $iAA8Q = parcelRequire("iAA8Q");





const $1b98d04ecebff28e$export$8ef94ae42a3729bd = 1;
const $1b98d04ecebff28e$export$cbefb5b89ef0719f = (orderedListNode)=>{
    const order = orderedListNode?.attrs?.order;
    return (0, $iAA8Q.resolveOrder)(order) ?? $1b98d04ecebff28e$export$8ef94ae42a3729bd;
};
const $1b98d04ecebff28e$export$320582fc14ba1e0f = (options)=>{
    const order = (0, $iAA8Q.resolveOrder)(options.order) ?? $1b98d04ecebff28e$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return String(largestCounter)?.split('.')?.[0]?.length;
};
module.exports["getOrderFromOrderedListNode"] = $1b98d04ecebff28e$export$cbefb5b89ef0719f;
module.exports["getItemCounterDigitsSize"] = $1b98d04ecebff28e$export$320582fc14ba1e0f;

});

parcelRegister("iAA8Q", function(module, exports) {
// resolve "order" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveStart"
// in packages/editor/adf-schema/src/schema/nodes/ordered-list.ts
const $2010d4e355fc7a31$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
module.exports["resolveOrder"] = $2010d4e355fc7a31$export$d445360e2a3c026b;

});

parcelRegister("k8PFz", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ /* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");

var $an4b1 = parcelRequire("an4b1");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $8dxef = parcelRequire("8dxef");


var $cRhiT = parcelRequire("cRhiT");

/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




var $39Puj = parcelRequire("39Puj");


var $lqPdm = parcelRequire("lqPdm");

const $6770fd352db2e355$export$35c9e86e192acb85 = ()=>{
    let cssString = '';
    (0, $39Puj.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $lqPdm.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};


const $947977f98ed45157$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $lOiVq.css)((0, $6770fd352db2e355$export$35c9e86e192acb85)());



var $bYPHE = parcelRequire("bYPHE");


function $71e724e94a377c98$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $71e724e94a377c98$export$808015ab1dd6897a = 24;
const $71e724e94a377c98$export$afe1899c3eea9823 = 16;
const $71e724e94a377c98$export$910bf0d22c3d10f2 = 14;
const $71e724e94a377c98$export$a43e30915fab3ccf = 8;
const $71e724e94a377c98$export$531f77930bf508de = 48;
const $71e724e94a377c98$export$c60fae4049791eae = 140;
const $71e724e94a377c98$export$72aad729077aa0fb = 1;
const $71e724e94a377c98$export$e56b8ca552b280f6 = 8;
const $71e724e94a377c98$export$bba39e724bc39451 = 6;
const $71e724e94a377c98$export$e5ff276883773ffd = 8;
const $71e724e94a377c98$export$880976487022eb5 = $71e724e94a377c98$export$808015ab1dd6897a + $71e724e94a377c98$export$e5ff276883773ffd - $71e724e94a377c98$export$72aad729077aa0fb;
/* first block node has 0 top margin */ var $71e724e94a377c98$var$_ref = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $71e724e94a377c98$var$firstNodeWithNotMarginTop = ()=>$71e724e94a377c98$var$_ref;
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required
/**
 * The style is mirrored in:
 * - packages/editor/renderer/src/ui/Renderer/RendererStyleContainer.tsx ( seems outdated )
 * - packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
 *
 * If you are updating this, please also update the above files.
 *
 * @deprecated This Emotion-based style function is being phased out as part of the
 * `platform_editor_core_static_css` experiment migration to Compiled CSS. While the experiment
 * is running, any changes here MUST also be reflected in `EditorContentContainer-compiled.tsx`
 * (look for `tableSharedStyle`, `tableSharedStyle_with_*`, `tableSharedStyle_without_*` entries
 * in the `editorContentStyles` cssMap). Failure to do so will cause visual regressions when the
 * compiled version is active.
 */ const $71e724e94a377c98$export$c2bf8eea75aa9302 = ()=>{
    const browser = (0, $8dxef.getBrowserInfo)();
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
    return /*#__PURE__*/ (0, $lOiVq.css)((0, $947977f98ed45157$export$677e93f0f5f9623a)(), " .", (0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* Fake side borders are not needed when the rounded overlay owns the outer border. */
				.${(0, $bYPHE.TableSharedCssClassName).TABLE_RIGHT_BORDER},
				.${(0, $bYPHE.TableSharedCssClassName).TABLE_LEFT_BORDER} {
					display: none;
				}
					` : `.${(0, $bYPHE.TableSharedCssClassName).TABLE_RIGHT_BORDER},
			.${(0, $bYPHE.TableSharedCssClassName).TABLE_LEFT_BORDER} {
				display: block;
				width: 1px;
				height: calc(100% - ${"var(--ds-space-300, 24px)"});
				background: ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"};
				position: absolute;
				top: ${"var(--ds-space-300, 24px)"};
			}
			.${(0, $bYPHE.TableSharedCssClassName).TABLE_RIGHT_BORDER} {
				right: 0;
			}
			.${(0, $bYPHE.TableSharedCssClassName).TABLE_LEFT_BORDER} {
				left: 0;
			}
			.${(0, $bYPHE.TableSharedCssClassName).TABLE_LEFT_BORDER}[data-with-numbered-table='true'] {
				left: ${(0, $7Y8M5.akEditorTableNumberColumnWidth) - 1}px;
			}`, ";.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", (0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $7Y8M5.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", (0, $bYPHE.TableSharedCssClassName).TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", (0, $bYPHE.TableSharedCssClassName).TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", (0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", (0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER, ">table,.", (0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}", (0, $iDrrr.fg)('platform_editor_bordered_panel_nested_in_table') ? `.${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} .ak-editor-panel {
			border: ${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"};
		}` : '', ".", (0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER, ">table,.", (0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER, ">table,.", (0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* Keep a transparent border so the collapsed border model reserves the same 1px slot
			   on the table edge; the ::after overlay draws the visible rounded border instead. */
			border: ${$71e724e94a377c98$export$72aad729077aa0fb}px solid transparent;` : `border: ${$71e724e94a377c98$export$72aad729077aa0fb}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"};
			border-left-color: transparent;
			border-right-color: transparent;`, " table-layout:fixed;font-size:1em;width:100%;", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `position: relative;

			/* Table-width outer-border owner for overflow-safe rounded corners. */
			&::after {
				content: '';
				position: absolute;
				inset: -0.5px;
				border: ${$71e724e94a377c98$export$72aad729077aa0fb}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"};
				border-radius: ${"var(--ds-radius-xlarge, 12px)"};
				pointer-events: none;
				z-index: 1;
			}

			/* When content-visibility is applied to the table (see editor-plugin-table nodeview), the
			   implied \`contain: paint\` clips descendant painting to the table's border-box. The
			   overlay above sits at \`inset: -0.5px\` (half a pixel outside), so it would be shaved \u{2014}
			   most visibly along the bottom. Pull it flush to the edge so it paints inside the clip. */
			&[data-content-visibility]::after {
				inset: 0;
			}` : '', " &[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, #00000000);}>tbody>tr>th,>tbody>tr>td{min-width:", $71e724e94a377c98$export$531f77930bf508de, "px;font-weight:var(--ds-font-weight-regular, 400);vertical-align:top;", (0, $anBbz.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) ? `&[data-valign='middle'] {
								vertical-align: middle;
							}
							&[data-valign='bottom'] {
								vertical-align: bottom;
							}` : '', " border:1px solid var(--ds-background-accent-gray-subtler, #DDDEE1);border-right-width:0;border-bottom-width:0;padding:var(--ds-space-100, 8px);", browser.gecko || browser.ie || browser.mac && browser.chrome ? 'background-clip: padding-box;' : '', " ", $71e724e94a377c98$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}>tbody>tr>td{background-color:var(--ds-surface, #FFFFFF);}", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* Let the wrapper overlay own the outer table perimeter.
				   data-reaches-* attributes are set by the TableCell node view. */
				> tbody > tr > th[data-reaches-top],
				> tbody > tr > td[data-reaches-top] {
					border-top-color: transparent;
				}

				> tbody > tr > th[data-reaches-left],
				> tbody > tr > td[data-reaches-left] {
					border-left-color: transparent;
				}

				> tbody > tr > td[data-reaches-left]::after {
					border-left-color: transparent;
				}

				> tbody > tr > td[data-reaches-bottom]::after,
				> tbody > tr > th[data-reaches-bottom]::after {
					border-bottom-color: transparent;
				}

				/* The rounded-table overlay owns transparent perimeter borders.
				   Paint edge cell backgrounds into that reserved border area so coloured
				   first/last rows do not show the page background through 1px seams. */
				> tbody > tr > th[data-reaches-top],
				> tbody > tr > td[data-reaches-top],
				> tbody > tr > th[data-reaches-bottom],
				> tbody > tr > td[data-reaches-bottom] {
					background-clip: border-box;
				}` : '', " th{background-color:var(--ds-background-accent-gray-subtlest, #F0F1F2);text-align:left;", (0, $ieeJu.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? '&:not(.danger)' : '&:not([style]):not(.danger)', "{.", (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, #FFFFFF);:not(.", (0, $7Y8M5.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, #0B120E24);}.", (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $an4b1.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, #0515240F);}.", (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, #0515240F);}>[data-ds--code--code-block]{background-image:", (0, $an4b1.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, #0515240F)!important;/* selector lives inside @atlaskit/code */--ds--code--line-number-bg-color:var(--ds-background-neutral, #0515240F);}}}}}}", (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* When the number column is enabled, the left visual edge belongs to the number column.
		   Remove the left border-radius and left border from the table's ::after overlay
		   so it doesn't double-up or round where the number column already provides that edge. */
		.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true'] {
			> .${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table::after,
			> .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table::after {
				border-top-left-radius: 0;
				border-bottom-left-radius: 0;
				border-left-color: transparent;
			}
		}` : '', ";");
};
module.exports["tableMarginTop"] = $71e724e94a377c98$export$808015ab1dd6897a;
module.exports["tableCellMinWidth"] = $71e724e94a377c98$export$531f77930bf508de;
module.exports["tableNewColumnMinWidth"] = $71e724e94a377c98$export$c60fae4049791eae;
module.exports["tableCellBorderWidth"] = $71e724e94a377c98$export$72aad729077aa0fb;
module.exports["tableCellPadding"] = $71e724e94a377c98$export$e56b8ca552b280f6;
module.exports["tableControlsSpacing"] = $71e724e94a377c98$export$880976487022eb5;
module.exports["tableSharedStyle"] = $71e724e94a377c98$export$c2bf8eea75aa9302;

});

parcelRegister("cRhiT", function(module, exports) {
// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $87bd2ad1789b9706$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};
module.exports["CodeBlockSharedCssClassName"] = $87bd2ad1789b9706$export$42659c26f026f6ea;

});

parcelRegister("lqPdm", function(module, exports) {
// This import will be stripped on build

var $89bON = parcelRequire("89bON");

function $f66f2d27964d8aff$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $f66f2d27964d8aff$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.token : undefined;
}
function $f66f2d27964d8aff$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $f66f2d27964d8aff$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $f66f2d27964d8aff$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #E9F2FE)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #669DF1)"
    },
    // source for hex code was legacy token B100
    /** blue - bold */ ['#ADCBFB']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.blue.subtler.hovered', fallback),
        token: "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)"
    },
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E7F9FF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #C6EDFB)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #6CC3E0)" // source for hex code was legacy token T100,
    },
    /** teal - bold */ ['#B1E4F7']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.teal.subtler.hovered', fallback),
        token: "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)"
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #DCFFF1)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #BAF3DB)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #4BCE97)" // source for hex code was legacy token G200,
    },
    /** green - bold */ ['#97EDC9']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.green.subtler.hovered', fallback),
        token: "var(--ds-background-accent-green-subtler-hovered, #97EDC9)"
    },
    // lime
    /** lime - light */ ['#EFFFD6']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.lime.subtlest', fallback),
        token: "var(--ds-background-accent-lime-subtlest, #EFFFD6)"
    },
    /** lime - medium */ ['#D3F1A7']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.lime.subtler', fallback),
        token: "var(--ds-background-accent-lime-subtler, #D3F1A7)"
    },
    /** lime - bold */ ['#BDE97C']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.lime.subtler.hovered', fallback),
        token: "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)"
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #F5E989)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FCA700)" // source for hex code was legacy token Y200,
    },
    /** yellow - bold */ ['#EFDD4E']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.yellow.subtler.hovered', fallback),
        token: "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)"
    },
    // orange
    /** orange - light */ ['#FFF5DB']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.orange.subtlest', fallback),
        token: "var(--ds-background-accent-orange-subtlest, #FFF5DB)"
    },
    /** orange - medium */ ['#FCE4A6']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.orange.subtler', fallback),
        token: "var(--ds-background-accent-orange-subtler, #FCE4A6)"
    },
    /** orange - bold */ ['#FBD779']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.orange.subtler.hovered', fallback),
        token: "var(--ds-background-accent-orange-subtler-hovered, #FBD779)"
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFECEB)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFD5D2)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #F87168)" // source for hex code was legacy token R100,
    },
    /** red - bold */ ['#FFB8B2']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.red.subtler.hovered', fallback),
        token: "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)"
    },
    // magenta
    /** magenta - light */ ['#FFECF8']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.magenta.subtlest', fallback),
        token: "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
    },
    /** magenta - medium */ ['#FDD0EC']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.magenta.subtler', fallback),
        token: "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    },
    /** magenta - bold */ ['#FCB6E1']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.magenta.subtler.hovered', fallback),
        token: "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)"
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #F8EEFE)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #EED7FC)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #C97CF4)" // source for hex code was legacy token P100,
    },
    /** purple - bold */ ['#E3BDFA']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.purple.subtler.hovered', fallback),
        token: "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)"
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $89bON.default)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F0F1F2)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #8C8F97)" // source for hex code was legacy token N60,
    },
    /** gray - bold */ ['#B7B9BE']: {
        getValue: (fallback)=>(0, $89bON.default)('color.background.accent.gray.subtler.hovered', fallback),
        token: "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)"
    }
};
module.exports["hexToEditorBackgroundPaletteColor"] = $f66f2d27964d8aff$export$5f6a44a42a4b38c2;
module.exports["hexToEditorBackgroundPaletteRawValue"] = $f66f2d27964d8aff$export$a270511a0e7fd61a;

});

parcelRegister("89bON", function(module, exports) {


var $3osen = parcelRequire("3osen");


var $1P2f3 = parcelRequire("1P2f3");

/**
 * Takes a dot-separated token name and and an optional fallback, and returns the current computed CSS value for the
 * resulting CSS Custom Property.
 * This should be used for when the CSS cascade isn't available, eg. `<canvas>` elements, JS charting libraries, etc.
 *
 * Note: these values change depending on the theme so consider pairing them with `useThemeObserver` in React, or the
 * `ThemeMutationObserver` class elsewhere.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * const theme = useThemeObserver();
 *
 * useEffect(() => {
 *  const lineColor = getTokenValue('color.background.accent.blue.subtle', B400);
 * }, [theme]);
 * ```
 *
 */ function $9cb3d3a148240402$var$getTokenValue(tokenId, fallback = '') {
    let token = (0, $3osen.default)[tokenId];
    let tokenValue = fallback;
    typeof $1P2f3;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $9cb3d3a148240402$export$2e2bcd8739ae039 = $9cb3d3a148240402$var$getTokenValue;
module.exports["default"] = $9cb3d3a148240402$export$2e2bcd8739ae039;

});

parcelRegister("bYPHE", function(module, exports) {

var $39Puj = parcelRequire("39Puj");

const $231b3e35d1c2690e$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $39Puj.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $39Puj.tablePrefixSelector)}-wrapper`,
    TABLE_NODE_WRAPPER_NO_OVERFLOW: `${(0, $39Puj.tablePrefixSelector)}-wrapper-no-overflow`,
    TABLE_SCROLL_INLINE_SHADOW: `${(0, $39Puj.tablePrefixSelector)}-scroll-inline-shadow`,
    TABLE_RIGHT_BORDER: `${(0, $39Puj.tablePrefixSelector)}-right-border`,
    TABLE_LEFT_BORDER: `${(0, $39Puj.tablePrefixSelector)}-left-border`,
    TABLE_NATIVE_STICKY: `${(0, $39Puj.tablePrefixSelector)}-row-native-sticky`,
    TABLE_STICKY_WRAPPER: `${(0, $39Puj.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $39Puj.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $39Puj.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $39Puj.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $39Puj.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $39Puj.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_STICKY: `${(0, $39Puj.tablePrefixSelector)}-sticky`,
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $39Puj.tableCellContentDomSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_WRAPPER: (0, $39Puj.tableCellSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_HEADER_CELL_WRAPPER: (0, $39Puj.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $39Puj.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $39Puj.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $39Puj.tablePrefixSelector)}-resizer-container`,
    TABLE_VIEW_CONTENT_WRAP: 'tableView-content-wrap'
};
module.exports["TableSharedCssClassName"] = $231b3e35d1c2690e$export$c096bca5477eb7ad;

});

parcelRegister("fKJ7J", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $65facb8c38219af1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    tableScrollRegion: {
        id: "fabric.editor.tableScrollRegion",
        defaultMessage: "Table scroll region"
    },
    tableOptions: {
        id: "fabric.editor.tableOptions",
        defaultMessage: "Table options"
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: "fabric.editor.tableResizeIncreaseScreenReaderInformation",
        defaultMessage: "Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}."
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: "fabric.editor.tableResizeDecreaseScreenReaderInformation",
        defaultMessage: "Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}."
    },
    headerRow: {
        id: "fabric.editor.headerRow",
        defaultMessage: "Header row"
    },
    headerColumn: {
        id: "fabric.editor.headerColumn",
        defaultMessage: "Header column"
    },
    numberedColumn: {
        id: "fabric.editor.numberedColumn",
        defaultMessage: "Numbered column"
    },
    collapseTable: {
        id: "fabric.editor.collapseTable",
        defaultMessage: "Collapse table"
    },
    resizeTable: {
        id: "fabric.editor.tables.resizeTable",
        defaultMessage: "Resize table"
    },
    insertColumn: {
        id: "fabric.editor.insertColumn",
        defaultMessage: "Insert column right"
    },
    addColumnLeft: {
        id: "fabric.editor.addColumnLeft",
        defaultMessage: "Add column left"
    },
    addColumnRight: {
        id: "fabric.editor.addColumnRight",
        defaultMessage: "Add column right"
    },
    insertColumnDrag: {
        id: "fabric.editor.insertColumnDrag",
        defaultMessage: "Insert column"
    },
    removeColumns: {
        id: "fabric.editor.removeColumns",
        defaultMessage: "Delete {0, plural, one {column} other {columns}}"
    },
    insertRow: {
        id: "fabric.editor.insertRow",
        defaultMessage: "Insert row below"
    },
    addRowAbove: {
        id: "fabric.editor.addRowAbove",
        defaultMessage: "Add row above"
    },
    addRowBelow: {
        id: "fabric.editor.addRowBelow",
        defaultMessage: "Add row below"
    },
    moveColumnLeft: {
        id: "fabric.editor.moveColumnLeft",
        defaultMessage: "Move {0, plural, one {column} other {columns}} left"
    },
    moveColumnLeftHelpDialogLabel: {
        id: "fabric.editor.moveColumnLeftHelpDialogLabel",
        defaultMessage: "Move column left"
    },
    moveColumnRight: {
        id: "fabric.editor.moveColumnRight",
        defaultMessage: "Move {0, plural, one {column} other {columns}} right"
    },
    moveColumnRightHelpDialogLabel: {
        id: "fabric.editor.moveColumnRightHelpDialogLabel",
        defaultMessage: "Move column right"
    },
    moveRowUp: {
        id: "fabric.editor.moveRowUp",
        defaultMessage: "Move {0, plural, one {row} other {rows}} up"
    },
    moveRowUpHelpDialogLabel: {
        id: "fabric.editor.moveRowUpHelpDialogLabel",
        defaultMessage: "Move row up"
    },
    moveRowDown: {
        id: "fabric.editor.moveDownDown",
        defaultMessage: "Move {0, plural, one {row} other {rows}} down"
    },
    moveRowDownHelpDialogLabel: {
        id: "fabric.editor.moveRowDownHelpDialogLabel",
        defaultMessage: "Move row down"
    },
    insertRowDrag: {
        id: "fabric.editor.insertRowDrag",
        defaultMessage: "Insert row"
    },
    removeRows: {
        id: "fabric.editor.removeRows",
        defaultMessage: "Delete {0, plural, one {row} other {rows}}"
    },
    rowNumbers: {
        id: "fabrid.editor.rowNumbers",
        defaultMessage: "Row numbers"
    },
    numberedRows: {
        id: "fabrid.editor.numberedRows",
        defaultMessage: "Numbered rows"
    },
    rowsAreInserted: {
        id: "fabric.editor.rowsAreInserted",
        defaultMessage: "{count, plural, one {A row has been} other {{count} rows have been}} inserted"
    },
    rowsAreRemoved: {
        id: "fabric.editor.rowsAreRemoved",
        defaultMessage: "{count, plural, one {The row has been} other {{count} rows have been}} removed"
    },
    rowSelected: {
        id: "fabric.editor.rowSelected",
        defaultMessage: "Row {index} of {total} selected"
    },
    rowMovedUp: {
        id: "fabric.editor.rowMovedUp",
        defaultMessage: "Row moved up to {index} of {total}"
    },
    rowMovedDown: {
        id: "fabric.editor.rowMovedDown",
        defaultMessage: "Row moved down to {index} of {total}"
    },
    columnsAreInserted: {
        id: "fabric.editor.columnsAreInserted",
        defaultMessage: "{count, plural, one {A column has been} other {{count} columns have been}} inserted"
    },
    columnsAreRemoved: {
        id: "fabric.editor.columnsAreRemoved",
        defaultMessage: "{count, plural, one {The column has been} other {{count} columns have been}} removed"
    },
    columnSelected: {
        id: "fabric.editor.columnSelected",
        defaultMessage: "Column {index} of {total} selected"
    },
    columnMovedLeft: {
        id: "fabric.editor.columnMovedLeft",
        defaultMessage: "Column moved left to {index} of {total}"
    },
    columnMovedRight: {
        id: "fabric.editor.columnMovedRight",
        defaultMessage: "Column moved right to {index} of {total}"
    },
    cellOptions: {
        id: "fabric.editor.cellOptions",
        defaultMessage: "Cell options"
    },
    confirmDeleteLinkedModalOKButton: {
        id: "fabric.editor.tables.confirmDeleteLinkedModalOKButton",
        defaultMessage: "Delete"
    },
    confirmDeleteLinkedModalMessage: {
        id: "fabric.editor.tables.confirmDeleteLinkedModalMessage",
        defaultMessage: "Deleting {nodeName} will break anything connected to it."
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: "fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix",
        defaultMessage: "Deleting"
    },
    confirmModalCheckboxLabel: {
        id: "fabric.editor.floatingToolbar.confirmModalCheckboxLabel",
        defaultMessage: "Also delete connected elements"
    },
    deleteElementTitle: {
        id: "fabric.editor.extension.deleteElementTitle",
        defaultMessage: "Delete element"
    },
    unnamedSource: {
        id: "fabric.editor.extension.sourceNoTitledName",
        defaultMessage: "this element"
    },
    adjustColumns: {
        id: "fabric.editor.tables.adjustColumn",
        defaultMessage: "Adjust column"
    },
    cornerControl: {
        id: "fabric.editor.cornerControl",
        defaultMessage: "Highlight table"
    },
    cellBackground: {
        id: "fabric.editor.cellBackground",
        defaultMessage: "Cell background"
    },
    cellAlignment: {
        id: "fabric.editor.table.cellAlignment",
        defaultMessage: "Alignment"
    },
    cellAlignmentTop: {
        id: "fabric.editor.table.cellAlignmentTop",
        defaultMessage: "Top"
    },
    cellAlignmentMiddle: {
        id: "fabric.editor.table.cellAlignmentMiddle",
        defaultMessage: "Middle"
    },
    cellAlignmentBottom: {
        id: "fabric.editor.table.cellAlignmentBottom",
        defaultMessage: "Bottom"
    },
    backgroundColor: {
        id: "fabric.editor.backgroundColor",
        defaultMessage: "Background color"
    },
    mergeCells: {
        id: "fabric.editor.mergeCells",
        defaultMessage: "Merge cells"
    },
    splitCell: {
        id: "fabric.editor.splitCell",
        defaultMessage: "Split cell"
    },
    clearCells: {
        id: "fabric.editor.clearCells",
        defaultMessage: "Clear {0, plural, one {cell} other {cells}}"
    },
    sortColumnASC: {
        id: "fabric.editor.sortColumnASC",
        defaultMessage: "Sort column A \u2192 Z"
    },
    sortColumnDESC: {
        id: "fabric.editor.sortColumnDESC",
        defaultMessage: "Sort column Z \u2192 A"
    },
    sortColumnIncreasing: {
        id: "fabric.editor.sortColumnIncreasing",
        defaultMessage: "Sort increasing"
    },
    sortColumnDecreasing: {
        id: "fabric.editor.sortColumnDecreasing",
        defaultMessage: "Sort decreasing"
    },
    canNotSortTable: {
        id: "fabric.editor.canNotSortTable",
        defaultMessage: "\u26A0\uFE0F You can't sort a table with merged cells"
    },
    canNotSortTableNoIcon: {
        id: "fabric.editor.canNotSortTableNoIcon",
        defaultMessage: "You can't sort a table with merged cells"
    },
    canNotMoveColumnLeftWithMergedCells: {
        id: "editor-common.messages.table.canNotMoveColumnLeftWithMergedCells",
        defaultMessage: "You can't move a column left with merged cells"
    },
    canNotMoveColumnRightWithMergedCells: {
        id: "editor-common.messages.table.canNotMoveColumnRightWithMergedCells",
        defaultMessage: "You can't move a column right with merged cells"
    },
    canNotMoveRowDownWithMergedCells: {
        id: "editor-common.messages.table.canNotMoveRowDownWithMergedCells",
        defaultMessage: "You can't move a row down with merged cells"
    },
    canNotMoveRowUpWithMergedCells: {
        id: "editor-common.messages.table.canNotMoveRowUpWithMergedCells",
        defaultMessage: "You can't move a row up with merged cells"
    },
    distributeColumns: {
        id: "fabric.editor.distributeColumns",
        defaultMessage: "Distribute columns"
    },
    fitToContent: {
        id: "fabric.editor.fitToContent",
        defaultMessage: "Fit to content"
    },
    lockColumnWidths: {
        id: "fabric.editor.lockColumns",
        defaultMessage: "Fixed column widths"
    },
    rowControl: {
        id: "fabric.editor.rowControl",
        defaultMessage: "Highlight row"
    },
    rowDragHandle: {
        id: "fabric.editor.rowDragHandle",
        defaultMessage: "Row options"
    },
    dragHandleZone: {
        id: "fabric.editor.dragHandleZone",
        defaultMessage: "Activate drag handle zone"
    },
    columnDragHandle: {
        id: "fabric.editor.columnDragHandle",
        defaultMessage: "Column options"
    },
    fullWidthLabel: {
        id: "fabric.editor.tableFullWidthLabel",
        defaultMessage: "Full-width"
    },
    startedColumnResize: {
        id: "fabric.editor.tables.startedColumnResize",
        defaultMessage: "Started column resize"
    },
    focusedOtherResize: {
        id: "fabric.editor.tables.otherResize",
        defaultMessage: "{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}"
    },
    changedColumnWidth: {
        id: "fabric.editor.tables.columnWidth",
        defaultMessage: "{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}"
    },
    columnResizeStop: {
        id: "fabric.editor.tables.resizeStop",
        defaultMessage: "Stopped resize"
    },
    columnResizeOverflow: {
        id: "fabric.editor.tables.columnResizeOverflow",
        defaultMessage: "You can only resize this column while the table has a scroll bar."
    },
    columnResizeLast: {
        id: "fabric.editor.tables.columnResizeLast",
        defaultMessage: "You can only resize this column to the left."
    },
    tableAlignmentOptions: {
        id: "fabric.editor.tableAlignmentOptions",
        defaultMessage: "Alignment options"
    },
    alignTableCenter: {
        id: "fabric.editor.alignTableCenter",
        defaultMessage: "Align center"
    },
    alignTableLeft: {
        id: "fabric.editor.alignTableLeft",
        defaultMessage: "Align left"
    }
});
module.exports["messages"] = $65facb8c38219af1$export$defe85febe8b728c;

});

parcelRegister("acipJ", function(module, exports) {
/** Helper type for single arg function */ function $5b9f59c12bb85318$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}
module.exports["compose"] = $5b9f59c12bb85318$export$f672e0b6f7222cd7;

});

parcelRegister("5fU8Q", function(module, exports) {
function $b1ec997d7493f629$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}
module.exports["convertProsemirrorTableNodeToArrayOfRows"] = $b1ec997d7493f629$export$69fbfaf01f2fd534;

});

parcelRegister("f9Emz", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7Meja = parcelRequire("7Meja");


var $2P3ZY = parcelRequire("2P3ZY");

function $650e994a4f9b02e2$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $650e994a4f9b02e2$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $650e994a4f9b02e2$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(RegExp("\\p{Number}", "gu"), '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(RegExp("\\p{Number}", "gu"), '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!stringNumber?.length) return acc;
            const maybeANumber = $650e994a4f9b02e2$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $650e994a4f9b02e2$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $650e994a4f9b02e2$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: (0, $2P3ZY.ContentType).LINK,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: (0, $2P3ZY.ContentType).NUMBER,
        value: normalizedText
    };
    return {
        type: (0, $2P3ZY.ContentType).TEXT,
        value: normalizedText ?? text
    };
}
function $650e994a4f9b02e2$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
        Get Meta value from the first child if the cell is of type
          * Heading (Any cell where the text is set to a heading type)
          * Paragraph (Normal text)
       */ case 'heading':
        case 'paragraph':
            return $650e994a4f9b02e2$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: (0, $2P3ZY.ContentType).LINK,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: (0, $2P3ZY.ContentType).LINK,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $650e994a4f9b02e2$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: (0, $2P3ZY.ContentType).STATUS,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: (0, $2P3ZY.ContentType).DATE,
                    value: timestamp
                };
            }
        case 'mention':
            {
                const text = firstChild.attrs.text || '';
                return {
                    type: (0, $2P3ZY.ContentType).MENTION,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $650e994a4f9b02e2$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $650e994a4f9b02e2$export$49215374a8bec29c = (options, order = (0, $7Meja.SortOrder).ASC)=>{
    const normalizeTextParser = $650e994a4f9b02e2$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $650e994a4f9b02e2$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $650e994a4f9b02e2$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
        Donot switch the order (Asec or Desc) if either node is null.
        This will ensure that empty cells are always at the bottom during sorting.
      */ if (metaNodeA === null || metaNodeB === null) return $650e994a4f9b02e2$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $7Meja.SortOrder).DESC ? -1 : 1) * $650e994a4f9b02e2$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $650e994a4f9b02e2$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if ((0, $iDrrr.fg)('platform_editor_fix_mixed_types_column_sort')) {
        if (metaNodeA.type === (0, $2P3ZY.ContentType).TEXT && metaNodeB.type === (0, $2P3ZY.ContentType).NUMBER || metaNodeA.type === (0, $2P3ZY.ContentType).NUMBER && metaNodeB.type === (0, $2P3ZY.ContentType).TEXT) return $650e994a4f9b02e2$var$compareValue(String(metaNodeA.value), String(metaNodeB.value));
    }
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $650e994a4f9b02e2$var$compareValue(metaNodeA.value, metaNodeB.value);
}
module.exports["createCompareNodes"] = $650e994a4f9b02e2$export$49215374a8bec29c;

});

parcelRegister("7Meja", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $fJCU9 = parcelRequire("fJCU9");


var $6OREF = parcelRequire("6OREF");


var $50ogq = parcelRequire("50ogq");


var $v0kiU = parcelRequire("v0kiU");


var $8QpVb = parcelRequire("8QpVb");


var $hvcLS = parcelRequire("hvcLS");


var $1xYQH = parcelRequire("1xYQH");

var $5e7465e1f8922865$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});
module.exports["SortOrder"] = $5e7465e1f8922865$export$7ae723045d45777a;

});

parcelRegister("6OREF", function(module, exports) {
var $a54e005a4bef11d6$export$ed55211407a9423 = /*#__PURE__*/ function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    return ToolbarSize;
}({});
module.exports["ToolbarSize"] = $a54e005a4bef11d6$export$ed55211407a9423;

});

parcelRegister("50ogq", function(module, exports) {
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of ToolbarWidthsNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ var $a80647d6322eeb96$export$423b5e8c92d477b9 = /*#__PURE__*/ function(ToolbarWidths) {
    ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
    ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
    ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
    ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
    ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
    return ToolbarWidths;
}({});
module.exports["ToolbarWidths"] = $a80647d6322eeb96$export$423b5e8c92d477b9;

});

parcelRegister("v0kiU", function(module, exports) {
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of ToolbarWidthsFullPageNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ var $5d19cedc51f0c567$export$63ca43752be70b90 = /*#__PURE__*/ function(ToolbarWidthsFullPage) {
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
    return ToolbarWidthsFullPage;
}({});
module.exports["ToolbarWidthsFullPage"] = $5d19cedc51f0c567$export$63ca43752be70b90;

});

parcelRegister("8QpVb", function(module, exports) {
var $7bc5aece41e90b45$export$501a79d885598191 = /*#__PURE__*/ function(ToolbarWidthsFullPageNext) {
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    return ToolbarWidthsFullPageNext;
}({});
module.exports["ToolbarWidthsFullPageNext"] = $7bc5aece41e90b45$export$501a79d885598191;

});

parcelRegister("hvcLS", function(module, exports) {
var $b1ab759a39ac971f$export$3f050002d3df641b = /*#__PURE__*/ function(ToolbarWidthsNext) {
    ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
    ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
    ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
    ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
    ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    return ToolbarWidthsNext;
}({});
module.exports["ToolbarWidthsNext"] = $b1ab759a39ac971f$export$3f050002d3df641b;

});

parcelRegister("1xYQH", function(module, exports) {
var $cc330a569fc78c9b$export$9106728c49045482 = /*#__PURE__*/ function(DIRECTION) {
    DIRECTION["UP"] = "up";
    DIRECTION["DOWN"] = "down";
    DIRECTION["LEFT"] = "left";
    DIRECTION["RIGHT"] = "right";
    return DIRECTION;
}({});
module.exports["DIRECTION"] = $cc330a569fc78c9b$export$9106728c49045482;

});

parcelRegister("ju7dM", function(module, exports) {
function $92761e595a42259f$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}
module.exports["hasMergedCell"] = $92761e595a42259f$export$f9d610bfbb78949b;

});

parcelRegister("9ppjA", function(module, exports) {

var $bjg0G = parcelRequire("bjg0G");


var $7Y8M5 = parcelRequire("7Y8M5");


var $2aFJ8 = parcelRequire("2aFJ8");


var $cBSrP = parcelRequire("cBSrP");


var $k8PFz = parcelRequire("k8PFz");


var $h9Lux = parcelRequire("h9Lux");

const $bb523c8dce5be0ea$var$GRID_SIZE = 8;
const $bb523c8dce5be0ea$var$NESTED_DND_GUTTER_OFFSET = 8;
const $bb523c8dce5be0ea$var$NESTED_DND_MARGIN_OFFSET = 12;
const $bb523c8dce5be0ea$export$9b77d38feba5446 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    default: (0, $7Y8M5.akEditorDefaultLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    wide: (0, $7Y8M5.akEditorWideLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    'full-width': (0, $7Y8M5.akEditorFullWidthLayoutWidth)
};
const $bb523c8dce5be0ea$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    if (!pos) return;
    const node = $bb523c8dce5be0ea$export$84f6ca4f6812e69a(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    const breakoutWidth = breakoutMark ? breakoutMark.attrs.width : undefined;
    let parentWidth = $bb523c8dce5be0ea$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled, breakoutWidth);
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['contextPanelPluginKey$'];
        }
    };
    switch(node.type){
        case schema.nodes.layoutSection:
            // Calculate width of parent layout column when
            // Parallel layout with viewport greater than 1024px
            // OR side panel of an extension is open and change the node width to smaller than containerWidth
            if (containerWidth.width > (0, $7Y8M5.gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
                // margin between sections
                parentWidth -= ((0, $cBSrP.LAYOUT_SECTION_MARGIN) + $bb523c8dce5be0ea$var$NESTED_DND_MARGIN_OFFSET + 2) * (node.childCount - 1);
                const $pos = state.doc.resolve(pos);
                const column = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
                parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
            // account for the padding of the parent node
            parentWidth -= ((0, $cBSrP.LAYOUT_COLUMN_PADDING) + $bb523c8dce5be0ea$var$NESTED_DND_GUTTER_OFFSET) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $2aFJ8.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $2aFJ8.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $bb523c8dce5be0ea$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $bb523c8dce5be0ea$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $bb523c8dce5be0ea$var$GRID_SIZE;
            // padding left
            parentWidth -= $bb523c8dce5be0ea$var$GRID_SIZE * 4 - $bb523c8dce5be0ea$var$GRID_SIZE / 2;
            break;
        case schema.nodes.tableCell:
        case schema.nodes.tableHeader:
            // Calculate the available column width
            if (Array.isArray(node.attrs.colwidth)) parentWidth = node.attrs.colwidth.slice(0, node.attrs.colspan).reduce((sum, width)=>sum + width, 0);
            // Compensate for padding
            parentWidth -= (0, $k8PFz.tableCellPadding) * 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $bb523c8dce5be0ea$export$84f6ca4f6812e69a = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $bjg0G.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand,
        state.schema.nodes.tableCell,
        state.schema.nodes.tableHeader,
        state.schema.nodes.bodiedSyncBlock
    ]);
    return parent ? parent.node : null;
};
const $bb523c8dce5be0ea$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled, breakoutWidth)=>{
    if (breakoutWidth) return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, breakoutWidth) : // container width minus breakout padding
    // --ak-editor--breakout-full-page-guttering-padding = (--ak-editor--large-gutter-padding * 2) + --ak-editor--default-gutter-padding
    Math.min(containerWidth.width - ((0, $7Y8M5.akEditorGutterPaddingDynamic)() * 2 + (0, $7Y8M5.akEditorGutterPadding)), breakoutWidth);
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $7Y8M5.akEditorFullWidthLayoutWidth)) : (0, $h9Lux.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $bb523c8dce5be0ea$export$3930799be057b305 = (node)=>{
    if (node?.attrs.width) return node.attrs.width;
    return $bb523c8dce5be0ea$export$9b77d38feba5446[node?.attrs.layout] || (0, $7Y8M5.akEditorDefaultLayoutWidth);
};
const $bb523c8dce5be0ea$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $bb523c8dce5be0ea$export$3930799be057b305(node) - offset;
    return $bb523c8dce5be0ea$export$3930799be057b305(node);
};
module.exports["layoutToWidth"] = $bb523c8dce5be0ea$export$9b77d38feba5446;
module.exports["getParentNodeWidth"] = $bb523c8dce5be0ea$export$d76cc081ce1449a8;
module.exports["getNestedParentNode"] = $bb523c8dce5be0ea$export$84f6ca4f6812e69a;
module.exports["getTableContainerWidth"] = $bb523c8dce5be0ea$export$3930799be057b305;

});

parcelRegister("2aFJ8", function(module, exports) {
const $bc70d11a325ce185$export$f5ecdce4c60ff98b = 8;
const $bc70d11a325ce185$export$5ac5087fe1217160 = $bc70d11a325ce185$export$f5ecdce4c60ff98b * 2;
const $bc70d11a325ce185$export$91624ec52c59c24c = 12;
module.exports["BODIED_EXT_PADDING"] = $bc70d11a325ce185$export$5ac5087fe1217160;
module.exports["BODIED_EXT_MBE_MARGIN_TOP"] = $bc70d11a325ce185$export$91624ec52c59c24c;

});

parcelRegister("cBSrP", function(module, exports) {
const $89160a074debbf10$export$cd04f19842abff0 = 8;
const $89160a074debbf10$export$a1bb91aa2d5fcce8 = $89160a074debbf10$export$cd04f19842abff0 * 1.5;
const $89160a074debbf10$export$e5ee675b2c7e739b = 50;
module.exports["LAYOUT_SECTION_MARGIN"] = $89160a074debbf10$export$cd04f19842abff0;
module.exports["LAYOUT_COLUMN_PADDING"] = $89160a074debbf10$export$a1bb91aa2d5fcce8;

});

parcelRegister("2bxao", function(module, exports) {
const $72bb3a545e6ada76$export$12fd658e5eef0d79 = 32;
const $72bb3a545e6ada76$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';
module.exports["FullPagePadding"] = $72bb3a545e6ada76$export$12fd658e5eef0d79;
module.exports["TELEPOINTER_ID"] = $72bb3a545e6ada76$export$74b525449cc7cbd1;

});

parcelRegister("5TMHS", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $7Meja = parcelRequire("7Meja");


var $fmXA0 = parcelRequire("fmXA0");


var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $63qYG = parcelRequire("63qYG");

var $4R9Nm = parcelRequire("4R9Nm");




const $823e8c5ce52366b5$var$newIconWrapperStyles = {
    base: "_23rrnHAAU9 _39xV02ey7F _0jFU0Vey7F _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0yKXXaP6LB",
    inactive: "_1YKVNsVpNL"
};
const $823e8c5ce52366b5$export$4be21af7f864512e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { sortOrdered: sortOrdered } = t0;
    const t1 = sortOrdered === (0, $7Meja.SortOrder).NO_ORDER && $823e8c5ce52366b5$var$newIconWrapperStyles.inactive;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $hekY6.default)([
            $823e8c5ce52366b5$var$newIconWrapperStyles.base,
            t1
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== sortOrdered) {
        t3 = sortOrdered === (0, $7Meja.SortOrder).DESC ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($63qYG))), {
            spacing: "none",
            label: ""
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4R9Nm))), {
            spacing: "none",
            label: ""
        });
        $[2] = sortOrdered;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t2,
            children: t3
        });
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ sortOrdered: sortOrdered })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            $823e8c5ce52366b5$var$newIconWrapperStyles.base,
            sortOrdered === (0, $7Meja.SortOrder).NO_ORDER && $823e8c5ce52366b5$var$newIconWrapperStyles.inactive
        ]),
        children: sortOrdered === (0, $7Meja.SortOrder).DESC ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($63qYG))), {
            spacing: "none",
            label: ""
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4R9Nm))), {
            spacing: "none",
            label: ""
        })
    });
};





const $8dc4a8cd49ebe705$export$f142573f51a67577 = (0, $kSwu1.defineMessages)({
    noOrderLabel: {
        id: "fabric.editor.tableHeader.sorting.no",
        defaultMessage: "No sort applied to the column"
    },
    ascOrderLabel: {
        id: "fabric.editor.tableHeader.sorting.asc",
        defaultMessage: "Ascending sort applied"
    },
    descOrderLabel: {
        id: "fabric.editor.tableHeader.sorting.desc",
        defaultMessage: "Descending sort applied"
    },
    invalidLabel: {
        id: "fabric.editor.tableHeader.sorting.invalid",
        defaultMessage: "You can't sort a table with merged cells"
    },
    defaultLabel: {
        id: "fabric.editor.tableHeader.sorting.default",
        defaultMessage: "Sort the column"
    }
});





const $b04c93659d7c7469$export$458c50917513cd1a = (0, $kSwu1.defineMessages)({
    noOrderLabel: {
        id: "fabric.editor.headingLink.noOrderLabel",
        defaultMessage: "Sort column A to Z"
    },
    ascOrderLabel: {
        id: "fabric.editor.headingLink.ascOrderLabel",
        defaultMessage: "Sort column Z to A"
    },
    descOrderLabel: {
        id: "fabric.editor.headingLink.descOrderLabel",
        defaultMessage: "Clear sorting"
    },
    invalidLabel: {
        id: "fabric.editor.headingLink.invalidLabel",
        // eslint-disable-next-line @atlassian/i18n/no-multiple-whitespaces
        defaultMessage: "\u26A0\uFE0F  You can't sort a table with merged cells"
    }
});



var $4DK3l = parcelRequire("4DK3l");

function $0106818d88fe91c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $0106818d88fe91c7$var$buttonStyles = /*#__PURE__*/ (0, $lOiVq.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:var(--ds-border-width-selected, 2px) solid var(--ds-border, #0B120E24);border-radius:var(--ds-radius-small, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F0F1F2);}&:active{background-color:var(--ds-surface-overlay-pressed, #DDDEE1);}&.", (0, $fmXA0.SORTABLE_COLUMN_ICON_CLASSNAME), "__not-allowed{cursor:not-allowed;}");
// Keep the sort button above header content nodes that the editor's native-anchor DnD
// styles give a z-index in live docs, which otherwise cover the button's clickable body.
const $0106818d88fe91c7$var$sortButtonElevatedStyles = {
    name: "1739oy8",
    styles: "z-index:1"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $0106818d88fe91c7$var$iconWrapperStyles = /*#__PURE__*/ (0, $lOiVq.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", (0, $4DK3l.StatusClassNames).DESC, "{transform:rotate(-180deg);}&.", (0, $fmXA0.SORTABLE_COLUMN_ICON_CLASSNAME), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $0106818d88fe91c7$var$iconStyles = {
    name: "3kmdk1",
    styles: "height:100%;width:2px;border-radius:var(--ds-radius-full, 9999px);background:var(--ds-icon, #292A2E);user-select:none;&::before, &::after{background:var(--ds-icon, #292A2E);content:'';height:2px;width:6px;position:absolute;border-radius:var(--ds-radius-full, 9999px);}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $0106818d88fe91c7$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $7Meja.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $fmXA0.SORTABLE_COLUMN_ICON_CLASSNAME)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${(0, $4DK3l.StatusClassNames).SORTING_NOT_ALLOWED} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $7Meja.SortOrder).ASC:
            return `${(0, $4DK3l.StatusClassNames).ASC} ${activeStatusClass}`;
        case (0, $7Meja.SortOrder).DESC:
            return `${(0, $4DK3l.StatusClassNames).DESC} ${activeStatusClass}`;
        default:
            return `${(0, $4DK3l.StatusClassNames).NO_ORDER} ${activeStatusClass}`;
    }
};
const $0106818d88fe91c7$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $b04c93659d7c7469$export$458c50917513cd1a);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $7Meja.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $7Meja.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $7Meja.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $0106818d88fe91c7$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $8dc4a8cd49ebe705$export$f142573f51a67577);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $7Meja.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $7Meja.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $7Meja.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $0106818d88fe91c7$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $fmXA0.SORTABLE_COLUMN_ICON_CLASSNAME)} ${sortOrdered !== (0, $7Meja.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $fmXA0.SORTABLE_COLUMN_ICON_CLASSNAME}__not-allowed `}`;
    const content = $0106818d88fe91c7$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $0106818d88fe91c7$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        delay: 0,
        content: content,
        position: "top"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $0106818d88fe91c7$var$buttonStyles,
            (0, $ieeJu.expValEquals)('confluence_live_doc_table_sort_bugfix', 'isEnabled', true) && $0106818d88fe91c7$var$sortButtonElevatedStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        "aria-hidden": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, (0, $ieeJu.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $823e8c5ce52366b5$export$4be21af7f864512e), {
        sortOrdered: sortOrdered
    }) : /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $0106818d88fe91c7$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $0106818d88fe91c7$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $0106818d88fe91c7$var$iconStyles
        ]
    }))));
};
const $0106818d88fe91c7$var$_default_1 = (0, $kSwu1.injectIntl)($0106818d88fe91c7$var$SortingIcon);
var $0106818d88fe91c7$export$2e2bcd8739ae039 = $0106818d88fe91c7$var$_default_1;
module.exports["default"] = $0106818d88fe91c7$export$2e2bcd8739ae039;

});

parcelRegister("fmXA0", function(module, exports) {
const $c3f55825be33c618$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;
module.exports["SORTABLE_COLUMN_ICON_CLASSNAME"] = $c3f55825be33c618$export$bd4f24d8b1e86b23;

});

parcelRegister("iWj7r", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $7439dcdc5947fe13$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(new Map());
const $7439dcdc5947fe13$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7439dcdc5947fe13$export$841858b892ce1f4c.Provider, {
        value: new Map()
    }, children);
};
const $7439dcdc5947fe13$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/prefer-stateless-function
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7439dcdc5947fe13$export$841858b892ce1f4c.Consumer, null, (storage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                    ...this.props,
                    smartCardStorage: storage
                }));
        }
    };
};
module.exports["Provider"] = $7439dcdc5947fe13$export$2881499e37b75b9a;
module.exports["withSmartCardStorage"] = $7439dcdc5947fe13$export$65e2d5a272a382b0;

});

parcelRegister("kS1Yv", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $cozmU = parcelRequire("cozmU");

const $1541cf78dc895700$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({});
const $1541cf78dc895700$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($1541cf78dc895700$var$RendererContext);
const $1541cf78dc895700$export$ca5df47902194781 = $1541cf78dc895700$var$RendererContext.Provider;
module.exports["useRendererContext"] = $1541cf78dc895700$export$a906432540ed7ed8;
module.exports["RendererContextProvider"] = $1541cf78dc895700$export$ca5df47902194781;

});

parcelRegister("cdX2q", function(module, exports) {

var $anBbz = parcelRequire("anBbz");


var $3u6EZ = parcelRequire("3u6EZ");

const $3510a4f7f733edd3$export$8c07f44cea64e3c7 = (tableNode)=>tableNode.attrs.width !== null || (0, $3u6EZ.hasTableColumnBeenResized)(tableNode);
const $3510a4f7f733edd3$export$90b9840b2d94b80a = ({ tableNode: tableNode, isSupported: isSupported, isTableNested: isTableNested })=>{
    if (!(0, $anBbz.expValEqualsNoExposure)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true)) return false;
    if (!tableNode || isTableNested) return false;
    return isSupported && !$3510a4f7f733edd3$export$8c07f44cea64e3c7(tableNode) && tableNode.attrs.layout === 'align-start';
};
module.exports["isTableInContentMode"] = $3510a4f7f733edd3$export$90b9840b2d94b80a;

});

parcelRegister("adWuF", function(module, exports) {

let $77187de112d41419$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $77187de112d41419$var$load("60QcS"),
    $77187de112d41419$var$load("6wr18"),
    $77187de112d41419$var$load("ffEVr"),
    $77187de112d41419$var$load("fL6En"),
    $77187de112d41419$var$load("iNYpR")
]).then(()=>parcelRequire('6Gf6E'));

});

parcelRegister("9xAS0", function(module, exports) {

let $6f23cbc174e22858$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6f23cbc174e22858$var$load("60QcS"),
    $6f23cbc174e22858$var$load("6wr18"),
    $6f23cbc174e22858$var$load("a8glC"),
    $6f23cbc174e22858$var$load("ffEVr"),
    $6f23cbc174e22858$var$load("fL6En"),
    $6f23cbc174e22858$var$load("4WVf0")
]).then(()=>parcelRequire('6KU95'));

});

parcelRegister("22G3u", function(module, exports) {

let $17cc63ff7b22d383$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $17cc63ff7b22d383$var$load("kJtoi").then(()=>parcelRequire('gvXEn'));

});

parcelRegister("9A4tY", function(module, exports) {

let $6f9af3fb6029755c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6f9af3fb6029755c$var$load("6wr18"),
    $6f9af3fb6029755c$var$load("ffEVr"),
    $6f9af3fb6029755c$var$load("fYS5K")
]).then(()=>parcelRequire('ckvpk'));

});

parcelRegister("1zncV", function(module, exports) {

let $124b0fdab89083df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $124b0fdab89083df$var$load("04RK7").then(()=>parcelRequire('jx4WZ'));

});

parcelRegister("6U7Ru", function(module, exports) {

let $506e12331e9c26fb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $506e12331e9c26fb$var$load("6wr18"),
    $506e12331e9c26fb$var$load("ffEVr"),
    $506e12331e9c26fb$var$load("eMWgI")
]).then(()=>parcelRequire('jOsRQ'));

});

parcelRegister("atGVx", function(module, exports) {

let $7a0de938e5ee9aa2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7a0de938e5ee9aa2$var$load("iMohY"),
    $7a0de938e5ee9aa2$var$load("3SirY"),
    $7a0de938e5ee9aa2$var$load("lHBuV")
]).then(()=>parcelRequire('7BiiX'));

});

parcelRegister("36hib", function(module, exports) {

let $241f58828a97809f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $241f58828a97809f$var$load("1f0Jg"),
    $241f58828a97809f$var$load("aQ52k"),
    $241f58828a97809f$var$load("hhss7"),
    $241f58828a97809f$var$load("Wowvf"),
    $241f58828a97809f$var$load("76AMq")
]).then(()=>parcelRequire('fBB7S'));

});

parcelRegister("15iJg", function(module, exports) {

let $0ca4c94970dc442f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0ca4c94970dc442f$var$load("1f0Jg"),
    $0ca4c94970dc442f$var$load("aQ52k"),
    $0ca4c94970dc442f$var$load("iMohY"),
    $0ca4c94970dc442f$var$load("3SirY"),
    $0ca4c94970dc442f$var$load("6pC5W"),
    $0ca4c94970dc442f$var$load("ihRIc")
]).then(()=>parcelRequire('hMAfQ'));

});

parcelRegister("b40eF", function(module, exports) {

let $80e040321cfbee82$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $80e040321cfbee82$var$load("6wr18"),
    $80e040321cfbee82$var$load("d1Xv1"),
    $80e040321cfbee82$var$load("gzxwO"),
    $80e040321cfbee82$var$load("ffEVr"),
    $80e040321cfbee82$var$load("1f0Jg"),
    $80e040321cfbee82$var$load("aQ52k"),
    $80e040321cfbee82$var$load("iMohY"),
    $80e040321cfbee82$var$load("3SirY"),
    $80e040321cfbee82$var$load("6pC5W"),
    $80e040321cfbee82$var$load("ihRIc"),
    $80e040321cfbee82$var$load("5KWjU")
]).then(()=>parcelRequire('eE4tp'));

});

parcelRegister("4xolx", function(module, exports) {

let $34dd212c4489d186$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $34dd212c4489d186$var$load("1f0Jg"),
    $34dd212c4489d186$var$load("aQ52k"),
    $34dd212c4489d186$var$load("iMohY"),
    $34dd212c4489d186$var$load("3SirY"),
    $34dd212c4489d186$var$load("d1Xv1"),
    $34dd212c4489d186$var$load("gzxwO"),
    $34dd212c4489d186$var$load("6vqGz"),
    $34dd212c4489d186$var$load("2l8zo"),
    $34dd212c4489d186$var$load("b55Kg"),
    $34dd212c4489d186$var$load("b1l6x"),
    $34dd212c4489d186$var$load("aN7tU"),
    $34dd212c4489d186$var$load("Tjs4D"),
    $34dd212c4489d186$var$load("aMsb0"),
    $34dd212c4489d186$var$load("2PXrC"),
    $34dd212c4489d186$var$load("h1yOv"),
    $34dd212c4489d186$var$load("aLwQm"),
    $34dd212c4489d186$var$load("gcLWi"),
    $34dd212c4489d186$var$load("fsgrC"),
    $34dd212c4489d186$var$load("eqj21"),
    $34dd212c4489d186$var$load("3oAU3"),
    $34dd212c4489d186$var$load("6fJCf"),
    $34dd212c4489d186$var$load("duEFL"),
    $34dd212c4489d186$var$load("1pJPT"),
    $34dd212c4489d186$var$load("8MPlE"),
    $34dd212c4489d186$var$load("4x9Jx"),
    $34dd212c4489d186$var$load("ea3NB"),
    $34dd212c4489d186$var$load("7EorR"),
    $34dd212c4489d186$var$load("fuOfV"),
    $34dd212c4489d186$var$load("jL1Ke"),
    $34dd212c4489d186$var$load("5MQ0D"),
    $34dd212c4489d186$var$load("cvcNg"),
    $34dd212c4489d186$var$load("iZR3N"),
    $34dd212c4489d186$var$load("4zz48"),
    $34dd212c4489d186$var$load("jXM1T"),
    $34dd212c4489d186$var$load("39XCn"),
    $34dd212c4489d186$var$load("jw3lv"),
    $34dd212c4489d186$var$load("7rqWx"),
    $34dd212c4489d186$var$load("aIze1"),
    $34dd212c4489d186$var$load("3Cky6"),
    $34dd212c4489d186$var$load("kG5Ju"),
    $34dd212c4489d186$var$load("il8bj"),
    $34dd212c4489d186$var$load("4N1MY"),
    $34dd212c4489d186$var$load("6wr18"),
    $34dd212c4489d186$var$load("aFLSJ"),
    $34dd212c4489d186$var$load("ffEVr"),
    $34dd212c4489d186$var$load("6bjEk"),
    $34dd212c4489d186$var$load("hhss7"),
    $34dd212c4489d186$var$load("ejk86"),
    $34dd212c4489d186$var$load("3pkSd"),
    $34dd212c4489d186$var$load("Wowvf"),
    $34dd212c4489d186$var$load("5ax2I")
]).then(()=>parcelRequire('bBXra'));

});

parcelRegister("jbsCY", function(module, exports) {

let $df75403cdb3484b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $df75403cdb3484b0$var$load("d1Xv1"),
    $df75403cdb3484b0$var$load("gzxwO"),
    $df75403cdb3484b0$var$load("6vqGz"),
    $df75403cdb3484b0$var$load("2l8zo"),
    $df75403cdb3484b0$var$load("b55Kg"),
    $df75403cdb3484b0$var$load("b1l6x"),
    $df75403cdb3484b0$var$load("aN7tU"),
    $df75403cdb3484b0$var$load("Tjs4D"),
    $df75403cdb3484b0$var$load("aMsb0"),
    $df75403cdb3484b0$var$load("2PXrC"),
    $df75403cdb3484b0$var$load("h1yOv"),
    $df75403cdb3484b0$var$load("aLwQm"),
    $df75403cdb3484b0$var$load("gcLWi"),
    $df75403cdb3484b0$var$load("fsgrC"),
    $df75403cdb3484b0$var$load("eqj21"),
    $df75403cdb3484b0$var$load("3oAU3"),
    $df75403cdb3484b0$var$load("6fJCf"),
    $df75403cdb3484b0$var$load("duEFL"),
    $df75403cdb3484b0$var$load("1pJPT"),
    $df75403cdb3484b0$var$load("8MPlE"),
    $df75403cdb3484b0$var$load("4x9Jx"),
    $df75403cdb3484b0$var$load("ea3NB"),
    $df75403cdb3484b0$var$load("7EorR"),
    $df75403cdb3484b0$var$load("fuOfV"),
    $df75403cdb3484b0$var$load("jL1Ke"),
    $df75403cdb3484b0$var$load("5MQ0D"),
    $df75403cdb3484b0$var$load("cvcNg"),
    $df75403cdb3484b0$var$load("iZR3N"),
    $df75403cdb3484b0$var$load("4zz48"),
    $df75403cdb3484b0$var$load("jXM1T"),
    $df75403cdb3484b0$var$load("39XCn"),
    $df75403cdb3484b0$var$load("jw3lv"),
    $df75403cdb3484b0$var$load("7rqWx"),
    $df75403cdb3484b0$var$load("aIze1"),
    $df75403cdb3484b0$var$load("3Cky6"),
    $df75403cdb3484b0$var$load("kG5Ju"),
    $df75403cdb3484b0$var$load("il8bj"),
    $df75403cdb3484b0$var$load("4N1MY"),
    $df75403cdb3484b0$var$load("6wr18"),
    $df75403cdb3484b0$var$load("aFLSJ"),
    $df75403cdb3484b0$var$load("ffEVr"),
    $df75403cdb3484b0$var$load("6bjEk"),
    $df75403cdb3484b0$var$load("hhss7"),
    $df75403cdb3484b0$var$load("Wowvf"),
    $df75403cdb3484b0$var$load("ejk86")
]).then(()=>parcelRequire('gPRUa'));

});

parcelRegister("aoBOL", function(module, exports) {

let $79197b1dcda55e14$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $79197b1dcda55e14$var$load("d1Xv1"),
    $79197b1dcda55e14$var$load("gzxwO"),
    $79197b1dcda55e14$var$load("6vqGz"),
    $79197b1dcda55e14$var$load("2l8zo"),
    $79197b1dcda55e14$var$load("b55Kg"),
    $79197b1dcda55e14$var$load("b1l6x"),
    $79197b1dcda55e14$var$load("aN7tU"),
    $79197b1dcda55e14$var$load("Tjs4D"),
    $79197b1dcda55e14$var$load("aMsb0"),
    $79197b1dcda55e14$var$load("2PXrC"),
    $79197b1dcda55e14$var$load("h1yOv"),
    $79197b1dcda55e14$var$load("aLwQm"),
    $79197b1dcda55e14$var$load("gcLWi"),
    $79197b1dcda55e14$var$load("fsgrC"),
    $79197b1dcda55e14$var$load("eqj21"),
    $79197b1dcda55e14$var$load("3oAU3"),
    $79197b1dcda55e14$var$load("6fJCf"),
    $79197b1dcda55e14$var$load("duEFL"),
    $79197b1dcda55e14$var$load("1pJPT"),
    $79197b1dcda55e14$var$load("8MPlE"),
    $79197b1dcda55e14$var$load("4x9Jx"),
    $79197b1dcda55e14$var$load("ea3NB"),
    $79197b1dcda55e14$var$load("7EorR"),
    $79197b1dcda55e14$var$load("fuOfV"),
    $79197b1dcda55e14$var$load("jL1Ke"),
    $79197b1dcda55e14$var$load("5MQ0D"),
    $79197b1dcda55e14$var$load("cvcNg"),
    $79197b1dcda55e14$var$load("iZR3N"),
    $79197b1dcda55e14$var$load("4zz48"),
    $79197b1dcda55e14$var$load("jXM1T"),
    $79197b1dcda55e14$var$load("39XCn"),
    $79197b1dcda55e14$var$load("jw3lv"),
    $79197b1dcda55e14$var$load("7rqWx"),
    $79197b1dcda55e14$var$load("aIze1"),
    $79197b1dcda55e14$var$load("3Cky6"),
    $79197b1dcda55e14$var$load("kG5Ju"),
    $79197b1dcda55e14$var$load("il8bj"),
    $79197b1dcda55e14$var$load("4N1MY"),
    $79197b1dcda55e14$var$load("6wr18"),
    $79197b1dcda55e14$var$load("aFLSJ"),
    $79197b1dcda55e14$var$load("ffEVr"),
    $79197b1dcda55e14$var$load("6bjEk"),
    $79197b1dcda55e14$var$load("hhss7"),
    $79197b1dcda55e14$var$load("ejk86"),
    $79197b1dcda55e14$var$load("Wowvf"),
    $79197b1dcda55e14$var$load("3pkSd")
]).then(()=>parcelRequire('8bJxr'));

});

parcelRegister("krgH5", function(module, exports) {

let $ee13474eef9b3ff6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ee13474eef9b3ff6$var$load("d1Xv1"),
    $ee13474eef9b3ff6$var$load("gzxwO"),
    $ee13474eef9b3ff6$var$load("79Tk4"),
    $ee13474eef9b3ff6$var$load("i9USC"),
    $ee13474eef9b3ff6$var$load("ea3NB"),
    $ee13474eef9b3ff6$var$load("1f0Jg"),
    $ee13474eef9b3ff6$var$load("aQ52k"),
    $ee13474eef9b3ff6$var$load("ewDPG"),
    $ee13474eef9b3ff6$var$load("iMohY"),
    $ee13474eef9b3ff6$var$load("3SirY"),
    $ee13474eef9b3ff6$var$load("6OMo6"),
    $ee13474eef9b3ff6$var$load("aaRXj"),
    $ee13474eef9b3ff6$var$load("fHlIz"),
    $ee13474eef9b3ff6$var$load("4QwAJ"),
    $ee13474eef9b3ff6$var$load("3i44s"),
    $ee13474eef9b3ff6$var$load("5kI0b"),
    $ee13474eef9b3ff6$var$load("kYkz1"),
    $ee13474eef9b3ff6$var$load("jfYeU"),
    $ee13474eef9b3ff6$var$load("b4nm1"),
    $ee13474eef9b3ff6$var$load("geXPZ"),
    $ee13474eef9b3ff6$var$load("aQ5uu"),
    $ee13474eef9b3ff6$var$load("6wr18"),
    $ee13474eef9b3ff6$var$load("aOIZj"),
    $ee13474eef9b3ff6$var$load("lVz4k"),
    $ee13474eef9b3ff6$var$load("iYOCR"),
    $ee13474eef9b3ff6$var$load("ffEVr"),
    $ee13474eef9b3ff6$var$load("jOE2W"),
    $ee13474eef9b3ff6$var$load("jTOhL"),
    $ee13474eef9b3ff6$var$load("cuNBo"),
    $ee13474eef9b3ff6$var$load("4Ldt2"),
    $ee13474eef9b3ff6$var$load("2XRLb"),
    $ee13474eef9b3ff6$var$load("gkVge"),
    $ee13474eef9b3ff6$var$load("io0qR"),
    $ee13474eef9b3ff6$var$load("3MJxZ"),
    $ee13474eef9b3ff6$var$load("kHMR7"),
    $ee13474eef9b3ff6$var$load("e3OZZ"),
    $ee13474eef9b3ff6$var$load("cL682"),
    $ee13474eef9b3ff6$var$load("4MePG"),
    $ee13474eef9b3ff6$var$load("7gPXS"),
    $ee13474eef9b3ff6$var$load("5JWJI"),
    $ee13474eef9b3ff6$var$load("hhss7"),
    $ee13474eef9b3ff6$var$load("7EorR"),
    $ee13474eef9b3ff6$var$load("91v6x")
]).then(()=>parcelRequire('4msnK'));

});

parcelRegister("4biZ8", function(module, exports) {

let $30b6ea8cc968ef60$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $30b6ea8cc968ef60$var$load("1f0Jg"),
    $30b6ea8cc968ef60$var$load("aQ52k"),
    $30b6ea8cc968ef60$var$load("6wr18"),
    $30b6ea8cc968ef60$var$load("ffEVr"),
    $30b6ea8cc968ef60$var$load("8wR19")
]).then(()=>parcelRequire('8BNw5'));

});

parcelRegister("4Q5c8", function(module, exports) {

let $38600c4cd2a5b02e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $38600c4cd2a5b02e$var$load("d1Xv1"),
    $38600c4cd2a5b02e$var$load("gzxwO"),
    $38600c4cd2a5b02e$var$load("79Tk4"),
    $38600c4cd2a5b02e$var$load("5K1Mf"),
    $38600c4cd2a5b02e$var$load("i9USC"),
    $38600c4cd2a5b02e$var$load("1f0Jg"),
    $38600c4cd2a5b02e$var$load("aQ52k"),
    $38600c4cd2a5b02e$var$load("ewDPG"),
    $38600c4cd2a5b02e$var$load("iMohY"),
    $38600c4cd2a5b02e$var$load("3SirY"),
    $38600c4cd2a5b02e$var$load("6OMo6"),
    $38600c4cd2a5b02e$var$load("aaRXj"),
    $38600c4cd2a5b02e$var$load("fHlIz"),
    $38600c4cd2a5b02e$var$load("4QwAJ"),
    $38600c4cd2a5b02e$var$load("3i44s"),
    $38600c4cd2a5b02e$var$load("5kI0b"),
    $38600c4cd2a5b02e$var$load("kYkz1"),
    $38600c4cd2a5b02e$var$load("jfYeU"),
    $38600c4cd2a5b02e$var$load("b4nm1"),
    $38600c4cd2a5b02e$var$load("geXPZ"),
    $38600c4cd2a5b02e$var$load("aQ5uu"),
    $38600c4cd2a5b02e$var$load("6wr18"),
    $38600c4cd2a5b02e$var$load("aOIZj"),
    $38600c4cd2a5b02e$var$load("lVz4k"),
    $38600c4cd2a5b02e$var$load("iYOCR"),
    $38600c4cd2a5b02e$var$load("7gPXS"),
    $38600c4cd2a5b02e$var$load("ea3NB"),
    $38600c4cd2a5b02e$var$load("ffEVr"),
    $38600c4cd2a5b02e$var$load("jOE2W"),
    $38600c4cd2a5b02e$var$load("jTOhL"),
    $38600c4cd2a5b02e$var$load("cuNBo"),
    $38600c4cd2a5b02e$var$load("4Ldt2"),
    $38600c4cd2a5b02e$var$load("2XRLb"),
    $38600c4cd2a5b02e$var$load("gkVge"),
    $38600c4cd2a5b02e$var$load("io0qR"),
    $38600c4cd2a5b02e$var$load("3MJxZ"),
    $38600c4cd2a5b02e$var$load("kHMR7"),
    $38600c4cd2a5b02e$var$load("e3OZZ"),
    $38600c4cd2a5b02e$var$load("cL682"),
    $38600c4cd2a5b02e$var$load("4MePG"),
    $38600c4cd2a5b02e$var$load("5JWJI"),
    $38600c4cd2a5b02e$var$load("7EorR"),
    $38600c4cd2a5b02e$var$load("lUBBr")
]).then(()=>parcelRequire('4gSB2'));

});

parcelRegister("9JAgI", function(module, exports) {

let $71647332f9b03be4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $71647332f9b03be4$var$load("1f0Jg"),
    $71647332f9b03be4$var$load("aQ52k"),
    $71647332f9b03be4$var$load("iMohY"),
    $71647332f9b03be4$var$load("3SirY"),
    $71647332f9b03be4$var$load("JmUi1")
]).then(()=>parcelRequire('lWEf5'));

});

parcelRegister("78smB", function(module, exports) {

let $531f48255fe82038$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $531f48255fe82038$var$load("d1Xv1"),
    $531f48255fe82038$var$load("gzxwO"),
    $531f48255fe82038$var$load("6vqGz"),
    $531f48255fe82038$var$load("60QcS"),
    $531f48255fe82038$var$load("b55Kg"),
    $531f48255fe82038$var$load("b1l6x"),
    $531f48255fe82038$var$load("6wr18"),
    $531f48255fe82038$var$load("ffEVr"),
    $531f48255fe82038$var$load("59hV4"),
    $531f48255fe82038$var$load("pUT24"),
    $531f48255fe82038$var$load("bz5yy"),
    $531f48255fe82038$var$load("hhss7"),
    $531f48255fe82038$var$load("caMoT")
]).then(()=>parcelRequire('4ybgQ'));

});

parcelRegister("lo4QF", function(module, exports) {

let $f91f99a79324e4fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f91f99a79324e4fc$var$load("1f0Jg"),
    $f91f99a79324e4fc$var$load("aQ52k"),
    $f91f99a79324e4fc$var$load("lwgDt")
]).then(()=>parcelRequire('eilSC'));

});

parcelRegister("Rc2LS", function(module, exports) {

let $09fe4afacb450df8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $09fe4afacb450df8$var$load("gi7Or").then(()=>parcelRequire('gWbtJ'));

});

parcelRegister("gIalr", function(module, exports) {

let $c2a8c7ad7f9aab42$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c2a8c7ad7f9aab42$var$load("i8XIa").then(()=>parcelRequire('30QUD'));

});

parcelRegister("hac25", function(module, exports) {



function $e0fe68ca36ce9924$export$e54c9225ca52acc(node) {
    let tableColumnWidths = [];
    node.forEach((row)=>{
        const currentTableWidth = [];
        row.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) currentTableWidth.push(...colwidth);
            else if (colspan !== undefined && colspan > 1) currentTableWidth.push(...Array(colspan).fill(0));
            else currentTableWidth.push(0);
        });
        if (currentTableWidth.length > tableColumnWidths.length) tableColumnWidths = currentTableWidth;
    });
    return tableColumnWidths;
}
function $e0fe68ca36ce9924$export$98951d3cdcfd364b(node) {
    const firstRow = node.firstChild;
    const tableColumnWidths = [];
    if (firstRow) firstRow.forEach((cell)=>{
        const { colspan: colspan, colwidth: colwidth } = cell.attrs;
        // column has been resized, colWidth will be an array, can safely take values even if cell is merged
        if (Array.isArray(colwidth)) tableColumnWidths.push(...colwidth);
        else if (colspan > 1) tableColumnWidths.push(...Array(colspan).fill(0));
        else tableColumnWidths.push(0);
    });
    return tableColumnWidths;
}
module.exports["getColumnWidths"] = $e0fe68ca36ce9924$export$e54c9225ca52acc;
module.exports["calcTableColumnWidths"] = $e0fe68ca36ce9924$export$98951d3cdcfd364b;

});

parcelRegister("YvadP", function(module, exports) {

var $2nOF5 = parcelRequire("2nOF5");
// eslint-disable-next-line import/no-namespace
var $f06be630c2ad4da2$exports = {};
$parcel$export($f06be630c2ad4da2$exports, "expandWithNestedExpand", () => (parcelRequire("chuMh")).expandWithNestedExpand);
$parcel$export($f06be630c2ad4da2$exports, "expandWithNestedExpandLocalId", () => (parcelRequire("chuMh")).expandWithNestedExpandLocalId);
$parcel$export($f06be630c2ad4da2$exports, "expandToJSON", () => (parcelRequire("chuMh")).toJSON);
$parcel$export($f06be630c2ad4da2$exports, "confluenceJiraIssue", () => (parcelRequire("9zObh")).confluenceJiraIssue);
$parcel$export($f06be630c2ad4da2$exports, "confluenceUnsupportedBlock", () => (parcelRequire("g185T")).confluenceUnsupportedBlock);
$parcel$export($f06be630c2ad4da2$exports, "confluenceUnsupportedInline", () => (parcelRequire("1E9VS")).confluenceUnsupportedInline);
$parcel$export($f06be630c2ad4da2$exports, "doc", () => (parcelRequire("5SlVI")).doc);
$parcel$export($f06be630c2ad4da2$exports, "blockquote", () => (parcelRequire("9oc8s")).blockquote);
$parcel$export($f06be630c2ad4da2$exports, "extendedBlockquote", () => (parcelRequire("9oc8s")).extendedBlockquote);
$parcel$export($f06be630c2ad4da2$exports, "extendedBlockquoteWithLocalId", () => (parcelRequire("9oc8s")).extendedBlockquoteWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "bulletList", () => (parcelRequire("9nUB4")).bulletList);
$parcel$export($f06be630c2ad4da2$exports, "bulletListSelector", () => (parcelRequire("9nUB4")).bulletListSelector);
$parcel$export($f06be630c2ad4da2$exports, "bulletListWithLocalId", () => (parcelRequire("9nUB4")).bulletListWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "codeBlock", () => (parcelRequire("jDAs4")).codeBlock);
$parcel$export($f06be630c2ad4da2$exports, "codeBlockWithLocalId", () => (parcelRequire("jDAs4")).codeBlockWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "codeBlockToJSON", () => (parcelRequire("jDAs4")).toJSON);
$parcel$export($f06be630c2ad4da2$exports, "hardBreak", () => (parcelRequire("ioLmC")).hardBreak);
$parcel$export($f06be630c2ad4da2$exports, "heading", () => (parcelRequire("3RygG")).heading);
$parcel$export($f06be630c2ad4da2$exports, "rule", () => (parcelRequire("2kGqi")).rule);
$parcel$export($f06be630c2ad4da2$exports, "ruleWithLocalId", () => (parcelRequire("2kGqi")).ruleWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "ruleRootOnlyStage0", () => (parcelRequire("2kGqi")).ruleRootOnlyStage0);
$parcel$export($f06be630c2ad4da2$exports, "orderedList", () => (parcelRequire("ab7A2")).orderedList);
$parcel$export($f06be630c2ad4da2$exports, "orderedListSelector", () => (parcelRequire("ab7A2")).orderedListSelector);
$parcel$export($f06be630c2ad4da2$exports, "orderedListWithLocalId", () => (parcelRequire("ab7A2")).orderedListWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "orderedListWithOrder", () => (parcelRequire("ab7A2")).orderedListWithOrder);
$parcel$export($f06be630c2ad4da2$exports, "orderedListWithOrderAndLocalId", () => (parcelRequire("ab7A2")).orderedListWithOrderAndLocalId);
$parcel$export($f06be630c2ad4da2$exports, "paragraph", () => (parcelRequire("gMOVH")).paragraph);
$parcel$export($f06be630c2ad4da2$exports, "emoji", () => (parcelRequire("kOOm4")).emoji);
$parcel$export($f06be630c2ad4da2$exports, "emojiWithLocalId", () => (parcelRequire("kOOm4")).emojiWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "image", () => (parcelRequire("234td")).image);
$parcel$export($f06be630c2ad4da2$exports, "mention", () => (parcelRequire("jKue6")).mention);
$parcel$export($f06be630c2ad4da2$exports, "mentionToJSON", () => (parcelRequire("jKue6")).toJSON);
$parcel$export($f06be630c2ad4da2$exports, "listItem", () => (parcelRequire("f5nzM")).listItem);
$parcel$export($f06be630c2ad4da2$exports, "listItemWithLocalId", () => (parcelRequire("f5nzM")).listItemWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "extendedPanel", () => (parcelRequire("jVdlG")).extendedPanel);
$parcel$export($f06be630c2ad4da2$exports, "extendedPanelWithLocalId", () => (parcelRequire("jVdlG")).extendedPanelWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "extendedPanelRootOnlyStage0", () => (parcelRequire("jVdlG")).extendedPanelRootOnlyStage0);
$parcel$export($f06be630c2ad4da2$exports, "extendedPanelC1RootOnlyStage0", () => (parcelRequire("jVdlG")).extendedPanelC1RootOnlyStage0);
$parcel$export($f06be630c2ad4da2$exports, "extendedPanelC1", () => (parcelRequire("jVdlG")).extendedPanelC1);
$parcel$export($f06be630c2ad4da2$exports, "extendedPanelC1WithLocalId", () => (parcelRequire("jVdlG")).extendedPanelC1WithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "PanelType", () => (parcelRequire("jVdlG")).PanelType);
$parcel$export($f06be630c2ad4da2$exports, "text", () => (parcelRequire("etdmL")).text);
$parcel$export($f06be630c2ad4da2$exports, "unknownBlock", () => (parcelRequire("hXS29")).default);
$parcel$export($f06be630c2ad4da2$exports, "caption", () => (parcelRequire("c94QJ")).caption);
$parcel$export($f06be630c2ad4da2$exports, "captionWithLocalId", () => (parcelRequire("c94QJ")).captionWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "media", () => (parcelRequire("2fsTz")).media);
$parcel$export($f06be630c2ad4da2$exports, "copyPrivateMediaAttributes", () => (parcelRequire("2fsTz")).copyPrivateAttributes);
$parcel$export($f06be630c2ad4da2$exports, "mediaToJSON", () => (parcelRequire("2fsTz")).toJSON);
$parcel$export($f06be630c2ad4da2$exports, "mediaGroup", () => (parcelRequire("l73oM")).mediaGroup);
$parcel$export($f06be630c2ad4da2$exports, "mediaInline", () => (parcelRequire("9biYD")).mediaInline);
$parcel$export($f06be630c2ad4da2$exports, "mediaSingle", () => (parcelRequire("f3bB0")).mediaSingle);
$parcel$export($f06be630c2ad4da2$exports, "mediaSingleSpec", () => (parcelRequire("f3bB0")).mediaSingleSpec);
$parcel$export($f06be630c2ad4da2$exports, "mediaSingleWithCaption", () => (parcelRequire("f3bB0")).mediaSingleWithCaption);
$parcel$export($f06be630c2ad4da2$exports, "mediaSingleWithWidthType", () => (parcelRequire("f3bB0")).mediaSingleWithWidthType);
$parcel$export($f06be630c2ad4da2$exports, "mediaSingleFull", () => (parcelRequire("f3bB0")).mediaSingleFull);
$parcel$export($f06be630c2ad4da2$exports, "mediaSingleFullWithLocalId", () => (parcelRequire("f3bB0")).mediaSingleFullWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "mediaSingleToJSON", () => (parcelRequire("f3bB0")).toJSON);
$parcel$export($f06be630c2ad4da2$exports, "table", () => (parcelRequire("39Puj")).table);
$parcel$export($f06be630c2ad4da2$exports, "tableWithNestedTable", () => (parcelRequire("39Puj")).tableWithNestedTable);
$parcel$export($f06be630c2ad4da2$exports, "tableRowWithNestedTable", () => (parcelRequire("39Puj")).tableRowWithNestedTable);
$parcel$export($f06be630c2ad4da2$exports, "tableCellWithNestedTable", () => (parcelRequire("39Puj")).tableCellWithNestedTable);
$parcel$export($f06be630c2ad4da2$exports, "tableHeaderWithNestedTable", () => (parcelRequire("39Puj")).tableHeaderWithNestedTable);
$parcel$export($f06be630c2ad4da2$exports, "tableCellStage0", () => (parcelRequire("39Puj")).tableCellStage0);
$parcel$export($f06be630c2ad4da2$exports, "tableHeaderStage0", () => (parcelRequire("39Puj")).tableHeaderStage0);
$parcel$export($f06be630c2ad4da2$exports, "tableCellWithNestedTableStage0", () => (parcelRequire("39Puj")).tableCellWithNestedTableStage0);
$parcel$export($f06be630c2ad4da2$exports, "tableHeaderWithNestedTableStage0", () => (parcelRequire("39Puj")).tableHeaderWithNestedTableStage0);
$parcel$export($f06be630c2ad4da2$exports, "tableRowWithLocalId", () => (parcelRequire("39Puj")).tableRowWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "tableCellWithLocalId", () => (parcelRequire("39Puj")).tableCellWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "tableHeaderWithLocalId", () => (parcelRequire("39Puj")).tableHeaderWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "tableRowWithNestedTableWithLocalId", () => (parcelRequire("39Puj")).tableRowWithNestedTableWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "tableCellWithNestedTableWithLocalId", () => (parcelRequire("39Puj")).tableCellWithNestedTableWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "tableHeaderWithNestedTableWithLocalId", () => (parcelRequire("39Puj")).tableHeaderWithNestedTableWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "tableStage0", () => (parcelRequire("39Puj")).tableStage0);
$parcel$export($f06be630c2ad4da2$exports, "tableWithCustomWidth", () => (parcelRequire("39Puj")).tableWithCustomWidth);
$parcel$export($f06be630c2ad4da2$exports, "tableToJSON", () => (parcelRequire("39Puj")).tableToJSON);
$parcel$export($f06be630c2ad4da2$exports, "tableCell", () => (parcelRequire("39Puj")).tableCell);
$parcel$export($f06be630c2ad4da2$exports, "toJSONTableCell", () => (parcelRequire("39Puj")).toJSONTableCell);
$parcel$export($f06be630c2ad4da2$exports, "tableHeader", () => (parcelRequire("39Puj")).tableHeader);
$parcel$export($f06be630c2ad4da2$exports, "toJSONTableHeader", () => (parcelRequire("39Puj")).toJSONTableHeader);
$parcel$export($f06be630c2ad4da2$exports, "tableRow", () => (parcelRequire("39Puj")).tableRow);
$parcel$export($f06be630c2ad4da2$exports, "tableBackgroundColorPalette", () => (parcelRequire("39Puj")).tableBackgroundColorPalette);
$parcel$export($f06be630c2ad4da2$exports, "tableBackgroundColorPaletteNew", () => (parcelRequire("39Puj")).tableBackgroundColorPaletteNew);
$parcel$export($f06be630c2ad4da2$exports, "tableBackgroundBorderColor", () => (parcelRequire("39Puj")).tableBackgroundBorderColor);
$parcel$export($f06be630c2ad4da2$exports, "tableBackgroundColorNames", () => (parcelRequire("39Puj")).tableBackgroundColorNames);
$parcel$export($f06be630c2ad4da2$exports, "getCellAttrs", () => (parcelRequire("39Puj")).getCellAttrs);
$parcel$export($f06be630c2ad4da2$exports, "getCellDomAttrs", () => (parcelRequire("39Puj")).getCellDomAttrs);
$parcel$export($f06be630c2ad4da2$exports, "tablePrefixSelector", () => (parcelRequire("39Puj")).tablePrefixSelector);
$parcel$export($f06be630c2ad4da2$exports, "tableCellSelector", () => (parcelRequire("39Puj")).tableCellSelector);
$parcel$export($f06be630c2ad4da2$exports, "tableHeaderSelector", () => (parcelRequire("39Puj")).tableHeaderSelector);
$parcel$export($f06be630c2ad4da2$exports, "tableCellContentWrapperSelector", () => (parcelRequire("39Puj")).tableCellContentWrapperSelector);
$parcel$export($f06be630c2ad4da2$exports, "tableCellContentDomSelector", () => (parcelRequire("39Puj")).tableCellContentDomSelector);
$parcel$export($f06be630c2ad4da2$exports, "decisionList", () => (parcelRequire("kAzEy")).decisionList);
$parcel$export($f06be630c2ad4da2$exports, "decisionListSelector", () => (parcelRequire("kAzEy")).decisionListSelector);
$parcel$export($f06be630c2ad4da2$exports, "decisionItem", () => (parcelRequire("98Lj8")).decisionItem);
$parcel$export($f06be630c2ad4da2$exports, "taskList", () => (parcelRequire("7eTEw")).taskList);
$parcel$export($f06be630c2ad4da2$exports, "taskListSelector", () => (parcelRequire("7eTEw")).taskListSelector);
$parcel$export($f06be630c2ad4da2$exports, "taskItem", () => (parcelRequire("9ehdj")).taskItem);
$parcel$export($f06be630c2ad4da2$exports, "blockTaskItem", () => (parcelRequire("9ehdj")).blockTaskItem);
$parcel$export($f06be630c2ad4da2$exports, "date", () => (parcelRequire("eq809")).date);
$parcel$export($f06be630c2ad4da2$exports, "dateWithLocalId", () => (parcelRequire("eq809")).dateWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "placeholder", () => (parcelRequire("59uj0")).placeholder);
$parcel$export($f06be630c2ad4da2$exports, "placeholderWithLocalId", () => (parcelRequire("59uj0")).placeholderWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "layoutSection", () => (parcelRequire("6OV8L")).layoutSection);
$parcel$export($f06be630c2ad4da2$exports, "layoutSectionWithLocalId", () => (parcelRequire("6OV8L")).layoutSectionWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "layoutSectionWithSingleColumn", () => (parcelRequire("6OV8L")).layoutSectionWithSingleColumn);
$parcel$export($f06be630c2ad4da2$exports, "layoutSectionWithSingleColumnLocalId", () => (parcelRequire("6OV8L")).layoutSectionWithSingleColumnLocalId);
$parcel$export($f06be630c2ad4da2$exports, "layoutColumn", () => (parcelRequire("6UUJT")).layoutColumn);
$parcel$export($f06be630c2ad4da2$exports, "layoutColumnStage0", () => (parcelRequire("6UUJT")).layoutColumnStage0);
$parcel$export($f06be630c2ad4da2$exports, "layoutColumnWithLocalId", () => (parcelRequire("6UUJT")).layoutColumnWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "inlineCard", () => (parcelRequire("dYkuB")).inlineCard);
$parcel$export($f06be630c2ad4da2$exports, "inlineCardWithLocalId", () => (parcelRequire("dYkuB")).inlineCardWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "blockCard", () => (parcelRequire("azoPw")).blockCard);
$parcel$export($f06be630c2ad4da2$exports, "blockCardWithLocalId", () => (parcelRequire("azoPw")).blockCardWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "unsupportedBlock", () => (parcelRequire("egqI8")).unsupportedBlock);
$parcel$export($f06be630c2ad4da2$exports, "unsupportedInline", () => (parcelRequire("kwL1e")).unsupportedInline);
$parcel$export($f06be630c2ad4da2$exports, "status", () => (parcelRequire("PYwg9")).status);
$parcel$export($f06be630c2ad4da2$exports, "nestedExpand", () => (parcelRequire("7RQ8H")).nestedExpand);
$parcel$export($f06be630c2ad4da2$exports, "nestedExpandWithLocalId", () => (parcelRequire("7RQ8H")).nestedExpandWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "embedCard", () => (parcelRequire("dtmRZ")).embedCard);
$parcel$export($f06be630c2ad4da2$exports, "embedCardWithLocalId", () => (parcelRequire("dtmRZ")).embedCardWithLocalId);
$parcel$export($f06be630c2ad4da2$exports, "extension", () => (parcelRequire("hVgcP")).extension);
$parcel$export($f06be630c2ad4da2$exports, "extensionRootOnlyStage0", () => (parcelRequire("hVgcP")).extensionRootOnlyStage0);
$parcel$export($f06be630c2ad4da2$exports, "inlineExtension", () => (parcelRequire("20WsY")).inlineExtension);
$parcel$export($f06be630c2ad4da2$exports, "bodiedExtension", () => (parcelRequire("04Oo7")).bodiedExtension);
$parcel$export($f06be630c2ad4da2$exports, "bodiedExtensionRootOnlyStage0", () => (parcelRequire("04Oo7")).bodiedExtensionRootOnlyStage0);
$parcel$export($f06be630c2ad4da2$exports, "extensionFrame", () => (parcelRequire("ixHGM")).extensionFrame);
$parcel$export($f06be630c2ad4da2$exports, "multiBodiedExtension", () => (parcelRequire("ixHGM")).multiBodiedExtension);
$parcel$export($f06be630c2ad4da2$exports, "multiBodiedExtensionRootOnlyStage0", () => (parcelRequire("ixHGM")).multiBodiedExtensionRootOnlyStage0);
$parcel$export($f06be630c2ad4da2$exports, "syncBlock", () => (parcelRequire("5Z7gB")).syncBlock);
$parcel$export($f06be630c2ad4da2$exports, "bodiedSyncBlock", () => (parcelRequire("c0Rae")).bodiedSyncBlock);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $chuMh = parcelRequire("chuMh");


var $9zObh = parcelRequire("9zObh");


var $g185T = parcelRequire("g185T");


var $1E9VS = parcelRequire("1E9VS");


var $5SlVI = parcelRequire("5SlVI");


var $9oc8s = parcelRequire("9oc8s");


var $9nUB4 = parcelRequire("9nUB4");


var $jDAs4 = parcelRequire("jDAs4");


var $ioLmC = parcelRequire("ioLmC");


var $3RygG = parcelRequire("3RygG");


var $2kGqi = parcelRequire("2kGqi");


var $ab7A2 = parcelRequire("ab7A2");


var $gMOVH = parcelRequire("gMOVH");


var $kOOm4 = parcelRequire("kOOm4");


var $234td = parcelRequire("234td");


var $jKue6 = parcelRequire("jKue6");


var $f5nzM = parcelRequire("f5nzM");


var $jVdlG = parcelRequire("jVdlG");


var $etdmL = parcelRequire("etdmL");


var $hXS29 = parcelRequire("hXS29");


var $c94QJ = parcelRequire("c94QJ");


var $2fsTz = parcelRequire("2fsTz");


var $l73oM = parcelRequire("l73oM");


var $9biYD = parcelRequire("9biYD");


var $f3bB0 = parcelRequire("f3bB0");


var $39Puj = parcelRequire("39Puj");


var $kAzEy = parcelRequire("kAzEy");


var $98Lj8 = parcelRequire("98Lj8");


var $7eTEw = parcelRequire("7eTEw");


var $9ehdj = parcelRequire("9ehdj");


var $eq809 = parcelRequire("eq809");


var $59uj0 = parcelRequire("59uj0");


var $6OV8L = parcelRequire("6OV8L");


var $6UUJT = parcelRequire("6UUJT");


var $dYkuB = parcelRequire("dYkuB");


var $azoPw = parcelRequire("azoPw");


var $egqI8 = parcelRequire("egqI8");


var $kwL1e = parcelRequire("kwL1e");


var $PYwg9 = parcelRequire("PYwg9");


var $7RQ8H = parcelRequire("7RQ8H");


var $dtmRZ = parcelRequire("dtmRZ");


var $hVgcP = parcelRequire("hVgcP");


var $20WsY = parcelRequire("20WsY");


var $04Oo7 = parcelRequire("04Oo7");


var $ixHGM = parcelRequire("ixHGM");


var $5Z7gB = parcelRequire("5Z7gB");


var $c0Rae = parcelRequire("c0Rae");



// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $539148ee7a6e9608$var$typedNodes = $f06be630c2ad4da2$exports;
const $539148ee7a6e9608$export$b1f729c6af6f2a6e = new Set(Object.keys($539148ee7a6e9608$var$typedNodes).filter((key)=>$539148ee7a6e9608$var$typedNodes[key] && $539148ee7a6e9608$var$typedNodes[key].group === 'inline'));


var $9p0BY = parcelRequire("9p0BY");




var $4XbfY = parcelRequire("4XbfY");


var $iDrrr = parcelRequire("iDrrr");


var $fqVYq = parcelRequire("fqVYq");


var $3lwj7 = parcelRequire("3lwj7");


var $3tNiJ = parcelRequire("3tNiJ");



const $e1ba910bb22b389d$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>(0, $3tNiJ.markOrder).indexOf(a.type.name) - (0, $3tNiJ.markOrder).indexOf(b.type.name));
};
const $e1ba910bb22b389d$export$fb80336a7e408cb3 = (doc, schema = (0, $4XbfY.defaultSchema), adfStage = 'final')=>{
    const node = $e1ba910bb22b389d$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $e1ba910bb22b389d$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $e1ba910bb22b389d$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $539148ee7a6e9608$export$b1f729c6af6f2a6e).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $e1ba910bb22b389d$export$fafd4f799ee68da0 = (content, schema = (0, $4XbfY.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$e1ba910bb22b389d$export$81b20b6c83a56bd(node, schema, adfStage));
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e1ba910bb22b389d$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e1ba910bb22b389d$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e1ba910bb22b389d$var$ANCHOR_LINK = /^#/;
const $e1ba910bb22b389d$var$flattenUnknownBlockTree = (node, schema = (0, $4XbfY.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(let i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($e1ba910bb22b389d$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$e1ba910bb22b389d$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $e1ba910bb22b389d$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $9p0BY.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
   * Find leaf nodes and join them. If leaf nodes' parent node is the same node
   * join with a blank space, otherwise they are children of different branches, i.e.
   * we need to join them with a hardBreak node
   */ return {
        type: 'unknownBlock',
        content: $e1ba910bb22b389d$var$flattenUnknownBlockTree(node)
    };
};
const $e1ba910bb22b389d$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $e1ba910bb22b389d$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $e1ba910bb22b389d$export$81b20b6c83a56bd = (originalNode, schema = (0, $4XbfY.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $e1ba910bb22b389d$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $e1ba910bb22b389d$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $9p0BY.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $9p0BY.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $9p0BY.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $9p0BY.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $9p0BY.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $9p0BY.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $e1ba910bb22b389d$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $e1ba910bb22b389d$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $e1ba910bb22b389d$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                const paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                const { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $e1ba910bb22b389d$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        const headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $e1ba910bb22b389d$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $jVdlG.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $2nOF5.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $2nOF5.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $2nOF5.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $2nOF5.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'blockTaskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $2nOF5.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: attrs?.localId || (0, $2nOF5.generateUuid)(),
                        width: attrs?.width || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $e1ba910bb22b389d$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
        case 'syncBlock':
            if (attrs && attrs.resourceId && (0, $fqVYq.editorExperiment)('platform_synced_block', true)) return {
                type: type,
                attrs: {
                    resourceId: attrs.resourceId,
                    localId: attrs.localId || (0, $2nOF5.generateUuid)()
                },
                marks: marks
            };
            else return $e1ba910bb22b389d$export$b9908ef75cad1e0e(node);
        case 'bodiedSyncBlock':
            if (attrs && attrs.resourceId && Array.isArray(content) && content.length > 0 && (0, $fqVYq.editorExperiment)('platform_synced_block', true)) return {
                type: type,
                attrs: {
                    resourceId: attrs.resourceId,
                    localId: attrs.localId || (0, $2nOF5.generateUuid)()
                },
                marks: marks,
                content: content
            };
            else return $e1ba910bb22b389d$export$b9908ef75cad1e0e(node);
    }
    return $e1ba910bb22b389d$export$b9908ef75cad1e0e(node);
};
const $e1ba910bb22b389d$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$e1ba910bb22b389d$var$RELATIVE_LINK.test(linkHref) && !$e1ba910bb22b389d$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $9p0BY.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ((0, $3lwj7.isSubSupType)(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $e1ba910bb22b389d$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $e1ba910bb22b389d$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};
module.exports["getMarksByOrder"] = $e1ba910bb22b389d$export$99a33ed044c278ae;
module.exports["getValidDocument"] = $e1ba910bb22b389d$export$fb80336a7e408cb3;
module.exports["getValidNode"] = $e1ba910bb22b389d$export$81b20b6c83a56bd;

});

parcelRegister("IYu9M", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $epbW8 = parcelRequire("epbW8");








var $fJCU9 = parcelRequire("fJCU9");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $lOiVq = parcelRequire("lOiVq");





var $iDrrr = parcelRequire("iDrrr");


var $kSwu1 = parcelRequire("kSwu1");


var $2Voi6 = parcelRequire("2Voi6");


var $bJeQi = parcelRequire("bJeQi");

const $a3a565b462457d70$var$markStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $epbW8.AnnotationMarkStates).ACTIVE}']`]: {
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: DSP-4147 - Annotation shadow
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
            cursor: 'pointer'
        }
    }
});
const $a3a565b462457d70$var$markStylesLayeringFix = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $epbW8.AnnotationMarkStates).ACTIVE}']`]: {
        // Only apply transparency to nested marks when parent is focused
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"] mark': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-background-color-mark &[data-has-focus="true"], &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $a3a565b462457d70$var$markStylesWithUpdatedShadow = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $epbW8.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $a3a565b462457d70$var$markStylesWithInlineComments = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $epbW8.AnnotationMarkStates).ACTIVE}']`]: {
        // was from common in AnnotationSharedCSSByState().common
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
        cursor: 'pointer',
        padding: `1px 0 ${"var(--ds-space-025, 2px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.card), &:has([data-inline-card])': {
            padding: '5px 0 3px 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.date-lozenger-container)': {
            paddingTop: "var(--ds-space-025, 2px)"
        },
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $a3a565b462457d70$var$markStylesWithCommentsPanel = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $epbW8.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&[data-is-hovered="true"]:not([data-has-focus="true"])': {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        }
    }
});
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a3a565b462457d70$var$MOBILE_USER_AGENT_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
const $a3a565b462457d70$var$isMobile = ()=>{
    return $a3a565b462457d70$var$MOBILE_USER_AGENT_REGEX.test(navigator.userAgent);
};
const $a3a565b462457d70$var$accessibilityStylesNew = /*#__PURE__*/ (0, $lOiVq.css)({
    '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    '&::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: [
            'var(--ak-renderer-annotation-startmarker)'
        ]
    },
    '&::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: [
            'var(--ak-renderer-annotation-endmarker)'
        ]
    }
});
const $a3a565b462457d70$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, isHovered: isHovered, onClick: onClick, useBlockLevel: useBlockLevel })=>{
    const intl = (0, $kSwu1.useIntl)();
    const annotationIds = (0, $cozmU.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $bJeQi.useAnnotationManagerDispatch)();
    const { currentSelectedAnnotationId: currentSelectedAnnotationId } = (0, $bJeQi.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    // after creating a new annotation, we need to set the markRef to the new mark
    const markRef = (0, $cozmU.useCallback)((node)=>{
        if (id === currentSelectedAnnotationId && node) dispatch({
            type: 'setSelectedMarkRef',
            data: {
                markRef: node
            }
        });
    }, [
        dispatch,
        id,
        currentSelectedAnnotationId
    ]);
    const onMarkClick = (0, $cozmU.useCallback)((event)=>{
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $epbW8.AnnotationMarkStates).ACTIVE) return;
        if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        if (isAnnotationManagerEnabled) // currentTarget is the right element if there are multiple overlapping annotations
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.currentTarget,
            annotationIds: annotationIds
        });
        else // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state,
        isAnnotationManagerEnabled
    ]);
    const onMarkEnter = (evt)=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- keyboard focus for mark / Enter handling
        const focusedElementTag = document.activeElement?.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus,
        'data-is-hovered': isHovered
    };
    const desktopAccessibilityAttributes = $a3a565b462457d70$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    };
    const accessibility = state !== (0, $epbW8.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', '),
        ...desktopAccessibilityAttributes
    };
    return (0, $lOiVq.jsx)(useBlockLevel ? 'div' : 'mark', {
        ref: id === currentSelectedAnnotationId ? markRef : undefined,
        id: id,
        [(0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $a3a565b462457d70$var$markStyles,
                $a3a565b462457d70$var$markStylesLayeringFix,
                (0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes') && $a3a565b462457d70$var$markStylesWithInlineComments,
                $a3a565b462457d70$var$markStylesWithCommentsPanel,
                !$a3a565b462457d70$var$isMobile() && $a3a565b462457d70$var$accessibilityStylesNew,
                $a3a565b462457d70$var$markStylesWithUpdatedShadow
            ],
            style: {
                '--ak-renderer-annotation-startmarker': `"${intl.formatMessage((0, $2Voi6.inlineCommentMessages).contentRendererInlineCommentMarkerStart)}"`,
                '--ak-renderer-annotation-endmarker': `"${intl.formatMessage((0, $2Voi6.inlineCommentMessages).contentRendererInlineCommentMarkerEnd)}"`
            }
        }
    }, children);
};



var $jnQNQ = parcelRequire("jnQNQ");


var $dYRDq = parcelRequire("dYRDq");


var $5J8wl = parcelRequire("5J8wl");


var $6RYDu = parcelRequire("6RYDu");




const $d17574c589514eb5$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
    const updateSubscriber = (0, $dYRDq.useInlineCommentSubscriberContext)();
    const states = (0, $cozmU.useContext)((0, $6RYDu.InlineCommentsStateContext));
    const { hasFocus: hasFocus, isHovered: isHovered } = (0, $5J8wl.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $cozmU.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const { dispatch: dispatch, annotationManager: annotationManager } = (0, $bJeQi.useAnnotationManagerDispatch)();
    const onClick = (0, $cozmU.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        if (annotationManager) {
            if (hasFocus) {
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return;
            }
            annotationManager.checkPreemptiveGate().then((canSelect)=>{
                if (canSelect) {
                    // if there is a draft, clear it first
                    annotationManager?.clearDraft();
                    // use setIsAnnotationSelected won't work here if there is a draft in progress
                    // so we need to use dispatch to update the state directly
                    dispatch({
                        type: 'updateAnnotation',
                        data: {
                            id: annotationIds[0],
                            selected: true
                        }
                    });
                    dispatch({
                        type: 'setSelectedMarkRef',
                        data: {
                            markRef: eventTarget
                        }
                    });
                }
            }).catch((_error)=>{
            // TODO: EDITOR-595 - An error occurred while checking the preemptive gate. We should report this error.
            });
        } else updateSubscriber.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel,
        dispatch,
        annotationManager,
        hasFocus
    ]);
    const activeParentIds = (0, $jnQNQ.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $epbW8.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a3a565b462457d70$export$4f5a51511304fdd0), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        isHovered: isHovered,
        state: states[id],
        useBlockLevel: useBlockLevel
    }, children);
};


const $2b79b4b6d19eecff$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $2b79b4b6d19eecff$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
    const data = {
        ...dataAttributes,
        ...(0, $epbW8.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return isMediaInline ? // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        id: id
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d17574c589514eb5$export$f3069f755c1eba0b), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel
    }, children);
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        id: id,
        ...data
    }, children));
};
var $2b79b4b6d19eecff$export$2e2bcd8739ae039 = $2b79b4b6d19eecff$var$AnnotationComponent;
module.exports["isAnnotationMark"] = $2b79b4b6d19eecff$export$855795c145f03402;
module.exports["default"] = $2b79b4b6d19eecff$export$2e2bcd8739ae039;

});

parcelRegister("jnQNQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6RYDu = parcelRequire("6RYDu");

const $9ed0bcfd9faf4227$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $cozmU.useContext)((0, $6RYDu.InlineCommentsStateContext));
    return (0, $cozmU.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};
module.exports["useInlineCommentsFilter"] = $9ed0bcfd9faf4227$export$8e7d47f9e38ad4f1;

});

parcelRegister("dYRDq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6RYDu = parcelRequire("6RYDu");

const $f7e1d96cb450bbfd$export$b46737175cffd396 = ()=>{
    const providers = (0, $cozmU.useContext)((0, $6RYDu.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};
module.exports["useInlineCommentSubscriberContext"] = $f7e1d96cb450bbfd$export$b46737175cffd396;

});

parcelRegister("7Glgp", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a63f77af04045b9b$export$42bb270d1224182 = (0, $kSwu1.defineMessages)({
    /**
   * Message taken from
   * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
   */ label: {
        id: "fabric.editor.codeBidiWarningLabel",
        defaultMessage: "Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code."
    }
});
module.exports["codeBidiWarningMessages"] = $a63f77af04045b9b$export$42bb270d1224182;

});

parcelRegister("g8ETs", function(module, exports) {
// This import will be stripped on build

var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");

function $3dbbd8697245ab26$export$9c2f408d391feb93(hexColor) {
    const normalizedHexColor = hexColor ? hexColor.toUpperCase() : undefined;
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return normalizedHexColor ? $3dbbd8697245ab26$export$57fa5089caad992[normalizedHexColor] : undefined;
}
const $3dbbd8697245ab26$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #357DE8)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #1558BC)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #2898BD)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #206A83)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #22A06B)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #216E4E)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FCA700)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #E06C00)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #C9372C)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #AE2E24)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #AF59E1)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #803FA5)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #7D818A)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #292A2E)",
    // source for hex code was legacy token N800
    // lime
    /** lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** lime - medium */ ['#6A9A23']: "var(--ds-icon-accent-lime, #6A9A23)",
    /** lime - strong */ ['#4C6B1F']: "var(--ds-text-accent-lime, #4C6B1F)",
    // orange
    /** orange - light */ ['#FCE4A6']: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    /** orange - medium */ ['#E06C00']: "var(--ds-icon-accent-orange, #E06C00)",
    /** orange - strong */ ['#9E4C00']: "var(--ds-text-accent-orange, #9E4C00)",
    // magenta
    /** magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** magenta - medium */ ['#CD519D']: "var(--ds-icon-accent-magenta, #CD519D)",
    /** magenta - strong */ ['#943D73']: "var(--ds-text-accent-magenta, #943D73)",
    // yellow
    /** yellow - medium */ get ['#B38600'] () {
        return (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_1') ? "var(--ds-border-accent-yellow, #B38600)" : "var(--ds-icon-accent-yellow, #B38600)";
    },
    /** yellow - strong */ ['#7F5F01']: "var(--ds-text-accent-yellow, #7F5F01)"
};
module.exports["hexToEditorTextPaletteColor"] = $3dbbd8697245ab26$export$9c2f408d391feb93;

});

parcelRegister("9Rqjc", function(module, exports) {
// This import will be stripped on build
// Color tokens defined on https://hello.atlassian.net/wiki/spaces/EOU/pages/3587733210/Text+highlighting+-+designs#Colour-palette
// values are asserted to improve generated type declarations
const $8723027d7a032ca5$export$12a518ff137dd389 = {
    /** Gray - light */ ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    /** Teal - light */ ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Yellow - light */ ['#F8E6A0']: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    /** Orange - light */ ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    /** Red - light */ ['#FFD5D2']: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    /** Magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    /** Blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    /** Green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #BAF3DB)"
};
function $8723027d7a032ca5$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $8723027d7a032ca5$export$12a518ff137dd389[hexColor.toUpperCase()];
}
module.exports["hexToEditorTextBackgroundPaletteColor"] = $8723027d7a032ca5$export$8b58ff1b36bb75e0;

});

parcelRegister("j9MAI", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $4XbfY = parcelRequire("4XbfY");


var $jTt8P = parcelRequire("jTt8P");


var $3ztIq = parcelRequire("3ztIq");

const $f63abd95ddb96e10$var$NATIVE_EMBED_EXTENSION_KEY = 'native-embed';
/**
 * Returns the set of parent node names whose content expression in the
 * supplied schema allows an `embedCard` child. Returns an empty set if the
 * schema does not declare an `embedCard` node.
 */ const $f63abd95ddb96e10$var$getEmbedCardAllowedParentTypes = (schema)=>{
    const embedCardType = schema.nodes.embedCard;
    if (!embedCardType) return new Set();
    const allowed = new Set();
    for (const nodeType of Object.values(schema.nodes))if (nodeType.contentMatch?.matchType(embedCardType)) allowed.add(nodeType.name);
    return allowed;
};
const $f63abd95ddb96e10$export$fdee1e5f1664414c = (adf, schema)=>{
    const embedCardAllowedParentTypes = $f63abd95ddb96e10$var$getEmbedCardAllowedParentTypes(schema);
    const isEmbedCardAllowedInParent = (parent)=>{
        const parentType = parent?.node?.type;
        return parentType ? embedCardAllowedParentTypes.has(parentType) : false;
    };
    let didTransform = false;
    const transformedAdf = (0, $jTt8P.traverse)(adf, {
        extension: (node, parent)=>{
            if (node.attrs?.['extensionKey'].split(':')[0] !== $f63abd95ddb96e10$var$NATIVE_EMBED_EXTENSION_KEY) return node;
            const url = node.attrs?.['parameters']?.macroParams?.url?.value;
            if (!url) {
                didTransform = true;
                return false;
            }
            didTransform = true;
            if (isEmbedCardAllowedInParent(parent)) return {
                type: 'embedCard',
                attrs: {
                    url: url,
                    layout: 'center'
                }
            };
            return {
                type: 'paragraph',
                content: [
                    {
                        type: 'inlineCard',
                        attrs: {
                            url: url
                        }
                    }
                ]
            };
        }
    });
    if (didTransform && transformedAdf) try {
        const validate = (0, $3ztIq.validator)();
        const { valid: valid } = validate(transformedAdf);
        if (!valid) // Transformed ADF is invalid – fall back to the original document
        return {
            transformedAdf: adf,
            hasValidTransform: false
        };
    } catch  {
        // Validation threw – fall back to the original document
        return {
            transformedAdf: adf,
            hasValidTransform: false
        };
    }
    return {
        transformedAdf: transformedAdf,
        hasValidTransform: didTransform
    };
};


var $hD7pG = parcelRequire("hD7pG");

var $ihHxk = parcelRequire("ihHxk");

var $bnFzS = parcelRequire("bnFzS");


var $krYZG = parcelRequire("krYZG");


var $1H5A4 = parcelRequire("1H5A4");

var $2K3wo = parcelRequire("2K3wo");


var $YvadP = parcelRequire("YvadP");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $dOBRD = parcelRequire("dOBRD");


var $cY9xy = parcelRequire("cY9xy");


var $ajhUs = parcelRequire("ajhUs");

var $7QLc6 = parcelRequire("7QLc6");







const $a412b024b310cf26$var$rendersMap = {};
const $a412b024b310cf26$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $7QLc6.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $ajhUs.getAnalyticsAppearance)(item.appearance),
                platform: (0, $cY9xy.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $cY9xy.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $a412b024b310cf26$var$schedule = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $a412b024b310cf26$var$DEFAULT_SAMPLING_RATE = 100;
const $a412b024b310cf26$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$a412b024b310cf26$var$rendersMap[appearance]) $a412b024b310cf26$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $a412b024b310cf26$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $a412b024b310cf26$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $a412b024b310cf26$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($a412b024b310cf26$var$rendersMap[appearance].size === 1) $a412b024b310cf26$var$schedule(()=>$a412b024b310cf26$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($a412b024b310cf26$var$rendersMap[appearance].size % sampleRate === 0) $a412b024b310cf26$var$rendersMap[appearance] = new Set();
};



var $lxxPS = parcelRequire("lxxPS");

const $7aa3df6f5be36cc5$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $7aa3df6f5be36cc5$var$withStopwatch = (cb)=>{
    const startTime = $7aa3df6f5be36cc5$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $7aa3df6f5be36cc5$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $7aa3df6f5be36cc5$var$_validation = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $ihHxk.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).RENDERER,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        });
        result = skipValidation ? transformedAdf || doc : (0, $2K3wo.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent, validationOverrides);
    } else result = (0, $YvadP.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    // Convert nested-table extensions into nested tables
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $bnFzS.transformNestedTablesIncomingDocument)(result);
        if (isTransformed) {
            dispatchAnalyticsEvent?.({
                action: (0, $krYZG.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).RENDERER,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent?.({
            action: (0, $krYZG.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).RENDERER,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $cY9xy.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
            }
        });
    }
    // Upgrade panel → panel_c1 where the schema allows it
    if (result && (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed, transformedNodeTypes: transformedNodeTypes } = (0, $hD7pG.transformContainerNodes)(result, schema);
        if (isTransformed && transformedAdf) {
            dispatchAnalyticsEvent?.({
                action: (0, $krYZG.ACTION).CONTAINER_NODE_TRANSFORMED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).RENDERER,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    transformedNodeTypes: transformedNodeTypes
                }
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent?.({
            action: (0, $krYZG.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).RENDERER,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $cY9xy.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform panel to panel_c1' : undefined}`
            }
        });
    }
    if (result && !(0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) && !(0, $iDrrr.fg)('platform_native_embeds_rollout_non_maui_experience') && (0, $iDrrr.fg)('platform_editor_native_embeds_fallback_transform')) {
        const { transformedAdf: transformedAdf, hasValidTransform: hasValidTransform } = (0, $f63abd95ddb96e10$export$fdee1e5f1664414c)(result, schema);
        if (hasValidTransform && transformedAdf) {
            dispatchAnalyticsEvent?.({
                action: (0, $krYZG.ACTION).NATIVE_EMBEDS_TRANSFORMED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).RENDERER,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    }
    return result;
};
const $7aa3df6f5be36cc5$var$memoValidation = (0, $dOBRD.default)($7aa3df6f5be36cc5$var$_validation, (newArgs, lastArgs)=>{
    const [newDoc, newSchema, newADFStage, newUseSpecValidator, , /* ignoring dispatchAnalyticsEvent */ newSkipValidation, newValidationOverrides] = newArgs;
    const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , /* ignoring dispatchAnalyticsEvent */ oldSkipValidation, oldValidationOverrides] = lastArgs;
    return $7aa3df6f5be36cc5$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && newSkipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7aa3df6f5be36cc5$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $7aa3df6f5be36cc5$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $7aa3df6f5be36cc5$var$memoSerializeFragment = (0, $dOBRD.default)($7aa3df6f5be36cc5$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $7aa3df6f5be36cc5$var$areDocsEqual(newDoc, oldDoc);
});
const $7aa3df6f5be36cc5$var$_createNodeAndCheck = (schema, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $krYZG.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $cY9xy.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $7aa3df6f5be36cc5$var$memoCreateNodeAndCheck = (0, $dOBRD.default)($7aa3df6f5be36cc5$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $7aa3df6f5be36cc5$var$areDocsEqual(newDoc, oldDoc);
});
const $7aa3df6f5be36cc5$export$59a54f98b9753d5c = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, serializer, schema = (0, $4XbfY.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats, skipValidation, validationOverrides)=>{
    const stat = {
        sanitizeTime: 0
    };
    if ((0, $iDrrr.fg)('platform_editor_renderer_rm_usespecbasedvalidator')) useSpecBasedValidator = true;
    const { output: validDoc, time: sanitizeTime } = $7aa3df6f5be36cc5$var$withStopwatch(()=>{
        return $7aa3df6f5be36cc5$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $7aa3df6f5be36cc5$var$withStopwatch(()=>{
        return $7aa3df6f5be36cc5$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $7aa3df6f5be36cc5$var$withStopwatch(()=>{
        return $7aa3df6f5be36cc5$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $1H5A4.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking?.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $a412b024b310cf26$export$a43de96edd8d0a0)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $lxxPS.countNodes)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};
module.exports["renderDocument"] = $7aa3df6f5be36cc5$export$59a54f98b9753d5c;

});

parcelRegister("ihHxk", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");

const $64b80b348ef15d2a$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $jTt8P.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    linkMark = mark;
                    node.marks?.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
module.exports["transformMediaLinkMarks"] = $64b80b348ef15d2a$export$6528700f3fa2fe2a;

});

parcelRegister("7QLc6", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");


var $5lKAn = parcelRequire("5lKAn");


var $gduAE = parcelRequire("gduAE");

const $1c7ecf71b0294b80$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: customThresholds?.degraded || (0, $gduAE.UNSUPPORTED_CONTENT_LEVEL_SEVERITY_THRESHOLD_DEFAULTS).DEGRADED,
        blocking: customThresholds?.blocking || (0, $gduAE.UNSUPPORTED_CONTENT_LEVEL_SEVERITY_THRESHOLD_DEFAULTS).BLOCKING
    };
};
const $1c7ecf71b0294b80$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $jTt8P.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                const originalNode = node.attrs?.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $jTt8P.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = parent.parent?.node?.type ?? 'unknown';
                        const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $1c7ecf71b0294b80$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return (0, $5lKAn.UNSUPPORTED_CONTENT_LEVEL_SEVERITY).DEGRADED;
    if (thresholds.blocking <= unsupportedContentLevelPercent) return (0, $5lKAn.UNSUPPORTED_CONTENT_LEVEL_SEVERITY).BLOCKING;
    return (0, $5lKAn.UNSUPPORTED_CONTENT_LEVEL_SEVERITY).NORMAL;
};
const $1c7ecf71b0294b80$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $1c7ecf71b0294b80$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $1c7ecf71b0294b80$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $1c7ecf71b0294b80$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};
module.exports["getUnsupportedContentLevelData"] = $1c7ecf71b0294b80$export$484b83e0462998d;

});

parcelRegister("5lKAn", function(module, exports) {
var $628c7d83b43faee2$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});
module.exports["UNSUPPORTED_CONTENT_LEVEL_SEVERITY"] = $628c7d83b43faee2$export$6632e71a22d31bf1;

});

parcelRegister("gduAE", function(module, exports) {
const $96a5a4f58a988637$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
module.exports["UNSUPPORTED_CONTENT_LEVEL_SEVERITY_THRESHOLD_DEFAULTS"] = $96a5a4f58a988637$export$f9f8a29778652c3e;

});

parcelRegister("lEb7o", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0e33fa0f52220c92$var$dest = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $0e33fa0f52220c92$export$20439b49fdd0d26c = $0e33fa0f52220c92$var$dest.Provider;
const $0e33fa0f52220c92$var$Consumer = $0e33fa0f52220c92$var$dest.Consumer;
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $0e33fa0f52220c92$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $cozmU.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e33fa0f52220c92$var$Consumer, null, (newActiveHeaderId)=>{
        if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
        else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
            setActiveHeaderId(newActiveHeaderId);
            onNestedHeaderIdMatch();
        }
        return null;
    });
};
module.exports["ActiveHeaderIdProvider"] = $0e33fa0f52220c92$export$20439b49fdd0d26c;
module.exports["ActiveHeaderIdConsumer"] = $0e33fa0f52220c92$export$cddc3c6ebe2d2cec;

});

parcelRegister("kMQcj", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $b8DpU = parcelRequire("b8DpU");

const $9ec1aaec2ac46baa$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $9ec1aaec2ac46baa$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $9ec1aaec2ac46baa$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $9ec1aaec2ac46baa$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $9ec1aaec2ac46baa$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $lOiVq.css)(">.mediaInlineView-content-wrap>.", $9ec1aaec2ac46baa$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $9ec1aaec2ac46baa$export$dd2e16f83ae6aa78, ",>.", $9ec1aaec2ac46baa$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $9ec1aaec2ac46baa$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $9ec1aaec2ac46baa$export$dee15762144889b7 = /*#__PURE__*/ (0, $lOiVq.css)(".", $9ec1aaec2ac46baa$export$dd2e16f83ae6aa78, "{height:", (0, $b8DpU.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $9ec1aaec2ac46baa$var$inlineImageHeight((0, $b8DpU.referenceHeights)['h1'], -3), ";}h2{", $9ec1aaec2ac46baa$var$inlineImageHeight((0, $b8DpU.referenceHeights)['h2'], -3), ";}h3{", $9ec1aaec2ac46baa$var$inlineImageHeight((0, $b8DpU.referenceHeights)['h3'], -2), ";}h4{", $9ec1aaec2ac46baa$var$inlineImageHeight((0, $b8DpU.referenceHeights)['h4'], -2), ";}h5{", $9ec1aaec2ac46baa$var$inlineImageHeight((0, $b8DpU.referenceHeights)['h5'], -2), ";}h6{", $9ec1aaec2ac46baa$var$inlineImageHeight((0, $b8DpU.referenceHeights)['h6'], -2), ";}");
const $9ec1aaec2ac46baa$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'inline-flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-radius-small, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$9ec1aaec2ac46baa$export$7ab34e219ce6eef}, ${(0, $b8DpU.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $9ec1aaec2ac46baa$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $lOiVq.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
    outline: 'none'
});
const $9ec1aaec2ac46baa$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $lOiVq.css)({
    borderColor: `var(${$9ec1aaec2ac46baa$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$9ec1aaec2ac46baa$export$263a8a844c370a89}, ${(0, $b8DpU.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$9ec1aaec2ac46baa$export$263a8a844c370a89}, ${(0, $b8DpU.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});
module.exports["INLINE_IMAGE_WRAPPER_CLASS_NAME"] = $9ec1aaec2ac46baa$export$dd2e16f83ae6aa78;
module.exports["INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY"] = $9ec1aaec2ac46baa$export$7ab34e219ce6eef;
module.exports["INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY"] = $9ec1aaec2ac46baa$export$263a8a844c370a89;
module.exports["INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY"] = $9ec1aaec2ac46baa$export$b0d1f1e1fb3c4b46;
module.exports["wrapperStyle"] = $9ec1aaec2ac46baa$export$c4d4f06a25de97f;
module.exports["selectedStyle"] = $9ec1aaec2ac46baa$export$a7abb1b3dc25813f;
module.exports["borderStyle"] = $9ec1aaec2ac46baa$export$4d0a7f76ad443516;

});

parcelRegister("b8DpU", function(module, exports) {
const $35bb06f9e9520b76$export$d722b7527b1834a8 = 250;
const $35bb06f9e9520b76$export$da894f7669b4e67c = 200;
const $35bb06f9e9520b76$export$286cf28b87ad4b4f = $35bb06f9e9520b76$export$d722b7527b1834a8 / $35bb06f9e9520b76$export$da894f7669b4e67c;
const $35bb06f9e9520b76$export$64fe09732fb8680 = 0;
const $35bb06f9e9520b76$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};
module.exports["DEFAULT_IMAGE_WIDTH"] = $35bb06f9e9520b76$export$d722b7527b1834a8;
module.exports["DEFAULT_IMAGE_HEIGHT"] = $35bb06f9e9520b76$export$da894f7669b4e67c;
module.exports["DEFAULT_INLINE_IMAGE_ASPECT_RATIO"] = $35bb06f9e9520b76$export$286cf28b87ad4b4f;
module.exports["DEFAULT_INLINE_IMAGE_BORDER_SIZE"] = $35bb06f9e9520b76$export$64fe09732fb8680;
module.exports["referenceHeights"] = $35bb06f9e9520b76$export$c1317a9224e4d798;

});

parcelRegister("e4nz6", function(module, exports) {
const $2d6fba7044e5634e$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
module.exports["DateSharedCssClassName"] = $2d6fba7044e5634e$export$99cdf122d0bb9f95;

});

parcelRegister("l3s1y", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");

const $b204c05058bd4af3$export$cfe6da7d522d87bb = 'rich-media-item';
const $b204c05058bd4af3$var$wrappedMediaBreakoutPoint = 410;
const $b204c05058bd4af3$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$b204c05058bd4af3$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$b204c05058bd4af3$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-right + .${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-left + .${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-right, .${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-right + .${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-left, .${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-left + .${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-left, .${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-right + .${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$b204c05058bd4af3$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
const $b204c05058bd4af3$export$b51dea84d928a378 = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$b204c05058bd4af3$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".mediaSingleView-content-wrap[layout^='wrap-']": {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        zIndex: (0, $7Y8M5.akEditorWrappedNodeZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$b204c05058bd4af3$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-right + .${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-left + .${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-right, .${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-right + .${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-left, .${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-left + .${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-left, .${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-right + .${$b204c05058bd4af3$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$b204c05058bd4af3$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
module.exports["richMediaClassName"] = $b204c05058bd4af3$export$cfe6da7d522d87bb;

});

parcelRegister("6U5OC", function(module, exports) {
// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $e68225416894930a$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
module.exports["SmartCardSharedCssClassName"] = $e68225416894930a$export$4ccd31bf665a88f6;

});

parcelRegister("HdvOc", function(module, exports) {
// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $defdcdc4f85f7edf$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    //NOTE: value is a selector (data attribute), not a class name
    TASK_LIST_CONTAINER: '[data-node-type="actionList"]',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};
module.exports["TaskDecisionSharedCssClassName"] = $defdcdc4f85f7edf$export$a7172b75d403a0e4;

});

parcelRegister("ft6gK", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");

var $an4b1 = parcelRequire("an4b1");


var $cRhiT = parcelRequire("cRhiT");


var $6Jzbk = parcelRequire("6Jzbk");


var $96p1s = parcelRequire("96p1s");

const $7f430a9bdfc4234a$var$codeBlockSharedStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED}
		> .${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        marginRight: "var(--ds-space-100, 8px)",
        code: {
            display: 'block',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap'
        }
    },
    [`.${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        display: 'flex',
        flex: 1,
        code: {
            flexGrow: 1,
            whiteSpace: 'pre'
        }
    },
    [`.${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        position: 'relative',
        backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
        borderRadius: "var(--ds-radius-small, 3px)",
        margin: `${(0, $7Y8M5.blockNodesVerticalMargin)} 0 0 0`,
        fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        minWidth: `${(0, $7Y8M5.akEditorTableCellMinWidth)}px`,
        cursor: 'pointer',
        clear: 'both',
        '--ds--code--bg-color': 'transparent',
        '.code-block-gutter-pseudo-element::before': {
            content: '"attr(data-label)"'
        },
        /* This is necessary to allow for arrow key navigation in/out of code blocks in Firefox. */ whiteSpace: 'normal',
        [`.${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_START}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            top: '0px',
            left: '0px'
        },
        [`${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_END}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            bottom: '0px',
            right: '0px'
        },
        [`.${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            display: 'flex',
            borderRadius: "var(--ds-radius-small, 3px)",
            width: '100%',
            counterReset: 'line',
            overflowX: 'auto',
            backgroundImage: 'var(--ak-renderer-codeblock-content-wrapper-bg-img)',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
            backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%`,
            backgroundPosition: `0 0,
				0 0,
				100% 0,
				100% 0,
				100% 0,
				100% 0,
				0 0,
				0 0`,
            /* Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers. */ overflowY: 'hidden'
        },
        [`.${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            position: 'relative',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            padding: "var(--ds-space-100, 8px)",
            flexShrink: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            boxSizing: 'content-box'
        },
        // This is a fix of marker of list item with code block.
        // The list item marker in Chrome is aligned by the baseline of the text,
        // that's why we need to add a text (content: "1") to the line number gutter to align
        // the list item marker with the text.
        // Without it, the list item marker will be aligned by the bottom of the code block.
        [`.${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
            content: '"1"',
            visibility: 'hidden',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem'
        },
        [`.${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
            code: {
                tabSize: 4,
                cursor: 'text',
                color: "var(--ds-text, #292A2E)",
                borderRadius: "var(--ds-radius-small, 3px)",
                margin: "var(--ds-space-100, 8px)",
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875}rem`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            }
        },
        [`.${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
            pointerEvents: 'none',
            userSelect: 'none',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            left: 0,
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            padding: `0px ${"var(--ds-space-100, 8px)"}`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem',
            textAlign: 'right',
            color: "var(--ds-text-subtlest, #6B6E76)",
            boxSizing: 'content-box'
        }
    }
});
const $7f430a9bdfc4234a$var$lightWeightCodeBlockStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    [`.${(0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        cursor: 'text'
    }
});
const $7f430a9bdfc4234a$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $7f430a9bdfc4234a$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $lOiVq.css)(".", (0, $96p1s.RendererCssClassName).DOCUMENT, ">.", $7f430a9bdfc4234a$export$afbde0e7339bed51.CONTAINER, " .", (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, $7Y8M5.blockNodesVerticalMargin), ";}");
};
const $7f430a9bdfc4234a$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, hideLineNumbers: hideLineNumbers = false, className: className }, ref)=>{
    const textRows = (0, $cozmU.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const { renderBidiWarnings: renderBidiWarnings } = (0, $6Jzbk.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const classNames = [
        $7f430a9bdfc4234a$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    const codeBlockBackgroundImage = (0, $an4b1.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $7f430a9bdfc4234a$var$codeBlockSharedStyles,
            $7f430a9bdfc4234a$var$lightWeightCodeBlockStyles
        ],
        style: {
            '--ak-renderer-codeblock-content-wrapper-bg-img': codeBlockBackgroundImage
        }
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        className: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, !hideLineNumbers && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        className: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("code", null, renderBidiWarnings(text))))));
});
var $7f430a9bdfc4234a$export$2e2bcd8739ae039 = $7f430a9bdfc4234a$var$LightWeightCodeBlock;
module.exports["LightWeightCodeBlockCssClassName"] = $7f430a9bdfc4234a$export$afbde0e7339bed51;
module.exports["default"] = $7f430a9bdfc4234a$export$2e2bcd8739ae039;

});

parcelRegister("6Jzbk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fYRS9 = parcelRequire("fYRS9");


var $7Glgp = parcelRequire("7Glgp");


var $cOjjv = parcelRequire("cOjjv");


var $ieeJu = parcelRequire("ieeJu");

const $c888306550d3e13b$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
    const intl = (0, $kSwu1.useIntl)();
    const warningLabel = intl.formatMessage((0, $7Glgp.codeBidiWarningMessages).label);
    const renderBidiWarnings = (text)=>{
        if ((0, $ieeJu.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true)) return text;
        return (0, $cOjjv.default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fYRS9.default), {
                bidiCharacter: bidiCharacter,
                key: index,
                label: warningLabel,
                tooltipEnabled: enableWarningTooltip
            }));
    };
    return {
        renderBidiWarnings: renderBidiWarnings,
        warningLabel: warningLabel
    };
};
module.exports["useBidiWarnings"] = $c888306550d3e13b$export$9fb9fe546a188c7b;

});

parcelRegister("csUNO", function(module, exports) {
const $b593ec561e95b51b$export$63adc0ebe3278d31 = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body.small': 'normal 400 0.875em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
module.exports["editorUGCTokensRefreshed"] = $b593ec561e95b51b$export$63adc0ebe3278d31;

});

parcelRegister("k8ZZN", function(module, exports) {

var $a5rDX = parcelRequire("a5rDX");

const $3131eb4f422748d2$export$ee47248f9a998789 = {
    EMOJI_CONTAINER: 'emojiView-content-wrap',
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_NODE: (0, $a5rDX.emojiNodeStyles),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_SPRITE: (0, $a5rDX.emojiSprite),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_IMAGE: (0, $a5rDX.emojiImage),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_PLACEHOLDER: (0, $a5rDX.placeholder),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_UNICODE: 'emoji-common-emoji-unicode'
};
module.exports["EmojiSharedCssClassName"] = $3131eb4f422748d2$export$ee47248f9a998789;

});

parcelRegister("95bQO", function(module, exports) {
const $7b0fd58ba01f81fb$var$prefix = 'ak-editor-sync-block';
const $7b0fd58ba01f81fb$export$84840734cffb342f = {
    prefix: $7b0fd58ba01f81fb$var$prefix,
    renderer: `${$7b0fd58ba01f81fb$var$prefix}__renderer`,
    error: `${$7b0fd58ba01f81fb$var$prefix}__error_state`,
    loading: `${$7b0fd58ba01f81fb$var$prefix}__loading_state`
};
const $7b0fd58ba01f81fb$export$8c57d8325d08218b = 'data-sync-block-renderer';
const $7b0fd58ba01f81fb$var$bodiedPrefix = 'ak-editor-bodied-sync-block';
const $7b0fd58ba01f81fb$export$628f41eb22ec9a2 = {
    prefix: $7b0fd58ba01f81fb$var$bodiedPrefix,
    renderer: `${$7b0fd58ba01f81fb$var$bodiedPrefix}__renderer`,
    content: `${$7b0fd58ba01f81fb$var$bodiedPrefix}__content`,
    selectionInside: `${$7b0fd58ba01f81fb$var$bodiedPrefix}__selection_inside`,
    // Applied by the node view when the block holds nothing but a single empty paragraph.
    // Emptiness is derived from the ProseMirror document rather than the rendered DOM, because
    // decorations (for example the selection marker's cursor widget) and ProseMirror's own
    // separator/trailing-break hack nodes are injected as children of that paragraph and make
    // DOM-shape heuristics unreliable. See EDITOR-8327.
    empty: `${$7b0fd58ba01f81fb$var$bodiedPrefix}__empty`
};
// Constant labelClassName value here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $7b0fd58ba01f81fb$var$labelClassName = 'ak-editor-sync-block__label';
const $7b0fd58ba01f81fb$export$f75b6075afbd73af = {
    labelClassName: $7b0fd58ba01f81fb$var$labelClassName
};
const $7b0fd58ba01f81fb$export$7e44804769d54f36 = 'disabled';
const $7b0fd58ba01f81fb$export$da351099a95c41a2 = 'view-mode';
const $7b0fd58ba01f81fb$export$ddb90512ea536019 = 'creation-loading';
const $7b0fd58ba01f81fb$export$52ab9fe57e8e4c2e = 'user-is-dragging';
const $7b0fd58ba01f81fb$export$9b10dd4c500e3ce8 = {
    disabledClassName: $7b0fd58ba01f81fb$export$7e44804769d54f36,
    viewModeClassName: $7b0fd58ba01f81fb$export$da351099a95c41a2,
    creationLoadingClassName: $7b0fd58ba01f81fb$export$ddb90512ea536019,
    draggingClassName: $7b0fd58ba01f81fb$export$52ab9fe57e8e4c2e
};
module.exports["SyncBlockSharedCssClassName"] = $7b0fd58ba01f81fb$export$84840734cffb342f;
module.exports["SyncBlockRendererDataAttributeName"] = $7b0fd58ba01f81fb$export$8c57d8325d08218b;
module.exports["BodiedSyncBlockSharedCssClassName"] = $7b0fd58ba01f81fb$export$628f41eb22ec9a2;
module.exports["SyncBlockLabelSharedCssClassName"] = $7b0fd58ba01f81fb$export$f75b6075afbd73af;
module.exports["SyncBlockStateCssClassName"] = $7b0fd58ba01f81fb$export$9b10dd4c500e3ce8;

});

parcelRegister("3uhT3", function(module, exports) {
/* eslint-disable jsdoc/require-jsdoc -- thin portal context helpers */ 
var $cozmU = parcelRequire("cozmU");

const $058167fc96162d3c$export$60d741e20e0aa309 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
function $058167fc96162d3c$export$b1072f43c67b540c(props) {
    const portalFromContext = (0, $cozmU.useContext)($058167fc96162d3c$export$60d741e20e0aa309);
    return props?.portal || portalFromContext;
}
module.exports["PortalContext"] = $058167fc96162d3c$export$60d741e20e0aa309;
module.exports["usePortal"] = $058167fc96162d3c$export$b1072f43c67b540c;

});

parcelRegister("iLcY8", function(module, exports) {
var $7f9d9aad03a0c25e$export$a8d23193462f2b63 = /*#__PURE__*/ function(PLATFORMS) {
    PLATFORMS["NATIVE"] = "mobileNative";
    PLATFORMS["HYBRID"] = "mobileHybrid";
    PLATFORMS["WEB"] = "web";
    return PLATFORMS;
}({});
var $7f9d9aad03a0c25e$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $7f9d9aad03a0c25e$export$57453495b81e2dde = /*#__PURE__*/ function(FULL_WIDTH_MODE) {
    FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
    FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
    return FULL_WIDTH_MODE;
}({});
var $7f9d9aad03a0c25e$export$60a219cfaef9722 = /*#__PURE__*/ function(BROWSER_FREEZE_INTERACTION_TYPE) {
    BROWSER_FREEZE_INTERACTION_TYPE["LOADING"] = "loading";
    BROWSER_FREEZE_INTERACTION_TYPE["TYPING"] = "typing";
    BROWSER_FREEZE_INTERACTION_TYPE["CLICKING"] = "clicking";
    BROWSER_FREEZE_INTERACTION_TYPE["PASTING"] = "pasting";
    return BROWSER_FREEZE_INTERACTION_TYPE;
}({});
module.exports["PLATFORMS"] = $7f9d9aad03a0c25e$export$a8d23193462f2b63;
module.exports["MODE"] = $7f9d9aad03a0c25e$export$e48589d9e4824227;
module.exports["FULL_WIDTH_MODE"] = $7f9d9aad03a0c25e$export$57453495b81e2dde;
module.exports["BROWSER_FREEZE_INTERACTION_TYPE"] = $7f9d9aad03a0c25e$export$60a219cfaef9722;

});

parcelRegister("jzpoq", function(module, exports) {
var $2b11966cc8d2c3ff$export$1627223e090990cf = /*#__PURE__*/ function(TABLE_ACTION) {
    TABLE_ACTION["DELETED"] = "deleted";
    TABLE_ACTION["CLEARED"] = "cleared";
    TABLE_ACTION["COLLAPSED"] = "collapsed";
    TABLE_ACTION["MERGED"] = "merged";
    TABLE_ACTION["SPLIT"] = "split";
    TABLE_ACTION["COLORED"] = "colored";
    TABLE_ACTION["TOGGLED_HEADER_COLUMN"] = "toggledHeaderColumn";
    TABLE_ACTION["TOGGLED_HEADER_ROW"] = "toggledHeaderRow";
    TABLE_ACTION["TOGGLED_NUMBER_COLUMN"] = "toggledNumberColumn";
    TABLE_ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    TABLE_ACTION["CUT"] = "cut";
    TABLE_ACTION["COPIED"] = "copied";
    TABLE_ACTION["ADDED_ROW"] = "addedRow";
    TABLE_ACTION["ADDED_COLUMN"] = "addedColumn";
    TABLE_ACTION["DELETED_ROW"] = "deletedRow";
    TABLE_ACTION["DELETED_COLUMN"] = "deletedColumn";
    TABLE_ACTION["SORTED_COLUMN"] = "sortedColumn";
    TABLE_ACTION["REPLACED"] = "replaced";
    TABLE_ACTION["ATTEMPTED_TABLE_WIDTH_CHANGE"] = "attemptedTableWidthChange";
    TABLE_ACTION["DISTRIBUTED_COLUMNS_WIDTHS"] = "distributedColumnsWidths";
    TABLE_ACTION["FIXED"] = "fixed";
    TABLE_ACTION["RESIZED"] = "resized";
    TABLE_ACTION["RESIZE_PERF_SAMPLING"] = "resizePerfSampling";
    TABLE_ACTION["COLUMN_RESIZED"] = "columnResized";
    TABLE_ACTION["OVERFLOW_CHANGED"] = "overflowChanged";
    TABLE_ACTION["INITIAL_OVERFLOW_CAPTURED"] = "initialOverflowCaptured";
    TABLE_ACTION["MOVED_ROW"] = "movedRow";
    TABLE_ACTION["MOVED_COLUMN"] = "movedColumn";
    TABLE_ACTION["CLONED_ROW"] = "clonedRow";
    TABLE_ACTION["CLONED_COLUMN"] = "clonedColumn";
    TABLE_ACTION["DRAG_MENU_OPENED"] = "dragMenuOpened";
    /**
   * This is a unique action that's used to track legacy table move behaviour flow of insert+copy+paste. Please use
   * the MOVED_ROW | MOVED_COLUMN actions if you want to track events which move row/cols in a single step.
   */ TABLE_ACTION["ROW_OR_COLUMN_MOVED"] = "rowOrColumnMoved";
    TABLE_ACTION["CHANGED_DISPLAY_MODE"] = "changedDisplayMode";
    TABLE_ACTION["CHANGED_ALIGNMENT"] = "changedAlignment";
    TABLE_ACTION["CHANGED_CELL_VERTICAL_ALIGNMENT"] = "changedVerticalAlignment";
    // Temporary to track usage of CONFCLOUD-78239 bug
    TABLE_ACTION["TABLE_CELL_BACKGROUND_FIXED"] = "tableCellBackgroundFixed";
    TABLE_ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    TABLE_ACTION["TABLE_EDITOR_HEIGHT_INFO"] = "tableEditorHeightInformation";
    TABLE_ACTION["TABLE_RENDERER_HEIGHT_INFO"] = "tableRendererHeightInformation";
    TABLE_ACTION["STICKY_HEADER_METHOD_TOGGLED"] = "stickyHeaderMethodToggled";
    TABLE_ACTION["FIT_TO_CONTENT_AUTO_CONVERTED"] = "fitToContentAutoConverted";
    TABLE_ACTION["FIT_TO_CONTENT_ON_DEMAND"] = "fitToContentOnDemand";
    return TABLE_ACTION;
}({});
var $2b11966cc8d2c3ff$export$6b0804bad09b61c6 = /*#__PURE__*/ function(TABLE_BREAKOUT) {
    TABLE_BREAKOUT["WIDE"] = "wide";
    TABLE_BREAKOUT["FULL_WIDTH"] = "fullWidth";
    TABLE_BREAKOUT["NORMAL"] = "normal";
    return TABLE_BREAKOUT;
}({});
var $2b11966cc8d2c3ff$export$e0b2ad636c1c8ab4 = /*#__PURE__*/ function(TABLE_OVERFLOW_CHANGE_TRIGGER) {
    TABLE_OVERFLOW_CHANGE_TRIGGER["EXTERNAL"] = "external";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ADDED_COLUMN"] = "addedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DELETED_COLUMN"] = "deletedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED_COLUMN"] = "resizedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ENABLED_NUMBERED_COLUMN"] = "enabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISABLED_NUMBERED_COLUMN"] = "disabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISTRIBUTED_COLUMNS"] = "distributedColumnsWidths";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED"] = "resizedTable";
    return TABLE_OVERFLOW_CHANGE_TRIGGER;
}({});
var $2b11966cc8d2c3ff$export$90dde066fa32cf2f = /*#__PURE__*/ function(TABLE_STATUS) {
    TABLE_STATUS["SUCCESS"] = "success";
    TABLE_STATUS["CANCELLED"] = "cancelled";
    TABLE_STATUS["INVALID"] = "invalid";
    return TABLE_STATUS;
}({});
var $2b11966cc8d2c3ff$export$a62a68f32aa71693 = /*#__PURE__*/ function(TABLE_DISPLAY_MODE) {
    TABLE_DISPLAY_MODE["FIXED"] = "fixed";
    TABLE_DISPLAY_MODE["DEFAULT"] = "default";
    TABLE_DISPLAY_MODE["INITIAL"] = "initial";
    return TABLE_DISPLAY_MODE;
}({});
var $2b11966cc8d2c3ff$export$ba2dfc055a59d951 = /*#__PURE__*/ function(CHANGE_ALIGNMENT_REASON) {
    CHANGE_ALIGNMENT_REASON["TABLE_RESIZING"] = "tableResizing";
    CHANGE_ALIGNMENT_REASON["TABLE_COLUMN_RESIZED"] = "tableColumnResized";
    CHANGE_ALIGNMENT_REASON["EDITOR_APPEARANCE_CHANGED"] = "editorAppearanceChanged";
    CHANGE_ALIGNMENT_REASON["TOOLBAR_OPTION_CHANGED"] = "toolbarOptionChanged";
    return CHANGE_ALIGNMENT_REASON;
}({});
module.exports["TABLE_ACTION"] = $2b11966cc8d2c3ff$export$1627223e090990cf;
module.exports["TABLE_OVERFLOW_CHANGE_TRIGGER"] = $2b11966cc8d2c3ff$export$e0b2ad636c1c8ab4;
module.exports["TABLE_STATUS"] = $2b11966cc8d2c3ff$export$90dde066fa32cf2f;
module.exports["TABLE_DISPLAY_MODE"] = $2b11966cc8d2c3ff$export$a62a68f32aa71693;
module.exports["CHANGE_ALIGNMENT_REASON"] = $2b11966cc8d2c3ff$export$ba2dfc055a59d951;

});

parcelRegister("l3it0", function(module, exports) {
function $f1040f3f95bbd29f$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}
module.exports["wrapWithUnsupported"] = $f1040f3f95bbd29f$export$87b732fa69cdf16e;

});

parcelRegister("kas7q", function(module, exports) {
const $c3569eacede02973$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
module.exports["shadowObserverClassNames"] = $c3569eacede02973$export$1cbe0bb16052178d;

});

parcelRegister("gPrpc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $k8PFz = parcelRequire("k8PFz");

var $bYPHE = parcelRequire("bYPHE");


var $fKJ7J = parcelRequire("fKJ7J");


var $9ECRl = parcelRequire("9ECRl");

var $dUm2W = parcelRequire("dUm2W");


var $iDrrr = parcelRequire("iDrrr");


var $acipJ = parcelRequire("acipJ");

var $5fU8Q = parcelRequire("5fU8Q");

var $f9Emz = parcelRequire("f9Emz");

var $ju7dM = parcelRequire("ju7dM");


var $7Meja = parcelRequire("7Meja");


var $7Y8M5 = parcelRequire("7Y8M5");


var $9ppjA = parcelRequire("9ppjA");


var $fqVYq = parcelRequire("fqVYq");


var $2bxao = parcelRequire("2bxao");


var $cAWpJ = parcelRequire("cAWpJ");


var $iWj7r = parcelRequire("iWj7r");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");








var $ieeJu = parcelRequire("ieeJu");




















var $kS1Yv = parcelRequire("kS1Yv");







// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $caa3e6d40a1cd6a5$var$MAX_SCALING_PERCENT = 0.3;
const $caa3e6d40a1cd6a5$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
const $caa3e6d40a1cd6a5$var$isTableColumnResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $caa3e6d40a1cd6a5$var$fixColumnWidth = ({ columnWidth: columnWidth, zeroWidthColumnsCount: zeroWidthColumnsCount, scaleDownPercent: scaleDownPercent, skipMinWidth: skipMinWidth })=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) {
        const scaled = Math.floor((1 - scaleDownPercent) * columnWidth);
        return skipMinWidth ? scaled : Math.max(scaled, (0, $k8PFz.tableCellMinWidth));
    }
    const adjusted = columnWidth - (0, $k8PFz.tableCellBorderWidth);
    if (skipMinWidth) return adjusted;
    return Math.max(adjusted, zeroWidthColumnsCount ? (0, $7Y8M5.akEditorTableLegacyCellMinWidth) : (0, $k8PFz.tableCellMinWidth));
};
const $caa3e6d40a1cd6a5$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    const numColumnScalePercent = (renderWidth - (0, $7Y8M5.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $7Y8M5.akEditorTableNumberColumnWidth));
    const diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
const $caa3e6d40a1cd6a5$export$2d9bdaa5b8cd99f0 = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
/**
 * Returns the data-column available width: total width minus the fixed number column if enabled.
 */ const $caa3e6d40a1cd6a5$var$getDataColumnWidth = (totalWidth, isNumberColumnEnabled)=>isNumberColumnEnabled ? totalWidth - (0, $7Y8M5.akEditorTableNumberColumnWidth) : totalWidth;
/**
 * Scales column widths proportionally to fit within availableWidth, matching the editor's
 * scaleTableTo(): floors each column to the nearest pixel, then redistributes any rounding
 * remainder to the first column that can absorb it without going below tableCellMinWidth.
 */ const $caa3e6d40a1cd6a5$var$scaleColumnsToWidth = (columnWidths, availableWidth)=>{
    const rawTotalWidth = columnWidths.reduce((sum, w)=>sum + w, 0);
    const scaleFactor = availableWidth / rawTotalWidth;
    const scaledWidths = columnWidths.map((colWidth)=>Math.max(Math.floor(colWidth * scaleFactor), (0, $k8PFz.tableCellMinWidth)));
    const totalScaled = scaledWidths.reduce((sum, w)=>sum + w, 0);
    const diff = availableWidth - totalScaled;
    if (diff !== 0 && Math.abs(diff) < (0, $k8PFz.tableCellMinWidth)) {
        for(let i = 0; i < scaledWidths.length; i++)if (scaledWidths[i] + diff > (0, $k8PFz.tableCellMinWidth)) {
            scaledWidths[i] += diff;
            break;
        }
    }
    return scaledWidths.map((width)=>({
            width: `${width}px`
        }));
};
/**
 * Computes column widths for tables inside sync blocks, matching the editor's scaleTableTo() exactly.
 * Returns null if not inside a sync block.
 *
 * For nested tables (isInsideOfTable=true), we use getTableContainerWidth(tableNode) as the
 * reference — the width the editor saved, which already accounts for the parent cell's available
 * space (colwidth minus tableCellPadding * 2). This matches bodiedSyncBlock where isRendererNested=false,
 * so renderScaleDownColgroup uses getTableContainerWidth(tableNode). For syncBlock the nested
 * renderer has isRendererNested=true, which incorrectly overrides tableContainerWidth with renderWidth
 * (the full container), causing overflow by 2 * tableCellPadding (16px).
 */ const $caa3e6d40a1cd6a5$var$renderSyncBlockColgroup = ({ isInsideOfSyncBlock: isInsideOfSyncBlock, isInsideOfTable: isInsideOfTable, tableNode: tableNode, columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidthProp, contextWidth: contextWidth })=>{
    if (!isInsideOfSyncBlock) return null;
    const rawTotalWidth = columnWidths.reduce((sum, w)=>sum + w, 0);
    if (isInsideOfTable) return null;
    // SSR / first client render before WidthObserver measures. Output % of original ADF
    // proportions so columns are stable — the CSS container query (100cqw) handles actual
    // scaling width. We key off renderWidthProp alone because WidthProvider initialises with
    // document.body.offsetWidth (non-zero on the client), so contextWidth > 0 even before
    // WidthObserver has measured the real container, which would skip this branch and produce
    // column widths scaled to the full viewport.
    if (renderWidthProp <= 0) {
        const fullTableWidth = isNumberColumnEnabled ? rawTotalWidth + (0, $7Y8M5.akEditorTableNumberColumnWidth) : rawTotalWidth;
        return columnWidths.map((colWidth)=>({
                width: `${colWidth / fullTableWidth * 100}%`
            }));
    }
    // contextWidth measures the sync block content area. Subtract 2 to match the editor's
    // getParentNodeWidth() border offset. Fall back to renderWidthProp for the non-CSS path.
    const effectiveRenderWidth = contextWidth > 0 ? contextWidth - 2 : renderWidthProp;
    const availableWidth = $caa3e6d40a1cd6a5$var$getDataColumnWidth(effectiveRenderWidth, isNumberColumnEnabled);
    // Only scale down if the table is actually wider than the available space.
    // If the table fits, return original widths with the same tableCellBorderWidth (2px) adjustment
    // that renderScaleDownColgroup applies via fixColumnWidth's no-scale path.
    if (availableWidth >= rawTotalWidth) return columnWidths.map((colWidth)=>({
            width: `${Math.max(colWidth - (0, $k8PFz.tableCellBorderWidth), (0, $k8PFz.tableCellMinWidth))}px`
        }));
    // Cap scaling at MAX_SCALING_PERCENT (30%), matching renderScaleDownColgroup's calcScalePercent.
    //
    // Both `availableWidth` and `rawTotalWidth` are already in data-column space (number column
    // excluded via getDataColumnWidth), so `diffPercent = 1 - availableWidth / rawTotalWidth` is
    // equivalent to calcScalePercent's `numColumnScalePercent` path when isNumberColumnEnabled,
    // and to the `noNumColumnScalePercent` path otherwise. We express the cap as a target width
    // (clampedAvailableWidth) rather than a scale-down percentage, but the result is the same:
    // columns are scaled by at most MAX_SCALING_PERCENT (30%).
    const diffPercent = 1 - availableWidth / rawTotalWidth;
    const clampedAvailableWidth = diffPercent <= $caa3e6d40a1cd6a5$var$MAX_SCALING_PERCENT ? availableWidth : Math.floor(rawTotalWidth * (1 - $caa3e6d40a1cd6a5$var$MAX_SCALING_PERCENT));
    return $caa3e6d40a1cd6a5$var$scaleColumnsToWidth(columnWidths, clampedAvailableWidth);
};
const $caa3e6d40a1cd6a5$var$renderScaleDownColgroup = (props)=>{
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer, isInsideOfSyncBlock: isInsideOfSyncBlock } = props;
    const skipMinWidth = !!(isInsideOfTable && isInsideOfSyncBlock);
    if (!columnWidths || columnWidths.every((width)=>width === 0) && (0, $iDrrr.fg)('platform_editor_numbered_column_in_include')) return [];
    const tableColumnResized = $caa3e6d40a1cd6a5$var$isTableColumnResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    // This is a fix for ED-23259
    // Some extensions (for ex: Page Properties or Excerpt) do not renderer tables directly inside themselves. They use ReactRenderer.
    // So if we add a check like isInsideExtension (similar to exising isInsideBlockNode), it will fail, and to the only way to learn
    // if the table is rendered inside another node, is to check if the Renderer itself is nested.
    const isRendererNested = isTopLevelRenderer === false;
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    // Tables with numbered columns inside of extensions cannot use the renderWidth when it is 0. In this case, it should
    // explicitly use the width coming from the table node as the final table container width.
    const tableContainerWidth = rendererAppearance === 'comment' && !tableNode?.attrs.width || isRendererNested && (!(0, $iDrrr.fg)('platform_fix_nested_num_column_scaling') || !isNumberColumnEnabled) ? renderWidth : (0, $9ppjA.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !isInsideOfTable && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $7Y8M5.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    const sumOfColumns = $caa3e6d40a1cd6a5$export$2d9bdaa5b8cd99f0(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        const calculatedTableContainerWidth = rendererAppearance === 'comment' ? sumOfColumns : tableContainerWidth;
        const scalePercentage = +((calculatedTableContainerWidth - (0, $7Y8M5.akEditorTableNumberColumnWidth)) / calculatedTableContainerWidth);
        const targetMaxWidth = calculatedTableContainerWidth - (0, $7Y8M5.akEditorTableNumberColumnWidth);
        let totalWidthAfterScale = 0;
        const newScaledTargetWidths = columnWidths.map((width)=>{
            // we need to scale each column UP, to ensure total width of table matches table container
            const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (calculatedTableContainerWidth - 1) : width;
            const newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        const diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $k8PFz.tableCellMinWidth)) {
            let updated = false;
            targetWidths = targetWidths.map((width)=>{
                if (!updated && width + diff > (0, $k8PFz.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $7Y8M5.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $7Y8M5.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && props.tableNode?.attrs.displayMode === 'fixed';
    const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $caa3e6d40a1cd6a5$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $caa3e6d40a1cd6a5$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $7Y8M5.akEditorTableLegacyCellMinWidth) ? (0, $7Y8M5.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) {
        const shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width;
        scaleDownPercent = $caa3e6d40a1cd6a5$var$calcScalePercent({
            renderWidth: renderWidth,
            tableWidth: tableWidth,
            maxScale: (0, $iDrrr.fg)('platform-ssr-table-resize') ? maxScalingPercent : shouldTable100ScaleDown ? 1 : maxScalingPercent,
            isNumberColumnEnabled: isNumberColumnEnabled
        });
    }
    if (isNumberColumnEnabled && (tableWidth < maxTableWidth || maxTableWidth === 0)) {
        const fixedColWidths = targetWidths.map((width)=>$caa3e6d40a1cd6a5$var$fixColumnWidth({
                columnWidth: width,
                zeroWidthColumnsCount: zeroWidthColumnsCount,
                scaleDownPercent: scaleDownPercent,
                skipMinWidth: skipMinWidth
            }) || cellMinWidth);
        const sumFixedColumnWidths = $caa3e6d40a1cd6a5$export$2d9bdaa5b8cd99f0(fixedColWidths);
        return fixedColWidths.map((colWidth)=>{
            const width = Math.max(colWidth, cellMinWidth);
            if (colWidth > (0, $7Y8M5.akEditorTableCellMinWidth)) // To make sure the numbered column isn't scaled, use
            // percentages for the other columns.
            // Calculate the percentage based on the sum of the fixed column widths
            return {
                width: `${width / sumFixedColumnWidths * 100}%`
            };
            else {
                // If the column is equal to or less than the minimum cell width, we need to return a fixed pixel width.
                // This is to prevent columns being scaled below the minimum cell width.
                const style = width ? {
                    width: `${width}px`
                } : {};
                return style;
            }
        });
    }
    return targetWidths.map((colWidth)=>{
        const width = $caa3e6d40a1cd6a5$var$fixColumnWidth({
            columnWidth: colWidth,
            zeroWidthColumnsCount: zeroWidthColumnsCount,
            scaleDownPercent: scaleDownPercent,
            skipMinWidth: skipMinWidth
        }) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $caa3e6d40a1cd6a5$export$89efc2d0ceeaa030 = (props)=>{
    const { isTopLevelRenderer: isTopLevelRenderer, nestedRendererType: nestedRendererType } = (0, $kS1Yv.useRendererContext)();
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    const { width: contextWidth } = (0, $cozmU.useContext)((0, $dUm2W.WidthContext));
    if (!columnWidths) return null;
    const isTableFixedColumnWidthsOptionEnabled = props.allowFixedColumnWidthOption ?? false;
    // For referenced sync blocks, nestedRendererType='syncedBlock' is set via RendererContextProvider
    // in AKRendererWrapper. ReactSerializer is a class and cannot read React context, so we detect
    // it here in the Colgroup component via useRendererContext() instead of prop-drilling.
    const isInsideOfSyncBlock = nestedRendererType === 'syncedBlock';
    // renderSyncBlockColgroup returns null when not applicable (flag off, SSR, not a sync block),
    // in which case ?? falls back to the standard renderScaleDownColgroup path.
    const colStyles = $caa3e6d40a1cd6a5$var$renderSyncBlockColgroup({
        isInsideOfSyncBlock: isInsideOfSyncBlock,
        isInsideOfTable: !!props.isInsideOfTable,
        tableNode: props.tableNode,
        columnWidths: columnWidths,
        isNumberColumnEnabled: !!isNumberColumnEnabled,
        renderWidth: props.renderWidth,
        contextWidth: contextWidth
    }) ?? $caa3e6d40a1cd6a5$var$renderScaleDownColgroup({
        ...props,
        isTopLevelRenderer: isTopLevelRenderer,
        isInsideOfSyncBlock: isInsideOfSyncBlock,
        isTableScalingEnabled: props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'max' && ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) || props.rendererAppearance === 'comment',
        isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'max' && ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)))
    });
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("colgroup", null, isNumberColumnEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("col", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            width: (0, $7Y8M5.akEditorTableNumberColumnWidth)
        },
        "data-test-id": 'num'
    }), colStyles.map((style, idx)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("col", {
            key: idx,
            style: style
        })));
};















var $cdX2q = parcelRequire("cdX2q");

const $0a7f2b7d1de6ed52$export$e217d2a535d6ae45 = ({ allowTableResizing: allowTableResizing, rendererAppearance: rendererAppearance })=>{
    return !!allowTableResizing && (rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max');
};


const $2778f0cf6bc7b31d$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfNestedRenderer: isInsideOfNestedRenderer, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing, isPresentational: isPresentational, fixTableSSRResizing: fixTableSSRResizing = false, allowFixedColumnWidthOption: allowFixedColumnWidthOption = false })=>{
    let tableWidth = tableNode ? (0, $9ppjA.getTableContainerWidth)(tableNode) : (0, $7Y8M5.akEditorDefaultLayoutWidth);
    let tableColumnWidths = columnWidths;
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !tableNode.attrs?.width) tableWidth = 'inherit';
    if (rendererAppearance === 'comment' && !allowTableResizing) // in the case we have css container stylings,
    // we don't need to calculate width here as this
    // is done via css
    {
        if (!(0, $iDrrr.fg)('platform-ssr-table-resize')) tableWidth = renderWidth;
    }
    // for columns that are evenly distributed, do not return `colgroup` since existing table containerQuery
    // scales up the columns width. This ensures columns always have 42px.
    if (rendererAppearance === 'comment') {
        if ((0, $iDrrr.fg)('platform-ssr-table-resize')) tableColumnWidths = columnWidths && (0, $caa3e6d40a1cd6a5$export$2d9bdaa5b8cd99f0)(columnWidths) ? columnWidths : undefined;
    }
    const tableLayout = tableNode?.attrs.layout;
    const tableDisplayMode = tableNode?.attrs.displayMode;
    const isContentMode = (0, $cdX2q.isTableInContentMode)({
        tableNode: tableNode,
        isSupported: (0, $0a7f2b7d1de6ed52$export$e217d2a535d6ae45)({
            allowTableResizing: allowTableResizing,
            rendererAppearance: rendererAppearance
        }),
        isTableNested: isInsideOfBlockNode || isInsideOfNestedRenderer || isInsideOfTable
    }) && (0, $ieeJu.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("table", {
        ...(0, $iDrrr.fg)('platform_renderer_isPresentational') && {
            role: isPresentational ? 'presentation' : undefined
        },
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        "data-initial-width-mode": isContentMode ? 'content' : undefined,
        ref: innerRef,
        style: {
            marginTop: fixTableSSRResizing ? '0px' : ''
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $caa3e6d40a1cd6a5$export$89efc2d0ceeaa030), {
        columnWidths: tableColumnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        isInsideOfBlockNode: isInsideOfBlockNode,
        isInsideOfTable: isInsideOfTable,
        isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
        allowTableResizing: allowTableResizing,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("tbody", null, children));
});





function $20b5ba7a9afd809d$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
            children: $20b5ba7a9afd809d$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, propsToInject);
    });
}


function $d3f92a5bc9d0e644$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d3f92a5bc9d0e644$export$3de6413b528017ca = 8;
const $d3f92a5bc9d0e644$var$modeSpecficStyles = {
    none: {
        name: "eivff4",
        styles: "display:none"
    },
    stick: {
        name: "duudsh",
        styles: "position:fixed"
    },
    'pin-bottom': {
        name: "a4hmbt",
        styles: "position:absolute"
    }
};
const $d3f92a5bc9d0e644$var$suppressExternalStickStyles = {
    name: "1hdnnda",
    styles: "&.fixed-table-div-custom-table-resizing[mode='stick']{background:var(--ds-surface, #FFFFFF);}"
};
// refactored based on fixedTableDivStaticStyles
// TODO: DSP-4123 - Quality ticket
const $d3f92a5bc9d0e644$var$fixedTableDivStaticStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    zIndex: 'var(--ak-renderer-sticky-header-zindex)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: 0,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        tr: {
            background: "var(--ds-surface, #FFFFFF)"
        }
    },
    borderTop: `${$d3f92a5bc9d0e644$export$3de6413b528017ca}px solid ${"var(--ds-surface, #FFFFFF)"}`,
    background: "var(--ds-surface-overlay, #FFFFFF)",
    boxShadow: `0 6px 4px -4px ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "div[data-expanded='false'] &": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
        top: '0px',
        height: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&.fixed-table-div-custom-table-resizing[mode='stick']": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: 'var(--ak-renderer-sticky-header-zindex)'
    }
});
const $d3f92a5bc9d0e644$var$FixedTableDiv = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
    let stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $7Y8M5.akEditorStickyHeaderZIndex);
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        css: [
            $d3f92a5bc9d0e644$var$fixedTableDivStaticStyles,
            $d3f92a5bc9d0e644$var$modeSpecficStyles?.[mode],
            (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && $d3f92a5bc9d0e644$var$suppressExternalStickStyles
        ],
        style: {
            '--ak-renderer-sticky-header-zindex': stickyHeaderZIndex,
            width: `${wrapperWidth}px`,
            top: typeof top === 'number' ? `${top}px` : undefined
        }
    }, props.children);
};
const $d3f92a5bc9d0e644$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing, fixTableSSRResizing: fixTableSSRResizing = false, allowFixedColumnWidthOption: allowFixedColumnWidthOption })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = /*#__PURE__*/ (0, $lOiVq.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = /*#__PURE__*/ (0, $lOiVq.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: styles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)($d3f92a5bc9d0e644$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: fixTableSSRResizing ? 0 : ''
        }
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $2778f0cf6bc7b31d$export$54ec01a60f47d33d), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        fixTableSSRResizing: fixTableSSRResizing,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption
    }, /**
               * @see https://product-fabric.atlassian.net/browse/ED-10235
               * We pass prop 'invisible' to our table's children nodes meaning
               * they exist inside of the 'invisible' duplicated table component that
               * enables sticky headers.
               */ (0, $20b5ba7a9afd809d$export$40e12ce8e0a76b0c)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 * @param table
 * @param defaultScrollRootId
 * @example
 */ function $d3f92a5bc9d0e644$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
    let parent = table;
    if (!parent) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
        if (!!defaultScrollRootId && parent.id === defaultScrollRootId) // If a defaultScrollRootId was specified and we reached the element with this id without finding a closer
        // scroll parent, use this element as the scroll parent
        return parent;
    }
    return null;
}
class $d3f92a5bc9d0e644$export$e97bc6692974bd0b {
    /**
   *
   * @param el
   * @param defaultScrollRootId
   * @example
   */ static fromElement(el, defaultScrollRootId) {
        return new $d3f92a5bc9d0e644$export$e97bc6692974bd0b($d3f92a5bc9d0e644$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
    }
    /**
   *
   */ get isElement() {
        return this.ref instanceof HTMLElement;
    }
    /**
   *
   */ get id() {
        if (this.ref instanceof HTMLElement) return this.ref.id;
        return '';
    }
    /**
   *
   */ get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    addEventListener(type, cb, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.addEventListener(type, cb, ...args);
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    removeEventListener(type, cb, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.removeEventListener(type, cb, ...args);
    }
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
}



const $60bc324c6dec9598$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $60bc324c6dec9598$export$ab050440a1241762 = (appearance)=>appearance === 'max';
const $60bc324c6dec9598$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $60bc324c6dec9598$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
const $60bc324c6dec9598$export$33331a99fac775a1 = (appearance)=>$60bc324c6dec9598$export$a64737a81cde10b4(appearance) || $60bc324c6dec9598$export$c0112b8340d4924b(appearance) || $60bc324c6dec9598$export$ab050440a1241762(appearance);








class $bab351e7c3fcf157$export$8c072780619cfc83 {
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        if (!this.wrapper) return;
        const scrollbarContainers = this.wrapper.parentElement?.querySelectorAll(`.${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @atlaskit/platform/valid-gate-name
        this.stickyScrollbarContainerElement = (0, $iDrrr.fg)('platform_editor_querySelector_fix_table_renderer') ? scrollbarContainers?.item(scrollbarContainers.length - 1) : this.wrapper.parentElement?.querySelector(`.${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        this.rendererScrollableElement = window.document;
        if (!this.rendererScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                if (target.classList.contains((0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.rendererScrollableElement
        });
        const bottomSentinels = this.wrapper?.parentElement?.getElementsByClassName((0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        // eslint-disable-next-line @atlaskit/platform/valid-gate-name
        this.sentinels.bottom = (0, $iDrrr.fg)('platform_editor_querySelector_fix_table_renderer') ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
        bottomSentinels?.item(bottomSentinels.length - 1) : // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.wrapper?.parentElement?.getElementsByClassName((0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)?.item(0);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.intersectionObserver.observe(el));
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0);
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
    }
    constructor(wrapper){
        this.wrapper = void 0;
        this.rendererScrollableElement = void 0;
        this.intersectionObserver = void 0;
        this.stickyScrollbarContainerElement = void 0;
        this.sentinels = {};
        this.topSentinelState = void 0;
        this.bottomSentinelState = void 0;
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.init();
    }
}





/* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop, @repo/internal/react/no-class-components */ 

















var $96p1s = parcelRequire("96p1s");




































const $7b2e3308afb44c9a$var$stickyContainerBaseStyles = {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    height: "var(--ds-space-250, 20px)",
    // MAX_BROWSER_SCROLLBAR_HEIGHT
    // Follow editor to hide by default so it does not show empty gap in SSR
    // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    display: 'block',
    width: '100%'
};
const $7b2e3308afb44c9a$var$stickyContainerAdditionalStyles = {
    visibility: 'hidden',
    overflowX: 'auto',
    position: 'sticky',
    bottom: "var(--ds-space-0, 0px)",
    zIndex: 1
};
const $7b2e3308afb44c9a$export$eec82c0a93aa66d9 = (appearance)=>(0, $60bc324c6dec9598$export$33331a99fac775a1)(appearance) || (0, $60bc324c6dec9598$export$f77d2ff45b2c53ed)(appearance);
const $7b2e3308afb44c9a$export$bdb2dadcb04aad50 = (appearance)=>(0, $60bc324c6dec9598$export$33331a99fac775a1)(appearance) && (0, $fqVYq.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $7b2e3308afb44c9a$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $7Meja.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $f9Emz.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $5fU8Q.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $7b2e3308afb44c9a$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $7b2e3308afb44c9a$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $7b2e3308afb44c9a$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $7b2e3308afb44c9a$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $7b2e3308afb44c9a$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $7b2e3308afb44c9a$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $cAWpJ.TableHeader);
    return children.every((node)=>node.type === (0, $cAWpJ.TableHeader));
};
const $7b2e3308afb44c9a$export$940095e914312886 = (node, children)=>{
    return $7b2e3308afb44c9a$export$28daf78feed5098c(children) && node && node.firstChild && !$7b2e3308afb44c9a$export$42f5658c8e0092da(node.firstChild);
};
/**
 * Fake left/right borders rendered as direct children of TABLE_CONTAINER
 * (the non-scrolling parent of the horizontally scrolling TABLE_NODE_WRAPPER).
 *
 * The visible styling for these divs lives in `tableFakeBorderStyles`
 * (`renderer/src/ui/Renderer/RendererStyleContainer.tsx`), which is itself
 * gated on `editorExperiment('platform_synced_block', true)` AND
 * `isInsideSyncBlock`.
 *
 * Shared between `renderer/src/react/nodes/table.tsx` and
 * `renderer/src/react/nodes/tableNew.tsx` so the two stay in sync.
 */ const $7b2e3308afb44c9a$var$TableFakeBorders = ({ isNumberColumnEnabled: isNumberColumnEnabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $bYPHE.TableSharedCssClassName).TABLE_LEFT_BORDER,
        "data-with-numbered-table": isNumberColumnEnabled ? 'true' : undefined,
        "data-testid": "table-left-border"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $bYPHE.TableSharedCssClassName).TABLE_RIGHT_BORDER,
        "data-with-numbered-table": isNumberColumnEnabled ? 'true' : undefined,
        "data-testid": "table-right-border"
    }));
const $7b2e3308afb44c9a$export$c8a6e9aeff774364 = ({ isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const { nestedRendererType: nestedRendererType } = (0, $kS1Yv.useRendererContext)();
    const isInsideOfRefSyncBlock = nestedRendererType === 'syncedBlock';
    if (!isInsideOfRefSyncBlock || !(0, $fqVYq.editorExperiment)('platform_synced_block', true)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b2e3308afb44c9a$var$TableFakeBorders, {
        isNumberColumnEnabled: isNumberColumnEnabled
    });
};
class $7b2e3308afb44c9a$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    /**
   * Checks if this table is inside a nested renderer (e.g. Include Page macro)
   * by looking for multiple .ak-renderer-document ancestors in the DOM.
   * The result is cached since a table's position in the DOM tree is stable after mount.
   */ isInsideNestedRenderer() {
        if (this._isInsideNestedRenderer !== null) return this._isInsideNestedRenderer;
        if (!this.containerRef) return false;
        let docAncestorCount = 0;
        let el = this.containerRef.parentElement;
        while(el){
            if (el.classList.contains((0, $96p1s.RendererCssClassName).DOCUMENT)) {
                docAncestorCount++;
                if (docAncestorCount >= 2) {
                    this._isInsideNestedRenderer = true;
                    return true;
                }
            }
            el = el.parentElement;
        }
        this._isInsideNestedRenderer = false;
        return false;
    }
    /**
   * Checks if this table is inside a table cell in the DOM. The result is cached
   * since a table's position in the DOM tree is stable after mount.
   */ isInsideTableCell() {
        if (this._isInsideTableCell !== null) return this._isInsideTableCell;
        if (!this.containerRef) return false;
        this._isInsideTableCell = Boolean(this.containerRef.closest('td, th'));
        return this._isInsideTableCell;
    }
    isInsideTableContext() {
        return Boolean(this.props.isInsideOfTable || this.isInsideTableCell());
    }
    /**
   * For tables inside nested renderers (e.g. Include Page macro), the parent
   * renderer's CSS override forces width:100%!important and left:0!important
   * which overrides the inline styles set by this component. Using
   * style.setProperty with 'important' priority on inline styles beats
   * stylesheet !important rules per the CSS cascade.
   *
   * Tables that are nested inside another table need to remain constrained by
   * their table-cell context. Do not promote their width to inline !important,
   * otherwise nested tables rendered through macros such as Excerpt Include can
   * overflow and overlap adjacent cells.
   *
   * Top-level tables in nested renderers still preserve their saved width, but
   * are capped to their containing block so wide tables do not escape constrained
   * macro bodies such as Excerpt Include panels.
   *
   * Uses lastComputedStyle (populated during render) rather than reading from
   * element.style, because React may remove properties from the DOM when their
   * values transition to undefined between renders.
   *
   * `platform_nested_table_style_override_2` fixes a follow-up regression where a
   * NON-resized table inside an Excerpt macro (not Excerpt Include) on a
   * wide/full-width page shrinks to only show its first columns in the renderer.
   * Inside a nested renderer (a macro body) a non-resized table's computed width
   * is a default layout cap (760px/1800px, or a `cqw` length for full-page
   * appearances) taken from the outer renderer's width context. That value does
   * not match the macro's own box, so promoting it to inline `!important` makes
   * the table collapse. Such tables have no author-chosen size to preserve, so
   * under this gate we re-assert the parent stylesheet's intent (fill the box:
   * `width: 100%; left: 0`) with inline `!important`.
   *
   * Explicitly resized tables (`tableNode.attrs.width` set) are excluded and keep
   * the original PGXT-10226 behavior: their author-chosen width/left is promoted
   * verbatim so the Include Page macro does not stretch or indent them. The
   * table-cell short-circuit (PGXT-10294) above also still applies.
   */ applyNestedRendererTableFix() {
        if (!this.containerRef || !(0, $iDrrr.fg)('platform_nested_table_style_override')) return;
        if (!this.isInsideNestedRenderer() || this.isInsideTableContext()) return;
        const { width: width, left: left, marginLeft: marginLeft } = this.lastComputedStyle;
        const style = this.containerRef.style;
        // A table is "explicitly resized" when the author set a width on the node.
        // Non-resized tables instead take a default layout cap (e.g. 760px/1800px)
        // derived from the outer renderer's appearance.
        const isExplicitlyResized = Boolean(this.props.tableNode?.attrs.width);
        if (!isExplicitlyResized && (0, $iDrrr.fg)('platform_nested_table_style_override_2')) {
            // PGXT-10421: For a NON-resized table inside a nested renderer (e.g. an
            // Excerpt macro body), the computed width is a default layout cap
            // (760px/1800px, or a `cqw` length for full-page appearances) taken from
            // the *outer* renderer's width context. That value does not match the
            // macro's own box, so promoting it to inline `!important` makes the table
            // ignore the available space and collapse to its first columns.
            //
            // These tables have no author-chosen size to preserve, so re-assert the
            // parent stylesheet's intent — fill the available box (`width: 100%`) —
            // with inline `!important` priority so it survives React re-renders and
            // wins over the stylesheet rule that leaks into nested renderers.
            style.setProperty('width', '100%', 'important');
            style.setProperty('max-width', '100%', 'important');
            style.setProperty('left', '0', 'important');
            style.setProperty('margin-left', '0', 'important');
            return;
        }
        // PGXT-10226: An explicitly resized table inside a nested renderer (e.g.
        // Include Page macro) must keep its author-chosen width and position. The
        // parent stylesheet forces `width: 100% !important; left: 0 !important`,
        // which would stretch and indent it, so we promote the component's own
        // computed width/left with inline `!important` to win the cascade.
        style.setProperty('width', width || 'auto', 'important');
        style.setProperty('max-width', '100%', 'important');
        style.setProperty('left', left || 'auto', 'important');
        style.setProperty('margin-left', marginLeft || '0', 'important');
    }
    /**
   * Starts observing table dimensions and wires sticky header/scrollbar behavior after mount.
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $d3f92a5bc9d0e644$export$e97bc6692974bd0b).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $7b2e3308afb44c9a$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $bab351e7c3fcf157$export$8c072780619cfc83)(this.wrapperRef.current);
        this.applyNestedRendererTableFix();
    }
    /**
   * Updates sticky header wiring and scroll synchronization after prop or state changes.
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $d3f92a5bc9d0e644$export$e97bc6692974bd0b).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
        // React re-applies the style prop on every render, which overwrites the
        // !important priorities set at mount time. Re-apply after each update.
        this.applyNestedRendererTableFix();
    }
    /**
   * Calculates the top offset used when the sticky header is pinned to the table bottom.
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $k8PFz.tableMarginTop) - (0, $d3f92a5bc9d0e644$export$3de6413b528017ca);
    }
    /**
   * Determines whether sticky header positioning should include the default scroll root offset.
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   * Resolves the top position for the sticky header based on the current sticky mode.
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   * Renders the table container, sticky header, table content, sticky scrollbar, and synced block borders.
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfNestedRenderer: isInsideOfNestedRenderer, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational, allowFixedColumnWidthOption: allowFixedColumnWidthOption } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $7Y8M5.akEditorDefaultLayoutWidth);
        let updatedLayout;
        const fullPageRendererWidthCSS = (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : `100cqw - ${0, $2bxao.FullPagePadding}px * 2`;
        const renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'max' && !tableNode?.attrs.width && ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) return `min(${0, $7Y8M5.akEditorMaxWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return `min(${0, $7Y8M5.akEditorFullWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) return renderWidthCSS;
            else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $9ppjA.getTableContainerWidth)(tableNode);
                return `min(${tableContainerWidth}px, ${renderWidthCSS})`;
            }
        };
        const tableWidthCSS = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLengthCSS = `min(${(0, $7Y8M5.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const maxWidthLineLengthCSS = `min(${(0, $7Y8M5.akEditorMaxWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $60bc324c6dec9598$export$f77d2ff45b2c53ed)(rendererAppearance) && allowTableAlignment;
        const lineLengthCSS = (0, $60bc324c6dec9598$export$c0112b8340d4924b)(rendererAppearance) ? fullWidthLineLengthCSS : (0, $60bc324c6dec9598$export$ab050440a1241762)(rendererAppearance) && ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) ? maxWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        const tableWidthNew = (0, $9ppjA.getTableContainerWidth)(tableNode);
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $60bc324c6dec9598$export$a64737a81cde10b4)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $60bc324c6dec9598$export$c0112b8340d4924b)(rendererAppearance) || (0, $60bc324c6dec9598$export$ab050440a1241762)(rendererAppearance) && ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        if (!shouldCalculateLeftForAlignment && (0, $60bc324c6dec9598$export$a64737a81cde10b4)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
        // When the screen is super wide we want table to break out.
        // However if screen is smaller than 760px. We want table align to left.
        leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if (rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max' && ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $7Y8M5.akEditorDefaultLayoutWidth) ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? `calc(${tableWidthCSS})` : 'inherit';
        const isContentModeTable = (0, $cdX2q.isTableInContentMode)({
            tableNode: tableNode,
            isSupported: (0, $0a7f2b7d1de6ed52$export$e217d2a535d6ae45)({
                allowTableResizing: allowTableResizing,
                rendererAppearance: rendererAppearance
            }),
            isTableNested: isInsideOfBlockNode || isInsideOfNestedRenderer || isInsideOfTable
        }) && (0, $ieeJu.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true);
        const style = {
            ...isContentModeTable && {
                '--renderer-table-max-width': renderWidthCSS
            },
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        // Store computed style values for applyNestedRendererTableFix() to use.
        // Reading from props rather than the DOM ensures correctness when React
        // removes properties (transitions from set to undefined) between renders.
        this.lastComputedStyle = {
            width: typeof style.width === 'number' ? `${style.width}px` : style.width,
            left: style.left,
            marginLeft: style.marginLeft
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
            "data-layout": updatedLayout,
            "data-testid": "table-container",
            ref: this.setContainerRef,
            style: style
        }, $7b2e3308afb44c9a$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
            "data-testid": "sticky-scrollbar-sentinel-top"
        }), stickyHeaders && tableNode && !isContentModeTable && $7b2e3308afb44c9a$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d3f92a5bc9d0e644$export$fd9654fc359d55a3), {
            isNumberColumnEnabled: isNumberColumnEnabled,
            tableWidth: "inherit",
            renderWidth: 0,
            layout: layout,
            handleRef: this.props.handleRef,
            shadowClassNames: this.props.shadowClassNames,
            top: this.stickyTop,
            mode: stickyMode,
            innerRef: this.stickyWrapperRef,
            wrapperWidth: this.state.wrapperWidth,
            columnWidths: columnWidths,
            rowHeight: this.state.headerRowHeight,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            allowTableResizing: allowTableResizing,
            fixTableSSRResizing: true,
            allowFixedColumnWidthOption: allowFixedColumnWidthOption
        }, [
            children && children[0]
        ]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER,
            ref: this.wrapperRef,
            "data-number-column": tableNode?.attrs.isNumberColumnEnabled,
            "data-layout": tableNode?.attrs.layout,
            "data-autosize": tableNode?.attrs.__autoSize,
            "data-table-local-id": tableNode?.attrs.localId,
            "data-table-width": tableNode?.attrs.width,
            "data-vc": "table-node-wrapper",
            onScroll: this.props.stickyHeaders && this.onWrapperScrolled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2778f0cf6bc7b31d$export$54ec01a60f47d33d), {
            innerRef: this.tableRef,
            columnWidths: columnWidths,
            layout: layout,
            renderWidth: 0,
            isNumberColumnEnabled: isNumberColumnEnabled,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfNestedRenderer: isInsideOfNestedRenderer,
            isInsideOfTable: isInsideOfTable,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
            allowTableResizing: allowTableResizing,
            isPresentational: isPresentational,
            allowFixedColumnWidthOption: allowFixedColumnWidthOption
        }, this.grabFirstRowRef(children))), $7b2e3308afb44c9a$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}${(0, $iDrrr.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '-view-page' : ''}`,
            ref: this.stickyScrollbarRef,
            "data-vc": "table-sticky-scrollbar-container",
            style: (0, $iDrrr.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? {
                ...$7b2e3308afb44c9a$var$stickyContainerBaseStyles,
                ...$7b2e3308afb44c9a$var$stickyContainerAdditionalStyles
            } : $7b2e3308afb44c9a$var$stickyContainerBaseStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                width: (0, $iDrrr.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '100%' : this.tableRef.current?.clientWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%'
            }
        })), $7b2e3308afb44c9a$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
            "data-testid": "sticky-scrollbar-sentinel-bottom"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b2e3308afb44c9a$export$c8a6e9aeff774364, {
            isNumberColumnEnabled: isNumberColumnEnabled
        })));
    }
    constructor(...args){
        super(...args);
        this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        };
        this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.stickyScrollbar = void 0;
        this.nextFrame = void 0;
        this.overflowParent = null;
        this.updatedLayout = 'custom';
        this.containerRef = null;
        this._isInsideNestedRenderer = null;
        this._isInsideTableCell = null;
        // Stores the last computed style values from render() for use by applyNestedRendererTableFix().
        // This avoids reading from the DOM which can be stale when React removes properties between renders.
        this.lastComputedStyle = {};
        this.resizeObserver = null;
        this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        };
        /**
     * Callback ref that captures the container DOM element and also forwards
     * to the handleRef prop from the overflow shadow HOC.
     */ this.setContainerRef = (el)=>{
            if (this.containerRef !== el) {
                this._isInsideNestedRenderer = null;
                this._isInsideTableCell = null;
            }
            this.containerRef = el;
            const { handleRef: handleRef } = this.props;
            if (typeof handleRef === 'function') handleRef(el);
            else if (handleRef && typeof handleRef === 'object') // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            handleRef.current = el;
        };
        this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        };
        this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        };
        this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $d3f92a5bc9d0e644$export$3de6413b528017ca);
            const tableTop = $7b2e3308afb44c9a$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $7b2e3308afb44c9a$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $7b2e3308afb44c9a$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        };
        this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        };
        this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        };
        this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
const $7b2e3308afb44c9a$var$getCellEdgePropsByCellOffset = (tableNode, isNumberColumnEnabled)=>{
    const cellEdgePropsByCellOffset = new Map();
    const cellRightByCellOffset = new Map();
    const occupiedGrid = [];
    let tableWidth = 0;
    let cellOffset = 0;
    tableNode.forEach((rowNode, _rowOffset, rowIndex)=>{
        occupiedGrid[rowIndex] = occupiedGrid[rowIndex] ?? [];
        let columnIndex = 0;
        cellOffset += 1;
        rowNode.forEach((cellNode)=>{
            while(occupiedGrid[rowIndex][columnIndex])columnIndex += 1;
            const colspan = cellNode.attrs.colspan || 1;
            const rowspan = cellNode.attrs.rowspan || 1;
            const cellLeft = columnIndex;
            const cellRight = cellLeft + colspan;
            const cellTop = rowIndex;
            const cellBottom = cellTop + rowspan;
            for(let row = cellTop; row < cellBottom; row += 1){
                occupiedGrid[row] = occupiedGrid[row] ?? [];
                for(let column = cellLeft; column < cellRight; column += 1)occupiedGrid[row][column] = true;
            }
            tableWidth = Math.max(tableWidth, cellRight);
            cellRightByCellOffset.set(cellOffset, cellRight);
            cellEdgePropsByCellOffset.set(cellOffset, {
                reachesBottom: cellBottom >= tableNode.childCount,
                // With number column enabled, PM column 0 is not visually leftmost and must not get `data-reaches-left`.
                reachesLeft: cellLeft === 0 && !isNumberColumnEnabled,
                reachesRight: false,
                reachesTop: cellTop === 0
            });
            columnIndex = cellRight;
            cellOffset += cellNode.nodeSize;
        });
        cellOffset += 1;
    });
    cellRightByCellOffset.forEach((cellRight, currentCellOffset)=>{
        const edgeProps = cellEdgePropsByCellOffset.get(currentCellOffset);
        if (edgeProps) edgeProps.reachesRight = cellRight >= tableWidth;
    });
    return cellEdgePropsByCellOffset;
};
const $7b2e3308afb44c9a$var$isRenderedTableCell = (element)=>{
    const { nodeType: nodeType } = element.props;
    return nodeType === 'tableCell' || nodeType === 'tableHeader' || element.type === (0, $cAWpJ.TableCell) || element.type === (0, $cAWpJ.TableHeader);
};
const $7b2e3308afb44c9a$var$addTableCellEdgePropsThroughWrappers = (rows, tableNode, isNumberColumnEnabled)=>{
    try {
        if (!tableNode) return rows;
        const cellEdgePropsByCellOffset = $7b2e3308afb44c9a$var$getCellEdgePropsByCellOffset(tableNode, isNumberColumnEnabled);
        let cellOffset = 0;
        return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(rows, (row, rowIndex)=>{
            const rowNode = tableNode.child(rowIndex);
            cellOffset += 1;
            let cellIndex = 0;
            const addEdgePropsToRenderedCells = (element)=>{
                if ($7b2e3308afb44c9a$var$isRenderedTableCell(element)) {
                    const cellNode = rowNode.child(cellIndex);
                    const edgeProps = cellEdgePropsByCellOffset.get(cellOffset);
                    cellIndex += 1;
                    cellOffset += cellNode.nodeSize;
                    return edgeProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(element, edgeProps) : element;
                }
                const { children: children } = element.props;
                if (children === undefined) return element;
                const childrenWithEdgeProps = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child) ? addEdgePropsToRenderedCells(child) : child);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(element, undefined, childrenWithEdgeProps);
            };
            const rowWithEdgeProps = addEdgePropsToRenderedCells(row);
            if (cellIndex !== rowNode.childCount) throw new Error('Rendered table row does not match its document node');
            cellOffset += 1;
            return rowWithEdgeProps;
        });
    } catch  {
        // Renderer can receive malformed historical ADF. If the table shape cannot
        // be described safely, keep rendering without rounded edge metadata.
        return rows;
    }
};
const $7b2e3308afb44c9a$var$addTableCellEdgeProps = (rows, tableNode, isNumberColumnEnabled)=>{
    try {
        if (!tableNode) return rows;
        const cellEdgePropsByCellOffset = $7b2e3308afb44c9a$var$getCellEdgePropsByCellOffset(tableNode, isNumberColumnEnabled);
        let cellOffset = 0;
        return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(rows, (row, rowIndex)=>{
            const rowNode = tableNode.child(rowIndex);
            cellOffset += 1;
            let cellIndex = 0;
            const rowChildren = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(row.props.children, (child)=>{
                if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) return child;
                const cellNode = rowNode.child(cellIndex);
                const edgeProps = cellEdgePropsByCellOffset.get(cellOffset);
                cellIndex += 1;
                cellOffset += cellNode.nodeSize;
                return edgeProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, edgeProps) : child;
            });
            cellOffset += 1;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(row, undefined, rowChildren);
        });
    } catch  {
        // Renderer can receive malformed historical ADF. If the table shape cannot
        // be described safely, keep rendering without rounded edge metadata.
        return rows;
    }
};
class $7b2e3308afb44c9a$export$827f89182557f335 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    /**
   * Renders processed table children inside the table container.
   *
   * @example
   */ render() {
        const { allowColumnSorting: allowColumnSorting, allowFixedColumnWidthOption: allowFixedColumnWidthOption, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, children: children, columnWidths: columnWidths, disableTableOverflowShadow: disableTableOverflowShadow, handleRef: handleRef, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfNestedRenderer: isInsideOfNestedRenderer, isInsideOfTable: isInsideOfTable, isNumberColumnEnabled: isNumberColumnEnabled, isPresentational: isPresentational, layout: layout, rendererAppearance: rendererAppearance, renderWidth: renderWidth, shadowClassNames: shadowClassNames, smartCardStorage: smartCardStorage, stickyHeaders: stickyHeaders, tabIndex: tabIndex, tableNode: tableNode } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children);
        const childrenWithTableEdgeProps = (0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? (0, $ieeJu.expValEquals)('platform_editor_table_q4_patch_5', 'isEnabled', true) ? $7b2e3308afb44c9a$var$addTableCellEdgePropsThroughWrappers(childrenArray, tableNode, isNumberColumnEnabled) : $7b2e3308afb44c9a$var$addTableCellEdgeProps(childrenArray, tableNode, isNumberColumnEnabled) : childrenArray;
        const orderedChildren = (0, $acipJ.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenWithTableEdgeProps);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b2e3308afb44c9a$export$f2c3aea42b2a048f, {
            allowColumnSorting: allowColumnSorting,
            allowFixedColumnWidthOption: allowFixedColumnWidthOption,
            allowTableAlignment: allowTableAlignment,
            allowTableResizing: allowTableResizing,
            columnWidths: columnWidths,
            disableTableOverflowShadow: disableTableOverflowShadow,
            handleRef: handleRef,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfNestedRenderer: isInsideOfNestedRenderer,
            isInsideOfTable: isInsideOfTable,
            isNumberColumnEnabled: isNumberColumnEnabled,
            isPresentational: isPresentational,
            layout: layout,
            rendererAppearance: rendererAppearance,
            renderWidth: renderWidth,
            shadowClassNames: shadowClassNames,
            smartCardStorage: smartCardStorage,
            stickyHeaders: stickyHeaders,
            tabIndex: tabIndex,
            tableNode: tableNode
        }, orderedChildren);
    }
    constructor(...args){
        super(...args);
        this.state = {
            tableOrderStatus: undefined
        };
        // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $7b2e3308afb44c9a$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $ju7dM.hasMergedCell)(tableNode)) return $7b2e3308afb44c9a$export$100baa0f10804e6e($7b2e3308afb44c9a$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        };
        this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $7b2e3308afb44c9a$export$28daf78feed5098c(rows);
            const lastRowIndex = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(rows) - 1;
            return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1,
                    isFirstRow: index === 0,
                    isLastRow: index === lastRowIndex
                });
            });
        };
    }
}









const $c370578c5f28b166$export$eec82c0a93aa66d9 = (appearance)=>(0, $60bc324c6dec9598$export$33331a99fac775a1)(appearance) || (0, $60bc324c6dec9598$export$f77d2ff45b2c53ed)(appearance);
const $c370578c5f28b166$export$bdb2dadcb04aad50 = (appearance)=>(0, $60bc324c6dec9598$export$33331a99fac775a1)(appearance) && (0, $fqVYq.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $c370578c5f28b166$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $7Meja.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $f9Emz.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $5fU8Q.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $c370578c5f28b166$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $c370578c5f28b166$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $c370578c5f28b166$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $c370578c5f28b166$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $c370578c5f28b166$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $c370578c5f28b166$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $cAWpJ.TableHeader);
    return children.every((node)=>node.type === (0, $cAWpJ.TableHeader));
};
/**
 * This TableWrapper component was created to make sure that the aria-label can be
 * internationalized without needing to add `intl` to the TableContainer.
 *
 * <TableWrapper wrapperRef={ref} onScroll={handleScroll} stickyHeaders={config}>
 *   <Table>...</Table>
 * </TableWrapper>
 */ const $c370578c5f28b166$var$TableWrapper = ({ children: children, wrapperRef: wrapperRef, onScroll: onScroll, stickyHeaders: stickyHeaders, tabIndex: tabIndex })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isScrollableRegion = tabIndex !== undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER,
        ref: wrapperRef,
        onScroll: stickyHeaders ? onScroll : undefined,
        // Adding tabIndex here because this is a scrollable container and it needs to be focusable so keyboard users can scroll it.
        // eslint-disable-next-line @atlassian/a11y/no-noninteractive-tabindex
        tabIndex: tabIndex,
        role: isScrollableRegion ? 'region' : undefined,
        "aria-label": isScrollableRegion ? formatMessage((0, $fKJ7J.messages).tableScrollRegion) : undefined
    }, children);
};
const $c370578c5f28b166$export$940095e914312886 = (node, children)=>{
    return $c370578c5f28b166$export$28daf78feed5098c(children) && node && node.firstChild && !$c370578c5f28b166$export$42f5658c8e0092da(node.firstChild);
};
class $c370578c5f28b166$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $d3f92a5bc9d0e644$export$e97bc6692974bd0b).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $c370578c5f28b166$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $bab351e7c3fcf157$export$8c072780619cfc83)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $d3f92a5bc9d0e644$export$e97bc6692974bd0b).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $k8PFz.tableMarginTop) - (0, $d3f92a5bc9d0e644$export$3de6413b528017ca);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfNestedRenderer: isInsideOfNestedRenderer, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational, allowFixedColumnWidthOption: allowFixedColumnWidthOption } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $7Y8M5.akEditorDefaultLayoutWidth);
        let left;
        let updatedLayout;
        // The tableWidth and left offset logic below must stay aligned with the `breakout-ssr.tsx` logic
        // Please consider changes below carefully to not negatively impact SSR
        // `renderWidth` cannot be depended on during SSR
        const isRenderWidthValid = !!renderWidth && renderWidth > 0;
        const fullPageRendererWidthCSS = (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : `100cqw - ${0, $2bxao.FullPagePadding}px * 2`;
        const renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return [
                isRenderWidthValid ? Math.min((0, $7Y8M5.akEditorFullWidthLayoutWidth), renderWidth) : (0, $7Y8M5.akEditorFullWidthLayoutWidth),
                `min(${(0, $7Y8M5.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'max' && !tableNode?.attrs.width) return [
                isRenderWidthValid ? Math.min((0, $7Y8M5.akEditorMaxWidthLayoutWidth), renderWidth) : (0, $7Y8M5.akEditorMaxWidthLayoutWidth),
                `min(${(0, $7Y8M5.akEditorMaxWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) {
                const tableContainerWidth = (0, $9ppjA.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? renderWidth : tableContainerWidth,
                    renderWidthCSS
                ];
            } else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $9ppjA.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth,
                    `min(${tableContainerWidth}px, ${renderWidthCSS})`
                ];
            }
        };
        const [tableWidth, tableWidthCSS] = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLength = isRenderWidthValid ? Math.min((0, $7Y8M5.akEditorFullWidthLayoutWidth), renderWidth) : (0, $7Y8M5.akEditorFullWidthLayoutWidth);
        const fullWidthLineLengthCSS = `min(${(0, $7Y8M5.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const maxWidthLineLength = isRenderWidthValid ? Math.min((0, $7Y8M5.akEditorMaxWidthLayoutWidth), renderWidth) : (0, $7Y8M5.akEditorMaxWidthLayoutWidth);
        const maxWidthLineLengthCSS = `min(${(0, $7Y8M5.akEditorMaxWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $60bc324c6dec9598$export$f77d2ff45b2c53ed)(rendererAppearance) && allowTableAlignment;
        const lineLength = (0, $60bc324c6dec9598$export$c0112b8340d4924b)(rendererAppearance) ? fullWidthLineLength : (0, $60bc324c6dec9598$export$ab050440a1241762)(rendererAppearance) && ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) ? maxWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
        const lineLengthCSS = (0, $60bc324c6dec9598$export$c0112b8340d4924b)(rendererAppearance) ? fullWidthLineLengthCSS : (0, $60bc324c6dec9598$export$ab050440a1241762)(rendererAppearance) && ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) ? maxWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        // Setting fixTableSSRResizing to false while FG logic is true in tableNew
        const fixTableSSRResizing = false;
        const tableWidthNew = fixTableSSRResizing ? (0, $9ppjA.getTableContainerWidth)(tableNode) : tableWidth;
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $60bc324c6dec9598$export$a64737a81cde10b4)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $60bc324c6dec9598$export$c0112b8340d4924b)(rendererAppearance) || ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && (0, $60bc324c6dec9598$export$ab050440a1241762)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) {
            left = (tableWidth - lineLength) / 2;
            leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        }
        if (fixTableSSRResizing) {
            if (!shouldCalculateLeftForAlignment && (0, $60bc324c6dec9598$export$a64737a81cde10b4)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
            // When the screen is super wide we want table to break out.
            // However if screen is smaller than 760px. We want table align to left.
            leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        } else if (!shouldCalculateLeftForAlignment && (0, $60bc324c6dec9598$export$a64737a81cde10b4)(rendererAppearance) && tableWidthNew > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if ((rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max') && fixTableSSRResizing) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $7Y8M5.akEditorDefaultLayoutWidth) ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        const isContentModeTable = (0, $cdX2q.isTableInContentMode)({
            tableNode: tableNode,
            isSupported: (0, $0a7f2b7d1de6ed52$export$e217d2a535d6ae45)({
                allowTableResizing: allowTableResizing,
                rendererAppearance: rendererAppearance
            }),
            isTableNested: isInsideOfBlockNode || isInsideOfNestedRenderer || isInsideOfTable
        }) && (0, $ieeJu.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true);
        let style;
        if (fixTableSSRResizing) style = {
            ...isContentModeTable && {
                '--renderer-table-max-width': renderWidthCSS
            },
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        else style = {
            ...isContentModeTable && {
                '--renderer-table-max-width': `${renderWidth}px`
            },
            width: finalTableContainerWidth,
            left: left,
            marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
            "data-layout": updatedLayout,
            ref: this.props.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style
        }, $c370578c5f28b166$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
            "data-testid": "sticky-scrollbar-sentinel-top"
        }), stickyHeaders && $c370578c5f28b166$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d3f92a5bc9d0e644$export$fd9654fc359d55a3), {
            isNumberColumnEnabled: isNumberColumnEnabled,
            tableWidth: tableWidth,
            layout: layout,
            renderWidth: renderWidth,
            handleRef: this.props.handleRef,
            shadowClassNames: this.props.shadowClassNames,
            top: this.stickyTop,
            mode: stickyMode,
            innerRef: this.stickyWrapperRef,
            wrapperWidth: this.state.wrapperWidth,
            columnWidths: columnWidths,
            rowHeight: this.state.headerRowHeight,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            allowTableResizing: allowTableResizing,
            allowFixedColumnWidthOption: allowFixedColumnWidthOption
        }, [
            children && children[0]
        ]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c370578c5f28b166$var$TableWrapper, {
            wrapperRef: this.wrapperRef,
            onScroll: this.props.stickyHeaders ? this.onWrapperScrolled : undefined,
            stickyHeaders: stickyHeaders,
            tabIndex: this.props.tabIndex
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2778f0cf6bc7b31d$export$54ec01a60f47d33d), {
            innerRef: this.tableRef,
            columnWidths: columnWidths,
            layout: layout,
            isNumberColumnEnabled: isNumberColumnEnabled,
            renderWidth: renderWidth,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfNestedRenderer: isInsideOfNestedRenderer,
            isInsideOfTable: isInsideOfTable,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
            allowTableResizing: allowTableResizing,
            isPresentational: isPresentational,
            allowFixedColumnWidthOption: allowFixedColumnWidthOption
        }, this.grabFirstRowRef(children))), $c370578c5f28b166$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
            ref: this.stickyScrollbarRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: "var(--ds-space-250, 20px)",
                // MAX_BROWSER_SCROLLBAR_HEIGHT
                // Follow editor to hide by default so it does not show empty gap in SSR
                // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: fixTableSSRResizing ? 'none' : 'block',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                width: '100%'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                width: this.tableRef.current?.clientWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%'
            }
        })), $c370578c5f28b166$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $bYPHE.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
            "data-testid": "sticky-scrollbar-sentinel-bottom"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7b2e3308afb44c9a$export$c8a6e9aeff774364), {
            isNumberColumnEnabled: isNumberColumnEnabled
        })));
    }
    constructor(...args){
        super(...args);
        this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        };
        this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
        this.stickyScrollbar = void 0;
        this.nextFrame = void 0;
        this.overflowParent = null;
        this.resizeObserver = null;
        this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        };
        this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        };
        this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        };
        this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $d3f92a5bc9d0e644$export$3de6413b528017ca);
            const tableTop = $c370578c5f28b166$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $c370578c5f28b166$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $c370578c5f28b166$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        };
        this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        };
        this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        };
        this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $c370578c5f28b166$export$91e0997fd3f75d56 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children);
        const orderedChildren = (0, $acipJ.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c370578c5f28b166$export$f2c3aea42b2a048f, this.props, orderedChildren);
    }
    constructor(...args){
        super(...args);
        this.state = {
            tableOrderStatus: undefined
        };
        // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $c370578c5f28b166$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $ju7dM.hasMergedCell)(tableNode)) return $c370578c5f28b166$export$100baa0f10804e6e($c370578c5f28b166$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        };
        this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $c370578c5f28b166$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c370578c5f28b166$var$TableWithShadowsAndContainerStyles = (0, $9ECRl.default)((0, $7b2e3308afb44c9a$export$827f89182557f335), {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c370578c5f28b166$var$TableWithShadows = (0, $9ECRl.default)($c370578c5f28b166$export$91e0997fd3f75d56, {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $bYPHE.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $c370578c5f28b166$var$TableWithWidth = (props)=>{
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $kS1Yv.useRendererContext)();
    const isInsideOfNestedRenderer = isTopLevelRenderer === false && (0, $ieeJu.expValEquals)('platform_editor_table_nested_content_mode_fix', 'isEnabled', true);
    if ((0, $iDrrr.fg)('platform-ssr-table-resize')) {
        const colWidthsSum = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
        if (colWidthsSum || props.allowTableResizing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c370578c5f28b166$var$TableWithShadowsAndContainerStyles, {
            ...props,
            isInsideOfNestedRenderer: isInsideOfNestedRenderer
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7b2e3308afb44c9a$export$827f89182557f335), {
            ...props,
            isInsideOfNestedRenderer: isInsideOfNestedRenderer
        });
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUm2W.WidthConsumer), null, ({ width: width })=>{
        const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, $2bxao.FullPagePadding) * 2 : width;
        const colWidthsSum = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
        if (colWidthsSum || props.allowTableResizing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c370578c5f28b166$var$TableWithShadows, {
            renderWidth: renderWidth,
            ...props,
            isInsideOfNestedRenderer: isInsideOfNestedRenderer
        });
        // there should not be a case when colWidthsSum is 0 and table is in overflow state - so no need to render shadows in this case
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c370578c5f28b166$export$91e0997fd3f75d56, {
            renderWidth: renderWidth,
            ...props,
            isInsideOfNestedRenderer: isInsideOfNestedRenderer
        });
    });
};
const $c370578c5f28b166$var$_default_1 = (0, $iWj7r.withSmartCardStorage)($c370578c5f28b166$var$TableWithWidth);
var $c370578c5f28b166$export$2e2bcd8739ae039 = $c370578c5f28b166$var$_default_1;
module.exports["isTableResizingEnabled"] = $c370578c5f28b166$export$eec82c0a93aa66d9;
module.exports["isStickyScrollbarEnabled"] = $c370578c5f28b166$export$bdb2dadcb04aad50;
module.exports["default"] = $c370578c5f28b166$export$2e2bcd8739ae039;

});

parcelRegister("kXCPk", function(module, exports) {
function $89440112709496d3$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $89440112709496d3$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$89440112709496d3$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}
module.exports["isNestedHeaderLinksEnabled"] = $89440112709496d3$export$7aa7587d1ce9583c;
module.exports["getActiveHeadingId"] = $89440112709496d3$export$acb253d79d72af92;

});

parcelRegister("dbAJC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1LnN = parcelRequire("i1LnN");


var $7Glgp = parcelRequire("7Glgp");

const $41c8e850ea07b487$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $41c8e850ea07b487$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $7Glgp.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1LnN.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
        ...props.dataAttributes
    }, props.children);
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $41c8e850ea07b487$var$_default_1 = (0, $kSwu1.injectIntl)($41c8e850ea07b487$export$7cea6ffa7022e85f);
var $41c8e850ea07b487$export$2e2bcd8739ae039 = $41c8e850ea07b487$var$_default_1;
module.exports["isCodeMark"] = $41c8e850ea07b487$export$86390c02c110ec2f;
module.exports["default"] = $41c8e850ea07b487$export$2e2bcd8739ae039;

});

parcelRegister("7TS3k", function(module, exports) {
$parcel$export(module.exports, "default", () => $4814a0d0cc83ae51$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $4814a0d0cc83ae51$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("em", props.dataAttributes, props.children);
}

});

parcelRegister("g8vg9", function(module, exports) {
$parcel$export(module.exports, "default", () => $3854ebfea24ab19d$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $8m50u = parcelRequire("8m50u");


var $6FNab = parcelRequire("6FNab");


var $cY9xy = parcelRequire("cY9xy");


var $krYZG = parcelRequire("krYZG");


var $ieeJu = parcelRequire("ieeJu");


var $gBjHb = parcelRequire("gBjHb");

/* link-compiled.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * Compiled branch of the `platform_editor_static_css` experiment.
 * Used via `componentWithCondition` in `link.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 



var $hekY6 = parcelRequire("hekY6");


var $FCr1g = parcelRequire("FCr1g");

const $ea2860f20b5beef4$var$anchorStyles = null;
const $ea2860f20b5beef4$export$10ae7cf734c9da69 = (props)=>/*#__PURE__*/ $cozmU.createElement((0, $FCr1g.default), {
        ...props,
        className: (0, $hekY6.default)([
            "_1UtDYzM7Tp _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMM7Tp _0CMRbkAwSC"
        ])
    });


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion branch of the `platform_editor_static_css` experiment.
 * Used via `componentWithCondition` in `link.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $lOiVq = parcelRequire("lOiVq");




function $8dfc56826cc1a100$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8dfc56826cc1a100$var$anchorStyles = {
    name: "sa5fy1",
    styles: "color:var(--ds-link, #1868DB);&:hover{color:var(--ds-link, #1868DB);text-decoration:underline;}&:active{color:var(--ds-link-pressed, #1558BC);}"
};
const $8dfc56826cc1a100$export$bcc8540ceca8fa1c = (props)=>// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $lOiVq.jsx)((0, $FCr1g.default), {
        css: $8dfc56826cc1a100$var$anchorStyles,
        ...props
    });


const $3854ebfea24ab19d$var$LinkUrlMigration = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_renderer_static_css', 'isEnabled', true), (0, $ea2860f20b5beef4$export$10ae7cf734c9da69), (0, $8dfc56826cc1a100$export$bcc8540ceca8fa1c));
function $3854ebfea24ab19d$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, onSetLinkTarget: onSetLinkTarget, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    let actualTarget = target;
    if (onSetLinkTarget && href) try {
        actualTarget = onSetLinkTarget(href) ?? actualTarget;
    } catch (error) {
    // eslint-disable-line no-unused-vars
    // If URL parsing fails, use the original target
    }
    const anchorProps = {
        href: href,
        target: actualTarget,
        title: href
    };
    if (actualTarget === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $6FNab.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, props.children);
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3854ebfea24ab19d$var$LinkUrlMigration, {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: (e)=>{
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).VISITED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).LINK,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $cY9xy.PLATFORM).WEB,
                    mode: (0, $cY9xy.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        },
        ...anchorProps,
        ...dataAttributes,
        isLinkComponent: true,
        enableResolve: true
    }, props.children));
}

});

parcelRegister("hL2mp", function(module, exports) {
$parcel$export(module.exports, "default", () => $d929e9f1d92d5e24$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $d929e9f1d92d5e24$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ...props.dataAttributes,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textDecoration: 'line-through'
        }
    }, props.children);
}

});

parcelRegister("hZh3g", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c6a00b2444d63d6$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $4c6a00b2444d63d6$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("strong", props.dataAttributes, props.children);
}

});

parcelRegister("kP3O8", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b8a1da78d1333a2$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

const $7b8a1da78d1333a2$var$isSub = (type)=>{
    return type === 'sub';
};
function $7b8a1da78d1333a2$export$2e2bcd8739ae039(props) {
    if ($7b8a1da78d1333a2$var$isSub(props.type)) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("sub", props.dataAttributes, props.children);
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("sup", props.dataAttributes, props.children);
}

});

parcelRegister("jFiyG", function(module, exports) {
$parcel$export(module.exports, "default", () => $c01034b1936214c0$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $cbws3 = parcelRequire("cbws3");


var $g8ETs = parcelRequire("g8ETs");


var $IQ4Dz = parcelRequire("IQ4Dz");

function $c01034b1936214c0$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $g8ETs.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $g8ETs.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $cbws3.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $cozmU.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ...props.dataAttributes,
        "data-text-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-text-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, props.children);
}

});

parcelRegister("BxuzK", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e205d2eec319d40$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $cbws3 = parcelRequire("cbws3");


var $9Rqjc = parcelRequire("9Rqjc");


var $IQ4Dz = parcelRequire("IQ4Dz");

function $0e205d2eec319d40$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    let paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $cbws3.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $cozmU.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    if (props.isStandalone) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-block-mark": props.dataAttributes['data-block-mark'],
        "data-renderer-mark": props.dataAttributes['data-renderer-mark'],
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "background-color-padding-left background-color-padding-right"
    }, props.children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ...props.dataAttributes,
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, props.children);
}

});

parcelRegister("Rqtsm", function(module, exports) {
$parcel$export(module.exports, "default", () => $8dc22ffb0e65a308$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $8dc22ffb0e65a308$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("u", props.dataAttributes, props.children);
}

});

parcelRegister("kVRDx", function(module, exports) {
$parcel$export(module.exports, "default", () => $46c6e59e5f859c11$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");


var $fqVYq = parcelRequire("fqVYq");


var $ieeJu = parcelRequire("ieeJu");


var $96p1s = parcelRequire("96p1s");

function $46c6e59e5f859c11$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Legacy centering (breaks position: sticky in nested content).
const $46c6e59e5f859c11$var$legacyWrapperStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $7Y8M5.blockNodesVerticalMargin)} 0`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    transform: 'translateX(-50%)'
});
const $46c6e59e5f859c11$var$flexWrapperStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $7Y8M5.blockNodesVerticalMargin)} 0`
});
// Flex item: no vertical margin so flex container height = content height (matches legacy single-wrapper height).
// flexShrink: 0 so the inner div keeps its width (matches legacy behaviour; flex items default to flex-shrink: 1).
const $46c6e59e5f859c11$var$innerWrapperStyles = {
    name: "ozd7xs",
    styles: "flex-shrink:0"
};
const $46c6e59e5f859c11$var$getWidth = (width, mode)=>{
    if ((0, $fqVYq.editorExperiment)('advanced_layouts', true) && width) return `min(${width}px, var(--ak-editor--breakout-container-without-gutter-width))`;
    else {
        if ((0, $ieeJu.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) {
            if (mode === 'max' || typeof width === 'number' && width >= (0, $7Y8M5.akEditorFullWidthLayoutWidth)) return `min(${0, $7Y8M5.akEditorMaxLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width))`;
        }
        if (mode === 'full-width') return `min(${0, $7Y8M5.akEditorFullWidthLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width))`;
        if (mode === 'wide') return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor--breakout-container-without-gutter-width))`;
    }
};
function $46c6e59e5f859c11$export$2e2bcd8739ae039(props) {
    const breakoutWidth = props.width ?? null;
    const width = $46c6e59e5f859c11$var$getWidth(breakoutWidth, props.mode);
    const useStickySafeCentering = (0, $ieeJu.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
    if (useStickySafeCentering) return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $96p1s.RendererCssClassName).STICKY_SAFE_BREAKOUT_WRAPPER + ' ' + (0, $96p1s.RendererCssClassName).FLEX_CENTER_WRAPPER,
        css: $46c6e59e5f859c11$var$flexWrapperStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $46c6e59e5f859c11$var$innerWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $96p1s.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} fabric-editor-breakout-mark fabric-editor-block-mark`,
        "data-mode": props.mode,
        ...(0, $fqVYq.editorExperiment)('advanced_layouts', true) && {
            'data-has-width': !!props.width,
            'data-width': props.width
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: width
        }
    }, props.children));
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $46c6e59e5f859c11$var$legacyWrapperStyles,
        "data-mode": props.mode,
        ...(0, $fqVYq.editorExperiment)('advanced_layouts', true) && {
            'data-has-width': !!props.width,
            'data-width': props.width
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: width
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-breakout-mark fabric-editor-block-mark"
    }, props.children);
}

});

parcelRegister("5ja7D", function(module, exports) {
$parcel$export(module.exports, "default", () => $fdbb2238d16953d7$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $fdbb2238d16953d7$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", props.dataAttributes, props.children);
}

});

parcelRegister("gakt2", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cb7e9ba4b8e99c3$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $5cb7e9ba4b8e99c3$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", props.dataAttributes, props.children);
}

});

parcelRegister("fAxeQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1bee546bb6e45cf$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $e1bee546bb6e45cf$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrapperElement, {
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer",
        ...props.dataAttributes
    }, props.children);
}

});

parcelRegister("hbojQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4e01d0400f20f2c$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $e4e01d0400f20f2c$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrapperElement, {
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment",
        ...props.dataAttributes
    }, props.children);
}

});

parcelRegister("aEH72", function(module, exports) {
$parcel$export(module.exports, "default", () => $929fe6cd4a816bc9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $lOiVq = parcelRequire("lOiVq");

function $929fe6cd4a816bc9$export$2e2bcd8739ae039(props) {
    const borderColor = props.color ?? '';
    const borderSize = props.size ?? 0;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("cGUVt", function(module, exports) {
$parcel$export(module.exports, "default", () => $60a1c50b52900a8c$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $60a1c50b52900a8c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-font-size",
        "data-font-size": props.fontSize
    }, props.children);
}

});

parcelRegister("gPm8T", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ca5529017ae1933$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $4ca5529017ae1933$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("blockquote", {
        "data-local-id": props.localId
    }, props.children);
}

});

parcelRegister("cfEQy", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6MqGo = parcelRequire("6MqGo");


var $gAjKf = parcelRequire("gAjKf");


var $aZS5C = parcelRequire("aZS5C");


var $GTXrQ = parcelRequire("GTXrQ");


var $krYZG = parcelRequire("krYZG");


var $WNsSX = parcelRequire("WNsSX");


var $8Kasn = parcelRequire("8Kasn");

const $f7a0d1980a35a4f2$var$BodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType, parameters: parameters, extensionViewportSizes: extensionViewportSizes, localId: localId, shouldDisplayExtensionAsInline: shouldDisplayExtensionAsInline, fireAnalyticsEvent: fireAnalyticsEvent } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const isInsideOfTable = path.some((node)=>node.type.name === 'table');
    const validationContextValue = (0, $cozmU.useMemo)(()=>({
            allowNestedTables: true
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gAjKf.ErrorBoundary), {
        component: (0, $GTXrQ.ACTION_SUBJECT).RENDERER,
        componentId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: `${extensionType}: ${extensionKey} `
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $WNsSX.AnnotationsPositionContext).Provider, {
        value: {
            startPos: props.startPos + 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Kasn.ValidationContextProvider), {
        value: validationContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZS5C.default), {
        ...props,
        type: "bodiedExtension"
    }, ({ node: node, result: result })=>{
        try {
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
            return (0, $6MqGo.renderExtension)(result, layout, {
                isTopLevel: path.length < 1,
                isInsideOfTable: isInsideOfTable,
                rendererAppearance: props.rendererAppearance,
                fireAnalyticsEvent: fireAnalyticsEvent
            }, removeOverflow, parameters?.extensionId, extensionViewportSizes, undefined, localId, shouldDisplayExtensionAsInline, node);
        } catch  {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return (0, $6MqGo.renderExtension)(children, layout, {
            isTopLevel: path.length < 1,
            isInsideOfTable: isInsideOfTable,
            rendererAppearance: props.rendererAppearance,
            fireAnalyticsEvent: fireAnalyticsEvent
        }, removeOverflow, parameters?.extensionId, extensionViewportSizes, undefined, localId, shouldDisplayExtensionAsInline, node);
    }))));
};
var $f7a0d1980a35a4f2$export$2e2bcd8739ae039 = $f7a0d1980a35a4f2$var$BodiedExtension;
module.exports["default"] = $f7a0d1980a35a4f2$export$2e2bcd8739ae039;

});

parcelRegister("h41Wr", function(module, exports) {
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $lOiVq = parcelRequire("lOiVq");


var $cozmU = parcelRequire("cozmU");


var $dUm2W = parcelRequire("dUm2W");


var $96p1s = parcelRequire("96p1s");


var $h9Lux = parcelRequire("h9Lux");





var $krYZG = parcelRequire("krYZG");


var $ieeJu = parcelRequire("ieeJu");

const $400ab2333d113076$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, children: children, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer, extensionKey: extensionKey = '', extensionType: extensionType = '', fireAnalyticsEvent: fireAnalyticsEvent })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return {
            changeActive (index) {
                if (!Number.isInteger(index)) return false;
                updateActiveChild(index);
                if ((0, $ieeJu.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true)) fireAnalyticsEvent?.({
                    action: (0, $krYZG.ACTION).CHANGE_ACTIVE,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
                    attributes: {
                        extensionType: extensionType,
                        extensionKey: extensionKey
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                });
                return true;
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children && Array.isArray(children) ? children.length : 0;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            removeChild (_index) {
                return false;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            reorderChildren (_fromIndex, _toIndex) {
                return false;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            updateParameters (_parameters) {
                return false;
            },
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return allowBodiedOverride ? childrenContainer : null;
            }
        };
    }, [
        updateActiveChild,
        children,
        allowBodiedOverride,
        childrenContainer,
        extensionKey,
        extensionType,
        fireAnalyticsEvent
    ]);
};






var $dOBRD = parcelRequire("dOBRD");


var $cd8tA = parcelRequire("cd8tA");


var $jB2jW = parcelRequire("jB2jW");


var $apAmb = parcelRequire("apAmb");




const $7ebf2cf93f697d34$var$getExtensionHandlerNode = (extensionHandler)=>{
    return ({ node: node, doc: doc, actions: actions })=>{
        return extensionHandler(node, doc, actions);
    };
};
const $7ebf2cf93f697d34$export$e55394818db35473 = ({ extensionHandlers: extensionHandlers, extensionType: extensionType, extensionKey: extensionKey })=>{
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>(0, $dOBRD.default)((0, $cd8tA.getNodeRenderer)), []);
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [privateProps, setPrivateProps] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState();
    const providerPromise = (0, $jB2jW.useProvider)('extensionProvider');
    const ExtensionHandlerNode = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        const extensionHandler = extensionHandlers && extensionHandlers[extensionType] && (0, $apAmb.getExtensionRenderer)(extensionHandlers[extensionType]);
        if (extensionHandler) return $7ebf2cf93f697d34$var$getExtensionHandlerNode(extensionHandler);
        return null;
    }, [
        extensionHandlers,
        extensionType
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (providerPromise) providerPromise.then((p)=>{
            if (isMounted.current) setProvider(p);
            return (0, $cd8tA.getExtensionModuleNodePrivateProps)(p, extensionType, extensionKey);
        }).then((pr)=>{
            if (isMounted.current) setPrivateProps(pr);
        });
    }, [
        providerPromise,
        extensionType,
        extensionKey
    ]);
    const ExtensionProviderNode = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (!provider) return null;
        return localGetNodeRenderer(provider, extensionType, extensionKey);
    }, [
        provider,
        extensionType,
        extensionKey,
        localGetNodeRenderer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (ExtensionHandlerNode && (0, $ieeJu.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true)) return {
            extensionContext: {
                NodeRenderer: ExtensionHandlerNode,
                privateProps: {
                    __allowBodiedOverride: true
                }
            },
            loading: false
        };
        if (!provider || !ExtensionProviderNode || !privateProps) return {
            extensionContext: null,
            loading: true
        };
        return {
            extensionContext: {
                NodeRenderer: ExtensionProviderNode,
                privateProps: privateProps
            },
            loading: false
        };
    }, [
        ExtensionHandlerNode,
        provider,
        ExtensionProviderNode,
        privateProps
    ]);
};






var $l7yGH = parcelRequire("l7yGH");


var $grAaA = parcelRequire("grAaA");

function $377b21e920aefedc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $377b21e920aefedc$var$containerStyles = {
    name: "hwppun",
    styles: "&:first-child > .ak-renderer-extension{margin-top:0;}&:first-child > .ak-renderer-sticky-safe-center-wrapper{margin-top:0;}"
};
const $377b21e920aefedc$var$MultiBodiedExtensionChildrenContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("article", {
        "data-testid": "multiBodiedExtension--frames"
    }, children);
};
const $377b21e920aefedc$var$MultiBodiedExtensionNavigation = ({ children: children })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("nav", {
        "data-testid": "multiBodiedExtension-navigation"
    }, children);
};
const $377b21e920aefedc$var$MultiBodiedExtensionWrapperLegacy = ({ width: width, path: path, layout: layout, rendererAppearance: rendererAppearance, children: children })=>{
    const isTopLevel = path.length < 1;
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $ieeJu.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $96p1s.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $96p1s.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            width: ((0, $ieeJu.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $h9Lux.calcBreakoutWidth)(layout, width) : (0, $ieeJu.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper-renderer",
        "data-top-level": isTopLevel || undefined
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $96p1s.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $377b21e920aefedc$var$MultiBodiedExtensionWrapperNext = ({ path: path, layout: layout, rendererAppearance: rendererAppearance, children: children })=>{
    const isTopLevel = path.length < 1;
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $ieeJu.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $96p1s.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $96p1s.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            width: ((0, $ieeJu.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $l7yGH.calcBreakoutWidthCss)(layout) : (0, $ieeJu.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper-renderer",
        "data-top-level": isTopLevel || undefined
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $96p1s.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $377b21e920aefedc$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], parameters: parameters, extensionType: extensionType, extensionKey: extensionKey, extensionHandlers: extensionHandlers, content: content, marks: marks, localId: localId, rendererAppearance: rendererAppearance } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $cozmU.useState)(0);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $cozmU.useContext)((0, $grAaA.default));
    const { loading: loading, extensionContext: extensionContext } = (0, $7ebf2cf93f697d34$export$e55394818db35473)({
        extensionHandlers: extensionHandlers,
        extensionType: extensionType,
        extensionKey: extensionKey
    });
    const actions = (0, $400ab2333d113076$export$3c7139d93ecb4f1f)({
        updateActiveChild: setActiveChildIndex,
        children: children,
        childrenContainer: /*#__PURE__*/ (0, $lOiVq.jsx)($377b21e920aefedc$var$MultiBodiedExtensionChildrenContainer, null, children),
        allowBodiedOverride: extensionContext?.privateProps?.__allowBodiedOverride,
        extensionKey: extensionKey,
        extensionType: extensionType,
        fireAnalyticsEvent: fireAnalyticsEvent
    });
    const renderContent = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if (loading || !extensionContext) return null;
        const { NodeRenderer: NodeRenderer, privateProps: privateProps } = extensionContext;
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: 'multiBodiedExtension',
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        if (privateProps.__allowBodiedOverride) return /*#__PURE__*/ (0, $lOiVq.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        });
        else return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $lOiVq.jsx)($377b21e920aefedc$var$MultiBodiedExtensionNavigation, null, /*#__PURE__*/ (0, $lOiVq.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        })), /*#__PURE__*/ (0, $lOiVq.jsx)($377b21e920aefedc$var$MultiBodiedExtensionChildrenContainer, null, children));
    }, [
        loading,
        extensionContext,
        marks,
        extensionKey,
        extensionType,
        parameters,
        content,
        localId,
        actions,
        children
    ]);
    // make the frame visible
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    const containerActiveFrameStyles = /*#__PURE__*/ (0, $lOiVq.css)("& [data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){display:block;}");
    if ((0, $ieeJu.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)) {
        const isTopLevel = path.length < 1;
        const useCenterWrapper = isTopLevel && [
            'wide',
            'full-width'
        ].includes(layout) && (0, $ieeJu.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
        const wrapper = /*#__PURE__*/ (0, $lOiVq.jsx)($377b21e920aefedc$var$MultiBodiedExtensionWrapperNext, {
            layout: layout,
            path: path,
            rendererAppearance: rendererAppearance
        }, renderContent());
        return /*#__PURE__*/ (0, $lOiVq.jsx)("section", {
            css: [
                $377b21e920aefedc$var$containerStyles,
                containerActiveFrameStyles
            ],
            "data-testid": "multiBodiedExtension--container",
            "data-multiBodiedExtension-container": true,
            "data-active-child-index": activeChildIndex,
            "data-layout": layout,
            "data-local-id": localId,
            "data-node-type": "multiBodiedExtension"
        }, useCenterWrapper ? /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $96p1s.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $96p1s.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, wrapper) : wrapper);
    }
    const isTopLevel = path.length < 1;
    const useCenterWrapper = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && (0, $ieeJu.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("section", {
        css: [
            $377b21e920aefedc$var$containerStyles,
            containerActiveFrameStyles
        ],
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex,
        "data-layout": layout,
        "data-local-id": localId
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dUm2W.WidthConsumer), null, ({ width: width })=>{
        const wrapper = /*#__PURE__*/ (0, $lOiVq.jsx)($377b21e920aefedc$var$MultiBodiedExtensionWrapperLegacy, {
            layout: layout,
            width: width,
            path: path,
            rendererAppearance: rendererAppearance
        }, renderContent());
        return useCenterWrapper ? /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $96p1s.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $96p1s.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, wrapper) : wrapper;
    }));
};
var $377b21e920aefedc$export$2e2bcd8739ae039 = $377b21e920aefedc$var$MultiBodiedExtension;
module.exports["default"] = $377b21e920aefedc$export$2e2bcd8739ae039;

});

parcelRegister("62oYX", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $lOiVq = parcelRequire("lOiVq");

const $99f6ea84f3e237ef$var$containerCSS = /*#__PURE__*/ (0, $lOiVq.css)({
    padding: `${"var(--ds-space-100, 8px)"}`,
    minHeight: '100px',
    // by default all frames are hidden, this style is overridden in multiBodiedExtensions for active frame
    display: 'none'
});
const $99f6ea84f3e237ef$var$ExtensionFrame = (props)=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $99f6ea84f3e237ef$var$containerCSS
        ],
        "data-extension-frame": "true"
    }, props.children);
};
var $99f6ea84f3e237ef$export$2e2bcd8739ae039 = $99f6ea84f3e237ef$var$ExtensionFrame;
module.exports["default"] = $99f6ea84f3e237ef$export$2e2bcd8739ae039;

});

parcelRegister("dMjNA", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5993fadd707cede$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $9nUB4 = parcelRequire("9nUB4");


var $47hKc = parcelRequire("47hKc");

function $f5993fadd707cede$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9nUB4.bulletListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $47hKc.getListIndentLevel)(props.path) : 1
    }, props.children);
}

});

parcelRegister("5iJHZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $532ce7f956ca7e48$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $96p1s = parcelRequire("96p1s");


var $krYZG = parcelRequire("krYZG");





var $grAaA = parcelRequire("grAaA");

class $a93f653ef34c0129$export$6e6724d89f27411 {
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            const startMatches = this.range?.compareBoundaryPoints(Range.START_TO_START, selection.range) === 0;
            const endMatches = this.range?.compareBoundaryPoints(Range.END_TO_END, selection.range) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        return el.contains(this.range?.commonAncestorContainer ?? null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $a93f653ef34c0129$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $a93f653ef34c0129$export$6e6724d89f27411(win.getSelection());
    }
    constructor(selection){
        this.type = void 0;
        this.range = void 0;
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
}


// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $3871e3f35e0a9414$var$MAC_PLATFORM_REGEX = /Mac/;
const $3871e3f35e0a9414$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $grAaA.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const mac = typeof navigator !== 'undefined' ? $3871e3f35e0a9414$var$MAC_PLATFORM_REGEX.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((e)=>{
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $a93f653ef34c0129$export$6e6724d89f27411).fromWindow();
        const isInput = e.target?.matches?.('input');
        if (elementSelection.eq(caught.current) || isInput) {
            fireAnalyticsEvent({
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                action: (0, $krYZG.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                action: (0, $krYZG.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((e)=>{
        clicked.current = ref.current?.contains(e.target) ?? false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('keydown', onKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', onClick);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('keydown', onKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};


function $532ce7f956ca7e48$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $96p1s.RendererCssClassName).DOCUMENT
    }, props.children);
}
function $532ce7f956ca7e48$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: (0, $3871e3f35e0a9414$export$98871b245ee25215)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $96p1s.RendererCssClassName).DOCUMENT
    }, props.children);
}
module.exports["DocWithSelectAllTrap"] = $532ce7f956ca7e48$export$41121a410ca2f650;

});

parcelRegister("6MqGo", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $aZS5C = parcelRequire("aZS5C");


var $9ECRl = parcelRequire("9ECRl");

var $dUm2W = parcelRequire("dUm2W");


var $h9Lux = parcelRequire("h9Lux");


var $96p1s = parcelRequire("96p1s");


var $4o0zT = parcelRequire("4o0zT");


var $ieeJu = parcelRequire("ieeJu");


var $l7yGH = parcelRequire("l7yGH");


var $iDrrr = parcelRequire("iDrrr");

function $32af7caf31c5d1be$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $32af7caf31c5d1be$var$viewportSizes = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
// Mirrors sizes from https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/forge/xen-editor-provider/src/render/renderers/ForgeUIExtension.tsx
const $32af7caf31c5d1be$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $32af7caf31c5d1be$var$getViewportSize = (extensionId, extensionViewportSizes)=>{
    if (!Array.isArray(extensionViewportSizes) || !extensionId) return;
    const extension = extensionViewportSizes.find((extension)=>extension.extensionId === extensionId);
    if (extension) {
        const viewportSize = extension.viewportSize && $32af7caf31c5d1be$var$viewportSizes.includes(extension.viewportSize) ? extension.viewportSize : 'default';
        return $32af7caf31c5d1be$var$macroHeights[viewportSize];
    }
};
const $32af7caf31c5d1be$var$containerStyle = {
    name: "nhejpy",
    styles: "container-type:inline-size"
};
/**
 * Fires an analytics event once on mount when a bodied extension is rendered as an inline element.
 * The node is stored in a ref to avoid re-firing if the node reference changes.
 */ const $32af7caf31c5d1be$var$FireExtensionAsInlineAnalytics = ({ fireAnalyticsEvent: fireAnalyticsEvent, node: node })=>{
    const nodeRef = (0, $cozmU.useRef)(node);
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).RENDERED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EXTENSION_AS_INLINE,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EXTENSION_BODIED,
            attributes: {
                extensionKey: nodeRef.current.extensionKey,
                extensionType: nodeRef.current.extensionType
            },
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        });
    }, [
        fireAnalyticsEvent
    ]);
    return null;
};
const $32af7caf31c5d1be$export$b7482bdc8aff85e4 = (content, layout, options = {}, removeOverflow, extensionId, extensionViewportSizes, nodeHeight, localId, shouldDisplayExtensionAsInline, node, isInsideOfInlineExtension)=>{
    const overflowContainerClass = !removeOverflow ? (0, $96p1s.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isInsideOfTable: isInsideOfTable = false, isTopLevel: isTopLevel = true, rendererAppearance: rendererAppearance, fireAnalyticsEvent: fireAnalyticsEvent } = options || {};
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $ieeJu.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $96p1s.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    /**
   * To reduce cumulative layout shift, we check installed manifest values (viewportSize) for Forge and extension node parameters
   * for Connect (legacy). As Connect is being phased out, we want Forge to also start to store its expected height
   * in node parameters, especially for dynamic content macros. LegacyMacroStyledElements implements logic similar to here
   * as the extension handler in CFE for legacy macros and Connect.
   */ const viewportSize = $32af7caf31c5d1be$var$getViewportSize(extensionId, extensionViewportSizes);
    const extensionHeight = nodeHeight || viewportSize;
    const isInline = shouldDisplayExtensionAsInline?.(node) && (0, $ieeJu.expValEquals)('platform_editor_render_bodied_extension_as_inline', 'isEnabled', true);
    const inlineClassName = isInline ? (0, $96p1s.RendererCssClassName).EXTENSION_AS_INLINE : '';
    const asInlineAnalytics = isInline && fireAnalyticsEvent && node ? /*#__PURE__*/ (0, $lOiVq.jsx)($32af7caf31c5d1be$var$FireExtensionAsInlineAnalytics, {
        fireAnalyticsEvent: fireAnalyticsEvent,
        node: node
    }) : null;
    if ((0, $ieeJu.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)) {
        const extensionDiv = /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            ref: options.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $96p1s.RendererCssClassName).EXTENSION} ${inlineClassName} ${options.shadowClassNames} ${centerAlignClass}`,
            style: {
                width: isInline ? undefined : ((0, $ieeJu.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $l7yGH.calcBreakoutWidthCss)(layout) : (0, $ieeJu.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                minHeight: isInline ? undefined : extensionHeight && `${extensionHeight}px`
            },
            "data-layout": layout,
            "data-local-id": localId,
            "data-testid": "extension--wrapper",
            "data-node-type": "extension",
            "data-top-level": isTopLevel || undefined
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            tabIndex: options.tabIndex,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: `${(0, $96p1s.RendererCssClassName).EXTENSION_INNER_WRAPPER} ${overflowContainerClass}`,
            css: [
                !(isInsideOfTable && (0, $4o0zT.isExperimentEnabled)('platform_editor_table_fit_to_content_patch_1')) && !isInsideOfInlineExtension && (0, $iDrrr.fg)('platform_fix_macro_renders_in_layouts') && $32af7caf31c5d1be$var$containerStyle
            ]
        }, asInlineAnalytics, content));
        return centerAlignClass && (0, $ieeJu.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true) ? /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $96p1s.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $96p1s.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, extensionDiv) : extensionDiv;
    }
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dUm2W.WidthConsumer), null, ({ width: width })=>{
        const extensionDiv = /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            ref: options.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $96p1s.RendererCssClassName).EXTENSION} ${inlineClassName} ${options.shadowClassNames} ${centerAlignClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isInline ? undefined : ((0, $ieeJu.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $h9Lux.calcBreakoutWidth)(layout, width) : (0, $ieeJu.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                minHeight: isInline ? undefined : `${extensionHeight}px`
            },
            "data-layout": layout,
            "data-local-id": localId,
            "data-top-level": isTopLevel || undefined
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            tabIndex: options.tabIndex,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: `${(0, $96p1s.RendererCssClassName).EXTENSION_INNER_WRAPPER} ${overflowContainerClass}`,
            css: [
                !(isInsideOfTable && (0, $4o0zT.isExperimentEnabled)('platform_editor_table_fit_to_content_patch_1')) && !isInsideOfInlineExtension && (0, $iDrrr.fg)('platform_fix_macro_renders_in_layouts') && $32af7caf31c5d1be$var$containerStyle
            ]
        }, asInlineAnalytics, content));
        return centerAlignClass && (0, $ieeJu.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true) ? /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $96p1s.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $96p1s.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, extensionDiv) : extensionDiv;
    });
};
const $32af7caf31c5d1be$var$Extension = (props)=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [], extensionViewportSizes: extensionViewportSizes, parameters: parameters, nodeHeight: nodeHeight, localId: localId, isInsideOfInlineExtension: isInsideOfInlineExtension } = props;
    const isInsideOfTable = path.some((node)=>node.type.name === 'table');
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $aZS5C.default), {
        ...props,
        type: "extension"
    }, ({ isExtensionProviderPending: isExtensionProviderPending, result: result })=>{
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(result)) return $32af7caf31c5d1be$export$b7482bdc8aff85e4(result, layout, {
                isTopLevel: path.length < 1,
                isInsideOfTable: isInsideOfTable,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames,
                tabIndex: props.tabIndex,
                rendererAppearance: props.rendererAppearance
            }, undefined, parameters?.extensionId, extensionViewportSizes, nodeHeight, localId, undefined, undefined, isInsideOfInlineExtension);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        if (isExtensionProviderPending && props.hideExtensionKeysWhilePending?.includes(props.extensionKey)) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
        // Always return default content if anything goes wrong
        return $32af7caf31c5d1be$export$b7482bdc8aff85e4(text || 'extension', layout, {
            isTopLevel: path.length < 1,
            isInsideOfTable: isInsideOfTable,
            handleRef: handleRef,
            shadowClassNames: shadowClassNames,
            tabIndex: props.tabIndex,
            rendererAppearance: props.rendererAppearance
        }, undefined, parameters?.extensionId, extensionViewportSizes, nodeHeight, localId, undefined, undefined, isInsideOfInlineExtension);
    });
};
const $32af7caf31c5d1be$var$_default_1 = (0, $9ECRl.default)($32af7caf31c5d1be$var$Extension, {
    overflowSelector: `.${(0, $96p1s.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});
var $32af7caf31c5d1be$export$2e2bcd8739ae039 = $32af7caf31c5d1be$var$_default_1;
module.exports["renderExtension"] = $32af7caf31c5d1be$export$b7482bdc8aff85e4;
module.exports["default"] = $32af7caf31c5d1be$export$2e2bcd8739ae039;

});

parcelRegister("k7Rhl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $32c4db4bada0626b$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null);
};
var $32c4db4bada0626b$export$2e2bcd8739ae039 = $32c4db4bada0626b$var$HardBreak;
module.exports["default"] = $32c4db4bada0626b$export$2e2bcd8739ae039;

});

parcelRegister("12rmB", function(module, exports) {
/* heading.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $aDSIl = parcelRequire("aDSIl");


var $a33Aa = parcelRequire("a33Aa");


var $krYZG = parcelRequire("krYZG");


var $9GVkD = parcelRequire("9GVkD");


var $ieeJu = parcelRequire("ieeJu");


var $grAaA = parcelRequire("grAaA");


var $jyFxy = parcelRequire("jyFxy");


var $2Voi6 = parcelRequire("2Voi6");


var $jqmxP = parcelRequire("jqmxP");


var $3qC7n = parcelRequire("3qC7n");

const $e376df85e6c56fdc$var$RENDERER_HEADING_WRAPPER = 'renderer-heading-wrapper';
const $e376df85e6c56fdc$var$RENDERER_COLLAPSIBLE_HEADING_WRAPPER = 'renderer-collapsible-heading-wrapper';
const $e376df85e6c56fdc$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $e376df85e6c56fdc$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
const $e376df85e6c56fdc$var$wrapperStyles = null;
const $e376df85e6c56fdc$var$collapsibleHeadingWrapperStyles = null;
const $e376df85e6c56fdc$var$collapsibleHeadingButtonStyles = null;
const $e376df85e6c56fdc$var$collapsibleHeadingButtonExpandedStyles = null;
const $e376df85e6c56fdc$var$collapsibleHeadingButtonHiddenStyles = null;
const $e376df85e6c56fdc$var$ChevronRightSmallIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: "",
        size: "small"
    });
const $e376df85e6c56fdc$var$hasFocusVisible = (target)=>{
    try {
        return target.matches(':focus-visible');
    } catch  {
        return true;
    }
};
const $e376df85e6c56fdc$var$getHeadingAnchorLinksConfig = (allowHeadingAnchorLinks)=>typeof allowHeadingAnchorLinks === 'object' ? allowHeadingAnchorLinks : undefined;
function $e376df85e6c56fdc$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, getHeadingLink: getHeadingLink, level: level, headingId: headingId, hideFromScreenReader: hideFromScreenReader }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $grAaA.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qC7n.default), {
            enableNestedHeaderLinks: enableNestedHeaderLinks,
            level: level,
            onCopyText: ()=>{
                fireAnalyticsEvent({
                    action: (0, $krYZG.ACTION).CLICKED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                    eventType: (0, $krYZG.EVENT_TYPE).UI
                });
                return (0, $jyFxy.copyTextToClipboard)(getHeadingLink?.(headingId) ?? $e376df85e6c56fdc$var$getCurrentUrlWithHash(headingId));
            },
            hideFromScreenReader: hideFromScreenReader,
            headingId: headingId
        }));
}
function $e376df85e6c56fdc$var$CollapsibleHeadingButton({ collapsibleHeading: collapsibleHeading, headingLevel: headingLevel, isHeadingHovered: isHeadingHovered }) {
    const intl = (0, $kSwu1.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $grAaA.default));
    const [isFocused, setIsFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const { isCollapsed: isCollapsed, toggle: toggle } = collapsibleHeading;
    const isVisible = isCollapsed || isFocused || isHeadingHovered;
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        event.stopPropagation();
        fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).TOGGLED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).HEADING,
            attributes: {
                expanded: isCollapsed,
                headingLevel: headingLevel
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        });
        toggle();
    }, [
        fireAnalyticsEvent,
        headingLevel,
        isCollapsed,
        toggle
    ]);
    const handleFocus = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        setIsFocused($e376df85e6c56fdc$var$hasFocusVisible(event.target));
    }, []);
    const handleBlur = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>setIsFocused(false), []);
    const handleKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>setIsFocused(true), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2I62gzdnbC _3iC0zddnbC _42Yu6B7dHp _1oUmNl68Ng _2aNwdzYbGa",
            !isCollapsed && "_2xvoozlxle",
            !isVisible && "_1YKVNsdnbC _1pp6NdYbGa _1YGe5G7dHp _2zpJqdIZbP _2ebWZK7dHp _1oqtr8IZbP"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: $e376df85e6c56fdc$var$ChevronRightSmallIcon,
        label: intl.formatMessage(isCollapsed ? (0, $2Voi6.collapsibleHeadingMessages).expandSection : (0, $2Voi6.collapsibleHeadingMessages).collapseSection),
        "aria-expanded": !isCollapsed,
        isTooltipDisabled: false,
        testId: "collapsible-heading-button",
        onClick: handleClick,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onKeyDown: handleKeyDown
    }));
}
function $e376df85e6c56fdc$var$CollapsibleHeadingContainer({ children: children, collapsibleHeading: collapsibleHeading, headingLevel: headingLevel }) {
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const [isFocused, setIsFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const mouseEnterHandler = ()=>{
        if (!mouseEntered.current) {
            (0, $a33Aa.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": $e376df85e6c56fdc$var$RENDERER_COLLAPSIBLE_HEADING_WRAPPER,
        "data-level": headingLevel,
        onMouseEnter: ()=>{
            mouseEnterHandler();
            setIsHovered(true);
        },
        onMouseLeave: ()=>setIsHovered(false),
        onFocus: (event)=>setIsFocused($e376df85e6c56fdc$var$hasFocusVisible(event.target)),
        onBlur: ()=>setIsFocused(false),
        className: (0, $hekY6.default)([
            "_0GTcwR7zWO _0LQT5EVa5s _1mT5xdRAKS"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e376df85e6c56fdc$var$CollapsibleHeadingButton, {
        collapsibleHeading: collapsibleHeading,
        headingLevel: headingLevel,
        isHeadingHovered: isHovered || isFocused
    }), children);
} /**
   * Old heading structure (before a11y fix):
   * - headning anchor is rendered INSIDE the heading element
   * - A duplicate anchor is rendered in VisuallyHidden for screen readers
   * - The visible button has hideFromScreenReader={true}
   *
   */ 
function $e376df85e6c56fdc$var$HeadingWithDuplicateAnchor(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible, localId: localId, asInline: asInline } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $e376df85e6c56fdc$var$hasRightAlignmentMark(marks);
    const headingAnchorLinksConfig = $e376df85e6c56fdc$var$getHeadingAnchorLinksConfig(allowHeadingAnchorLinks);
    const enableNestedHeaderLinks = headingAnchorLinksConfig?.allowNestedHeaderLinks;
    const getHeadingLink = headingAnchorLinksConfig?.getHeadingLink;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $a33Aa.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(HX, {
        id: headingIdToUse,
        "data-local-id": localId,
        "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
        "data-as-inline": asInline,
        onMouseEnter: mouseEnterHandler,
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e376df85e6c56fdc$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId,
        hideFromScreenReader: true
    }), props.children, showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e376df85e6c56fdc$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId,
        hideFromScreenReader: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        testId: "visually-hidden-heading-anchor"
    }, showAnchorLink && headingId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e376df85e6c56fdc$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId
    })));
} /**
   * New heading structure (a11y fix):
   * - Heading anchor is rendered OUTSIDE the heading element in a .renderer-heading-wrapper div
   * - Uses data-level attribute for CSS styling
   * - Better accessibility: heading contains only text, button is a sibling
   */ 
function $e376df85e6c56fdc$var$HeadingWithWrapper(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible, localId: localId, asInline: asInline, collapsibleHeading: collapsibleHeading } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const [isFocused, setIsFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $e376df85e6c56fdc$var$hasRightAlignmentMark(marks);
    const headingAnchorLinksConfig = $e376df85e6c56fdc$var$getHeadingAnchorLinksConfig(allowHeadingAnchorLinks);
    const enableNestedHeaderLinks = headingAnchorLinksConfig?.allowNestedHeaderLinks;
    const getHeadingLink = headingAnchorLinksConfig?.getHeadingLink;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if ((showAnchorLink || collapsibleHeading) && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $a33Aa.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    const handleWrapperMouseEnter = ()=>{
        mouseEnterHandler();
        setIsHovered(true);
    };
    const handleWrapperMouseLeave = ()=>setIsHovered(false);
    const handleWrapperFocus = (event)=>setIsFocused($e376df85e6c56fdc$var$hasFocusVisible(event.target));
    const handleWrapperBlur = ()=>setIsFocused(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_3iDTPbvLZJ",
            collapsibleHeading && "_0GTcwR7zWO _0LQT5EVa5s _1mT5xdRAKS",
            $e376df85e6c56fdc$var$RENDERER_HEADING_WRAPPER
        ]),
        "data-testid": $e376df85e6c56fdc$var$RENDERER_HEADING_WRAPPER,
        "data-level": props.level,
        onMouseEnter: collapsibleHeading ? handleWrapperMouseEnter : undefined,
        onMouseLeave: collapsibleHeading ? handleWrapperMouseLeave : undefined,
        onFocus: collapsibleHeading ? handleWrapperFocus : undefined,
        onBlur: collapsibleHeading ? handleWrapperBlur : undefined
    }, collapsibleHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e376df85e6c56fdc$var$CollapsibleHeadingButton, {
        collapsibleHeading: collapsibleHeading,
        headingLevel: props.level,
        isHeadingHovered: isHovered || isFocused
    }), showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e376df85e6c56fdc$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId,
        hideFromScreenReader: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(HX, {
        id: headingIdToUse,
        "data-local-id": localId,
        "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
        "data-as-inline": asInline,
        onMouseEnter: collapsibleHeading ? undefined : mouseEnterHandler,
        tabIndex: -1
    }, props.children), showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e376df85e6c56fdc$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId,
        hideFromScreenReader: false
    }));
} /**
   * Gated Heading component:
   * - When platform_editor_copy_link_a11y_inconsistency_fix experiment is enabled,
   *   returns HeadingWithWrapper (new a11y-improved structure)
   * - Otherwise preserves HeadingWithDuplicateAnchor (old structure), adding only the collapse
   *   container when the top-level heading is collapsible
   */ 
function $e376df85e6c56fdc$var$Heading({ allowHeadingAnchorLinks: allowHeadingAnchorLinks, children: children, dataAttributes: dataAttributes, headingId: headingId, invisible: invisible, level: level, localId: localId, marks: marks, nodeType: nodeType, path: path, showAnchorLink: showAnchorLink, serializer: serializer, asInline: asInline }) {
    const collapsibleHeading = (0, $jqmxP.useCollapsibleHeading)(dataAttributes['data-renderer-start-pos'], path?.length === 0);
    if ((0, $ieeJu.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e376df85e6c56fdc$var$HeadingWithWrapper, {
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        dataAttributes: dataAttributes,
        headingId: headingId,
        invisible: invisible,
        level: level,
        localId: localId,
        marks: marks,
        nodeType: nodeType,
        serializer: serializer,
        showAnchorLink: showAnchorLink,
        asInline: asInline,
        collapsibleHeading: collapsibleHeading
    }, children);
    const headingWithDuplicateAnchor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e376df85e6c56fdc$var$HeadingWithDuplicateAnchor, {
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        dataAttributes: dataAttributes,
        headingId: headingId,
        invisible: invisible,
        level: level,
        localId: localId,
        marks: marks,
        nodeType: nodeType,
        serializer: serializer,
        showAnchorLink: showAnchorLink,
        asInline: asInline
    }, children);
    if (collapsibleHeading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e376df85e6c56fdc$var$CollapsibleHeadingContainer, {
        collapsibleHeading: collapsibleHeading,
        headingLevel: level
    }, headingWithDuplicateAnchor);
    return headingWithDuplicateAnchor;
}
var $e376df85e6c56fdc$export$2e2bcd8739ae039 = $e376df85e6c56fdc$var$Heading;
module.exports["default"] = $e376df85e6c56fdc$export$2e2bcd8739ae039;

});

parcelRegister("l531v", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aZS5C = parcelRequire("aZS5C");

const $9daee45b28a2ecea$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZS5C.default), {
        ...props,
        type: "inlineExtension"
    }, ({ result: result })=>{
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(result)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, result);
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, text || 'inlineExtension');
    }));
};
var $9daee45b28a2ecea$export$2e2bcd8739ae039 = $9daee45b28a2ecea$var$InlineExtension;
module.exports["default"] = $9daee45b28a2ecea$export$2e2bcd8739ae039;

});

parcelRegister("1YbJm", function(module, exports) {
$parcel$export(module.exports, "default", () => $34a94a4fb516de65$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $fqVYq = parcelRequire("fqVYq");

function $34a94a4fb516de65$export$2e2bcd8739ae039(props) {
    return (0, $fqVYq.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: "layout-section-container",
        "data-local-id": props.localId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-layout-section": true,
        "data-layout-columns": props?.content?.length
    }, props.children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-layout-section": true,
        "data-local-id": props.localId
    }, props.children);
}

});

parcelRegister("3PnTZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b7b7e274eb776bf$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $8m50u = parcelRequire("8m50u");


var $ieeJu = parcelRequire("ieeJu");

/* layoutColumn-compiled.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * Compiled branch of the `platform_editor_static_css` experiment.
 * Used via `componentWithCondition` in `layoutColumn.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $hekY6 = parcelRequire("hekY6");





var $dUm2W = parcelRequire("dUm2W");


var $iDrrr = parcelRequire("iDrrr");




const $0ce6f920034381c8$var$clearNextSiblingMarginTopStyle = null;
const $0ce6f920034381c8$var$verticalAlignMiddleStyles = null;
const $0ce6f920034381c8$var$verticalAlignBottomStyles = null;
const $0ce6f920034381c8$var$multipleWrappedImagesStyle = null; // localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $0ce6f920034381c8$var$clearNextSiblingBlockMarkMarginTopStyle = null;
const $0ce6f920034381c8$export$417b5700bb65fae1 = (props)=>{
    const isLayoutColumnMenuEnabled = (0, $ieeJu.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true);
    const isLayoutColumnValignRenderingEnabled = (0, $ieeJu.expValEquals)('platform_editor_layout_column_valign_rendering', 'isEnabled', true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        "data-valign": props.valign,
        style: {
            flexBasis: `${props.width}%`
        },
        className: (0, $hekY6.default)([
            (isLayoutColumnValignRenderingEnabled || isLayoutColumnMenuEnabled) && props.valign === 'middle' && "_3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT",
            (isLayoutColumnValignRenderingEnabled || isLayoutColumnMenuEnabled) && props.valign === 'bottom' && "_3iDTPbQ4SZ _0aFT5vbt8w _37wbyuz9WS",
            (0, $iDrrr.fg)('platform_editor_fix_media_in_renderer') && "_4k5rJtdnbC _2xQXhydnbC"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUm2W.WidthProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_4gcIbWAASz",
            "_31n3sWAASz _3JcWRXAASz _0LytGzAASz _2MBtJuAASz _0ut3unAASz _1SRkexAASz _19qHuIAASz"
        ])
    }), props.children));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion branch of the `platform_editor_static_css` experiment.
 * Used via `componentWithCondition` in `layoutColumn.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");










function $07f61e97d6c2ef4d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
const $07f61e97d6c2ef4d$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $07f61e97d6c2ef4d$var$verticalAlignMiddleStyles = {
    name: "16mmcnu",
    styles: "display:flex;flex-direction:column;justify-content:center"
};
const $07f61e97d6c2ef4d$var$verticalAlignBottomStyles = {
    name: "igeqly",
    styles: "display:flex;flex-direction:column;justify-content:flex-end"
};
const $07f61e97d6c2ef4d$var$multipleWrappedImagesStyle = {
    name: "y2yz5o",
    styles: "& [class*=\"image-wrap-\"] + [class*=\"image-wrap-\"], & [class*=\"image-wrap-\"]:has( + [class*=\"image-wrap-\"]){margin-top:0;}"
};
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $07f61e97d6c2ef4d$var$clearNextSiblingBlockMarkMarginTopStyle = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`+ .fabric-editor-block-mark > p,
	  + .fabric-editor-block-mark > h1,
	  + .fabric-editor-block-mark > h2,
	  + .fabric-editor-block-mark > h3,
	  + .fabric-editor-block-mark > h4,
	  + .fabric-editor-block-mark > h5,
	  + .fabric-editor-block-mark > h6
	`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});
const $07f61e97d6c2ef4d$export$2cc1a43fb56df180 = (props)=>{
    const isLayoutColumnMenuEnabled = (0, $ieeJu.expValEquals)('platform_editor_layout_column_menu', 'isEnabled', true);
    const isLayoutColumnValignRenderingEnabled = (0, $ieeJu.expValEquals)('platform_editor_layout_column_valign_rendering', 'isEnabled', true);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        "data-valign": props.valign,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- flexBasis is dynamic
        style: {
            flexBasis: `${props.width}%`
        },
        css: [
            // Keep separate: Compiled crashes on ternary/object lookup here.
            (isLayoutColumnValignRenderingEnabled || isLayoutColumnMenuEnabled) && props.valign === 'middle' && $07f61e97d6c2ef4d$var$verticalAlignMiddleStyles,
            (isLayoutColumnValignRenderingEnabled || isLayoutColumnMenuEnabled) && props.valign === 'bottom' && $07f61e97d6c2ef4d$var$verticalAlignBottomStyles,
            (0, $iDrrr.fg)('platform_editor_fix_media_in_renderer') && $07f61e97d6c2ef4d$var$multipleWrappedImagesStyle
        ]
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dUm2W.WidthProvider), null, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: [
            $07f61e97d6c2ef4d$var$clearNextSiblingMarginTopStyle,
            $07f61e97d6c2ef4d$var$clearNextSiblingBlockMarkMarginTopStyle
        ]
    }), props.children));
};


const $5b7b7e274eb776bf$var$LayoutSectionMigration = (0, $8m50u.componentWithCondition)(()=>(0, $ieeJu.expValEquals)('platform_editor_renderer_static_css', 'isEnabled', true), (0, $0ce6f920034381c8$export$417b5700bb65fae1), (0, $07f61e97d6c2ef4d$export$2cc1a43fb56df180));
function $5b7b7e274eb776bf$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5b7b7e274eb776bf$var$LayoutSectionMigration, props);
}

});

parcelRegister("aNi0I", function(module, exports) {
$parcel$export(module.exports, "default", () => $d743d69be334469a$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $d743d69be334469a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", null, props.children);
}

});

parcelRegister("dRPWO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $88npU = parcelRequire("88npU");

const $d1789a1c325fbe61$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88npU.default), {
        hasContent: true,
        dataAttributes: dataAttributes
    }, children);
};
var $d1789a1c325fbe61$export$2e2bcd8739ae039 = $d1789a1c325fbe61$var$RenderCaption;
module.exports["default"] = $d1789a1c325fbe61$export$2e2bcd8739ae039;

});

parcelRegister("cLDox", function(module, exports) {
$parcel$export(module.exports, "default", () => $5843be233ec89c70$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $ab7A2 = parcelRequire("ab7A2");


var $g2MiL = parcelRequire("g2MiL");


var $eTXkv = parcelRequire("eTXkv");

var $iAA8Q = parcelRequire("iAA8Q");


var $47hKc = parcelRequire("47hKc");

function $5843be233ec89c70$export$2e2bcd8739ae039(props) {
    const extraProps = {};
    const itemCounterDigitsSize = (0, $eTXkv.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: props?.content?.length
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 1) extraProps.style = (0, $g2MiL.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $iAA8Q.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ol", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $ab7A2.orderedListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $47hKc.getListIndentLevel)(props.path) : 1,
        start: props.start,
        ...extraProps
    }, props.children);
}

});

parcelRegister("ZVVLb", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a2ac3a7eda92373$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");




function $105a9fe3c32a8479$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, "\xa0");
    return children;
}


function $9a2ac3a7eda92373$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes, localId: localId, asInline: asInline }) {
    return(// ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", {
        ...dataAttributes,
        "data-local-id": localId,
        "data-as-inline": asInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $105a9fe3c32a8479$export$2e2bcd8739ae039), null, children)));
}

});

parcelRegister("174uk", function(module, exports) {
$parcel$export(module.exports, "default", () => $02ef053957377134$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $02ef053957377134$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-placeholder": `${props.text}`
    }, props.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null);
}

});

parcelRegister("fARVe", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf704b1908ac2fba$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $bf704b1908ac2fba$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("hr", {
        role: "presentation"
    });
}

});

parcelRegister("cAWpJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $39Puj = parcelRequire("39Puj");


var $cbws3 = parcelRequire("cbws3");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $7Meja = parcelRequire("7Meja");


var $lqPdm = parcelRequire("lqPdm");


var $5TMHS = parcelRequire("5TMHS");


var $cY9xy = parcelRequire("cY9xy");


var $krYZG = parcelRequire("krYZG");


var $96p1s = parcelRequire("96p1s");


var $kSwu1 = parcelRequire("kSwu1");


var $2Voi6 = parcelRequire("2Voi6");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");

const $6d9a98672a9aa511$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $6d9a98672a9aa511$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $7Meja.SortOrder).NO_ORDER:
            return (0, $7Meja.SortOrder).ASC;
        case (0, $7Meja.SortOrder).ASC:
            return (0, $7Meja.SortOrder).DESC;
        case (0, $7Meja.SortOrder).DESC:
            return (0, $7Meja.SortOrder).NO_ORDER;
    }
    return (0, $7Meja.SortOrder).NO_ORDER;
};
const $6d9a98672a9aa511$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $2Voi6.tableCellMessages);
    switch(currentSortOrder){
        case (0, $7Meja.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $7Meja.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $7Meja.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
const $6d9a98672a9aa511$var$getDataAttributes = (colwidth, background, cellEdgeProps, valign)=>{
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    if ((0, $ieeJu.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) {
        if (cellEdgeProps?.reachesTop) attrs['data-reaches-top'] = true;
        if (cellEdgeProps?.reachesBottom) attrs['data-reaches-bottom'] = true;
        if (cellEdgeProps?.reachesLeft) attrs['data-reaches-left'] = true;
        if (cellEdgeProps?.reachesRight) attrs['data-reaches-right'] = true;
    }
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    if (valign && (0, $anBbz.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true)) attrs['data-valign'] = valign;
    return attrs;
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $6d9a98672a9aa511$var$cssVariablePattern = /^var\(--.*\)$/;
const $6d9a98672a9aa511$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode, valign: valign })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $lqPdm.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $6d9a98672a9aa511$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $cbws3.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    if (valign && (0, $anBbz.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true)) style.verticalAlign = valign;
    return style;
};
const $6d9a98672a9aa511$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $IQ4Dz.default)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort, reachesTop: reachesTop, reachesBottom: reachesBottom, reachesLeft: reachesLeft, reachesRight: reachesRight, valign: valign } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const backgroundHex = background?.toLowerCase();
        const colorName = backgroundHex ? (0, $39Puj.tableBackgroundColorNameByHex).get(backgroundHex) : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrapperComponent, {
            rowSpan: rowspan,
            colSpan: colspan,
            // Note: When content from a renderer is pasted into an editor
            // the background color is not taken from the inline style.
            // Instead it is taken from the data-cell-background attribute
            // (added via getDataAttributes below).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $6d9a98672a9aa511$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode,
                valign: valign
            }),
            colorname: colorName,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ...$6d9a98672a9aa511$var$getDataAttributes(colwidth, background, {
                reachesTop: reachesTop,
                reachesBottom: reachesBottom,
                reachesLeft: reachesLeft,
                reachesRight: reachesRight
            }, valign),
            "aria-sort": ariaSort
        }, children);
    };
};
const $6d9a98672a9aa511$var$TH = $6d9a98672a9aa511$var$getWithCellProps('th');
const $6d9a98672a9aa511$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $kSwu1.useIntl)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $7Meja.SortOrder).NO_ORDER ? (0, $96p1s.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrapperComponent, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrapperComponent, {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $96p1s.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $6d9a98672a9aa511$var$getSortOrderLabel(intl, sortOrdered)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $96p1s.RendererCssClassName).SORTABLE_COLUMN
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("figure", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $96p1s.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5TMHS.default), {
            isSortingAllowed: !!onSorting,
            sortOrdered: sortOrdered,
            onClick: sort,
            onKeyDown: onKeyPress
        }))));
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$6d9a98672a9aa511$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $6d9a98672a9aa511$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $krYZG.ACTION).SORT_COLUMN,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $cY9xy.PLATFORM).WEB,
                        mode: (0, $cY9xy.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $cY9xy.PLATFORM).WEB,
                    mode: (0, $cY9xy.MODE).RENDERER
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            });
        }
    };
};
const $6d9a98672a9aa511$export$f850895b287ef28e = $6d9a98672a9aa511$export$cfca40ca5c56a38e($6d9a98672a9aa511$var$TH);
const $6d9a98672a9aa511$var$TD = $6d9a98672a9aa511$var$getWithCellProps('td');
const $6d9a98672a9aa511$export$1e4baea7053fc0e3 = $6d9a98672a9aa511$var$TD;
module.exports["TableHeader"] = $6d9a98672a9aa511$export$f850895b287ef28e;
module.exports["TableCell"] = $6d9a98672a9aa511$export$1e4baea7053fc0e3;

});

parcelRegister("7OAKt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $acipJ = parcelRequire("acipJ");


var $7Meja = parcelRequire("7Meja");


var $96p1s = parcelRequire("96p1s");

class $2bfdc8f454abe6d8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { children: children, innerRef: innerRef, isFirstRow: isFirstRow, isLastRow: isLastRow } = this.props;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("tr", {
            ref: innerRef
        }, this.props.isNumberColumnEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("td", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $96p1s.RendererCssClassName).NUMBER_COLUMN,
            "data-reaches-left": true,
            "data-reaches-top": isFirstRow || undefined,
            "data-reaches-bottom": isLastRow || undefined
        }, this.props.index), (0, $acipJ.compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray));
    }
    constructor(...args){
        super(...args);
        this.state = {
            colGroupWidths: []
        };
        this.addSortableColumn = (childrenArray)=>{
            const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
            const isHeaderRow = !rowIndex;
            if (allowColumnSorting && isHeaderRow) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) {
                    const { tableOrderStatus: tableOrderStatus } = this.props;
                    let sortOrdered = (0, $7Meja.SortOrder).NO_ORDER;
                    if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, $7Meja.SortOrder).NO_ORDER;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
                        columnIndex: index,
                        onSorting: this.props.onSorting,
                        sortOrdered: sortOrdered,
                        isHeaderRow: isHeaderRow
                    });
                }
            });
            return childrenArray;
        };
        this.addColGroupWidth = (childrenArray)=>{
            if (this.state.colGroupWidths?.length) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
                    colGroupWidth: this.state.colGroupWidths[index]
                });
            });
            return childrenArray;
        };
    }
}
module.exports["default"] = $2bfdc8f454abe6d8$export$2e2bcd8739ae039;

});

parcelRegister("57Y2G", function(module, exports) {
$parcel$export(module.exports, "default", () => $4483b76740b83344$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $4483b76740b83344$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: "UnknownBlock"
    }, props.children);
}

});

parcelRegister("a89Z1", function(module, exports) {
function $f7460e0f91c050f8$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    const defaultLocale = 'en';
    let canTranslateToLocale = true;
    const locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}
module.exports["getUnsupportedContent"] = $f7460e0f91c050f8$export$d4ded51d0f0bd2df;

});

parcelRegister("HYsb2", function(module, exports) {
const $15db0eb1461277fe$export$dca2026e63034304 = (importedModule)=>{
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};
module.exports["resolveImportSync"] = $15db0eb1461277fe$export$dca2026e63034304;

});

parcelRegister("judez", function(module, exports) {
const $c0506076fe718eed$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};
module.exports["buildExtensionKeyAndNodeKey"] = $c0506076fe718eed$export$5f3eb042babacbbd;

});

parcelRegister("beDE4", function(module, exports) {
var $c56b449a212d483f$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});
module.exports["ShadowKeys"] = $c56b449a212d483f$export$ebeea2fe2e93862e;

});

parcelRegister("fTrZV", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $60EJg = parcelRequire("60EJg");


var $7Y8M5 = parcelRequire("7Y8M5");


var $dUm2W = parcelRequire("dUm2W");

function $5ddc38808d4efbf4$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
const $5ddc38808d4efbf4$export$3de34996b814f0f0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BaseThemeWrapper(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { baseFontSize: baseFontSize, children: children } = t0;
    const t1 = baseFontSize || 14;
    let t2;
    if ($[0] !== t1) {
        t2 = {
            baseFontSize: t1,
            layoutMaxWidth: (0, $7Y8M5.akEditorDefaultLayoutWidth)
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const memoizedTheme = t2;
    let t3;
    if ($[2] !== children || $[3] !== memoizedTheme) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $60EJg.a), {
            theme: memoizedTheme,
            children: children
        });
        $[2] = children;
        $[3] = memoizedTheme;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function BaseThemeWrapper({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $cozmU.useMemo)(()=>({
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $7Y8M5.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $60EJg.a), {
        theme: memoizedTheme,
        children: children
    });
};
const $5ddc38808d4efbf4$export$a1a213d350ca51ca = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BaseTheme(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children, baseFontSize: baseFontSize } = t0;
    let t1;
    if ($[0] !== baseFontSize || $[1] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dUm2W.WidthConsumer), {
            children: (t2)=>{
                const { breakpoint: breakpoint } = t2;
                return /*#__PURE__*/ (0, $8aG6j.jsx)($5ddc38808d4efbf4$export$3de34996b814f0f0, {
                    breakpoint: breakpoint,
                    baseFontSize: baseFontSize,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
                        children: children
                    })
                });
            }
        });
        $[0] = baseFontSize;
        $[1] = children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function BaseTheme({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dUm2W.WidthConsumer), {
        children: ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, $8aG6j.jsx)($5ddc38808d4efbf4$export$3de34996b814f0f0, {
                breakpoint: breakpoint,
                baseFontSize: baseFontSize,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
                    children: children
                })
            })
    });
};
module.exports["mapBreakpointToLayoutMaxWidth"] = $5ddc38808d4efbf4$export$b5ccf4d25d2c5af1;
module.exports["BaseTheme"] = $5ddc38808d4efbf4$export$a1a213d350ca51ca;

});

parcelRegister("bJeQi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $epbW8 = parcelRequire("epbW8");


var $fJCU9 = parcelRequire("fJCU9");


var $hRnS5 = parcelRequire("hRnS5");

const $c7274055ae162b70$var$initState = {
    isDrafting: false,
    draftId: undefined,
    draftMarkRef: undefined,
    draftActionResult: undefined,
    annotations: {},
    currentSelectedAnnotationId: undefined,
    currentSelectedMarkRef: undefined,
    currentHoveredAnnotationId: undefined
};
const $c7274055ae162b70$var$AnnotationManagerStateContext = /*#__PURE__*/ (0, $cozmU.createContext)($c7274055ae162b70$var$initState);
const $c7274055ae162b70$var$AnnotationManagerDispatchContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    annotationManager: undefined,
    dispatch: ()=>{}
});
function $c7274055ae162b70$var$reducer(state, action) {
    switch(action.type){
        case 'reset':
            return {
                ...state,
                ...$c7274055ae162b70$var$initState
            };
        case 'loadAnnotation':
            {
                const currentIds = Object.keys(state.annotations);
                const uids = Array.from(new Set(currentIds.concat(action.data.map((a)=>a.id))));
                const updates = [];
                for (const id of uids){
                    const loadedAnnotation = action.data.find((a)=>a.id === id);
                    if (!loadedAnnotation && state.annotations[id]?.markState === (0, $epbW8.AnnotationMarkStates).ACTIVE) {
                        // If the annotation is not in the loaded data, we need to remove it from the state. However,
                        // rather then removing it, we will set the mark state to resolved. This is to align it better with
                        // how the editor works.
                        updates.push({
                            id: id,
                            markState: (0, $epbW8.AnnotationMarkStates).RESOLVED
                        });
                        continue;
                    }
                    if (!!loadedAnnotation?.markState && state.annotations[id]?.markState !== loadedAnnotation.markState) {
                        updates.push({
                            id: id,
                            markState: loadedAnnotation.markState
                        });
                        continue;
                    }
                }
                if (updates.length > 0) return {
                    ...state,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'updateAnnotation':
            {
                const current = state.annotations[action.data.id];
                const { id: id, selected: selected, hovered: hovered, markState: markState = current?.markState } = action.data;
                const updates = [];
                // If the annotation is not currently in the state, we need to add it to the state.
                if (!current) updates.push({
                    id: id,
                    markState: markState ?? (0, $epbW8.AnnotationMarkStates).ACTIVE
                });
                // The goal of the following is to enforce a single selection and a single hover state across all annotations.
                let nextSelectedId = state.currentSelectedAnnotationId;
                if (selected && nextSelectedId !== id) nextSelectedId = id;
                // If the annotation is currently selected and it's being unselected, we need to remove it from the
                // current selected annotation id.
                if (selected === false && nextSelectedId === id) nextSelectedId = undefined;
                let nextHoveredId = state.currentHoveredAnnotationId;
                if (hovered && nextHoveredId !== id) nextHoveredId = id;
                // If the annotation is currently hovered and it's being unhovered, we need to remove it from the
                // current hovered annotation id.
                if (hovered === false && nextHoveredId === id) nextHoveredId = undefined;
                // If the annotations mark state is not the same as the current mark state, we need to update it.
                if (current?.markState !== markState) {
                    updates.push({
                        id: id,
                        markState: markState ?? (0, $epbW8.AnnotationMarkStates).ACTIVE
                    });
                    // If the annotation is currently selected and it's being resolved, then we need to remove it from the
                    // current selected annotation id also.
                    if (markState === (0, $epbW8.AnnotationMarkStates).RESOLVED && nextSelectedId === id) nextSelectedId = undefined;
                }
                if (updates.length > 0 || nextSelectedId !== state.currentSelectedAnnotationId || nextHoveredId !== state.currentHoveredAnnotationId) return {
                    ...state,
                    currentSelectedAnnotationId: nextSelectedId,
                    currentHoveredAnnotationId: nextHoveredId,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'resetSelectedAnnotation':
            if (state.currentSelectedAnnotationId !== undefined) return {
                ...state,
                currentSelectedAnnotationId: undefined,
                currentSelectedMarkRef: undefined
            };
            return state;
        case 'resetHoveredAnnotation':
            if (state.currentHoveredAnnotationId !== undefined) return {
                ...state,
                currentHoveredAnnotationId: undefined
            };
            return state;
        case 'setDrafting':
            if (state.isDrafting !== action.data.isDrafting || state.draftId !== action.data.draftId || state.draftActionResult !== action.data.draftActionResult) // XXX: When a draft is open the current selected annotation should no longer be selected. We need
            // to decide what is better UX,
            // 1 - do we want to deselct the selected annotation on draft open, if so then when draft is closed the s
            // selected annotation will not come back
            // 2 - do we want to still allow the selected annotation to be selected when draft is open, however the underlying
            // mark style just shows the annotation as not selected when a draft is active. Then when a draft closes
            // we can reopen the previous selected annotation.
            return {
                ...state,
                isDrafting: action.data.isDrafting,
                draftId: action.data.draftId,
                draftActionResult: action.data.draftActionResult
            };
            return state;
        case 'setDraftMarkRef':
            if (state.draftMarkRef !== action.data.draftMarkRef) return {
                ...state,
                draftMarkRef: action.data.draftMarkRef
            };
            return state;
        case 'setSelectedMarkRef':
            if (state.currentSelectedMarkRef !== action.data.markRef) return {
                ...state,
                currentSelectedMarkRef: action.data.markRef
            };
            return state;
    }
}
const $c7274055ae162b70$export$f21fb05766361bb3 = ({ children: children, annotationManager: annotationManager, updateSubscriber: updateSubscriber })=>{
    const [state, dispatch] = (0, $cozmU.useReducer)($c7274055ae162b70$var$reducer, $c7274055ae162b70$var$initState);
    const actionContext = (0, $cozmU.useContext)((0, $hRnS5.RendererContext));
    (0, $cozmU.useEffect)(()=>{
        const getDraft = ()=>{
            if (!state.isDrafting || !state.draftActionResult || !state.draftMarkRef || !state.draftId) return {
                success: false,
                reason: 'draft-not-started'
            };
            return {
                success: true,
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            };
        };
        annotationManager?.hook('getDraft', getDraft);
        return ()=>{
            annotationManager?.unhook('getDraft', getDraft);
        };
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    // We need to watch for the draft mark element to exist, so we can inform any listeners that the draft has been started
    // and give them a reference to the element
    (0, $cozmU.useEffect)(()=>{
        if (state.isDrafting && state.draftId && state.draftMarkRef && state.draftActionResult) annotationManager?.emit({
            name: 'draftAnnotationStarted',
            data: {
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            }
        });
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    (0, $cozmU.useEffect)(()=>{
        const setIsAnnotationSelected = (id, isSelected)=>{
            if (state.isDrafting) return {
                success: false,
                reason: 'draft-in-progress'
            };
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            // the annotation is currently not selected and is being selected
            if (id !== state.currentSelectedAnnotationId && isSelected) {
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true
                    }
                });
                dispatch({
                    type: 'setSelectedMarkRef',
                    data: {
                        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- resolve mark node by id in the document
                        markRef: document.getElementById(id) || undefined
                    }
                });
            } else if (id === state.currentSelectedAnnotationId && !isSelected) dispatch({
                type: 'resetSelectedAnnotation'
            });
            return {
                success: true,
                isSelected: isSelected
            };
        };
        annotationManager?.hook('setIsAnnotationSelected', setIsAnnotationSelected);
        return ()=>{
            annotationManager?.unhook('setIsAnnotationSelected', setIsAnnotationSelected);
        };
    }, [
        annotationManager,
        state.isDrafting,
        state.annotations,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    const prevSelectedAnnotationId = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useEffect)(()=>{
        if (prevSelectedAnnotationId.current) annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: prevSelectedAnnotationId.current,
                isSelected: false,
                inlineNodeTypes: []
            }
        });
        prevSelectedAnnotationId.current = state.currentSelectedAnnotationId;
    }, [
        state.currentSelectedAnnotationId,
        annotationManager
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (state.currentSelectedAnnotationId && state.currentSelectedMarkRef && state.currentSelectedMarkRef.id === state.currentSelectedAnnotationId) annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: state.currentSelectedAnnotationId,
                isSelected: true,
                inlineNodeTypes: []
            }
        });
    }, [
        annotationManager,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        const setIsAnnotationHovered = (id, isHovered)=>{
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: id,
                    hovered: isHovered
                }
            });
            return {
                success: true,
                isHovered: isHovered
            };
        };
        annotationManager?.hook('setIsAnnotationHovered', setIsAnnotationHovered);
        return ()=>{
            annotationManager?.unhook('setIsAnnotationHovered', setIsAnnotationHovered);
        };
    }, [
        annotationManager,
        state.annotations
    ]);
    (0, $cozmU.useEffect)(()=>{
        const clearAnnotation = (id)=>{
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            const result = actionContext.deleteAnnotation(id, (0, $epbW8.AnnotationTypes).INLINE_COMMENT);
            if (!result) return {
                success: false,
                reason: 'clear-failed'
            };
            const { step: step, doc: doc } = result;
            return {
                success: true,
                actionResult: {
                    step: step,
                    doc: doc
                }
            };
        };
        annotationManager?.hook('clearAnnotation', clearAnnotation);
        return ()=>{
            annotationManager?.unhook('clearAnnotation', clearAnnotation);
        };
    }, [
        annotationManager,
        state.annotations,
        actionContext
    ]);
    /**
   * This is a temporary solution to ensure that the annotation manager state is in sync with the
   * old updateSubscriber. The updateSubscriber will eventually be deprecated and the state will be managed
   * by the annotation manager itself.
   */ (0, $cozmU.useEffect)(()=>{
        const onSetAnnotationState = (payload)=>{
            if (!payload) return;
            Object.values(payload).forEach((annotation)=>{
                if (annotation.id && annotation.annotationType === (0, $epbW8.AnnotationTypes).INLINE_COMMENT) dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: annotation.id,
                        markState: annotation.state ?? undefined
                    }
                });
            });
        };
        const onAnnotationSelected = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    selected: true
                }
            });
        };
        const onAnnotationHovered = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    hovered: true
                }
            });
        };
        const onAnnotationSelectedRemoved = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        const onAnnotationHoveredRemoved = ()=>{
            dispatch({
                type: 'resetHoveredAnnotation'
            });
        };
        const onAnnotationClick = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: _eventTargetType, viewMethod: _viewMethod })=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: annotationIds[0],
                    selected: true
                }
            });
            dispatch({
                type: 'setSelectedMarkRef',
                data: {
                    markRef: eventTarget
                }
            });
        };
        const onAnnotationDeselect = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        updateSubscriber?.on((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
        updateSubscriber?.on((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
        updateSubscriber?.on((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
        updateSubscriber?.on((0, $fJCU9.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
        updateSubscriber?.on((0, $fJCU9.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
        updateSubscriber?.on((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
        updateSubscriber?.on((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        return ()=>{
            updateSubscriber?.off((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
            updateSubscriber?.off((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
            updateSubscriber?.off((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
            updateSubscriber?.off((0, $fJCU9.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
            updateSubscriber?.off((0, $fJCU9.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
            updateSubscriber?.off((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
            updateSubscriber?.off((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        };
    }, [
        updateSubscriber
    ]);
    const dispatchData = (0, $cozmU.useMemo)(()=>({
            annotationManager: annotationManager,
            dispatch: dispatch
        }), [
        annotationManager,
        dispatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7274055ae162b70$var$AnnotationManagerStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7274055ae162b70$var$AnnotationManagerDispatchContext.Provider, {
        value: dispatchData
    }, children));
};
const $c7274055ae162b70$export$654a1fb45487f838 = ()=>{
    return (0, $cozmU.useContext)($c7274055ae162b70$var$AnnotationManagerStateContext);
};
const $c7274055ae162b70$export$12cbbb89fb7702d0 = ()=>{
    return (0, $cozmU.useContext)($c7274055ae162b70$var$AnnotationManagerDispatchContext);
};
module.exports["AnnotationManagerProvider"] = $c7274055ae162b70$export$f21fb05766361bb3;
module.exports["useAnnotationManagerState"] = $c7274055ae162b70$export$654a1fb45487f838;
module.exports["useAnnotationManagerDispatch"] = $c7274055ae162b70$export$12cbbb89fb7702d0;

});

parcelRegister("82HbV", function(module, exports) {
/* eslint-disable @atlaskit/platform/no-direct-document-usage -- draft selection uses document range APIs */ const $f7db5bdf68d6a74f$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $f7db5bdf68d6a74f$var$buildDataAttributesQuery = (pos)=>{
    const a = $f7db5bdf68d6a74f$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $f7db5bdf68d6a74f$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($f7db5bdf68d6a74f$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};
module.exports["dataAttributes"] = $f7db5bdf68d6a74f$export$15d6ddc168d35719;
module.exports["updateWindowSelectionAroundDraft"] = $f7db5bdf68d6a74f$export$e14699d956e87e73;

});

parcelRegister("lX0Us", function(module, exports) {

var $fRYCB = parcelRequire("fRYCB");


var $iDrrr = parcelRequire("iDrrr");

function $f64613f4461d54bc$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
    if (!(0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const inlineNodeNames = (0, $fRYCB.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}
function $f64613f4461d54bc$export$1726c23d64498b6({ actions: actions, pos: pos }) {
    if (!(0, $iDrrr.fg)('cc_comments_log_draft_annotation_ancestor_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const ancestorNodeNames = (0, $fRYCB.getRangeAncestorNodeNames)({
        doc: doc,
        pos: pos
    });
    return ancestorNodeNames;
}
module.exports["getRendererRangeInlineNodeNames"] = $f64613f4461d54bc$export$b0ea72d31617ccea;
module.exports["getRendererRangeAncestorNodeNames"] = $f64613f4461d54bc$export$1726c23d64498b6;

});

parcelRegister("2P3ZY", function(module, exports) {
var $a2e560b52c03055b$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});
module.exports["ContentType"] = $a2e560b52c03055b$export$e2e108cbe2e4f865;

});

parcelRegister("4DK3l", function(module, exports) {
var $9e38ab4521e8f00f$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});
module.exports["StatusClassNames"] = $9e38ab4521e8f00f$export$c3618f310f725028;

});

parcelRegister("3u6EZ", function(module, exports) {
const $014f7577e1dd126c$export$b44a013e4f554514 = (tableNode)=>{
    const firstRow = tableNode.content.firstChild;
    if (!firstRow) return false;
    for(let i = 0; i < firstRow.childCount; i++){
        if (firstRow.child(i).attrs.colwidth) return true;
    }
    return false;
};
module.exports["hasTableColumnBeenResized"] = $014f7577e1dd126c$export$b44a013e4f554514;

});

parcelRegister("3lwj7", function(module, exports) {
const $fadc3b0195da64df$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
module.exports["isSubSupType"] = $fadc3b0195da64df$export$30f8aa4cc1f8c1cb;

});

parcelRegister("3tNiJ", function(module, exports) {
/*
 * It's important that this order follows the marks rank defined here:
 * https://product-fabric.atlassian.net/wiki/spaces/ETEMP/pages/11174043/Atlassian+Document+Format+-+Internal+documentation#Rank
 */ const $772d0c28c2386499$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
module.exports["markOrder"] = $772d0c28c2386499$export$62d5811a2955c1d8;

});

parcelRegister("dIt4J", function(module, exports) {
const $f502ccdb7787f8aa$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
module.exports["isSameMark"] = $f502ccdb7787f8aa$export$b1304404bdc42b7a;

});

parcelRegister("2Voi6", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $kSwu1 = parcelRequire("kSwu1");

const $b87f2baaa8600d6e$export$7f5b2987e1dbb312 = (0, $kSwu1.defineMessages)({
    collapseSection: {
        id: "fabric.editor.collapsibleHeading.collapseSection.ai-non-final",
        defaultMessage: "Collapse section"
    },
    expandSection: {
        id: "fabric.editor.collapsibleHeading.expandSection.ai-non-final",
        defaultMessage: "Expand section"
    }
});
const $b87f2baaa8600d6e$export$74bada844422036d = (0, $kSwu1.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: "fabric.editor.headingLink.copyAnchorLink",
        defaultMessage: "Copy link to heading"
    },
    copyLinkToClipboard: {
        id: "fabric.editor.headingLink.copyAnchorLinkTo",
        defaultMessage: "Copy link to"
    },
    copyHeadingLinkLabelledBy: {
        id: "fabric.editor.headingLink.copyAnchorLinkLabelledBy",
        defaultMessage: "{copyLink} {heading}"
    },
    copiedHeadingLinkToClipboard: {
        id: "fabric.editor.headingLink.copied",
        defaultMessage: "Copied!"
    },
    failedToCopyHeadingLink: {
        id: "fabric.editor.headingLink.failedToCopy",
        defaultMessage: "Copy failed"
    },
    copyAriaLabel: {
        id: "fabric.editor.headingLink.copyAriaLabel",
        defaultMessage: "Copy"
    }
});
const $b87f2baaa8600d6e$export$c79ebc36348824d1 = (0, $kSwu1.defineMessages)({
    noneSortingLabel: {
        id: "fabric.editor.headingLink.noneSortingLabel",
        defaultMessage: "none"
    },
    ascSortingLabel: {
        id: "fabric.editor.headingLink.ascSortingLabel",
        defaultMessage: "ascending"
    },
    descSortingLabel: {
        id: "fabric.editor.headingLink.descSortingLabel",
        defaultMessage: "descending"
    }
});
const $b87f2baaa8600d6e$export$9f52c375a6ef34fc = (0, $kSwu1.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: "fabric.editor.inlineComment.marker.start",
        defaultMessage: "inline comment start"
    },
    contentRendererInlineCommentMarkerEnd: {
        id: "fabric.editor.inlineComment.marker.end",
        defaultMessage: "inline comment end"
    }
});
module.exports["collapsibleHeadingMessages"] = $b87f2baaa8600d6e$export$7f5b2987e1dbb312;
module.exports["headingAnchorLinkMessages"] = $b87f2baaa8600d6e$export$74bada844422036d;
module.exports["tableCellMessages"] = $b87f2baaa8600d6e$export$c79ebc36348824d1;
module.exports["inlineCommentMessages"] = $b87f2baaa8600d6e$export$9f52c375a6ef34fc;

});

parcelRegister("5J8wl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fJCU9 = parcelRequire("fJCU9");


var $epbW8 = parcelRequire("epbW8");


var $krYZG = parcelRequire("krYZG");


var $iTJtk = parcelRequire("iTJtk");


var $bJeQi = parcelRequire("bJeQi");

const $76fdd91f2e7f14af$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $cozmU.useState)({});
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $bJeQi.useAnnotationManagerDispatch)();
    const { annotations: annotations } = (0, $bJeQi.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            return ()=>{
                updateSubscriber.off((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            };
        }
    }, [
        states,
        type,
        updateSubscriber,
        dispatch,
        isAnnotationManagerEnabled
    ]);
    const annotationMarkStates = (0, $cozmU.useMemo)(()=>{
        return Object.values(annotations).reduce((acc, curr)=>{
            return {
                ...acc,
                [curr.id]: curr.markState
            };
        }, {});
    }, [
        annotations
    ]);
    if (isAnnotationManagerEnabled) return annotationMarkStates;
    else return states;
};
const $76fdd91f2e7f14af$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $cozmU.useState)(false);
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentHoveredAnnotationId: currentHoveredAnnotationId } = (0, $bJeQi.useAnnotationManagerState)();
    const { annotationManager: annotationManager } = (0, $bJeQi.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const callbackForHoveredAnnotation = (payload)=>{
            setIsHovered(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
        };
        const removeHoverEffect = ()=>{
            setIsHovered(false);
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.on((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.on((0, $fJCU9.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.on((0, $fJCU9.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
            return ()=>{
                updateSubscriber.off((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
                updateSubscriber.off((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
                updateSubscriber.off((0, $fJCU9.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
                updateSubscriber.off((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
            };
        }
    }, [
        id,
        updateSubscriber,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return {
        hasFocus: currentSelectedAnnotationId === id,
        isHovered: currentHoveredAnnotationId === id
    };
    else return {
        hasFocus: hasFocus,
        isHovered: isHovered
    };
};
const $76fdd91f2e7f14af$var$NO_ANNOTATION_SELECTED = {
    annotations: [],
    clickElementTarget: undefined
};
const $76fdd91f2e7f14af$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $cozmU.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
    const { annotationManager: annotationManager } = (0, $bJeQi.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentSelectedMarkRef: currentSelectedMarkRef } = (0, $bJeQi.useAnnotationManagerState)();
    const selectedAnnotation = (0, $cozmU.useMemo)(()=>{
        return currentSelectedAnnotationId && currentSelectedMarkRef && currentSelectedMarkRef.id === currentSelectedAnnotationId ? {
            annotations: [
                {
                    id: currentSelectedAnnotationId,
                    type: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
                }
            ],
            clickElementTarget: currentSelectedMarkRef
        } : // When creating a new annotation, currentSelectedAnnotationId and currentSelectedMarkRef will be set one after another,
        // if this isn't a const, it will cause useMemo to return two different "empty" objects and causes infinite re-renders.
        $76fdd91f2e7f14af$var$NO_ANNOTATION_SELECTED;
    }, [
        currentSelectedAnnotationId,
        currentSelectedMarkRef
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!updateSubscriber || isNestedRender) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $krYZG.ACTION).VIEWED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    targetNodeType: eventTargetType,
                    method: viewMethod
                }
            }).fire((0, $iTJtk.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.on((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            return ()=>{
                updateSubscriber.off((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
                updateSubscriber.off((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            };
        }
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isNestedRender,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return isNestedRender ? null : selectedAnnotation;
    else return annotationClickEvent;
};
module.exports["useAnnotationStateByTypeEvent"] = $76fdd91f2e7f14af$export$95f9f9045e92d283;
module.exports["useHasFocusEvent"] = $76fdd91f2e7f14af$export$48f5d7f6702be07c;
module.exports["useAnnotationClickEvent"] = $76fdd91f2e7f14af$export$26cf539704e444c1;

});

parcelRegister("6RYDu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $7fa3a843b9d3f925$export$6a26b015ac619737 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $7fa3a843b9d3f925$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $cozmU.createContext)({});
module.exports["ProvidersContext"] = $7fa3a843b9d3f925$export$6a26b015ac619737;
module.exports["InlineCommentsStateContext"] = $7fa3a843b9d3f925$export$aafe46a36ef535ba;

});

parcelRegister("lxxPS", function(module, exports) {
/* eslint-disable jsdoc/require-jsdoc */ 
var $4EPzQ = parcelRequire("4EPzQ");

function $0985e1c4c175ac29$export$1daf15cbaf649dad(adfDocument) {
    return (0, $4EPzQ.reduce)(adfDocument, (acc, node)=>{
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}
module.exports["countNodes"] = $0985e1c4c175ac29$export$1daf15cbaf649dad;

});

parcelRegister("an4b1", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");

const $815a27cd335eb930$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $lOiVq.css)();
};
module.exports["overflowShadow"] = $815a27cd335eb930$export$c5c1e4f4640336fb;

});

parcelRegister("l7yGH", function(module, exports) {
const $3889d235496eeb47$export$87eeb477611c8fe = (layout)=>{
    if (layout === 'full-width') return 'min(var(--ak-editor--breakout-container-without-gutter-width), var(--ak-editor--full-width-layout-width))';
    if (layout === 'wide') return 'min(var(--ak-editor--breakout-container-without-gutter-width), var(--ak-editor--breakout-wide-layout-width))';
    return '100%';
};
module.exports["calcBreakoutWidthCss"] = $3889d235496eeb47$export$87eeb477611c8fe;

});

parcelRegister("jqmxP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $4oVOc = parcelRequire("4oVOc");


var $782Oz = parcelRequire("782Oz");

const $4c14c60c78d48fd8$var$CollapsibleHeadingsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
const $4c14c60c78d48fd8$var$emptyCollapsedHeadings = new Set();
function $4c14c60c78d48fd8$var$isSameDocument(currentDocument, nextDocument) {
    // Renderer reparses equivalent ADF on parent rerenders, so object identity is not stable.
    return currentDocument === nextDocument || Boolean(currentDocument && nextDocument && currentDocument.eq(nextDocument));
}
function $4c14c60c78d48fd8$var$supportsHiddenUntilFound(rendererRef) {
    const body = rendererRef.current?.ownerDocument.body;
    return body ? 'onbeforematch' in body : false;
}
function $4c14c60c78d48fd8$export$158f0ca2ade2cf24({ children: children, isEnabled: isEnabled, pmDocument: pmDocument, rendererRef: rendererRef }) {
    const [isBrowserFindSupported, setIsBrowserFindSupported] = (0, $cozmU.useState)(false);
    const [state, setState] = (0, $cozmU.useState)({
        pmDocument: pmDocument,
        positions: new Set()
    });
    const originalHiddenAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(new WeakMap()).current;
    const sections = (0, $cozmU.useMemo)(()=>(0, $782Oz.buildTopLevelHeadingSections)(pmDocument), [
        pmDocument
    ]);
    const collapsibleSectionPositions = (0, $cozmU.useMemo)(()=>new Set(sections.filter((section)=>section.contentFrom < section.to).map((section)=>section.headingPos)), [
        sections
    ]);
    const isCurrentDocument = $4c14c60c78d48fd8$var$isSameDocument(state.pmDocument, pmDocument);
    const collapsedHeadings = isCurrentDocument ? state.positions : $4c14c60c78d48fd8$var$emptyCollapsedHeadings;
    const isActive = isEnabled && isBrowserFindSupported && Boolean(pmDocument);
    (0, $cozmU.useEffect)(()=>{
        setIsBrowserFindSupported(isEnabled && $4c14c60c78d48fd8$var$supportsHiddenUntilFound(rendererRef));
    }, [
        isEnabled,
        rendererRef
    ]);
    const updateCollapsedHeadings = (0, $cozmU.useCallback)((update)=>{
        setState((currentState)=>{
            const isStillCurrentDocument = $4c14c60c78d48fd8$var$isSameDocument(currentState.pmDocument, pmDocument);
            const positions = new Set(isStillCurrentDocument ? currentState.positions : $4c14c60c78d48fd8$var$emptyCollapsedHeadings);
            if (!update(positions)) return isStillCurrentDocument ? currentState : {
                pmDocument: pmDocument,
                positions: positions
            };
            return {
                pmDocument: pmDocument,
                positions: positions
            };
        });
    }, [
        pmDocument
    ]);
    const collapse = (0, $cozmU.useCallback)((headingPos)=>{
        if (!collapsibleSectionPositions.has(headingPos)) return;
        updateCollapsedHeadings((positions)=>{
            if (positions.has(headingPos)) return false;
            positions.add(headingPos);
            return true;
        });
    }, [
        collapsibleSectionPositions,
        updateCollapsedHeadings
    ]);
    const expand = (0, $cozmU.useCallback)((headingPos)=>{
        updateCollapsedHeadings((positions)=>positions.delete(headingPos));
    }, [
        updateCollapsedHeadings
    ]);
    const expandMany = (0, $cozmU.useCallback)((headingPositions)=>{
        const positionsToExpand = new Set(headingPositions);
        updateCollapsedHeadings((positions)=>{
            let didChange = false;
            positionsToExpand.forEach((headingPos)=>{
                didChange = positions.delete(headingPos) || didChange;
            });
            return didChange;
        });
    }, [
        updateCollapsedHeadings
    ]);
    const expandContainingPosition = (0, $cozmU.useCallback)((position)=>{
        expandMany(sections.filter((section)=>position >= section.contentFrom && position < section.to).map((section)=>section.headingPos));
    }, [
        expandMany,
        sections
    ]);
    const toggle = (0, $cozmU.useCallback)((headingPos)=>{
        if (!collapsibleSectionPositions.has(headingPos)) return;
        updateCollapsedHeadings((positions)=>{
            if (positions.has(headingPos)) positions.delete(headingPos);
            else positions.add(headingPos);
            return true;
        });
    }, [
        collapsibleSectionPositions,
        updateCollapsedHeadings
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>isActive ? {
            canCollapse: (headingPos)=>collapsibleSectionPositions.has(headingPos),
            collapse: collapse,
            expand: expand,
            expandContainingPosition: expandContainingPosition,
            expandMany: expandMany,
            isCollapsed: (headingPos)=>collapsedHeadings.has(headingPos),
            toggle: toggle
        } : null, [
        collapse,
        collapsedHeadings,
        collapsibleSectionPositions,
        expand,
        expandContainingPosition,
        expandMany,
        isActive,
        toggle
    ]);
    (0, $cozmU.useEffect)(()=>{
        const rendererRoot = rendererRef.current;
        if (!rendererRoot) return;
        const positions = isActive ? collapsedHeadings : $4c14c60c78d48fd8$var$emptyCollapsedHeadings;
        const sync = ()=>(0, $4oVOc.reconcileCollapsedHeadingContent)({
                collapsedHeadings: positions,
                originalHiddenAttributes: originalHiddenAttributes,
                rendererRoot: rendererRoot,
                sections: sections
            });
        sync();
        if (!isActive || positions.size === 0) return;
        const rendererDocuments = (0, $4oVOc.getOwnedRendererDocuments)(rendererRoot);
        const rendererDocumentSet = new Set(rendererDocuments);
        const handleBeforeMatch = (event)=>{
            const target = event.target;
            const HTMLElementConstructor = rendererRoot.ownerDocument.defaultView?.HTMLElement;
            if (!HTMLElementConstructor || !(target instanceof HTMLElementConstructor)) return;
            const collapsedContent = target.closest(`[${(0, $4oVOc.COLLAPSED_CONTENT_OWNERS_ATTRIBUTE)}]`);
            if (!collapsedContent) return;
            const rendererDocument = collapsedContent.closest('.ak-renderer-document');
            if (!rendererDocument || !rendererDocumentSet.has(rendererDocument)) return;
            expandMany((0, $4oVOc.getCollapsedContentOwners)(collapsedContent));
        };
        const unbindBeforeMatchListeners = rendererDocuments.map((rendererDocument)=>(0, $cbY7C.bind)(rendererDocument, {
                type: 'beforematch',
                listener: handleBeforeMatch,
                options: {
                    capture: true
                }
            }));
        const observer = typeof MutationObserver === 'undefined' ? undefined : new MutationObserver(sync);
        rendererDocuments.forEach((rendererDocument)=>{
            observer?.observe(rendererDocument, {
                childList: true
            });
        });
        return ()=>{
            observer?.disconnect();
            unbindBeforeMatchListeners.forEach((unbindBeforeMatch)=>unbindBeforeMatch());
        };
    }, [
        collapsedHeadings,
        expandMany,
        isActive,
        originalHiddenAttributes,
        rendererRef,
        sections
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            const rendererRoot = rendererRef.current;
            if (rendererRoot) (0, $4oVOc.reconcileCollapsedHeadingContent)({
                collapsedHeadings: $4c14c60c78d48fd8$var$emptyCollapsedHeadings,
                originalHiddenAttributes: originalHiddenAttributes,
                rendererRoot: rendererRoot,
                sections: []
            });
        }, [
        originalHiddenAttributes,
        rendererRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4c14c60c78d48fd8$var$CollapsibleHeadingsContext.Provider, {
        value: contextValue
    }, children);
}
function $4c14c60c78d48fd8$export$3df123b939d40b52(startPos, isTopLevel) {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($4c14c60c78d48fd8$var$CollapsibleHeadingsContext);
    const contextToggle = context?.toggle;
    const isCollapsible = Boolean(context && isTopLevel && context.canCollapse(startPos));
    const isCollapsed = Boolean(isCollapsible && context?.isCollapsed(startPos));
    const toggle = (0, $cozmU.useCallback)(()=>contextToggle?.(startPos), [
        contextToggle,
        startPos
    ]);
    return (0, $cozmU.useMemo)(()=>isCollapsible ? {
            isCollapsed: isCollapsed,
            toggle: toggle
        } : null, [
        isCollapsed,
        isCollapsible,
        toggle
    ]);
}
function $4c14c60c78d48fd8$export$16b4e68f51f04e9e() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($4c14c60c78d48fd8$var$CollapsibleHeadingsContext);
}
module.exports["CollapsibleHeadingsProvider"] = $4c14c60c78d48fd8$export$158f0ca2ade2cf24;
module.exports["useCollapsibleHeading"] = $4c14c60c78d48fd8$export$3df123b939d40b52;

});

parcelRegister("3qC7n", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $kTb7m = parcelRequire("kTb7m");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $2Voi6 = parcelRequire("2Voi6");

function $d03baa4664731a08$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d03baa4664731a08$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $d03baa4664731a08$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $d03baa4664731a08$export$3c9cedc52604835d,
        ref: ref
    }, children);
});
const $d03baa4664731a08$var$copyAnchorButtonStyles = {
    name: "x4slh0",
    styles: "display:inline;outline:none;background-color:transparent;border:none;color:var(--ds-icon, #292A2E);cursor:pointer;right:0"
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $d03baa4664731a08$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) {
            if ((0, $ieeJu.expValEquals)('a11y-fixes-week4-may-2026', 'isEnabled', true)) // Fix for A11Y-30972: Use content as a function with update callback so
            // the Tooltip repositions without unmounting (which caused focus loss).
            // @see https://hello.jira.atlassian.cloud/browse/A11Y-30972
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
                tag: $d03baa4664731a08$var$CopyAnchorWrapperWithRef,
                content: this.renderTooltipContent,
                position: "top",
                delay: 0,
                isScreenReaderAnnouncementDisabled: (0, $ieeJu.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? true : false
            }, this.renderAnchorButton());
            // We set the key to the message to ensure it remounts when the message
            // changes, so that it correctly repositions.
            // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
                tag: $d03baa4664731a08$var$CopyAnchorWrapperWithRef,
                content: tooltipMessage,
                position: "top",
                delay: 0,
                key: tooltipMessage,
                isScreenReaderAnnouncementDisabled: (0, $ieeJu.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? true : false
            }, this.renderAnchorButton());
        }
        return this.renderAnchorButton();
    }
    constructor(props){
        super(props);
        this.state = {
            tooltipMessage: '',
            isClicked: false
        };
        this.copyLinkId = void 0;
        this._tooltipUpdate = void 0;
        // Stable reference for Tooltip content prop to avoid recreating on each render
        this.renderTooltipContent = ({ update: update })=>{
            this._tooltipUpdate = update;
            return this.state.tooltipMessage;
        };
        this.setTooltipState = (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 - investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            }, ()=>{
                // Reposition tooltip after content change (replaces the key-based remount)
                if ((0, $ieeJu.expValEquals)('a11y-fixes-week4-may-2026', 'isEnabled', true)) this._tooltipUpdate?.();
            });
        };
        this.getCopyAriaLabel = ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $2Voi6.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        };
        this.copyToClipboard = async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $2Voi6.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch  {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        };
        this.resetMessage = ()=>{
            const tooltip = (0, $ieeJu.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? (0, $2Voi6.headingAnchorLinkMessages).copyLinkToClipboard : (0, $2Voi6.headingAnchorLinkMessages).copyHeadingLinkToClipboard;
            this.setTooltipState(tooltip);
        };
        this.renderAnchorButton = ()=>{
            const { hideFromScreenReader: hideFromScreenReader = false, headingId: headingId } = this.props;
            const labelledBy = (0, $ieeJu.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? this.props.intl.formatMessage((0, $2Voi6.headingAnchorLinkMessages).copyHeadingLinkLabelledBy, {
                copyLink: this.copyLinkId,
                heading: headingId
            }) : headingId;
            const tabIndex = (0, $ieeJu.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? 0 : hideFromScreenReader ? undefined : -1;
            return /*#__PURE__*/ (0, $lOiVq.jsx)("button", {
                "data-testid": "anchor-button",
                id: this.copyLinkId,
                css: $d03baa4664731a08$var$copyAnchorButtonStyles,
                onMouseLeave: this.resetMessage,
                onBlur: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: tabIndex,
                "aria-label": hideFromScreenReader ? undefined : this.state.tooltipMessage,
                "aria-labelledby": hideFromScreenReader ? undefined : labelledBy,
                type: "button"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                label: this.getCopyAriaLabel(),
                color: this.state.isClicked ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)"
            }));
        };
        this.copyLinkId = (0, $ieeJu.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? crypto.randomUUID() : undefined;
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $d03baa4664731a08$var$_default_1 = (0, $kSwu1.injectIntl)($d03baa4664731a08$var$HeadingAnchor);
var $d03baa4664731a08$export$2e2bcd8739ae039 = $d03baa4664731a08$var$_default_1;
module.exports["HeadingAnchorWrapperClassName"] = $d03baa4664731a08$export$3c9cedc52604835d;
module.exports["default"] = $d03baa4664731a08$export$2e2bcd8739ae039;

});

parcelRegister("47hKc", function(module, exports) {
function $1f5a879f832ce8b6$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}
module.exports["getListIndentLevel"] = $1f5a879f832ce8b6$export$75aa84e85754623e;

});

parcelRegister("4oVOc", function(module, exports) {
const $bd7d5b5834cb79fb$var$RENDERER_DOCUMENT_SELECTOR = '.ak-renderer-document';
const $bd7d5b5834cb79fb$var$RENDERER_START_POS_ATTRIBUTE = 'data-renderer-start-pos';
const $bd7d5b5834cb79fb$var$HEADING_SELECTOR = [
    1,
    2,
    3,
    4,
    5,
    6
].map((level)=>`h${level}[${$bd7d5b5834cb79fb$var$RENDERER_START_POS_ATTRIBUTE}]`).join(',');
const $bd7d5b5834cb79fb$export$2116c0d2c1e9b9e4 = 'data-renderer-collapsed-content-owners';
function $bd7d5b5834cb79fb$var$getDirectRendererChild(rendererDocument, element) {
    let currentElement = element;
    while(currentElement && currentElement.parentElement !== rendererDocument)currentElement = currentElement.parentElement;
    return currentElement?.parentElement === rendererDocument ? currentElement : null;
}
function $bd7d5b5834cb79fb$var$getTopLevelHeadingPositionsByContainer(rendererDocument, topLevelHeadingPositions) {
    const headingPositionsByContainer = new Map();
    rendererDocument.querySelectorAll($bd7d5b5834cb79fb$var$HEADING_SELECTOR).forEach((headingElement)=>{
        if (headingElement.closest($bd7d5b5834cb79fb$var$RENDERER_DOCUMENT_SELECTOR) !== rendererDocument) return;
        const position = Number(headingElement.getAttribute($bd7d5b5834cb79fb$var$RENDERER_START_POS_ATTRIBUTE));
        if (!Number.isFinite(position) || !topLevelHeadingPositions.has(position)) return;
        const headingContainer = $bd7d5b5834cb79fb$var$getDirectRendererChild(rendererDocument, headingElement);
        if (headingContainer) headingPositionsByContainer.set(headingContainer, position);
    });
    return headingPositionsByContainer;
}
function $bd7d5b5834cb79fb$var$restoreHiddenAttribute(element, originalHiddenAttributes) {
    if (!originalHiddenAttributes.has(element)) return;
    const originalHiddenAttribute = originalHiddenAttributes.get(element);
    if (originalHiddenAttribute === null || originalHiddenAttribute === undefined) element.removeAttribute('hidden');
    else element.setAttribute('hidden', originalHiddenAttribute);
    originalHiddenAttributes.delete(element);
}
function $bd7d5b5834cb79fb$var$setCollapsedOwners(element, owners, originalHiddenAttributes) {
    if (!originalHiddenAttributes.has(element)) originalHiddenAttributes.set(element, element.getAttribute('hidden'));
    element.setAttribute($bd7d5b5834cb79fb$export$2116c0d2c1e9b9e4, Array.from(owners).join(','));
    element.setAttribute('hidden', 'until-found');
}
function $bd7d5b5834cb79fb$var$getDesiredCollapsedContentOwners(rendererDocuments, collapsedHeadings, sections) {
    const desiredOwners = new Map();
    if (collapsedHeadings.size === 0) return desiredOwners;
    const topLevelHeadingPositions = new Set(sections.map((section)=>section.headingPos));
    const sectionsByHeadingPosition = new Map(sections.map((section)=>[
            section.headingPos,
            section
        ]));
    rendererDocuments.forEach((rendererDocument)=>{
        // Index headings once, then reconcile every top-level renderer child in DOM order.
        const headingPositionsByContainer = $bd7d5b5834cb79fb$var$getTopLevelHeadingPositionsByContainer(rendererDocument, topLevelHeadingPositions);
        let activeCollapsedSections = [];
        const contentElements = Array.from(rendererDocument.children);
        contentElements.forEach((contentElement)=>{
            const headingPosition = headingPositionsByContainer.get(contentElement);
            if (headingPosition !== undefined) activeCollapsedSections = activeCollapsedSections.filter((section)=>section.to > headingPosition);
            if (activeCollapsedSections.length > 0) desiredOwners.set(contentElement, new Set(activeCollapsedSections.map((section)=>section.headingPos)));
            if (headingPosition !== undefined && collapsedHeadings.has(headingPosition)) {
                const section = sectionsByHeadingPosition.get(headingPosition);
                if (section) activeCollapsedSections.push(section);
            }
        });
    });
    return desiredOwners;
}
function $bd7d5b5834cb79fb$export$236858493fcc483b(rendererRoot) {
    return Array.from(rendererRoot.querySelectorAll($bd7d5b5834cb79fb$var$RENDERER_DOCUMENT_SELECTOR)).filter((rendererDocument)=>{
        const parentRendererDocument = rendererDocument.parentElement?.closest($bd7d5b5834cb79fb$var$RENDERER_DOCUMENT_SELECTOR);
        return !parentRendererDocument || !rendererRoot.contains(parentRendererDocument);
    });
}
function $bd7d5b5834cb79fb$export$371cf0cf237e6c69({ collapsedHeadings: collapsedHeadings, originalHiddenAttributes: originalHiddenAttributes, rendererRoot: rendererRoot, sections: sections }) {
    const rendererDocuments = $bd7d5b5834cb79fb$export$236858493fcc483b(rendererRoot);
    const desiredOwners = $bd7d5b5834cb79fb$var$getDesiredCollapsedContentOwners(rendererDocuments, collapsedHeadings, sections);
    rendererDocuments.forEach((rendererDocument)=>{
        rendererDocument.querySelectorAll(`[${$bd7d5b5834cb79fb$export$2116c0d2c1e9b9e4}]`).forEach((element)=>{
            if (element.closest($bd7d5b5834cb79fb$var$RENDERER_DOCUMENT_SELECTOR) === rendererDocument && !desiredOwners.has(element)) {
                element.removeAttribute($bd7d5b5834cb79fb$export$2116c0d2c1e9b9e4);
                $bd7d5b5834cb79fb$var$restoreHiddenAttribute(element, originalHiddenAttributes);
            }
        });
    });
    desiredOwners.forEach((owners, element)=>{
        const desiredOwnersAttribute = Array.from(owners).join(',');
        if (element.getAttribute($bd7d5b5834cb79fb$export$2116c0d2c1e9b9e4) !== desiredOwnersAttribute || element.getAttribute('hidden') !== 'until-found') $bd7d5b5834cb79fb$var$setCollapsedOwners(element, owners, originalHiddenAttributes);
    });
}
function $bd7d5b5834cb79fb$export$18ccec9830a10d6e(element) {
    return (element.getAttribute($bd7d5b5834cb79fb$export$2116c0d2c1e9b9e4) ?? '').split(',').filter((owner)=>owner !== '').map(Number).filter(Number.isFinite);
}
module.exports["COLLAPSED_CONTENT_OWNERS_ATTRIBUTE"] = $bd7d5b5834cb79fb$export$2116c0d2c1e9b9e4;
module.exports["getOwnedRendererDocuments"] = $bd7d5b5834cb79fb$export$236858493fcc483b;
module.exports["reconcileCollapsedHeadingContent"] = $bd7d5b5834cb79fb$export$371cf0cf237e6c69;
module.exports["getCollapsedContentOwners"] = $bd7d5b5834cb79fb$export$18ccec9830a10d6e;

});

parcelRegister("782Oz", function(module, exports) {
const $a942444b3b14739c$var$RENDERER_DOCUMENT_POSITION_OFFSET = 1;
function $a942444b3b14739c$export$640970ddc72cf5cf(pmDocument) {
    if (!pmDocument) return [];
    const sections = [];
    const openSections = [];
    const documentEnd = pmDocument.content.size + $a942444b3b14739c$var$RENDERER_DOCUMENT_POSITION_OFFSET;
    pmDocument.forEach((node, offset)=>{
        if (node.type.name !== 'heading') return;
        const headingPos = offset + $a942444b3b14739c$var$RENDERER_DOCUMENT_POSITION_OFFSET;
        const level = Number(node.attrs.level);
        while(openSections.length > 0 && openSections[openSections.length - 1].level >= level){
            const section = openSections.pop();
            if (section) section.to = headingPos;
        }
        const section = {
            contentFrom: headingPos + node.nodeSize,
            headingPos: headingPos,
            level: level,
            to: documentEnd
        };
        sections.push(section);
        openSections.push(section);
    });
    return sections;
}
module.exports["buildTopLevelHeadingSections"] = $a942444b3b14739c$export$640970ddc72cf5cf;

});


$parcel$global.rlb("bToBz")
//# sourceMappingURL=FullPageEditorComponent.eae2b9fb.js.map
